/**
 * Bundle Builder - Client-Side State Management
 * Handles step navigation, product selection, pricing, and cart integration
 * @version 2.1.0 - Dramatic loading sequence
 */

// #region agent log - Safari iOS debug instrumentation
// DISABLED FOR PRODUCTION - Was used to debug Safari iOS crashes
// To re-enable, set BB_DEBUG_ENABLED = true
(function() {
  var BB_DEBUG_ENABLED = false; // Set to true to enable debug logging
  
  if (!BB_DEBUG_ENABLED) {
    // Provide no-op functions so any remaining calls don't error
    window._bbDebugLog = function() {};
    window._bbDumpLogs = function() { return 'Debug disabled'; };
    return;
  }
  
  var DEBUG_ENDPOINT = 'http://127.0.0.1:7242/ingest/d9b3e475-32e5-41d8-ae2f-3d7b6ab7940b';
  var SESSION_ID = 'safari-ios-debug-' + Date.now();
  var pageLoadTime = Date.now();
  var pageLoadCount = parseInt(localStorage.getItem('bb_debug_load_count') || '0') + 1;
  localStorage.setItem('bb_debug_load_count', String(pageLoadCount));
  
  // Check for previous session logs (indicates a refresh happened)
  var prevLogs = localStorage.getItem('bb_debug_logs');
  if (prevLogs && pageLoadCount > 1) {
    console.warn('🔴 BB DEBUG: Previous session logs found! Page likely refreshed. Load #' + pageLoadCount);
    console.warn('Previous logs:', prevLogs);
  }
  
  // Clear old logs at start of new session
  localStorage.setItem('bb_debug_logs', '');
  
  // H1, H3, H4, H5 - Core page lifecycle tracking
  window._bbDebugLog = function(loc, msg, data, hypothesisId) {
    var entry = {
      t: Date.now() - pageLoadTime,
      loc: loc,
      msg: msg,
      h: hypothesisId,
      d: data || {}
    };
    
    // Save to localStorage (persists across refreshes!)
    var logs = localStorage.getItem('bb_debug_logs') || '';
    logs += JSON.stringify(entry) + '\n';
    localStorage.setItem('bb_debug_logs', logs);
    
    // Also try remote endpoint (works on desktop)
    fetch(DEBUG_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        location: loc,
        message: msg,
        data: Object.assign({ timeSinceLoad: Date.now() - pageLoadTime, userAgent: navigator.userAgent.substring(0, 100), loadCount: pageLoadCount }, data || {}),
        timestamp: Date.now(),
        sessionId: SESSION_ID,
        hypothesisId: hypothesisId || 'general'
      })
    }).catch(function() {});
    
    // Console log for visibility
    console.log('[BB DEBUG ' + hypothesisId + '] ' + msg, entry.d);
  };
  
  // Log page load immediately with load count
  var isSafariiOS = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && /iPhone|iPad/.test(navigator.userAgent);
  window._bbDebugLog('bundle-builder.js:TOP', 'Page script started', { 
    isSafariiOS: isSafariiOS,
    loadCount: pageLoadCount,
    prevLogsExist: !!prevLogs 
  }, 'H3');
  
  // #region agent log - H7/H8 FAST heartbeats (500ms) to catch exact crash moment
  var heartbeatCount = 0;
  var heartbeatInterval = setInterval(function() {
    heartbeatCount++;
    // Get memory estimate if available (Chrome/Safari)
    var memInfo = {};
    if (performance && performance.memory) {
      memInfo = {
        usedJSHeap: Math.round(performance.memory.usedJSHeapSize / 1024 / 1024),
        totalJSHeap: Math.round(performance.memory.totalJSHeapSize / 1024 / 1024)
      };
    }
    window._bbDebugLog('heartbeat', 'Alive', { 
      beat: heartbeatCount, 
      ms: heartbeatCount * 500,
      mem: memInfo,
      soundLoaded: !!(window.BB && window.BB.Sound && window.BB.Sound.isLoaded && window.BB.Sound.isLoaded()),
      fbConnected: !!window._bbFirebaseConnected
    }, 'H7');
    // Stop after 30 seconds to avoid log spam
    if (heartbeatCount >= 60) clearInterval(heartbeatInterval);
  }, 500);
  // #endregion
  
  // H5 - Track unhandled errors
  window.addEventListener('error', function(e) {
    window._bbDebugLog('window:error', 'Unhandled error', { message: e.message, filename: e.filename, lineno: e.lineno }, 'H5');
  });
  
  // H5 - Track unhandled promise rejections
  window.addEventListener('unhandledrejection', function(e) {
    window._bbDebugLog('window:unhandledrejection', 'Unhandled promise rejection', { reason: String(e.reason).substring(0, 200) }, 'H5');
  });
  
  // H4 - Track visibility changes
  document.addEventListener('visibilitychange', function() {
    window._bbDebugLog('document:visibilitychange', 'Visibility changed', { hidden: document.hidden, visibilityState: document.visibilityState }, 'H4');
  });
  
  // H4 - Track page show/hide (bfcache)
  window.addEventListener('pageshow', function(e) {
    window._bbDebugLog('window:pageshow', 'Page show event', { persisted: e.persisted }, 'H4');
  });
  
  window.addEventListener('pagehide', function(e) {
    window._bbDebugLog('window:pagehide', 'Page hide event', { persisted: e.persisted }, 'H4');
  });
  
  // H3 - Track memory warnings (Safari specific)
  if (window.performance && window.performance.memory) {
    setInterval(function() {
      var mem = window.performance.memory;
      if (mem.usedJSHeapSize > mem.jsHeapSizeLimit * 0.9) {
        window._bbDebugLog('memory:warning', 'High memory usage', { used: mem.usedJSHeapSize, limit: mem.jsHeapSizeLimit }, 'H3');
      }
    }, 5000);
  }
  
  // Expose function to dump logs (call from console: window._bbDumpLogs())
  window._bbDumpLogs = function() {
    var logs = localStorage.getItem('bb_debug_logs') || 'No logs';
    console.log('=== BB DEBUG LOGS (Load #' + pageLoadCount + ') ===');
    console.log(logs);
    return logs;
  };
  
  // Clear load count after 5 minutes of stable page (no refresh)
  setTimeout(function() {
    localStorage.setItem('bb_debug_load_count', '0');
    console.log('[BB DEBUG] Page stable for 5 min, reset load count');
  }, 5 * 60 * 1000);
})();
// #endregion

// Global analytics tracking
window.BB = window.BB || {};
window.BB.trackProductClick = function(productHandle, productTitle) {
  var FIREBASE_URL = 'https://us-central1-pipdecksapp.cloudfunctions.net';
  fetch(FIREBASE_URL + '/trackProductClick', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      productHandle: productHandle,
      productTitle: productTitle
    })
  }).catch(function(err) {
    console.warn('Product click tracking failed:', err);
  });
};

(function() {
  'use strict';

  // Find all bundle builder instances on the page
  const bundleBuilders = document.querySelectorAll('.bundle-builder');

  bundleBuilders.forEach(function(container) {
    initBundleBuilder(container);
  });

  function initBundleBuilder(container) {
    // #region agent log - H3 init tracking
    if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initBundleBuilder', 'Bundle builder init started', { bundleBuildersCount: bundleBuilders.length }, 'H3');
    // #endregion
    
    const sectionId = container.dataset.sectionId;
    
    // Configuration from data attributes
    const config = {
      sectionId: sectionId,
      timerDuration: parseInt(container.dataset.timerDuration) || 600,
      timerUrgent: parseInt(container.dataset.timerUrgent) || 120,
      queueEnabled: container.dataset.queueEnabled === 'true',
      queueStart: parseInt(container.dataset.queueStart) || 10, // Default to 10 for faster testing
      tiers: {
        2: parseInt(container.dataset.tier2) || 20,
        3: parseInt(container.dataset.tier3) || 30,
        4: parseInt(container.dataset.tier4) || 40,
        5: parseInt(container.dataset.tier5) || 50
      },
      currency: container.dataset.currency || 'GBP',
      moneyFormat: container.dataset.moneyFormat || '£{{amount}}',
      currencySymbol: (container.dataset.moneyFormat || '£{{amount}}').replace(/\{\{.*\}\}/, '').trim() || '£',
      // Legacy phantom product - no longer used
      phantomVariantId: container.dataset.phantomVariantId || '',
      // Free hat promotion
      freeHatEnabled: container.dataset.freeHatEnabled === 'true',
      freeHatMinCart: parseInt(container.dataset.freeHatMinCart) || 10000
    };
    
    // ========================================================================
    // FREE HAT PROMOTION (UK Only)
    // ========================================================================
    var freeHatData = null;
    var userCountry = null;
    var selectedHatVariant = null;
    
    // Load free hat data
    (function loadFreeHatData() {
      var hatDataEl = document.getElementById('bb-free-hat-' + sectionId);
      if (hatDataEl) {
        try {
          freeHatData = JSON.parse(hatDataEl.textContent);
          console.log('[BB Free Hat] Loaded hat data:', freeHatData);
        } catch (e) {
          console.error('[BB Free Hat] Failed to parse hat data:', e);
        }
      }
    })();
    
    // Detect user country
    (function detectCountry() {
      fetch('/browsing_context_suggestions.json')
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data && data.detected_values && data.detected_values.country) {
            userCountry = data.detected_values.country.handle.toLowerCase();
            console.log('[BB Geo] Detected country:', userCountry);
            
            // Update UI based on country
            updateFreeShippingMessage();
            updateFreeHatPromotion();
          }
        })
        .catch(function(err) {
          console.log('[BB Geo] Could not detect country:', err);
        });
    })();
    
    // Free shipping countries (same as your existing list)
    var freeShippingCountries = [
      'ad', 'at', 'be', 'ba', 'bg', 'hr', 'cz', 'dk', 'ee', 'fo', 'fi', 'fr', 'de', 'gi', 'gr', 
      'gg', 'hu', 'is', 'ie', 'im', 'it', 'je', 'xk', 'lv', 'li', 'lt', 'lu', 'mt', 'md', 'mc', 
      'me', 'nl', 'mk', 'no', 'pl', 'pt', 'ro', 'sm', 'rs', 'sk', 'si', 'es', 'sj', 'se', 'ch', 
      'va', 'us', 'gb', 'ca'
    ];
    
    function updateFreeShippingMessage() {
      // Add free shipping badge to physical step if user is in free shipping country
      if (!userCountry || freeShippingCountries.indexOf(userCountry) === -1) return;
      
      var physicalStep = container.querySelector('.bb-step[data-step="3"]');
      if (!physicalStep) return;
      
      // Check if already added
      if (physicalStep.querySelector('.bb-free-shipping-badge')) return;
      
      var badge = document.createElement('div');
      badge.className = 'bb-free-shipping-badge';
      badge.innerHTML = '<span class="bb-shipping-icon">🚚</span> FREE SHIPPING to your country!';
      
      // Add to physical step header
      var header = physicalStep.querySelector('.bb-mode-header, .bb-step-header');
      if (header) {
        header.appendChild(badge);
      }
      
      console.log('[BB Free Shipping] Added free shipping badge for', userCountry);
    }
    
    function updateFreeHatPromotion() {
      // Only show for UK users
      if (userCountry !== 'gb') return;
      if (!config.freeHatEnabled || !freeHatData) return;
      
      // Check if any variants are available
      var availableVariants = freeHatData.variants.filter(function(v) { return v.available; });
      if (availableVariants.length === 0) {
        console.log('[BB Free Hat] No hat variants in stock');
        return;
      }
      
      // Set default selected variant (first available)
      if (!selectedHatVariant) {
        selectedHatVariant = availableVariants[0];
      }
      
      // Show free hat UI
      showFreeHatBanner();
    }
    
    function showFreeHatBanner() {
      if (!freeHatData) return;
      
      // Check if banner already exists
      if (container.querySelector('.bb-free-hat-banner')) return;
      
      var availableVariants = freeHatData.variants.filter(function(v) { return v.available; });
      
      // Create variant selector HTML
      var variantOptions = availableVariants.map(function(v) {
        var selected = selectedHatVariant && selectedHatVariant.id === v.id ? ' selected' : '';
        return '<option value="' + v.id + '"' + selected + '>' + v.title + '</option>';
      }).join('');
      
      var banner = document.createElement('div');
      banner.className = 'bb-free-hat-banner';
      banner.innerHTML = 
        '<div class="bb-hat-content">' +
          '<div class="bb-hat-icon">🎩</div>' +
          '<div class="bb-hat-text">' +
            '<div class="bb-hat-title">🎉 You won a FREE Pip Hat!</div>' +
            '<div class="bb-hat-subtitle">UK exclusive - added to your order</div>' +
          '</div>' +
          '<div class="bb-hat-selector">' +
            '<select id="bb-hat-variant-select" class="bb-hat-select">' +
              variantOptions +
            '</select>' +
          '</div>' +
          '<div class="bb-hat-checkmark">✓</div>' +
        '</div>';
      
      // Add to mini cart or summary area
      var miniCart = container.querySelector('#bb-mini-cart .cart-panel');
      if (miniCart) {
        miniCart.insertBefore(banner, miniCart.firstChild);
      } else {
        // Fallback: add to top of container
        container.insertBefore(banner, container.firstChild);
      }
      
      // Add event listener for variant selection
      var select = banner.querySelector('#bb-hat-variant-select');
      if (select) {
        select.addEventListener('change', function() {
          var selectedId = parseInt(this.value);
          selectedHatVariant = freeHatData.variants.find(function(v) { return v.id === selectedId; });
          console.log('[BB Free Hat] Selected variant:', selectedHatVariant);
        });
      }
      
      console.log('[BB Free Hat] Showing free hat banner for UK user');
    }
    
    // ========================================================================
    // LOCALSTORAGE VERSION CHECK - Clear old debug panel settings
    // Bump this version to force-clear everyone's localStorage
    // ========================================================================
    (function() {
      var BB_STORAGE_VERSION = 'bb_v3'; // Bump this to clear all users' localStorage
      var storedVersion = localStorage.getItem('bb_storage_version');
      
      if (storedVersion !== BB_STORAGE_VERSION) {
        // Clear ALL bb_ keys (debug, settings, etc)
        var keysToRemove = [];
        for (var i = 0; i < localStorage.length; i++) {
          var key = localStorage.key(i);
          if (key && (key.startsWith('bb_') || key.startsWith('bb-'))) {
            keysToRemove.push(key);
          }
        }
        keysToRemove.forEach(function(key) {
          localStorage.removeItem(key);
        });
        // Set new version
        localStorage.setItem('bb_storage_version', BB_STORAGE_VERSION);
        console.log('[BB] Cleared ALL bb_ localStorage settings (version bump to ' + BB_STORAGE_VERSION + ')');
      }
    })();

    // ========================================================================
    // STEP 1 DESCRIPTION HIGHLIGHT
    // Enhance description with highlighted text
    // ========================================================================
    (function() {
      var step1 = container.querySelector('[data-step="1"]');
      if (step1) {
        var desc = step1.querySelector('.bb-step-description');
        if (desc) {
          // Replace "Add 5+ decks" with "Add 5+ Digital Decks" and highlight "Digital Decks" + "50% discount"
          var text = desc.textContent || desc.innerText;
          if (text.includes('5+')) {
            desc.innerHTML = 'Add 5+ <span class="bb-highlight">Digital Decks</span> to unlock the maximum <span class="bb-highlight">50% discount</span>.';
          }
        }
      }
    })();

    // ========================================================================
    // QUEUE SYSTEM (Firebase Realtime Database)
    // Gatekeeper controls for releasing users from the queue
    // ========================================================================
    var QueueSystem = (function() {
      var firebaseApp, database;
      var isInitialized = false;
      var myTicket = null;
      var isReleased = true; // DEFAULT TO TRUE (open mode) until Firebase is configured
      var queuePosition = 0;
      var isOpenMode = true; // No Firebase = open mode
      var callbacks = {
        onRelease: [],
        onPositionChange: []
      };
      
      // Firebase config - REPLACE WITH YOUR OWN
      // When these are placeholder values, the system runs in "open mode" (everyone can enter)
      var firebaseConfig = {
        apiKey: "YOUR_FIREBASE_API_KEY",
        authDomain: "YOUR_PROJECT.firebaseapp.com",
        databaseURL: "https://YOUR_PROJECT-default-rtdb.firebaseio.com",
        projectId: "YOUR_PROJECT",
        storageBucket: "YOUR_PROJECT.appspot.com",
        messagingSenderId: "YOUR_SENDER_ID",
        appId: "YOUR_APP_ID"
      };
      
      async function init() {
        if (isInitialized) return;
        
        // Check if Firebase is configured (not placeholder values)
        if (firebaseConfig.apiKey === "YOUR_FIREBASE_API_KEY" || 
            firebaseConfig.projectId === "YOUR_PROJECT") {
          console.log('🚪 QueueSystem: Running in OPEN MODE (Firebase not configured)');
          isOpenMode = true;
          isReleased = true;
          isInitialized = true;
          triggerCallbacks('onRelease');
          return;
        }
        
        try {
          // Dynamic import Firebase
          const firebase = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js');
          const firebaseDb = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-database.js');
          
          isOpenMode = false;
          isReleased = false; // Now we need to check Firebase for release status
          
          // Initialize Firebase
          firebaseApp = firebase.initializeApp(firebaseConfig);
          database = firebaseDb.getDatabase(firebaseApp);
          
          // Get or create ticket
          myTicket = getOrCreateTicket();
          
          // Register in queue
          await registerInQueue(firebaseDb);
          
          // Subscribe to release status
          subscribeToRelease(firebaseDb);
          
          // Subscribe to queue position
          subscribeToQueuePosition(firebaseDb);
          
          isInitialized = true;
          console.log('🎟️ QueueSystem: Initialized with ticket', myTicket.substring(0, 8) + '...');
          
        } catch (e) {
          console.warn('🔴 QueueSystem: Firebase init failed, running in open mode', e);
          // Fallback: Allow entry without queue
          isReleased = true;
          triggerCallbacks('onRelease');
        }
      }
      
      function getOrCreateTicket() {
        var stored = localStorage.getItem('bb_queue_ticket');
        if (stored) return stored;
        
        var newTicket = 'ticket_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('bb_queue_ticket', newTicket);
        return newTicket;
      }
      
      async function registerInQueue(firebaseDb) {
        var queueRef = firebaseDb.ref(database, 'queue/' + myTicket);
        await firebaseDb.set(queueRef, {
          name: PlayerCustomization.getName(),
          joinedAt: Date.now(),
          color: PlayerCustomization.getColor(),
          sprite: PlayerCustomization.getSprite()
        });
        
        // Set up disconnect cleanup
        firebaseDb.onDisconnect(queueRef).remove();
      }
      
      function subscribeToRelease(firebaseDb) {
        var releaseRef = firebaseDb.ref(database, 'released/' + myTicket);
        firebaseDb.onValue(releaseRef, function(snapshot) {
          if (snapshot.exists()) {
            isReleased = true;
            console.log('🎉 QueueSystem: You have been released!');
            triggerCallbacks('onRelease');
          }
        });
      }
      
      function subscribeToQueuePosition(firebaseDb) {
        var queueRef = firebaseDb.ref(database, 'queue');
        firebaseDb.onValue(queueRef, function(snapshot) {
          if (!snapshot.exists()) {
            queuePosition = 0;
            triggerCallbacks('onPositionChange', 0);
            return;
          }
          
          var queue = snapshot.val();
          var tickets = Object.keys(queue);
          var myData = queue[myTicket];
          if (!myData) {
            queuePosition = 0;
            triggerCallbacks('onPositionChange', 0);
            return;
          }
          
          // Sort by joinedAt to get position
          var sorted = tickets.sort(function(a, b) {
            return queue[a].joinedAt - queue[b].joinedAt;
          });
          
          var position = sorted.indexOf(myTicket);
          queuePosition = position;
          triggerCallbacks('onPositionChange', position);
        });
      }
      
      function triggerCallbacks(type, data) {
        callbacks[type].forEach(function(cb) {
          try { cb(data); } catch(e) {}
        });
      }
      
      function onRelease(callback) {
        callbacks.onRelease.push(callback);
        // Immediately call if already released
        if (isReleased) callback();
      }
      
      function onPositionChange(callback) {
        callbacks.onPositionChange.push(callback);
        callback(queuePosition);
      }
      
      function getTicket() { return myTicket; }
      function getIsReleased() { return isReleased; }
      function getPosition() { return queuePosition; }
      
      return {
        init: init,
        getTicket: getTicket,
        getIsReleased: getIsReleased,
        getPosition: getPosition,
        onRelease: onRelease,
        onPositionChange: onPositionChange
      };
    })();
    
    // ========================================================================
    // PLAYER CUSTOMIZATION
    // Names, colors, and sprites for multiplayer identity
    // ========================================================================
    var PlayerCustomization = (function() {
      var playerName = null;
      var playerColor = null;
      var playerSprite = null;
      
      // Preset colors for paint can (accessible pairs: bg + text)
      var colorPresets = [
        { bg: '#fe5f55', text: '#ffffff', name: 'Coral' },
        { bg: '#4ade80', text: '#000000', name: 'Mint' },
        { bg: '#60a5fa', text: '#000000', name: 'Sky' },
        { bg: '#f59e0b', text: '#000000', name: 'Amber' },
        { bg: '#a855f7', text: '#ffffff', name: 'Purple' },
        { bg: '#ec4899', text: '#ffffff', name: 'Pink' },
        { bg: '#14b8a6', text: '#000000', name: 'Teal' },
        { bg: '#f97316', text: '#000000', name: 'Orange' },
        { bg: '#8b5cf6', text: '#ffffff', name: 'Violet' },
        { bg: '#06b6d4', text: '#000000', name: 'Cyan' }
      ];
      
      // Evolution chains - 4 base characters with 6 evolution stages each
      // Evolves every 2 cards: 1 → 2-3 → 4-5 → 6-7 → 8-9 → 10
      // Scale increases exponentially: 1.0 → 1.2 → 1.5 → 2.0 → 2.6 → 3.4
      var evolutionChains = {
        feline: {
          id: 'feline',
          name: 'Feline',
          baseEmoji: '🐱',
          stages: [
            { emoji: '🐱', name: 'Kitten', scale: 1.0 },
            { emoji: '😺', name: 'Cat', scale: 1.2 },
            { emoji: '🐈', name: 'Tabby', scale: 1.5 },
            { emoji: '🐆', name: 'Leopard', scale: 1.8 },
            { emoji: '🦁', name: 'Lion', scale: 2.1 },
            { emoji: '👑', name: 'King', scale: 2.5, final: true }
          ]
        },
        amphibian: {
          id: 'amphibian',
          name: 'Amphibian',
          baseEmoji: '🐸',
          stages: [
            { emoji: '🐸', name: 'Tadpole', scale: 1.0 },
            { emoji: '🦎', name: 'Lizard', scale: 1.2 },
            { emoji: '🐊', name: 'Croc', scale: 1.5 },
            { emoji: '🐲', name: 'Drake', scale: 1.8 },
            { emoji: '🐉', name: 'Dragon', scale: 2.1 },
            { emoji: '🔥', name: 'Ancient', scale: 2.5, final: true }
          ]
        },
        mammal: {
          id: 'mammal',
          name: 'Mammal',
          baseEmoji: '🐰',
          stages: [
            { emoji: '🐰', name: 'Bunny', scale: 1.0 },
            { emoji: '🐇', name: 'Rabbit', scale: 1.2 },
            { emoji: '🦊', name: 'Fox', scale: 1.5 },
            { emoji: '🐺', name: 'Wolf', scale: 1.8 },
            { emoji: '🐻', name: 'Bear', scale: 2.1 },
            { emoji: '⚡', name: 'Titan', scale: 2.5, final: true }
          ]
        },
        avian: {
          id: 'avian',
          name: 'Avian',
          baseEmoji: '🐣',
          stages: [
            { emoji: '🐣', name: 'Egg', scale: 1.0 },
            { emoji: '🐥', name: 'Chick', scale: 1.2 },
            { emoji: '🐤', name: 'Bird', scale: 1.5 },
            { emoji: '🦅', name: 'Eagle', scale: 1.8 },
            { emoji: '🦚', name: 'Phoenix', scale: 2.1 },
            { emoji: '✨', name: 'Legend', scale: 2.5, final: true }
          ]
        }
      };
      
      // Selectable base characters (user picks one)
      var spritePresets = [
        { id: 'feline', emoji: '🐱', name: 'Feline', chainId: 'feline' },
        { id: 'amphibian', emoji: '🐸', name: 'Amphibian', chainId: 'amphibian' },
        { id: 'mammal', emoji: '🐰', name: 'Mammal', chainId: 'mammal' },
        { id: 'avian', emoji: '🐣', name: 'Avian', chainId: 'avian' }
      ];
      
      var currentTier = 0;
      var currentEvolutionStage = 0;
      
      function init() {
        loadFromStorage();
        if (!playerName) generateNewName();
        if (!playerColor) playerColor = colorPresets[0];
        if (!playerSprite) playerSprite = spritePresets[0];
      }
      
      function loadFromStorage() {
        var storedName = localStorage.getItem('bb_player_name');
        var storedColorIdx = localStorage.getItem('bb_player_color');
        var storedSpriteIdx = localStorage.getItem('bb_player_sprite');
        
        // Migrate old-style names (no space = old format)
        if (storedName && storedName.indexOf(' ') === -1) {
          storedName = null; // Will trigger generateNewName()
        }
        
        if (storedName) playerName = storedName;
        if (storedColorIdx) playerColor = colorPresets[parseInt(storedColorIdx)] || colorPresets[0];
        if (storedSpriteIdx) playerSprite = spritePresets[parseInt(storedSpriteIdx)] || spritePresets[0];
      }
      
      function saveToStorage() {
        localStorage.setItem('bb_player_name', playerName);
        localStorage.setItem('bb_player_color', colorPresets.indexOf(playerColor));
        localStorage.setItem('bb_player_sprite', spritePresets.indexOf(playerSprite));
      }
      
      function generateNewName() {
        // Delegate to BB.Player for team-specific names
        if (window.BB && window.BB.Player && window.BB.Player.generateNewName) {
          playerName = window.BB.Player.generateNewName();
          return playerName;
        }
        // Fallback if BB.Player not loaded yet
        playerName = 'Player ' + Math.floor(Math.random() * 9000 + 1000);
        saveToStorage();
        return playerName;
      }
      
      function getName() {
        if (!playerName) init();
        return playerName;
      }
      
      function getColor() {
        if (!playerColor) init();
        return playerColor;
      }
      
      function getSprite() {
        if (!playerSprite) init();
        return playerSprite;
      }
      
      function cycleColor() {
        var currentIdx = colorPresets.indexOf(playerColor);
        var nextIdx = (currentIdx + 1) % colorPresets.length;
        playerColor = colorPresets[nextIdx];
        saveToStorage();
        return playerColor;
      }
      
      function cycleSprite() {
        var currentIdx = spritePresets.indexOf(playerSprite);
        var nextIdx = (currentIdx + 1) % spritePresets.length;
        playerSprite = spritePresets[nextIdx];
        saveToStorage();
        return playerSprite;
      }
      
      function getColorPresets() { return colorPresets; }
      function getSpritePresets() { return spritePresets; }
      
      // Tier management (based on cards selected)
      // Evolution happens every 2 cards: 1 → 2 → 4 → 6 → 8 → 10
      function getTier() { return currentTier; }
      function getEvolutionStage() { return currentEvolutionStage; }
      
      function getTierSprite() {
        var chain = getSelectedChain();
        if (!chain) return { emoji: '❓', name: 'Unknown', scale: 1.0 };
        return chain.stages[currentEvolutionStage] || chain.stages[0];
      }
      
      function getSelectedChain() {
        if (!playerSprite || !playerSprite.chainId) return evolutionChains.feline;
        return evolutionChains[playerSprite.chainId] || evolutionChains.feline;
      }
      
      function setTierFromCardCount(cardCount) {
        var oldTier = currentTier;
        var oldStage = currentEvolutionStage;
        
        currentTier = cardCount;
        
        // Calculate evolution stage (evolves every 2 cards)
        // Stage 0: 0-1 cards, Stage 1: 2-3, Stage 2: 4-5, Stage 3: 6-7, Stage 4: 8-9, Stage 5: 10
        if (cardCount >= 10) {
          currentEvolutionStage = 5; // FINAL FORM
        } else if (cardCount >= 8) {
          currentEvolutionStage = 4;
        } else if (cardCount >= 6) {
          currentEvolutionStage = 3;
        } else if (cardCount >= 4) {
          currentEvolutionStage = 2;
        } else if (cardCount >= 2) {
          currentEvolutionStage = 1;
        } else {
          currentEvolutionStage = 0;
        }
        
        var evolved = currentEvolutionStage > oldStage;
        var devolved = currentEvolutionStage < oldStage;
        var isFinalForm = currentEvolutionStage === 5 && oldStage !== 5;
        
        var chain = getSelectedChain();
        var stageData = chain.stages[currentEvolutionStage];
        
        return { 
          tier: currentTier, 
          stage: currentEvolutionStage,
          evolved: evolved,
          devolved: devolved,
          isFinalForm: isFinalForm,
          sprite: stageData,
          chainId: chain.id
        };
      }
      
      function getEvolutionChains() { return evolutionChains; }
      
      // Backwards compatibility - returns current chain's stages as tier sprites
      function getTierSprites() {
        var chain = getSelectedChain();
        return chain ? chain.stages : [];
      }
      
      // Initialize on load
      init();
      
      return {
        init: init,
        getName: getName,
        getColor: getColor,
        getSprite: getSprite,
        cycleColor: cycleColor,
        cycleSprite: cycleSprite,
        generateNewName: generateNewName,
        getColorPresets: getColorPresets,
        getSpritePresets: getSpritePresets,
        getTier: getTier,
        getTierSprite: getTierSprite,
        getTierSprites: getTierSprites,
        getEvolutionStage: getEvolutionStage,
        getSelectedChain: getSelectedChain,
        getEvolutionChains: getEvolutionChains,
        setTierFromCardCount: setTierFromCardCount
      };
    })();
    
    // ========================================================================
    // MULTIPLAYER SYSTEM (Liveblocks) - Using external module with queue support
    // Real-time cursors on loading screen + avatars on progress bar
    // ========================================================================
    // Use the external BB.Multiplayer module which has queue integration
    // This module is loaded from bb-multiplayer.js and includes:
    // - Firebase queue system (joinQueue, batch assignments)
    // - Liveblocks real-time cursors and avatars
    // - Batch release handling
    var MultiplayerSystem = window.BB && window.BB.Multiplayer ? window.BB.Multiplayer : {
      // Fallback stub if external module not loaded
      init: function() { console.warn('BB.Multiplayer not loaded'); },
      enterGame: function() {},
      flyOff: function() {},
      updatePlayerCustomization: function() {},
      updateAvatarPosition: function() {},
      renderAvatars: function() {},
      getOthersCount: function() { return 0; },
      jumpMyAvatar: function() {},
      evolveMyAvatar: function() {},
      onRelease: function() {},
      onQueueUpdate: function() {},
      getGlobalQueueCount: function() { return 0; },
      getBatchNumber: function() { return 1; },
      getIsReleased: function() { return true; }
    };
    
    // REMOVED: Old internal MultiplayerSystem implementation
    // Now using external bb-multiplayer.js with queue integration
    // The old code (850+ lines) has been replaced with the external module reference above
    
    /* OLD INTERNAL CODE REMOVED - START
    var MultiplayerSystem_OLD = (function() {
      var client, room;
      var cursorLayer, avatarLayer;
      var isActive = false;
      var myStatus = 'loading'; // 'loading' | 'playing'
      var others = [];
      var myAvatarPosition = 0.5; // 0-1 position on progress bar
      
      // Render loop state
      var peerData = new Map(); // connectionId -> { x, y, avatarX, targetX, targetY, targetAvatarX, ... }
      var animationFrameId = null;
      var lastRenderTime = 0;
      var myProgressAvatar = null;
      
      // Local avatar state for smooth rendering (updated via RAF, not mousemove)
      var myTargetAvatarX = 0.5;      // Target position (set by mousemove)
      var myCurrentAvatarX = 0.5;     // Interpolated position (rendered each frame)
      var avatarBarWidth = 300;       // Cached bar width (updated on resize)
      
      async function init() {
        if (isActive) return;
        
        // Set up cursor layer and events IMMEDIATELY (before Liveblocks connects)
        setupCursorLayer();
        // Avatar layer is created lazily in renderFrame when progress bar exists
        bindEvents();
        
        // Start render loop
        startRenderLoop();
        
        try {
          // Dynamic import for ESM module
          const { createClient } = await import('https://esm.sh/@liveblocks/client@1.9.1');
          
          client = createClient({
            publicApiKey: "pk_prod_cn9FnPiYlqzTrFskJRQ85VmnCKJWc6ffWm04QxtD9GJ-5cYkHa-87D9OL5gKjXeb",
          });
          
          // Join room based on section ID to keep it scoped if multiple builders exist
          var roomId = "bb-queue-" + (config.sectionId || "global");
          
          const { room: joinedRoom, leave } = client.enterRoom(roomId, {
            initialPresence: {
              cursor: null,
              status: 'loading',
              name: PlayerCustomization.getName(),
              color: PlayerCustomization.getColor(),
              sprite: PlayerCustomization.getSprite(),
              avatarX: 0.5,  // Position on progress bar (0-1)
              savings: 0,
              ticket: QueueSystem.getTicket ? QueueSystem.getTicket() : null
            }
          });
          
          room = joinedRoom;
          isActive = true;
          
          console.log('🟢 Multiplayer: Connected to room', roomId);
          console.log('🎭 Player:', PlayerCustomization.getName());
          
          // Subscribe to others - JUST UPDATE DATA, DON'T RENDER DIRECTLY
          room.subscribe("others", (newOthers) => {
            others = newOthers;
            updateStatusCount();
            
            // Sync peerData map with current others list
            // 1. Add/Update peers
            others.forEach(user => {
               if (!user.presence) return;
               
               let peer = peerData.get(user.connectionId);
               if (!peer) {
                 peer = { 
                   x: user.presence.cursor ? user.presence.cursor.x : 0, 
                   y: user.presence.cursor ? user.presence.cursor.y : 0,
                   avatarX: user.presence.avatarX || 0.5,
                   currentX: user.presence.cursor ? user.presence.cursor.x : 0,
                   currentY: user.presence.cursor ? user.presence.cursor.y : 0,
                   currentAvatarX: user.presence.avatarX || 0.5
                 };
                 peerData.set(user.connectionId, peer);
               }
               
               // Update targets
               if (user.presence.cursor) {
                 peer.x = user.presence.cursor.x;
                 peer.y = user.presence.cursor.y;
               }
               if (typeof user.presence.avatarX === 'number') {
                 peer.avatarX = user.presence.avatarX;
               }
               
               // Store presence data for rendering
               peer.presence = user.presence;
            });
            
            // 2. Remove stale peers
            const activeIds = new Set(others.map(u => u.connectionId));
            for (const [id, peer] of peerData) {
              if (!activeIds.has(id)) {
                peerData.delete(id);
                // Cleanup DOM elements immediately using cached refs
                if (peer.cursorEl) {
                    peer.cursorEl.remove();
                } else {
                    var cursorEl = document.getElementById('cursor-' + id);
                    if (cursorEl) cursorEl.remove();
                }
                
                if (peer.avatarEl) {
                    peer.avatarEl.remove();
                } else {
                    var avatarEl = document.getElementById('avatar-' + id);
                    if (avatarEl) avatarEl.remove();
                }
              }
            }
          });
          
          // Listen for broadcast events (Fly-off, Jumps)
          room.subscribe("event", ({ event, connectionId }) => {
            if (event.type === 'PLAYER_FLY_OFF') {
              createFlyOffAnimation(event.name, event.color, event.sprite, event.savings, event.avatarX * window.innerWidth);
            }
            else if (event.type === 'PLAYER_JUMP') {
              // Trigger jump for a remote user
              // Use connectionId from the wrapper, or fallback to event payload if locally passed (self)
              var targetId = connectionId || event.connectionId;
              
              var avatarEl = document.getElementById('avatar-' + targetId);
              if (avatarEl) {
                // Find the sprite element to animate
                var spriteEl = avatarEl.querySelector('.bb-mp-avatar-sprite');
                if (spriteEl) {
                  // Reset animation
                  spriteEl.style.animation = 'none';
                  void spriteEl.offsetWidth; // Force reflow
                  spriteEl.style.animation = '';
                  
                  // Add jump class to parent (which now targets sprite in CSS)
                  avatarEl.classList.add('bb-avatar-jump');
                  setTimeout(function() {
                    avatarEl.classList.remove('bb-avatar-jump');
                  }, 500);
                }
              }
            }
            else if (event.type === 'PLAYER_EVOLVE') {
              // Trigger evolution animation for a remote user
              var targetId = connectionId || event.connectionId;
              var avatarEl = document.getElementById('avatar-' + targetId);
              
              if (avatarEl) {
                var spriteEl = avatarEl.querySelector('.bb-mp-avatar-sprite');
                
                // Add white flash BEFORE changing the sprite (Mario-style)
                avatarEl.classList.remove('bb-avatar-evolve', 'bb-avatar-devolve', 'bb-avatar-legendary');
                void avatarEl.offsetWidth;
                
                if (event.isFinalForm) {
                  avatarEl.classList.add('bb-avatar-legendary');
                  console.log('🐉 Someone became LEGENDARY!');
                } else if (event.evolved) {
                  avatarEl.classList.add('bb-avatar-evolve');
                } else if (event.devolved) {
                  avatarEl.classList.add('bb-avatar-devolve');
                }
                
                // Update sprite AFTER flash starts (50ms delay for dramatic effect)
                if (spriteEl && event.tierSprite) {
                  setTimeout(function() {
                    spriteEl.textContent = event.tierSprite.emoji;
                    spriteEl.style.transform = 'scale(' + event.tierSprite.scale + ')';
                  }, 50);
                }
                
                setTimeout(function() {
                  avatarEl.classList.remove('bb-avatar-evolve', 'bb-avatar-devolve', 'bb-avatar-legendary');
                }, event.isFinalForm ? 1500 : 600);
              }
            }
          });
          
        } catch (e) {
          console.warn('🔴 Multiplayer: Failed to initialize', e);
        }
      }
      
      var myCursorEl = null;
      
      function setupCursorLayer() {
        // Create cursor layer for OTHER users' cursors (if not already created)
        if (!cursorLayer) {
          cursorLayer = document.createElement('div');
          cursorLayer.className = 'bb-cursor-layer';
          cursorLayer.id = 'bb-cursor-layer';
          document.body.appendChild(cursorLayer);
          console.log('🎯 Cursor layer created for others');
        }
        
        // Always apply custom cursor and create avatar preview
        applyCustomCursor();
        
        console.log('🎯 Using native CSS cursor for self (zero lag)');
        
        // Status counter - shows queue position (add to intro if it exists)
        var intro = document.getElementById('bb-intro-' + config.sectionId);
        if (intro && !document.getElementById('bb-mp-status')) {
          var statusEl = document.createElement('div');
          statusEl.className = 'bb-mp-status';
          statusEl.id = 'bb-mp-status';
          statusEl.innerHTML = '<div class="bb-mp-dot"></div> <span id="bb-mp-position">0 people ahead of you</span>';
          intro.appendChild(statusEl);
        }
      }
      
      var myAvatarPreview = null;
      
      function applyCustomCursor() {
        var playerColor = PlayerCustomization.getColor();
        var playerSprite = PlayerCustomization.getSprite();
        var playerName = PlayerCustomization.getName();
        
        // Create SVG cursor with the player's color (native performance!)
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">' +
          '<path d="M5.65376 12.3673H5.46026L5.31717 12.4976L0.500002 16.8829L0.500002 1.19841L11.7841 12.3673H5.65376Z" ' +
          'fill="' + playerColor.bg + '" stroke="white" stroke-width="1"/>' +
          '</svg>';
        
        // Encode as data URI
        var encoded = 'data:image/svg+xml,' + encodeURIComponent(svg);
        
        // Apply to intro overlay (and body as fallback)
        var intro = document.getElementById('bb-intro-' + config.sectionId);
        var cursorCSS = 'url("' + encoded + '") 0 0, auto';
        
        if (intro) {
          intro.style.cursor = cursorCSS;
        }
        document.body.style.cursor = cursorCSS;
        
        // Also create a style element for hover states
        var styleEl = document.getElementById('bb-custom-cursor-style');
        if (!styleEl) {
          styleEl = document.createElement('style');
          styleEl.id = 'bb-custom-cursor-style';
          document.head.appendChild(styleEl);
        }
        styleEl.textContent = '.bb-intro-overlay, .bb-intro-overlay * { cursor: url("' + encoded + '") 0 0, auto !important; }';
        
        // Create/update avatar preview badge (interactive - click to customize!)
        if (!myAvatarPreview) {
          myAvatarPreview = document.createElement('div');
          myAvatarPreview.className = 'bb-my-avatar-preview';
          myAvatarPreview.id = 'bb-my-avatar-preview';
          document.body.appendChild(myAvatarPreview);
          
          // Make it interactive
          myAvatarPreview.addEventListener('click', function(e) {
            var target = e.target;
            
            // Click on sprite to change avatar
            if (target.classList.contains('bb-my-avatar-sprite')) {
              PlayerCustomization.cycleSprite();
              updateMyCursor();
              if (room) {
                room.updatePresence({
                  sprite: PlayerCustomization.getSprite()
                });
              }
            }
            
            // Click on color dot to change color
            if (target.classList.contains('bb-my-avatar-color')) {
              PlayerCustomization.cycleColor();
              updateMyCursor();
              if (room) {
                room.updatePresence({
                  color: PlayerCustomization.getColor()
                });
              }
            }
          });
        }
        
        myAvatarPreview.innerHTML = 
          '<div class="bb-my-avatar-sprite" title="Click to change avatar">' + playerSprite.emoji + '</div>' +
          '<div class="bb-my-avatar-info">' +
            '<div class="bb-my-avatar-name" style="background:' + playerColor.bg + ';color:' + playerColor.text + '">' + playerName + '</div>' +
            '<div class="bb-my-avatar-row">' +
              '<div class="bb-my-avatar-color" style="background:' + playerColor.bg + '" title="Click to change color"></div>' +
              '<div class="bb-my-avatar-label">Click to customize</div>' +
            '</div>' +
          '</div>';
        
        // Make sure it's visible during loading
        if (myStatus === 'loading') {
          myAvatarPreview.style.display = 'flex';
        }
        
        console.log('🎨 Applied custom cursor color:', playerColor.name, 'sprite:', playerSprite.name);
        console.log('🎭 Avatar preview created/updated:', myAvatarPreview);
      }
      
      function updateMyCursor() {
        // Update the native CSS cursor when color changes
        applyCustomCursor();
      }
      
      function hideMyAvatarPreview() {
        if (myAvatarPreview) {
          myAvatarPreview.style.display = 'none';
        }
      }
      
      function bindEvents() {
        document.addEventListener('mousemove', function(e) {
          // Only broadcast to others if connected (own cursor uses native CSS - zero lag!)
          if (!isActive || myStatus !== 'loading') return;
          
          // Normalize coordinates (0-1) for broadcasting to others
          var x = e.clientX / window.innerWidth;
          var y = e.clientY / window.innerHeight;
          
          if (room) {
            room.updatePresence({
              cursor: { x: x, y: y },
              status: myStatus
            });
          }
        });
        
        // Handle visibility change to stop broadcasting when tab hidden
        document.addEventListener('visibilitychange', function() {
          if (document.hidden && room) {
            // Optional: could clear cursor
          }
        });
      }
      
      function startRenderLoop() {
        console.log('🎬 Render loop DISABLED for debugging');
        return; // DISABLED FOR DEBUGGING
        function loop(time) {
          renderFrame(time);
          animationFrameId = requestAnimationFrame(loop);
        }
        animationFrameId = requestAnimationFrame(loop);
      }
      
      function renderFrame(time) {
        try {
          // Log once every 5 seconds to confirm loop is alive
          if (time - lastRenderTime > 5000) {
             console.log('🔄 Render loop heartbeat. Peers:', peerData.size, 'CursorLayer:', !!cursorLayer, 'AvatarLayer:', !!avatarLayer);
             lastRenderTime = time;
          }
          
          // Try to find/create layers if missing
          if (!avatarLayer) {
            // Append to bar container (not progress wrapper) so avatars stay aligned with the track
            var barContainer = document.querySelector('.bb-tier-bar-container');
            var progressWrapper = document.querySelector('.bb-tier-progress-wrapper');
            if (barContainer && progressWrapper) {
              avatarLayer = document.getElementById('bb-avatar-layer');
              if (!avatarLayer) {
                avatarLayer = document.createElement('div');
                avatarLayer.id = 'bb-avatar-layer';
                avatarLayer.className = 'bb-avatar-layer';
                barContainer.style.position = 'relative';
                barContainer.appendChild(avatarLayer);
                console.log('✅ Avatar layer created inside bar container');
                // Cache initial bar width - use full progress wrapper width for avatar movement
                avatarBarWidth = progressWrapper.offsetWidth || 300;
              }
            }
          }

          if (!cursorLayer && !avatarLayer) return;
          
          // Smooth interpolation factor (adjust for speed/smoothness)
          // 0.15 = snappy but smooth, 0.05 = very floaty
          const LERP_FACTOR = 0.2;
          // Local avatar uses higher lerp for more responsive feel
          const LOCAL_LERP_FACTOR = 0.35;
          
          // Render peers
          peerData.forEach((peer, connectionId) => {
            // Interpolate positions
            peer.currentX += (peer.x - peer.currentX) * LERP_FACTOR;
            peer.currentY += (peer.y - peer.currentY) * LERP_FACTOR;
            peer.currentAvatarX += (peer.avatarX - peer.currentAvatarX) * LERP_FACTOR;
            
            // Render Cursor (Loading Screen)
            if (peer.presence.status === 'loading' && cursorLayer) {
              renderPeerCursor(connectionId, peer);
            } else {
               // Hide cursor if playing
               if (peer.cursorEl) peer.cursorEl.style.display = 'none';
            }
            
            // Render Avatar (Progress Bar)
            if (peer.presence.status === 'playing' && avatarLayer) {
              renderPeerAvatar(connectionId, peer);
            } else {
               // Hide avatar if loading
               if (peer.avatarEl) peer.avatarEl.style.display = 'none';
            }
          });
          
          // Render MY Local Avatar with smooth interpolation
          if (myStatus === 'playing') {
            ensureMyAvatarExists();
            
            // Smooth interpolate toward target position
            myCurrentAvatarX += (myTargetAvatarX - myCurrentAvatarX) * LOCAL_LERP_FACTOR;
            
            // Update visual position using GPU-accelerated transform
            if (myProgressAvatar) {
              // Cap max position to account for avatar width (50px)
              var maxX = avatarBarWidth - 50;
              var xPos = myCurrentAvatarX * maxX;
              myProgressAvatar.style.transform = 'translate3d(' + xPos + 'px, 0, 0)';
            }
          }
        } catch (e) {
          console.error('🔴 Render Loop Error:', e);
        }
      }
      
      function renderPeerCursor(connectionId, peer) {
        // Use cached element if available to avoid DOM query
        var el = peer.cursorEl;
        
        if (!el) {
            // Try finding it or create it
            el = document.getElementById('cursor-' + connectionId);
            if (!el) {
                el = document.createElement('div');
                el.id = 'cursor-' + connectionId;
                el.className = 'bb-mp-cursor';
                // Only set innerHTML on creation
                var playerName = peer.presence.name || ('Player ' + (connectionId % 100));
                var playerColor = peer.presence.color || { bg: '#fe5f55', text: '#ffffff' };
                var playerSprite = peer.presence.sprite || { emoji: '🎴' };
                
                el.innerHTML = 
                    '<svg class="bb-mp-cursor-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path d="M5.65376 12.3673H5.46026L5.31717 12.4976L0.500002 16.8829L0.500002 1.19841L11.7841 12.3673H5.65376Z" fill="' + playerColor.bg + '" stroke="white"/>' +
                    '</svg>' +
                    '<div class="bb-mp-cursor-sprite">' + playerSprite.emoji + '</div>' +
                    '<div class="bb-mp-cursor-label" style="background:' + playerColor.bg + ';color:' + playerColor.text + '">' + playerName + '</div>';
                cursorLayer.appendChild(el);
            }
            peer.cursorEl = el; // Cache for next frame
        } else {
            el.style.display = 'block';
            
            // Only update DOM if data actually changed (optimization)
            // Use cached values in peer to track last rendered state
            if (peer.lastRenderedName !== peer.presence.name || 
                peer.lastRenderedColor !== peer.presence.color) {
                
                var playerName = peer.presence.name || ('Player ' + (connectionId % 100));
                var playerColor = peer.presence.color || { bg: '#fe5f55', text: '#ffffff' };
                var playerSprite = peer.presence.sprite || { emoji: '🎴' };
                
                var label = el.querySelector('.bb-mp-cursor-label');
                if (label) {
                    label.textContent = playerName;
                    label.style.background = playerColor.bg;
                    label.style.color = playerColor.text;
                }
                var path = el.querySelector('path');
                if (path) path.setAttribute('fill', playerColor.bg);
                var sprite = el.querySelector('.bb-mp-cursor-sprite');
                if (sprite) sprite.textContent = playerSprite.emoji;
                
                peer.lastRenderedName = peer.presence.name;
                peer.lastRenderedColor = peer.presence.color;
            }
        }
        
        var x = peer.currentX * window.innerWidth;
        var y = peer.currentY * window.innerHeight;
        el.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
      }
      
      function renderPeerAvatar(connectionId, peer) {
        var el = peer.avatarEl;
        
        var playerName = peer.presence.name || ('Player ' + (connectionId % 100));
        var playerColor = peer.presence.color || { bg: '#fe5f55', text: '#ffffff' };
        
        // Use tier sprite if available, otherwise fall back to base sprite
        var tierSprite = peer.presence.tierSprite;
        var displayEmoji = tierSprite ? tierSprite.emoji : (peer.presence.sprite ? peer.presence.sprite.emoji : '🥚');
        var displayScale = tierSprite ? tierSprite.scale : 1.0;
        
        if (!el) {
          if (!avatarLayer) return;
          // Try finding or create
          el = document.getElementById('avatar-' + connectionId);
          if (!el) {
              el = document.createElement('div');
              el.id = 'avatar-' + connectionId;
              el.className = 'bb-mp-avatar';
              el.style.willChange = 'transform'; // GPU hint
              el.innerHTML = '<div class="bb-mp-avatar-sprite" style="transform:scale(' + displayScale + ')">' + displayEmoji + '</div>' +
                '<div class="bb-mp-avatar-name" style="background:' + playerColor.bg + ';color:' + playerColor.text + '">' + playerName + '</div>';
              avatarLayer.appendChild(el);
          }
          peer.avatarEl = el; // Cache it
        } else {
          el.style.display = 'flex'; // Ensure visible
          
          // Update only if changed
          if (peer.lastRenderedEmoji !== displayEmoji || 
              peer.lastRenderedScale !== displayScale) {
              
              var spriteEl = el.querySelector('.bb-mp-avatar-sprite');
              if (spriteEl) {
                spriteEl.textContent = displayEmoji;
                spriteEl.style.transform = 'scale(' + displayScale + ')';
              }
              peer.lastRenderedEmoji = displayEmoji;
              peer.lastRenderedScale = displayScale;
          }
          
          if (peer.lastRenderedName !== playerName || 
              peer.lastRenderedColor !== playerColor) {
              
              var nameEl = el.querySelector('.bb-mp-avatar-name');
              if (nameEl) {
                nameEl.textContent = playerName;
                nameEl.style.background = playerColor.bg;
                nameEl.style.color = playerColor.text;
              }
              peer.lastRenderedName = playerName;
              peer.lastRenderedColor = playerColor;
          }
        }
        
        // Use cached bar width for performance, GPU-accelerated transform
        // Cap max position to account for avatar width (50px)
        var maxX = avatarBarWidth - 50;
        var xPos = peer.currentAvatarX * maxX;
        el.style.transform = 'translate3d(' + xPos + 'px, 0, 0)';
      }
      
      function ensureMyAvatarExists() {
        if (!avatarLayer) return;
        
        // Critical Fix: Check if myProgressAvatar is detached or missing
        if (!myProgressAvatar || !document.body.contains(myProgressAvatar)) {
          // Recreate it!
          console.log('🔧 Recreating detached local avatar');
          var playerName = PlayerCustomization.getName();
          var playerColor = PlayerCustomization.getColor();
          
          // Use tier sprite for evolved state
          var tierSprite = PlayerCustomization.getTierSprite();
          var displayEmoji = tierSprite ? tierSprite.emoji : '🥚';
          var displayScale = tierSprite ? tierSprite.scale : 1.0;
          
          // Remove old ref if it exists but is detached
          if (myProgressAvatar) myProgressAvatar.remove();
          
          myProgressAvatar = document.createElement('div');
          myProgressAvatar.id = 'bb-my-progress-avatar';
          myProgressAvatar.className = 'bb-mp-avatar bb-mp-avatar-me';
          // Add will-change hint for GPU compositing
          myProgressAvatar.style.willChange = 'transform';
          myProgressAvatar.innerHTML = 
            '<div class="bb-mp-avatar-sprite" style="transform:scale(' + displayScale + ')">' + displayEmoji + '</div>' +
            '<div class="bb-mp-avatar-name" style="background:' + playerColor.bg + ';color:' + playerColor.text + '">' + playerName + '</div>';
          avatarLayer.appendChild(myProgressAvatar);
          
          // Restore position immediately using GPU-accelerated transform
          // Cap max position to account for avatar width (50px)
          var maxX = avatarBarWidth - 50;
          var xPos = myCurrentAvatarX * maxX;
          myProgressAvatar.style.transform = 'translate3d(' + xPos + 'px, 0, 0)';
        }
      }
      
      // Removed old renderCursors and renderAvatars functions as they are replaced by the loop
      // keeping placeholder to avoid breaking calls if any remain
      function renderCursors() {} 
      function renderAvatars() {}
      
      function jumpMyAvatar() {
        if (!myProgressAvatar) return;
        
        // Broadcast the jump to others
        if (room) {
          room.broadcastEvent({
            type: 'PLAYER_JUMP',
            connectionId: room.getSelf().connectionId // Helper to ID who jumped
          });
        }
        
        // Local animation
        // Remove any existing jump class
        myProgressAvatar.classList.remove('bb-avatar-jump');
        
        // Force reflow to restart animation
        void myProgressAvatar.offsetWidth;
        
        // Add jump class
        myProgressAvatar.classList.add('bb-avatar-jump');
        
        // Remove class after animation
        setTimeout(function() {
          myProgressAvatar.classList.remove('bb-avatar-jump');
        }, 500);
      }
      
      function evolveMyAvatar(cardCount) {
        var result = PlayerCustomization.setTierFromCardCount(cardCount);
        
        // Check if tier actually changed (either up or down)
        var tierChanged = result.evolved || result.devolved;
        if (!tierChanged) return result;
        
        var tierSprite = result.sprite;
        
        // Update local avatar
        if (myProgressAvatar) {
          var spriteEl = myProgressAvatar.querySelector('.bb-mp-avatar-sprite');
          if (spriteEl) {
            // Add white flash BEFORE changing the sprite (Mario-style)
            myProgressAvatar.classList.remove('bb-avatar-evolve', 'bb-avatar-devolve', 'bb-avatar-legendary');
            void myProgressAvatar.offsetWidth; // Force reflow
            
            if (result.isFinalForm) {
              // LEGENDARY evolution - big flash!
              myProgressAvatar.classList.add('bb-avatar-legendary');
              console.log('🐉 LEGENDARY EVOLUTION! Stage:', result.stage);
            } else if (result.evolved) {
              // Evolution UP - white flash
              myProgressAvatar.classList.add('bb-avatar-evolve');
              console.log('⬆️ EVOLVED to stage', result.stage, tierSprite.name);
            } else if (result.devolved) {
              // Devolution DOWN - different animation
              myProgressAvatar.classList.add('bb-avatar-devolve');
              console.log('⬇️ DEVOLVED to stage', result.stage, tierSprite.name);
            }
            
            // Update sprite AFTER flash starts (50ms delay for dramatic effect)
            setTimeout(function() {
              spriteEl.textContent = tierSprite.emoji;
              spriteEl.style.transform = 'scale(' + tierSprite.scale + ')';
            }, 50);
          }
          
          // Remove animation class after it plays
          setTimeout(function() {
            myProgressAvatar.classList.remove('bb-avatar-evolve', 'bb-avatar-devolve', 'bb-avatar-legendary');
          }, result.isFinalForm ? 1500 : 600);
        }
        
        // Broadcast to others
        if (room) {
          room.updatePresence({ 
            tier: result.tier,
            stage: result.stage,
            tierSprite: tierSprite
          });
          
          // Broadcast event for the flash animation (both evolve and devolve)
          room.broadcastEvent({
            type: 'PLAYER_EVOLVE',
            connectionId: room.getSelf().connectionId,
            tier: result.tier,
            stage: result.stage,
            evolved: result.evolved,
            devolved: result.devolved,
            isFinalForm: result.isFinalForm,
            tierSprite: tierSprite
          });
        }
        
        return result;
      }
      
      // Throttle for network broadcasts (50ms = 20 updates/sec max)
      var lastBroadcastTime = 0;
      var pendingBroadcast = null;
      var BROADCAST_THROTTLE = 50;
      
      function updateAvatarPositionLocal(normalizedX) {
        // Just set the target - render loop will handle smooth interpolation
        myTargetAvatarX = Math.max(0, Math.min(1, normalizedX));
        myAvatarPosition = myTargetAvatarX; // Keep in sync for broadcasts
        
        // Throttled broadcast to others
        var now = Date.now();
        if (now - lastBroadcastTime >= BROADCAST_THROTTLE) {
          lastBroadcastTime = now;
          if (room) {
            room.updatePresence({ avatarX: myAvatarPosition });
          }
        } else if (!pendingBroadcast) {
          // Schedule a final broadcast to ensure we send the last position
          pendingBroadcast = setTimeout(function() {
            pendingBroadcast = null;
            lastBroadcastTime = Date.now();
            if (room) {
              room.updatePresence({ avatarX: myAvatarPosition });
            }
          }, BROADCAST_THROTTLE);
        }
      }
      
      // Keep old function for compatibility (calls local update)
      function updateAvatarPosition(normalizedX) {
        updateAvatarPositionLocal(normalizedX);
      }
      
      function updateStatusCount() {
        var countEl = document.getElementById('bb-mp-count');
        var positionEl = document.getElementById('bb-mp-position');
        
        if (countEl) {
          var position = QueueSystem.getPosition ? QueueSystem.getPosition() : 0;
          countEl.textContent = position;
        }
        
        if (positionEl) {
          var position = QueueSystem.getPosition ? QueueSystem.getPosition() : 0;
          positionEl.textContent = position === 0 ? "You're next!" : position + ' people ahead of you';
        }
      }
      
      function enterGame() {
        if (room) {
          myStatus = 'playing';
          room.updatePresence({
            cursor: null,
            status: 'playing',
            avatarX: 0.5
          });
          
          // Hide cursor layer and avatar preview
          if (cursorLayer) cursorLayer.style.display = 'none';
          hideMyAvatarPreview();
          var statusEl = document.getElementById('bb-mp-status');
          if (statusEl) statusEl.classList.add('hidden');
          
          // Reset cursor to default
          document.body.style.cursor = '';
          var styleEl = document.getElementById('bb-custom-cursor-style');
          if (styleEl) styleEl.textContent = '';
          
          // Start tracking mouse for avatar position and render my avatar on progress bar
          startAvatarTracking();
          renderAvatars(); // Create my avatar on progress bar immediately
        }
      }
      
      function startAvatarTracking() {
        // Use full progress wrapper for both tracking and positioning
        // Avatars should move across the entire wrapper width
        var progressWrapper = document.querySelector('.bb-tier-progress-wrapper');
        if (!progressWrapper) return;
        
        // Cache the rect and only update periodically (layout thrashing prevention)
        var cachedRect = progressWrapper.getBoundingClientRect();
        var lastRectUpdate = Date.now();
        
        // Update cached bar width on resize
        var updateBarWidth = function() {
          // Avatar width uses full progress wrapper width
          avatarBarWidth = progressWrapper.offsetWidth || 300;
          cachedRect = progressWrapper.getBoundingClientRect();
          lastRectUpdate = Date.now();
        };
        window.addEventListener('resize', updateBarWidth);
        updateBarWidth(); // Initial update
        
        function getRect() {
          var now = Date.now();
          if (now - lastRectUpdate > 500) { // Update rect every 500ms max
            cachedRect = progressWrapper.getBoundingClientRect();
            lastRectUpdate = now;
          }
          return cachedRect;
        }
        
        document.addEventListener('mousemove', function(e) {
          if (myStatus !== 'playing') return;
          
          var rect = getRect();
          var relativeX = (e.clientX - rect.left) / rect.width;
          relativeX = Math.max(0, Math.min(1, relativeX));
          updateAvatarPositionLocal(relativeX); // Just sets target, render loop handles visual
        });
        
        // Touch support
        document.addEventListener('touchmove', function(e) {
          if (myStatus !== 'playing' || !e.touches[0]) return;
          
          var rect = getRect();
          var relativeX = (e.touches[0].clientX - rect.left) / rect.width;
          relativeX = Math.max(0, Math.min(1, relativeX));
          updateAvatarPositionLocal(relativeX); // Just sets target, render loop handles visual
        });
      }
      
      function flyOff(savings) {
        // Animate current user's avatar flying off with savings message
        var progressWrapper = document.querySelector('.bb-tier-progress-wrapper');
        if (!progressWrapper || !avatarLayer) return;
        
        var playerName = PlayerCustomization.getName();
        var playerColor = PlayerCustomization.getColor();
        var playerSprite = PlayerCustomization.getSprite();
        var savingsAmount = savings || Math.floor(Math.random() * (507 - 92 + 1)) + 92;
        
        // Broadcast to others
        if (room) {
          room.broadcastEvent({
            type: 'PLAYER_FLY_OFF',
            name: playerName,
            color: playerColor,
            sprite: playerSprite,
            savings: savingsAmount,
            avatarX: myAvatarPosition
          });
        }
        
        // Create fly-off animation element
        createFlyOffAnimation(playerName, playerColor, playerSprite, savingsAmount, myAvatarPosition * progressWrapper.offsetWidth);
      }
      
      function createFlyOffAnimation(name, color, sprite, savings, xPos) {
        var progressWrapper = document.querySelector('.bb-tier-progress-wrapper');
        if (!progressWrapper) return;
        
        // Clamp position to keep notification on screen
        // Bubble is 200px min-width, centered via transform: translateX(-50%)
        // So we need 120px margin on each side to prevent clipping (half of 200px + padding)
        var wrapperWidth = progressWrapper.offsetWidth;
        var bubbleHalfWidth = 120; // Half of min-width (200px) + padding buffer
        var minX = bubbleHalfWidth;
        var maxX = wrapperWidth - bubbleHalfWidth;
        var clampedX = Math.max(minX, Math.min(maxX, xPos));
        
        var flyEl = document.createElement('div');
        flyEl.className = 'bb-mp-flyoff';
        flyEl.innerHTML = '<div class="bb-mp-flyoff-sprite">' + sprite.emoji + '</div>' +
          '<div class="bb-mp-flyoff-bubble" style="background:' + color.bg + ';color:' + color.text + '">' +
          name + ' saved <span class="bb-mp-flyoff-amount">£' + savings + '</span>!</div>';
        flyEl.style.left = clampedX + 'px';
        
        progressWrapper.appendChild(flyEl);
        
        // Convert to Twemoji for consistent emoji rendering
        if (window.twemoji) {
          window.twemoji.parse(flyEl, { folder: 'svg', ext: '.svg', className: 'twemoji' });
        }
        
        // Trigger animation
        requestAnimationFrame(function() {
          flyEl.classList.add('bb-mp-flyoff-animate');
        });
        
        // Remove after animation (5 seconds to give users time to see it)
        setTimeout(function() {
          flyEl.remove();
        }, 5000);
      }
      
      function updatePlayerCustomization() {
        if (room) {
          room.updatePresence({
            name: PlayerCustomization.getName(),
            color: PlayerCustomization.getColor(),
            sprite: PlayerCustomization.getSprite()
          });
          renderCursors(); // Re-render to show own cursor changes
        }
      }
      
      function getOthersCount() {
        return others.filter(function(u) { 
          return u.presence && u.presence.status === 'loading'; 
        }).length;
      }
      
      return {
        init: init,
        enterGame: enterGame,
        flyOff: flyOff,
        updatePlayerCustomization: updatePlayerCustomization,
        updateAvatarPosition: updateAvatarPosition,
        renderAvatars: renderAvatars,
        getOthersCount: getOthersCount,
        jumpMyAvatar: jumpMyAvatar,
        evolveMyAvatar: evolveMyAvatar
      };
    })();
    OLD INTERNAL CODE REMOVED - END */

    // ========================================================================
    // PERFORMANCE MONITOR
    // ========================================================================
    var Perf = {
      enabled: true,
      enable3DTilt: false, // DEFAULT OFF: Removed as requested for performance
      enableCardWave: true,
      enableShadows: true,
      enableFire: true,
      enableParticles: true,
      enableTextShake: true,
      fps: 60,
      lastFrameTime: performance.now(),
      frameCount: 0,
      lastFpsUpdate: 0,
      tier: 'high', // 'high', 'medium', 'low'
      isMobile: /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    };
    
    // Auto-detect performance tier on init
    function detectPerformanceTier() {
      // ========================================================================
      // IMMEDIATE iOS DETECTION: Set LOW tier instantly for iOS devices
      // This prevents canvas memory issues BEFORE any heavy resources are created
      // iOS Safari has a 384 MB canvas limit that causes immediate crashes
      // ========================================================================
      var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      
      // iOS Handling - Tier based on core count (proxy for device age)
      // iPhone 12+ = 6 cores, iPhone X/8 = 6 cores, iPhone 7 = 4 cores, older = 2 cores
      if (isIOS) {
        var cores = navigator.hardwareConcurrency || 2;
        
        if (cores >= 6) {
          // High-spec iOS (iPhone 8/X and newer with 6 cores)
          Perf.tier = 'high';
          Perf.enableShadows = false; // Shadows still expensive on mobile retina
          Perf.enableFire = true;
          Perf.enableParticles = true; // Particles ON for high-spec iOS!
          console.log('⚡ Performance Tier: HIGH (iOS ' + cores + ' cores - All effects ON)');
        } else if (cores >= 4) {
          // Medium-spec iOS (iPhone 7 and similar with 4 cores)
          Perf.tier = 'medium';
          Perf.enableShadows = false;
          Perf.enableFire = true;
          Perf.enableParticles = true; // Particles ON for medium iOS too
          console.log('⚡ Performance Tier: MEDIUM (iOS ' + cores + ' cores - Fire & Particles ON)');
        } else {
          // Low-spec/Older iOS (<4 cores)
          Perf.tier = 'low';
          Perf.enableCardWave = false;
          Perf.enableShadows = false;
          Perf.enableFire = false;
          Perf.enableParticles = false;
          Perf.enableTextShake = false;
          document.body.classList.add('bb-perf-low');
          console.log('⚡ Performance Tier: LOW (iOS ' + cores + ' cores - All effects OFF)');
        }
        
        toggleShadows(false);
        updatePerfControls();
        return; // Skip benchmark on iOS
      }
      
      // 1. Check for hardware concurrency (CPU cores)
      var cores = navigator.hardwareConcurrency || 4;
      
      // 2. Check for low-power mode / battery saver
      // (Slows down CPU, throttles requestAnimationFrame)
      var isLowPower = false;
      
      // 3. Simple GPU/FPS benchmark during loading
      // We run a quick loop to see if we can hit 60fps with a basic load
      var start = performance.now();
      var frames = 0;
      
      function bench() {
        frames++;
        if (performance.now() - start < 200) {
          requestAnimationFrame(bench);
        } else {
          // Analyze result after 200ms
          var fps = (frames * 1000) / (performance.now() - start);
          
          if (cores < 4 || fps < 40) {
            Perf.tier = 'low';
            Perf.enableCardWave = false; // Wave OFF for low tier
            Perf.enableShadows = false;  // Disable expensive shadows
            Perf.enableFire = false;     // Disable canvas fire
            Perf.enableParticles = false; // Disable particles
            Perf.enableTextShake = false; // Text shake OFF for low tier
            document.body.classList.add('bb-perf-low'); // Disable CSS effects
            toggleShadows(false);
            console.log('⚡ Performance Tier: LOW (All effects OFF)');
          } else if (fps < 55) {
            Perf.tier = 'medium';
            Perf.enableShadows = false;  // Shadows OFF for medium
            Perf.enableFire = true;      // Fire ON for medium tier
            Perf.enableParticles = true; // Particles ON for medium
            console.log('⚡ Performance Tier: MEDIUM (Fire & Particles ON)');
          } else {
            Perf.tier = 'high';
            console.log('⚡ Performance Tier: HIGH (All Effects ON)');
          }
          
          // Re-apply settings to UI controls if they exist
          updatePerfControls();
        }
      }
      
      requestAnimationFrame(bench);
    }
    
    // Run detection immediately (SYNCHRONOUS for iOS, async for others)
    detectPerformanceTier();

    window.BBPerf = Perf; // Expose globally

    function updatePerfControls() {
        // Sync checkboxes with detected tier
        var mapping = {
            'chk-perf-tilt': 'enable3DTilt',
            'chk-perf-wave': 'enableCardWave',
            'chk-perf-shadows': 'enableShadows',
            'chk-perf-fire': 'enableFire',
            'chk-perf-particles': 'enableParticles',
            'chk-perf-shake': 'enableTextShake'
        };
        
        for (var id in mapping) {
            var el = document.getElementById(id);
            if (el) el.checked = Perf[mapping[id]];
        }
    }

    // Track if we've logged the mobile skip message
    var mobileSkipLogged = false;
    
    function updateFPS() {
      // Skip FPS monitoring on mobile - saves CPU/battery
      if (Perf.isMobile) {
        if (!mobileSkipLogged) {
          console.log('⚡ FPS monitoring disabled on mobile');
          mobileSkipLogged = true;
        }
        return;
      }
      if (!Perf.enabled) return;
      var now = performance.now();
      Perf.frameCount++;
      
      if (now - Perf.lastFpsUpdate >= 1000) {
        Perf.fps = Math.round((Perf.frameCount * 1000) / (now - Perf.lastFpsUpdate));
        Perf.lastFpsUpdate = now;
        Perf.frameCount = 0;
        
        // Update live FPS display
        var fpsEl = document.getElementById('bb-perf-fps');
        if (fpsEl) {
          fpsEl.textContent = Perf.fps;
          fpsEl.style.color = Perf.fps < 30 ? '#ff4c4c' : (Perf.fps < 55 ? '#ffca28' : '#4ade80');
        }
        
        // Update benchmark report if results available
        var results = Perf.benchmarkResults;
        if (results) {
          var tierEl = document.getElementById('bb-perf-bench');
          var statusEl = document.getElementById('bb-bench-status');
          var avgEl = document.getElementById('bb-bench-avg');
          var minEl = document.getElementById('bb-bench-min');
          var maxEl = document.getElementById('bb-bench-max');
          var coresEl = document.getElementById('bb-bench-cores');
          var framesEl = document.getElementById('bb-bench-frames');
          
          if (tierEl) {
            var tier = (results.tier || 'pending').toUpperCase();
            tierEl.textContent = tier;
            tierEl.style.color = tier === 'HIGH' ? '#4ade80' : (tier === 'MEDIUM' ? '#ffca28' : (tier === 'LOW' ? '#ff4c4c' : '#888'));
          }
          if (statusEl) {
            statusEl.textContent = results.tier !== 'pending' ? 'Complete' : 'Measuring...';
            statusEl.style.color = results.tier !== 'pending' ? '#4ade80' : '#ffca28';
          }
          if (avgEl) avgEl.textContent = results.avgFps || '--';
          if (minEl) minEl.textContent = results.minFps || '--';
          if (maxEl) maxEl.textContent = results.maxFps || '--';
          if (coresEl) coresEl.textContent = results.cores || '--';
          if (framesEl) framesEl.textContent = results.frameCount || '--';
        }
      }
      requestAnimationFrame(updateFPS);
    }
    requestAnimationFrame(updateFPS);

    // Toggle CSS class for shadows/effects
    function toggleShadows(enabled) {
      if (enabled) {
        document.body.classList.remove('perf-no-shadows');
      } else {
        document.body.classList.add('perf-no-shadows');
      }
    }
    
    // Toggle fire effect
    function toggleFire(enabled) {
      if (window.balatroFireInstance) {
        if (enabled) {
          window.balatroFireInstance.resume();
        } else {
          window.balatroFireInstance.pause();
        }
      }
      if (window.balatroFireInstanceSavings) {
        if (enabled) {
          window.balatroFireInstanceSavings.resume();
        } else {
          window.balatroFireInstanceSavings.pause();
        }
      }
    }

    // Digital Upgrade Variant Mapping
    // Maps product title (from Step 1) to digital upgrade variant from the Video Library product
    // 
    // This map is populated DYNAMICALLY from Shopify variant data (see bb-upgrade-variants JSON)
    // The variant titles should match the deck names (e.g. "Storyteller Tactics")
    //
    // Fields populated for each entry:
    //   - variantId: Shopify variant ID for the video library variant
    //   - price: The variant's current selling price (in cents) - from Shopify
    //   - comparePrice: The variant's compare_at_price for strike-through display - from Shopify
    //   - title: Display title for the upgrade (e.g. "Storyteller Tactics Videos & Templates")
    //
    let DIGITAL_UPGRADE_MAP = {};
    
    // Build the upgrade map from Shopify variant data (called during init)
    function buildUpgradeMapFromShopify() {
      const upgradeDataEl = document.getElementById('bb-upgrade-variants-' + sectionId);
      
      if (!upgradeDataEl) {
        console.warn('[BB Upgrades] No upgrade variants JSON found. Make sure to select a Video Library product in the Upgrades step settings.');
        return;
      }
      
      try {
        const data = JSON.parse(upgradeDataEl.textContent);
        
        if (!data.variants || data.variants.length === 0) {
          console.warn('[BB Upgrades] Video Library product has no variants.');
          return;
        }
        
        // Build map from variants - variant title becomes the key (should match deck names)
        data.variants.forEach(function(variant) {
          // The variant title should match deck names like "Storyteller Tactics"
          const deckName = variant.title;
          
          DIGITAL_UPGRADE_MAP[deckName] = {
            variantId: String(variant.variantId),
            price: variant.price,
            comparePrice: variant.comparePrice,
            title: deckName + ' Videos & Templates',
            available: variant.available
          };
        });
        
        console.log('[BB Upgrades] Built upgrade map from Shopify data:', Object.keys(DIGITAL_UPGRADE_MAP).length, 'variants');
        
      } catch (e) {
        console.error('[BB Upgrades] Failed to parse upgrade variants JSON:', e);
      }
    }
    
    // Initialize upgrade map from Shopify data immediately
    buildUpgradeMapFromShopify();

    // ========================================================================
    // CAROUSEL STATE - Defined early so functions can access it
    // ========================================================================
    var carouselState = {
      track: null,
      grid: null,
      cards: [],
      isDragging: false,
      wasDragging: false, // Flag to prevent clicks after drag
      startX: 0,
      currentX: 0,
      translateX: 0,
      velocity: 0,
      lastX: 0,
      lastTime: 0,
      cardWidth: 0,
      gap: 40, // Gap between cards
      enabled: true,
      animationFrame: null,
      clickBlockTimeout: null, // Timeout for click blocking
      minX: 0, // Minimum translateX (right edge)
      maxX: 0, // Maximum translateX (left edge, always 0)
      // 3D Scroll Tilt Settings
      tiltMaxAngle: 25,      // Max rotation in degrees
      tiltDistance: 400,     // Pixel distance from center to reach max tilt
      tiltCurve: 1.0         // 1.0 = Linear, >1 = Ease In (flat center), <1 = Ease Out
    };

    // ========================================================================
    // SOUND SYSTEM - Now provided by bb-sound.js (modular)
    // See docs/modules/BB-SOUND.md for API reference
    // window.SoundSystem is set by bb-sound.js via BB.Sound
    // ========================================================================

    // State
    const state = {
      currentStep: 1,
      totalSteps: container.querySelectorAll('.bb-step-container').length,
      selectedProducts: [], // {variantId, productId, price, comparePrice, title, handle, type}
      selectedUpgrades: [],
      selectedAddons: [],
      selectedVault: [],
      selectedDigitalGoodies: [], // {variantId, productId, price, comparePrice, title, type}
      selectedPhysical: [], // Physical deck selections
      discountTier: 0,
      timerRemaining: config.timerDuration,
      timerInterval: null,
      bundleSessionId: generateSessionId(),
      upgradeMode: false, // True when in upgrade selection mode (between Step 1 and Step 2)
      detectedCompletePackages: [] // Complete Package bundles detected
    };
    
    // ========================================================================
    // COMPLETE PACKAGE DETECTION - Swap components for bundled product
    // ========================================================================
    const completePackageMappingsEl = document.getElementById('bb-complete-package-mappings-' + sectionId);
    const completePackageMappings = completePackageMappingsEl 
      ? JSON.parse(completePackageMappingsEl.textContent || '{"mappings":[]}').mappings.filter(function(m) { return m.deckName; })
      : [];
    
    console.log('[BB Complete Package] Loaded', completePackageMappings.length, 'mappings:', completePackageMappings.map(function(m) { return m.deckName; }));
    
    // ========================================================================
    // LOCAL STORAGE PERSISTENCE - Save/restore bundle selections
    // ========================================================================
    const STORAGE_KEY = 'bb_bundle_selections';
    const STORAGE_EXPIRY_HOURS = 24; // Clear saved selections after 24 hours
    
    function saveBundleToStorage() {
      try {
        const data = {
          timestamp: Date.now(),
          selectedProducts: state.selectedProducts,
          selectedUpgrades: state.selectedUpgrades,
          selectedAddons: state.selectedAddons,
          selectedVault: state.selectedVault,
          selectedDigitalGoodies: state.selectedDigitalGoodies,
          selectedPhysical: state.selectedPhysical || []
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        console.log('[BB Storage] Saved selections:', {
          products: state.selectedProducts.length,
          upgrades: state.selectedUpgrades.length,
          physical: (state.selectedPhysical || []).length,
          goodies: (state.selectedDigitalGoodies || []).length
        });
      } catch (e) {
        console.warn('[BB Storage] Failed to save:', e);
      }
    }
    
    function loadBundleFromStorage() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return false;
        
        const data = JSON.parse(stored);
        
        // Check if expired
        const hoursSinceStored = (Date.now() - data.timestamp) / (1000 * 60 * 60);
        if (hoursSinceStored > STORAGE_EXPIRY_HOURS) {
          console.log('[BB Storage] Stored selections expired, clearing');
          localStorage.removeItem(STORAGE_KEY);
          return false;
        }
        
        // Restore selections
        if (data.selectedProducts) state.selectedProducts = data.selectedProducts;
        if (data.selectedUpgrades) state.selectedUpgrades = data.selectedUpgrades;
        if (data.selectedAddons) state.selectedAddons = data.selectedAddons;
        if (data.selectedVault) state.selectedVault = data.selectedVault;
        if (data.selectedDigitalGoodies) state.selectedDigitalGoodies = data.selectedDigitalGoodies;
        if (data.selectedPhysical) state.selectedPhysical = data.selectedPhysical;
        
        console.log('[BB Storage] Restored selections:', {
          products: state.selectedProducts.length,
          upgrades: state.selectedUpgrades.length,
          physical: (state.selectedPhysical || []).length,
          goodies: (state.selectedDigitalGoodies || []).length
        });
        
        return state.selectedProducts.length > 0 || 
               (state.selectedPhysical && state.selectedPhysical.length > 0) ||
               (state.selectedDigitalGoodies && state.selectedDigitalGoodies.length > 0);
      } catch (e) {
        console.warn('[BB Storage] Failed to load:', e);
        return false;
      }
    }
    
    function clearBundleStorage() {
      localStorage.removeItem(STORAGE_KEY);
      console.log('[BB Storage] Cleared saved selections');
    }
    
    // Restore visual state of cards from saved selections
    function restoreSavedSelections() {
      const hasSelections = loadBundleFromStorage();
      if (!hasSelections) return;
      
      console.log('[BB Storage] Restoring visual state of cards...');
      
      // Wait for DOM to be ready
      setTimeout(function() {
        // Restore product card selections
        state.selectedProducts.forEach(function(product) {
          var card = container.querySelector('.bb-balatro-card[data-variant-id="' + product.variantId + '"]');
          if (card) {
            card.classList.add('selected');
            card.classList.remove('unselected');
            // Set checkmark to visible
            var checkmark = card.querySelector('.bb-card-checkmark');
            if (checkmark) {
              checkmark.style.opacity = '1';
              checkmark.style.transform = 'scale(1)';
            }
          }
        });
        
        // Update upgrade cards
        state.selectedUpgrades.forEach(function(upgrade) {
          var item = container.querySelector('.bb-upgrade-item[data-variant-id="' + upgrade.variantId + '"]');
          if (item) {
            item.classList.add('selected');
          }
        });
        
        // Update tier/avatar based on selection count
        if (state.selectedProducts.length > 0) {
          var newTier = Math.min(state.selectedProducts.length, 14);
          if (window.SoundSystem && window.SoundSystem.setTier) {
            window.SoundSystem.setTier(newTier);
          }
          if (window.BB && window.BB.Player && window.BB.Player.setTierFromCardCount) {
            window.BB.Player.setTierFromCardCount(state.selectedProducts.length);
          }
        }
        
        // Update calculations and UI
        updateCalculation();
        
        console.log('[BB Storage] Visual state restored');
      }, 500);
    }
    
    // ========================================================================
    // CARD STATE MANAGEMENT - Single source of truth for card states
    // Prevents race conditions and ensures consistency between CSS and logic
    // ========================================================================
    
    // Card state enum
    const CARD_STATE = {
      UNSELECTED: 'unselected',       // Not in cart
      SELECTED: 'selected',           // In cart (digital deck)
      UPGRADEABLE: 'upgradeable',     // Can be upgraded (in upgrade mode)
      UPGRADING: 'upgrading',         // Animation in progress
      UPGRADED: 'upgraded',           // Videos/templates added
      DOWNGRADING: 'downgrading'      // Downgrade animation in progress
    };
    
    // Map of card element -> state info
    const cardStateMap = new Map();
    
    // Animation lock - prevents any card interactions while true
    var isAnimationLocked = false;
    
    // Get card state (returns state object or null if not tracked)
    function getCardState(card) {
      return cardStateMap.get(card) || null;
    }
    
    // Set card state with validation
    function setCardState(card, newState, options) {
      options = options || {};
      var currentState = cardStateMap.get(card);
      var title = card.dataset.title || 'Unknown';
      
      // Create initial state if not exists
      if (!currentState) {
        currentState = {
          state: CARD_STATE.UNSELECTED,
          previousState: null,
          timestamp: Date.now()
        };
      }
      
      // Store previous state
      var prevState = currentState.state;
      
      // Update state
      currentState.previousState = prevState;
      currentState.state = newState;
      currentState.timestamp = Date.now();
      
      cardStateMap.set(card, currentState);
      
      console.log('[BB State] ' + title + ': ' + prevState + ' → ' + newState);
      
      // Sync CSS classes with state
      syncCardClasses(card, newState, options);
      
      return currentState;
    }
    
    // Sync CSS classes based on state (CSS is visual representation, not source of truth)
    function syncCardClasses(card, cardState, options) {
      // Remove all state classes first
      card.classList.remove(
        'selected', 'upgradeable', 'upgrade-mode', 'upgrade-charging',
        'upgrade-release', 'upgrade-complete', 'upgraded', 'upgrade-locked',
        'downgrading', 'deselecting'
      );
      
      // Apply classes based on state
      switch (cardState) {
        case CARD_STATE.UNSELECTED:
          // No classes needed
          break;
          
        case CARD_STATE.SELECTED:
          card.classList.add('selected');
          break;
          
        case CARD_STATE.UPGRADEABLE:
          card.classList.add('selected', 'upgrade-mode', 'upgradeable');
          break;
          
        case CARD_STATE.UPGRADING:
          card.classList.add('selected', 'upgrade-mode');
          // Animation class added separately by animation function
          break;
          
        case CARD_STATE.UPGRADED:
          card.classList.add('selected', 'upgrade-complete', 'upgraded');
          if (!state.upgradeMode) {
            card.classList.add('upgrade-locked');
          } else {
            card.classList.add('upgrade-mode');
          }
          break;
          
        case CARD_STATE.DOWNGRADING:
          card.classList.add('selected', 'downgrading');
          break;
      }
    }
    
    // Check if a card can be interacted with
    // Note: Global animation lock removed Dec 2024 to allow multiple simultaneous upgrades
    function canInteractWithCard(card) {
      var cardState = getCardState(card);
      if (!cardState) return true; // Untracked card, allow interaction
      
      // Block only THIS card during its animation state (allows other cards to be clicked)
      if (cardState.state === CARD_STATE.UPGRADING || 
          cardState.state === CARD_STATE.DOWNGRADING) {
        console.log('[BB State] BLOCKED: This card is in animation state');
        return false;
      }
      
      return true;
    }
    
    // Initialize card states from DOM (for page load / refresh)
    function initializeCardStates() {
      var allCards = container.querySelectorAll('.bb-balatro-card:not(.bb-carousel-clone)');
      allCards.forEach(function(card) {
        var initialState = CARD_STATE.UNSELECTED;
        
        if (card.classList.contains('upgrade-complete') || card.classList.contains('upgraded')) {
          initialState = CARD_STATE.UPGRADED;
        } else if (card.classList.contains('selected')) {
          initialState = CARD_STATE.SELECTED;
        }
        
        setCardState(card, initialState);
      });
      
      console.log('[BB State] Initialized ' + allCards.length + ' cards');
    }

    // DOM Elements
    const els = {
      container: container,
      queueScreen: container.querySelector('.bb-queue-screen'),
      queueCount: container.querySelector('.bb-queue-count'),
      header: container.querySelector('.bb-header'),
      main: container.querySelector('.bb-main'),
      footer: container.querySelector('.bb-sticky-footer'),
      timer: container.querySelector('.bb-timer-display'),
      timerValue: container.querySelector('.bb-timer-value'),
      tierFill: container.querySelector('.bb-tier-bar-fill-wrapper'),
      tierStatus: container.querySelector('.bb-tier-status'),
      tierNext: container.querySelector('.bb-tier-next'),
      tierPercentDisplay: container.querySelector('.bb-tier-percent-display'),
      tierPercentValue: container.querySelector('.bb-tier-percent-value'),
      tierPercentSuffix: container.querySelector('.bb-tier-percent-suffix'),
      tierPercentShadow: container.querySelector('.bb-tier-percent-shadow'),
      tierSavingsDisplay: container.querySelector('.bb-tier-savings-display'),
      tierSavingsValue: container.querySelector('.bb-tier-savings-value'),
      tierSavingsPrefix: container.querySelector('.bb-tier-savings-prefix'),
      tierSavingsShadow: container.querySelector('.bb-tier-savings-shadow'),
      tierItemsCount: container.querySelector('.bb-tier-items-count'),
      navPrices: container.querySelectorAll('.bb-nav-price'),
      navSubtotals: container.querySelectorAll('.bb-nav-subtotal'),
      subtotalValues: container.querySelectorAll('.bb-tier-subtotal-value'),
      navSavings: container.querySelectorAll('.bb-nav-savings'),
      navBtns: container.querySelectorAll('.bb-nav-btn-next'),
      stepContainers: container.querySelectorAll('.bb-step-container'),
      stepNavItems: container.querySelectorAll('.bb-step-item')
    };

    // ========================================================================
    // Shake Animation System (Re-implemented)
    // ========================================================================
    
    // ========================================================================
    // Shake Animation System - Dual Layer (Hover Wave + Tier Shake)
    // ========================================================================
    
    var shakeSettings = {
      hoverTravel: 1.7,
      hoverRotation: 0,
      hoverDuration: 4400,
      hoverStagger: 850,
      shakeSpeed: 105,
      cardTravel: 2,
      cardDuration: 3000,
      cardStagger: 2650,
      popScale: 1.6,
      popDuration: 200,
      popStagger: 50,
      originX: 50,
      originY: 60,
      showOrigin: false,
      fireSideFade: 0.31,
      fireFlameHeight: 0.42,
      fireScale: 0.05,
      fireSpeedY: 0.05,
      fireWobble: 0.05,
      fireThreshold: 1.2,
      fireDetail: 1.2,
      fireAperture: 0.11,
      fireSoftness: 0.143,
      fireAlpha: 1,
      fireColorTop: '#0093fe',
      fireColorMid: '#0093fe',
      fireColorBot: '#00ffff',
      fireOffsetX: 24,
      fireOffsetY: -171,
      fireWidth: 75,
      fireHeight: 195,
      
      // GLOBAL TEXT POSITION SETTINGS
      percentTextX: 0,
      percentTextY: 0,
      percentShadowX: 0,
      percentShadowY: 3,
      savingsTextX: -6,
      savingsTextY: -1,
      savingsShadowX: -2,
      savingsShadowY: 7
    };

    // Per-tier intensity presets for the SHAKE (jitter) effect
    // These values are applied ON TOP of the global hover/wave
    // Also includes light/glow intensity settings and fire effect settings
    var TIER_INTENSITY = {
      "0": {
        "shakeTravel": 0,
        "shakeRotation": 0.7,
        "shakeStagger": 0,
        "idleIntensity": 0.05,
        "hoverGlow": 0.15,
        "selectedGlow": 0.15,
        "selectedFlicker": 0.05,
        "hoverTravel": 1.1,
        "hoverRotation": 0,
        "hoverDuration": 5000,
        "hoverStagger": 850,
        "shakeSpeed": 105,
        "cardTravel": 1,
        "cardDuration": 5200,
        "cardStagger": 3050,
        "popScale": 1.6,
        "popDuration": 200,
        "popStagger": 50,
        "fireSideFade": 0,
        "fireFlameHeight": 0,
        "fireScale": 0,
        "fireSpeedY": 0,
        "fireWobble": 0,
        "fireThreshold": 0,
        "fireDetail": 0,
        "fireAperture": 0,
        "fireSoftness": 0,
        "fireAlpha": 0,
        "fireColorTop": "#0093fe",
        "fireColorMid": "#00ffff",
        "fireColorBot": "#00ffff",
        "fireOffsetX": 0,
        "fireOffsetY": -131,
        "fireWidth": 100,
        "fireHeight": 185,
        "savingsFireColorTop": "#ff4c40",
        "savingsFireColorMid": "#fea948",
        "savingsFireColorBot": "#feffda",
        "savingsFireOffsetX": 24,
        "savingsFireOffsetY": -171,
        "savingsFireWidth": 75,
        "savingsFireHeight": 195,
        "savingsBgColor": "#fb4c45",
        "savingsShadowColor": "#b02823",
        "percentTextX": 0,
        "percentTextY": 0,
        "percentShadowX": 0,
        "percentShadowY": 3,
        "savingsTextX": -6,
        "savingsTextY": -1,
        "savingsShadowX": -2,
        "savingsShadowY": 7
      },
      "1": {
        "shakeTravel": 0,
        "shakeRotation": 1,
        "shakeStagger": 10,
        "idleIntensity": 0.05,
        "hoverGlow": 0.15,
        "selectedGlow": 0.15,
        "selectedFlicker": 0.05,
        "hoverTravel": 1.2,
        "hoverRotation": 0,
        "hoverDuration": 4400,
        "hoverStagger": 850,
        "shakeSpeed": 105,
        "cardTravel": 2,
        "cardDuration": 3000,
        "cardStagger": 2650,
        "popScale": 1.6,
        "popDuration": 200,
        "popStagger": 50,
        "fireSideFade": 1.38,
        "fireFlameHeight": 0.09,
        "fireScale": 0.05,
        "fireSpeedY": 0.017,
        "fireWobble": 0.05,
        "fireThreshold": 1.12,
        "fireDetail": 1.1,
        "fireAperture": 0.16,
        "fireSoftness": 0.111,
        "fireAlpha": 1,
        "fireColorTop": "#0093fe",
        "fireColorMid": "#0093fe",
        "fireColorBot": "#00ffff",
        "fireOffsetX": 1,
        "fireOffsetY": -59,
        "fireWidth": 100,
        "fireHeight": 150,
        "savingsFireColorTop": "#ff4c40",
        "savingsFireColorMid": "#fea948",
        "savingsFireColorBot": "#feffda",
        "savingsFireOffsetX": -16,
        "savingsFireOffsetY": -59,
        "savingsFireWidth": 125,
        "savingsFireHeight": 150,
        "savingsBgColor": "#fb4c45",
        "savingsShadowColor": "#b02823",
        "percentTextX": 0,
        "percentTextY": 0,
        "percentShadowX": 0,
        "percentShadowY": 3,
        "savingsTextX": -6,
        "savingsTextY": -1,
        "savingsShadowX": -2,
        "savingsShadowY": 7
      },
      "2": {
        "shakeTravel": 0,
        "shakeRotation": 2.2,
        "shakeStagger": 55,
        "idleIntensity": 0.1,
        "hoverGlow": 0.25,
        "selectedGlow": 0.25,
        "selectedFlicker": 0.1,
        "hoverTravel": 1.7,
        "hoverRotation": 0,
        "hoverDuration": 4400,
        "hoverStagger": 850,
        "shakeSpeed": 105,
        "cardTravel": 2,
        "cardDuration": 3000,
        "cardStagger": 2650,
        "popScale": 1.6,
        "popDuration": 200,
        "popStagger": 50,
        "fireSideFade": 0.74,
        "fireFlameHeight": 0.21,
        "fireScale": 0.05,
        "fireSpeedY": 0.03,
        "fireWobble": 0.05,
        "fireThreshold": 1.16,
        "fireDetail": 1,
        "fireAperture": 0.23,
        "fireSoftness": 0.112,
        "fireAlpha": 1,
        "fireColorTop": "#0093fe",
        "fireColorMid": "#00ffff",
        "fireColorBot": "#00ffff",
        "fireOffsetX": -3,
        "fireOffsetY": -66,
        "fireWidth": 100,
        "fireHeight": 165,
        "savingsFireColorTop": "#ff4c40",
        "savingsFireColorMid": "#fea948",
        "savingsFireColorBot": "#feffda",
        "savingsFireOffsetX": -17,
        "savingsFireOffsetY": -78,
        "savingsFireWidth": 125,
        "savingsFireHeight": 195,
        "savingsBgColor": "#fb4c45",
        "savingsShadowColor": "#b02823",
        "percentTextX": 0,
        "percentTextY": 0,
        "percentShadowX": 0,
        "percentShadowY": 3,
        "savingsTextX": 0,
        "savingsTextY": 0,
        "savingsShadowX": 0,
        "savingsShadowY": 3
      },
      "3": {
        "shakeTravel": 0,
        "shakeRotation": 2.2,
        "shakeStagger": 55,
        "idleIntensity": 0.1,
        "hoverGlow": 0.25,
        "selectedGlow": 0.25,
        "selectedFlicker": 0.1,
        "hoverTravel": 1.7,
        "hoverRotation": 0,
        "hoverDuration": 4400,
        "hoverStagger": 850,
        "shakeSpeed": 105,
        "cardTravel": 2,
        "cardDuration": 3000,
        "cardStagger": 2650,
        "popScale": 1.6,
        "popDuration": 200,
        "popStagger": 50,
        "fireSideFade": 0.68,
        "fireFlameHeight": 0.37,
        "fireScale": 0.05,
        "fireSpeedY": 0.035,
        "fireWobble": 0.05,
        "fireThreshold": 1.13,
        "fireDetail": 1,
        "fireAperture": 0.23,
        "fireSoftness": 0.111,
        "fireAlpha": 1,
        "fireColorTop": "#0093fe",
        "fireColorMid": "#00ffff",
        "fireColorBot": "#00ffff",
        "fireOffsetX": -4,
        "fireOffsetY": -66,
        "fireWidth": 105,
        "fireHeight": 165,
        "savingsFireColorTop": "#ff4c40",
        "savingsFireColorMid": "#fea948",
        "savingsFireColorBot": "#feffda",
        "savingsFireOffsetX": -16,
        "savingsFireOffsetY": -59,
        "savingsFireWidth": 125,
        "savingsFireHeight": 150,
        "savingsBgColor": "#fb4c45",
        "savingsShadowColor": "#b02823",
        "percentTextX": 0,
        "percentTextY": 0,
        "percentShadowX": 0,
        "percentShadowY": 3,
        "savingsTextX": 0,
        "savingsTextY": 0,
        "savingsShadowX": 0,
        "savingsShadowY": 3
      },
      "4": {
        "shakeTravel": 0,
        "shakeRotation": 2.6,
        "shakeStagger": 65,
        "idleIntensity": 0.12,
        "hoverGlow": 0.3,
        "selectedGlow": 0.3,
        "selectedFlicker": 0.12,
        "hoverTravel": 1.7,
        "hoverRotation": 0,
        "hoverDuration": 4400,
        "hoverStagger": 850,
        "shakeSpeed": 105,
        "cardTravel": 2,
        "cardDuration": 3000,
        "cardStagger": 2650,
        "popScale": 1.6,
        "popDuration": 200,
        "popStagger": 50,
        "fireSideFade": 0.44,
        "fireFlameHeight": 0.38,
        "fireScale": 0.05,
        "fireSpeedY": 0.04,
        "fireWobble": 0.05,
        "fireThreshold": 1.02,
        "fireDetail": 1.1,
        "fireAperture": 0.23,
        "fireSoftness": 0.111,
        "fireAlpha": 1,
        "fireColorTop": "#0093fe",
        "fireColorMid": "#00ffff",
        "fireColorBot": "#00ffff",
        "fireOffsetX": -4,
        "fireOffsetY": -66,
        "fireWidth": 110,
        "fireHeight": 165,
        "savingsFireColorTop": "#ff4c40",
        "savingsFireColorMid": "#fea948",
        "savingsFireColorBot": "#feffda",
        "savingsFireOffsetX": -12,
        "savingsFireOffsetY": -60,
        "savingsFireWidth": 115,
        "savingsFireHeight": 150,
        "savingsBgColor": "#fb4c45",
        "savingsShadowColor": "#b02823",
        "percentTextX": 0,
        "percentTextY": 0,
        "percentShadowX": 0,
        "percentShadowY": 3,
        "savingsTextX": 0,
        "savingsTextY": 0,
        "savingsShadowX": 0,
        "savingsShadowY": 3
      },
      "5": {
        "shakeTravel": 0.8,
        "shakeRotation": 6.1,
        "shakeStagger": 55,
        "idleIntensity": 0.15,
        "hoverGlow": 0.4,
        "selectedGlow": 0.4,
        "selectedFlicker": 0.15,
        "hoverTravel": 1.7,
        "hoverRotation": 0,
        "hoverDuration": 4400,
        "hoverStagger": 850,
        "shakeSpeed": 105,
        "cardTravel": 2,
        "cardDuration": 3000,
        "cardStagger": 2650,
        "popScale": 1.6,
        "popDuration": 200,
        "popStagger": 50,
        "fireSideFade": 0.5,
        "fireFlameHeight": 0.36,
        "fireScale": 0.05,
        "fireSpeedY": 0.05,
        "fireWobble": 0.05,
        "fireThreshold": 1.2,
        "fireDetail": 1.2,
        "fireAperture": 0.11,
        "fireSoftness": 0.188,
        "fireAlpha": 1,
        "fireColorTop": "#0093fe",
        "fireColorMid": "#00ffff",
        "fireColorBot": "#00ffff",
        "fireOffsetX": -2,
        "fireOffsetY": -78,
        "fireWidth": 105,
        "fireHeight": 195,
        "savingsFireColorTop": "#ff4c40",
        "savingsFireColorMid": "#fea948",
        "savingsFireColorBot": "#feffda",
        "savingsFireOffsetX": -12,
        "savingsFireOffsetY": -60,
        "savingsFireWidth": 115,
        "savingsFireHeight": 150,
        "savingsBgColor": "#ff4c45",
        "savingsShadowColor": "#b02823",
        "percentTextX": 0,
        "percentTextY": 0,
        "percentShadowX": 0,
        "percentShadowY": 3,
        "savingsTextX": 0,
        "savingsTextY": 0,
        "savingsShadowX": 0,
        "savingsShadowY": 3
      }
    };

    var shakeState = {
      startTime: Date.now(),
      isPopping: false,
      popStartTime: 0,
      currentTierIndex: 0,  // Track current tier for debug panel
      // Cache DOM elements to prevent querySelectorAll every frame
      cachedPercentMain: [],
      cachedPercentShadow: [],
      cachedSavingsMain: [],
      cachedSavingsShadow: []
    };

    function cacheShakeElements() {
      // Only cache if elements exist (DOM ready)
      if (!els.tierPercentValue) return;
      
      // Helper to safely get array from querySelectorAll
      const getChars = (el) => el ? Array.from(el.querySelectorAll('.bb-char')) : [];
      
      // Cache PERCENT BOX chars
      const percentChars = getChars(els.tierPercentValue);
      const suffixChars = getChars(els.tierPercentSuffix);
      shakeState.cachedPercentMain = [...percentChars, ...suffixChars];
      shakeState.cachedPercentShadow = getChars(els.tierPercentShadow);
      
      // Cache SAVINGS BOX chars
      const savingsPrefixChars = getChars(els.tierSavingsPrefix);
      const savingsValueChars = getChars(els.tierSavingsValue);
      shakeState.cachedSavingsMain = [...savingsPrefixChars, ...savingsValueChars];
      shakeState.cachedSavingsShadow = getChars(els.tierSavingsShadow);
    }

    // PERFORMANCE FIX: Track if shake animation loop is running
    var shakeAnimationRunning = false;
    
    // Text shake animation for percentage display
    function updateShakeAnimation() {
      if (!els.tierPercentValue) {
        shakeAnimationRunning = false;
        return;
      }
      
      // Use cached elements - NO DOM QUERYING IN LOOP
      // Fallback to empty array if cache not yet populated
      const percentMainChars = shakeState.cachedPercentMain || [];
      const percentShadowChars = shakeState.cachedPercentShadow || [];
      const savingsMainChars = shakeState.cachedSavingsMain || [];
      const savingsShadowChars = shakeState.cachedSavingsShadow || [];
      
      const allMainChars = [...percentMainChars, ...savingsMainChars];
      
      // PERFORMANCE FIX: Stop loop if no chars to animate
      if (allMainChars.length === 0) {
        shakeAnimationRunning = false;
        return;  // Don't schedule next frame
      }

      const now = Date.now();
      const elapsed = now - shakeState.startTime;
      
      // Get current tier intensity
      const tierIndex = shakeState.currentTierIndex || 0;
      const tierIntensity = TIER_INTENSITY[tierIndex] || TIER_INTENSITY[0];
      
      // Check if pop animation is complete for all characters
      if (shakeState.isPopping) {
          const pStagger = tierIntensity.popStagger !== undefined ? tierIntensity.popStagger : shakeSettings.popStagger;
          const pDuration = tierIntensity.popDuration !== undefined ? tierIntensity.popDuration : shakeSettings.popDuration;
          const totalDuration = pDuration + (allMainChars.length * pStagger);
          
          if (now - shakeState.popStartTime > totalDuration) {
              shakeState.isPopping = false;
          }
      }

      // Animation function to apply transformations
      // index is relative to each box (starts at 0 for each box)
      function animateChar(char, index, allowPop, globalIndex) {
        // POP CALCULATION - uses globalIndex for staggered pop across all chars
        let scale = 1;
        if (allowPop && shakeState.isPopping) {
            const pStagger = tierIntensity.popStagger !== undefined ? tierIntensity.popStagger : shakeSettings.popStagger;
            const pDuration = tierIntensity.popDuration !== undefined ? tierIntensity.popDuration : shakeSettings.popDuration;
            const pScale = tierIntensity.popScale !== undefined ? tierIntensity.popScale : shakeSettings.popScale;
            
            const charPopStart = shakeState.popStartTime + (globalIndex * pStagger);
            const popElapsed = now - charPopStart;
            
            if (popElapsed >= 0 && popElapsed < pDuration) {
                const progress = popElapsed / pDuration;
                if (progress < 0.5) {
                    scale = 1 + (pScale - 1) * (progress * 2);
                } else {
                    scale = 1 + (pScale - 1) * (2 - progress * 2);
                }
            }
        }

        // LAYER 1: Global Hover Wave - uses local index so each box wave starts at 0
        const hStagger = tierIntensity.hoverStagger !== undefined ? tierIntensity.hoverStagger : shakeSettings.hoverStagger;
        const hDuration = tierIntensity.hoverDuration !== undefined ? tierIntensity.hoverDuration : shakeSettings.hoverDuration;
        const hTravel = tierIntensity.hoverTravel !== undefined ? tierIntensity.hoverTravel : shakeSettings.hoverTravel;
        const hRotation = tierIntensity.hoverRotation !== undefined ? tierIntensity.hoverRotation : shakeSettings.hoverRotation;
        
        const hoverTime = elapsed - (index * hStagger);
        const hoverY = Math.sin(2 * Math.PI * hoverTime / hDuration) * hTravel;
        const hoverR = Math.cos(2 * Math.PI * hoverTime / hDuration) * hRotation;
        
        // LAYER 2: Tier Shake Jitter - uses local index
        const sSpeed = tierIntensity.shakeSpeed !== undefined ? tierIntensity.shakeSpeed : shakeSettings.shakeSpeed;
        const shakeStagger = tierIntensity.shakeStagger || 0;
        const shakeTime = elapsed - (index * shakeStagger);
        
        // Only apply shake to main chars (allowPop=true), shadow chars only get wave
        let shakeY = 0;
        let shakeR = 0;
        
        if (allowPop) {
            shakeY = Math.sin(2 * Math.PI * shakeTime / sSpeed) * tierIntensity.shakeTravel;
            shakeR = Math.cos(2 * Math.PI * shakeTime / sSpeed) * tierIntensity.shakeRotation;
        }
        
        // Combine both layers
        const totalY = hoverY + shakeY;
        const totalR = hoverR + shakeR;
        
        // Apply transform
        char.style.transformOrigin = shakeSettings.originX + '% ' + shakeSettings.originY + '%';
        char.style.transform = 'translateY(' + totalY.toFixed(2) + 'px) rotate(' + totalR.toFixed(2) + 'deg) scale(' + scale.toFixed(2) + ')';
        
        // Debug origin
        if (shakeSettings.showOrigin) char.classList.add('show-origin');
        else char.classList.remove('show-origin');
        
        // Pass origin to CSS
        char.style.setProperty('--char-origin-x', shakeSettings.originX + '%');
        char.style.setProperty('--char-origin-y', shakeSettings.originY + '%');
      }

      // Animate Percent Box - Main Chars (with Pop, index starts at 0 for both wave and pop)
      percentMainChars.forEach((char, index) => animateChar(char, index, true, index));
      
      // Animate Percent Box - Shadow Chars (No Pop, index starts at 0)
      percentShadowChars.forEach((char, index) => animateChar(char, index, false, index));
      
      // Animate Savings Box - Main Chars (with Pop, index starts at 0 for BOTH wave AND pop - local to box)
      savingsMainChars.forEach((char, index) => animateChar(char, index, true, index));
      
      // Animate Savings Box - Shadow Chars (No Pop, index starts at 0)
      savingsShadowChars.forEach((char, index) => animateChar(char, index, false, index));

      requestAnimationFrame(updateShakeAnimation);
    }

    // Helper to start/restart shake animation
    function startShakeAnimation() {
      if (!shakeAnimationRunning && Perf.enableTextShake) {
        shakeAnimationRunning = true;
        requestAnimationFrame(updateShakeAnimation);
      }
    }
    
    // Expose globally for re-enabling
    window._restartShakeAnimation = startShakeAnimation;
    
    // Start the loop (if enabled)
    if (Perf.enableTextShake) {
      shakeAnimationRunning = true;
      requestAnimationFrame(updateShakeAnimation);
    }

    // Card Wave Animation Loop + Scroll Tilt
    // PERFORMANCE FIX: Track if card wave animation loop is running
    var cardWaveAnimationRunning = false;
    
    // TEMPORARILY DISABLED FOR PERFORMANCE DEBUGGING
    function updateCardWave() {
        cardWaveAnimationRunning = false;
        return; // DISABLED
        
        const now = Date.now();
        // Use cached cards to prevent DOM thrashing
        const cards = carouselState.cards || [];
        
        // Get current tier settings
        const tierIndex = shakeState.currentTierIndex || 0;
        const tierIntensity = TIER_INTENSITY[tierIndex] || TIER_INTENSITY[0];
        
        // Use GLOBAL settings for card wave (no tier override)
        const cTravel = shakeSettings.cardTravel;
        const cDuration = shakeSettings.cardDuration;
        const cStagger = shakeSettings.cardStagger;
        
        // Use cached viewport center (updated on resize)
        var viewportCenter = carouselState.viewportCenter || 0;
        
        cards.forEach(function(card, index) {
            // SCROLL TILT LOGIC (Coverflow-lite)
            var rotateY = 0;
            
            if (Perf.enable3DTilt) {
                // Apply tilt based on distance from center active slot
                // 1. Calculate card center visual position
                // Use cached cardWidth to prevent layout thrashing
                var cardWidth = carouselState.cardWidth || 140; 
                var gap = carouselState.gap || 40;
                var cardTrackX = index * (cardWidth + gap) + (cardWidth / 2);
                var visualX = cardTrackX + carouselState.translateX;
                
                // 2. Distance from center (negative = left of center, positive = right of center)
                var dist = visualX - viewportCenter;
                
                // 3. Calculate Rotation Y
                // "Right side tilts upwards towards viewer" -> if dist > 0 (right), rotateY should be NEGATIVE
                // Max rotation ~20deg at ~300px distance
                var maxTilt = carouselState.tiltMaxAngle !== undefined ? carouselState.tiltMaxAngle : 25;
                var tiltDistance = carouselState.tiltDistance || 400; // Distance at which max tilt is reached
                var curve = carouselState.tiltCurve || 1;
                
                // Apply tilt if we have a valid viewport center
                if (viewportCenter > 0) {
                    // Normalize distance (-1 to 1 based on tiltDistance)
                    var normDist = Math.max(-1, Math.min(1, dist / tiltDistance));
                    
                    // Apply curve (preserve sign)
                    var sign = Math.sign(normDist);
                    var factor = sign * Math.pow(Math.abs(normDist), curve);
                    
                    // If dist > 0 (Right), factor > 0 -> rotateY should be negative
                    rotateY = -factor * maxTilt;
                }
            }
            
            // Skip wave animation for upgraded/upgrade states - let CSS handle their elevated position
            var isUpgradeState = card.classList.contains('upgrade-charging') || 
                                 card.classList.contains('upgrade-release') || 
                                 card.classList.contains('upgrade-complete') || 
                                 card.classList.contains('upgraded');
            
            if (isUpgradeState) {
                // Don't apply any inline transform - let CSS handle the elevated position
                card.style.transform = '';
            } else if (!card.matches(':hover') && !card.classList.contains('active-slot') && !card.classList.contains('clicking')) {
                // Only apply floating wave if NOT hovered and NOT clicking (click animation needs clean transform)
                const offset = parseFloat(card.dataset.waveOffset) || 0;
                const staggerTime = offset * cStagger;
                const time = now - staggerTime;
                
                // Simple sine wave float
                const y = Perf.enableCardWave ? Math.sin(2 * Math.PI * time / cDuration) * cTravel : 0;
                
                // Apply float transform
                // Note: We use CSS variables for rotation so they compose with 3D effect css
                card.style.transform = 'translateY(' + y.toFixed(2) + 'px)';
                
                // Apply Scroll Tilt to CSS variable (only if not active slot, active slot is flat)
                // We update this continuously so it animates smoothly
                card.style.setProperty('--rotate-y', rotateY.toFixed(2) + 'deg');
                
                // Also set rotate-x to 0 to reset any residual mouse effect
                card.style.setProperty('--rotate-x', '0deg');
                
            } else if (card.classList.contains('clicking')) {
                // During click animation, clear inline transform so CSS animation can apply
                card.style.transform = '';
            } else if (card.classList.contains('active-slot')) {
                // Active slot: No float, flat rotation (0deg) unless interacted
                // If mouse hovering on desktop, CSS :hover handles it
                // If not hovered (mobile touch), ensure it's flat
                if (!card.matches(':hover')) {
                    card.style.transform = '';
                    card.style.setProperty('--rotate-y', '0deg');
                    card.style.setProperty('--rotate-x', '0deg');
                }
                // If hovered, let mouse listeners handle --rotate variables
            } else {
                // Hovered but not active slot (desktop rare case): Let CSS/Mouse handle it
                card.style.transform = '';
            }
        });
        
        requestAnimationFrame(updateCardWave);
    }
    
    // Helper to start/restart card wave animation
    function startCardWaveAnimation() {
      if (!cardWaveAnimationRunning && (Perf.enableCardWave || Perf.enable3DTilt)) {
        cardWaveAnimationRunning = true;
        requestAnimationFrame(updateCardWave);
      }
    }
    
    // Expose globally for re-enabling
    window._restartCardWaveAnimation = startCardWaveAnimation;

    function renderDebugPanel() {
        var tierIndex = shakeState.currentTierIndex || 0;
        var tierIntensity = TIER_INTENSITY[tierIndex] || TIER_INTENSITY[0];
        
        // ===== LOCALSTORAGE KEYS =====
        var LS_PANEL_POS = 'bb_debug_panel_pos';
        var LS_PANEL_SIZE = 'bb_debug_panel_size';
        var LS_COLLAPSED = 'bb_debug_collapsed';
        var LS_FIRE_TAB = 'bb_debug_fire_tab';
        var LS_TIER_SETTINGS = 'bb_debug_tier_settings';
        
        // Load saved state
        var savedPos = JSON.parse(localStorage.getItem(LS_PANEL_POS) || 'null');
        var savedSize = JSON.parse(localStorage.getItem(LS_PANEL_SIZE) || 'null');
        var savedCollapsed = JSON.parse(localStorage.getItem(LS_COLLAPSED) || '{}');
        var savedFireTab = localStorage.getItem(LS_FIRE_TAB) || 'discount';
        
        // Load saved tier settings into TIER_INTENSITY
        var savedTierSettings = JSON.parse(localStorage.getItem(LS_TIER_SETTINGS) || 'null');
        if (savedTierSettings) {
            Object.keys(savedTierSettings).forEach(function(key) {
                TIER_INTENSITY[key] = savedTierSettings[key];
            });
            tierIntensity = TIER_INTENSITY[tierIndex] || TIER_INTENSITY[0];
        }
        
        // Track original values for change detection
        var originalValues = JSON.parse(JSON.stringify(TIER_INTENSITY));
        
        const panel = document.createElement('div');
        panel.className = 'bb-debug-panel minimized'; // Start minimized by default
        
        // Position panel absolutely within the fixed container
        panel.style.position = 'absolute';
        panel.style.right = '20px';
        panel.style.top = '80px';
        panel.style.left = 'auto';
        panel.style.bottom = 'auto';
        
        // Apply saved size
        if (savedSize) {
            panel.style.width = savedSize.width + 'px';
            panel.style.height = savedSize.height + 'px';
        }
        
        // Helper to create control row HTML
        function ctrl(label, inputId, sliderId, value, min, max, step, unit) {
            unit = unit || '';
            return '<div class="bb-debug-control-row">' +
                '<div class="bb-debug-control-label"><span>' + label + '</span><span class="bb-debug-control-value" id="val-' + inputId + '">' + value + unit + '</span></div>' +
                '<div class="bb-debug-control-input">' +
                '<input type="range" id="' + sliderId + '" min="' + min + '" max="' + max + '" step="' + step + '" value="' + value + '">' +
                '<input type="number" id="' + inputId + '" min="' + min + '" max="' + max + '" step="' + step + '" value="' + value + '">' +
                '</div></div>';
        }
        
        // Helper for color control
        function colorCtrl(label, inputId, value) {
            return '<div class="bb-debug-color-row"><label>' + label + '</label><input type="color" id="' + inputId + '" value="' + value + '"></div>';
        }
        
        // Helper for section with collapse (used inside categories)
        function section(id, icon, title, color, content) {
            var collapsed = savedCollapsed[id] ? ' collapsed' : '';
            return '<div class="bb-debug-section' + collapsed + '" data-section-id="' + id + '">' +
                '<div class="bb-debug-section-header">' +
                '<div class="bb-debug-section-title" style="color: ' + color + '"><span class="icon">' + icon + '</span>' + title + '</div>' +
                '<span class="bb-debug-section-chevron">▼</span></div>' +
                '<div class="bb-debug-section-body">' + content + '</div></div>';
        }
        
        // Helper for category with nested tabs
        function category(id, icon, title, tabs) {
            var collapsed = savedCollapsed['cat-' + id] ? ' collapsed' : '';
            var activeTab = localStorage.getItem('bb_debug_cat_' + id + '_tab') || Object.keys(tabs)[0];
            
            var tabsHtml = '<div class="bb-debug-nested-tabs">';
            var contentsHtml = '';
            
            Object.keys(tabs).forEach(function(tabId) {
                var tab = tabs[tabId];
                var isActive = tabId === activeTab;
                tabsHtml += '<button class="bb-debug-nested-tab' + (isActive ? ' active' : '') + '" data-cat="' + id + '" data-tab="' + tabId + '">' + tab.label + '</button>';
                contentsHtml += '<div class="bb-debug-nested-content' + (isActive ? ' active' : '') + '" data-cat="' + id + '" data-tab-content="' + tabId + '">' + tab.content + '</div>';
            });
            
            tabsHtml += '</div>';
            
            return '<div class="bb-debug-category' + collapsed + '" data-category-id="' + id + '">' +
                '<div class="bb-debug-category-header">' +
                '<div class="bb-debug-category-title"><span class="icon">' + icon + '</span>' + title + '</div>' +
                '<span class="bb-debug-category-chevron">▼</span></div>' +
                '<div class="bb-debug-category-body">' + tabsHtml + contentsHtml + '</div></div>';
        }
        
        // Helper for simple category (no nested tabs, just content)
        function simpleCategory(id, icon, title, content) {
            var collapsed = savedCollapsed['cat-' + id] ? ' collapsed' : '';
            return '<div class="bb-debug-category' + collapsed + '" data-category-id="' + id + '">' +
                '<div class="bb-debug-category-header">' +
                '<div class="bb-debug-category-title"><span class="icon">' + icon + '</span>' + title + '</div>' +
                '<span class="bb-debug-category-chevron">▼</span></div>' +
                '<div class="bb-debug-category-body" style="padding: 12px 14px;">' + content + '</div></div>';
        }
        
        // Fire controls - shared between tabs (uses current tab prefix)
        function fireControls(prefix, ti, isDiscount) {
            var firePrefix = isDiscount ? 'fire' : 'savingsFire';
            var colorTop = isDiscount ? (ti.fireColorTop || '#0093fe') : (ti.savingsFireColorTop || '#ff4c40');
            var colorMid = isDiscount ? (ti.fireColorMid || '#00ffff') : (ti.savingsFireColorMid || '#fea948');
            var colorBot = isDiscount ? (ti.fireColorBot || '#00ffff') : (ti.savingsFireColorBot || '#feffda');
            var offsetX = isDiscount ? (ti.fireOffsetX || 0) : (ti.savingsFireOffsetX || 0);
            var offsetY = isDiscount ? (ti.fireOffsetY || -131) : (ti.savingsFireOffsetY || -131);
            var width = isDiscount ? (ti.fireWidth || 100) : (ti.savingsFireWidth || 100);
            var height = isDiscount ? (ti.fireHeight || 185) : (ti.savingsFireHeight || 185);
            
            return '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Flame Shape</div>' +
                ctrl('Flame Height', prefix + '-fire-height', 'slider-' + prefix + '-fire-height', ti.fireFlameHeight || 0.3, 0, 1.5, 0.01) +
                ctrl('Noise Scale', prefix + '-fire-scale', 'slider-' + prefix + '-fire-scale', ti.fireScale || 0.05, 0.01, 2, 0.01) +
                ctrl('Speed Y', prefix + '-fire-speed', 'slider-' + prefix + '-fire-speed', ti.fireSpeedY || 0.03, -0.2, 0.2, 0.001) +
                ctrl('Wobble', prefix + '-fire-wobble', 'slider-' + prefix + '-fire-wobble', ti.fireWobble || 0.05, 0, 1, 0.01) +
                ctrl('Threshold', prefix + '-fire-threshold', 'slider-' + prefix + '-fire-threshold', ti.fireThreshold || 1.1, 0, 1.2, 0.01) +
                ctrl('Detail', prefix + '-fire-detail', 'slider-' + prefix + '-fire-detail', ti.fireDetail || 1.1, 0.1, 5, 0.1) +
                ctrl('Aperture', prefix + '-fire-aperture', 'slider-' + prefix + '-fire-aperture', ti.fireAperture || 0.2, 0, 2, 0.01) +
                ctrl('Softness', prefix + '-fire-softness', 'slider-' + prefix + '-fire-softness', ti.fireSoftness || 0.1, 0.001, 1, 0.001) +
                ctrl('Side Fade', prefix + '-fire-sidefade', 'slider-' + prefix + '-fire-sidefade', ti.fireSideFade || 0.3, 0, 1.5, 0.01) +
                ctrl('Alpha', prefix + '-fire-alpha', 'slider-' + prefix + '-fire-alpha', ti.fireAlpha || 1, 0, 1, 0.01) +
                '</div><div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Colors</div>' +
                colorCtrl('Top', prefix + '-color-top', colorTop) +
                colorCtrl('Middle', prefix + '-color-mid', colorMid) +
                colorCtrl('Bottom', prefix + '-color-bot', colorBot) +
                '</div><div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Position</div>' +
                ctrl('X Offset', prefix + '-offset-x', 'slider-' + prefix + '-offset-x', offsetX, -100, 100, 1, 'px') +
                ctrl('Y Offset', prefix + '-offset-y', 'slider-' + prefix + '-offset-y', offsetY, -200, 50, 1, 'px') +
                ctrl('Width', prefix + '-width', 'slider-' + prefix + '-width', width, 50, 300, 5, '%') +
                ctrl('Height', prefix + '-height', 'slider-' + prefix + '-height', height, 50, 300, 5, '%') +
                '</div>';
        }
        
        // Build sound mixer content
        function buildSoundMixer() {
            var sounds = window.BundleBuilderSounds || {};
            var actions = sounds.actions || ['card-select', 'card-deselect', 'physical-add', 'physical-remove', 'goodies-add', 'goodies-remove', 'checkout-click', 'hover-card', 'button-click', 'progress-grow', 'deck-light', 'number-tick', 'upgrade-slam', 'upgrade-sequence', 'spark-burst', 'checkmark-land', 'tier-unlock', 'ambient-loop'];
            var html = '<div class="bb-debug-subsection-title">Volume Mixer</div>';
            
            actions.forEach(function(action) {
                var savedVol = parseFloat(localStorage.getItem('bb_sound_vol_' + action) || '100');
                html += '<div class="bb-sound-mixer-item">' +
                    '<span class="bb-sound-mixer-name">' + action + '</span>' +
                    '<div class="bb-sound-mixer-controls">' +
                    '<input type="range" class="sound-vol-slider" data-sound="' + action + '" min="0" max="100" value="' + savedVol + '" style="width: 80px;">' +
                    '<span class="bb-debug-control-value" id="vol-' + action + '">' + savedVol + '%</span>' +
                    '<button class="bb-sound-preview-btn" data-sound="' + action + '" title="Preview">▶</button>' +
                    '</div></div>';
            });
            
            return html;
        }
        
        // Build sound upload content
        function buildSoundUpload() {
            return '<div class="bb-debug-subsection-title">Upload Test Sounds</div>' +
                '<p style="font-size: 10px; color: #888; margin-bottom: 10px;">Upload sounds locally to test before committing to Strapi.</p>' +
                '<div class="bb-sound-upload-zone" id="sound-upload-zone">' +
                '<div class="bb-sound-upload-icon">🎵</div>' +
                '<div class="bb-sound-upload-text">Drop audio file here</div>' +
                '<div class="bb-sound-upload-hint">or click to browse</div>' +
                '<input type="file" id="sound-file-input" accept="audio/*" style="display: none;">' +
                '</div>' +
                '<div class="bb-sound-list" id="uploaded-sounds-list"></div>';
        }
        
        // Build sound preview content
        function buildSoundPreview() {
            var sounds = window.BundleBuilderSounds || {};
            var actions = sounds.actions || ['card-select', 'card-deselect', 'physical-add', 'physical-remove', 'goodies-add', 'goodies-remove', 'checkout-click', 'hover-card', 'button-click', 'progress-grow', 'deck-light', 'number-tick', 'upgrade-slam', 'upgrade-sequence', 'spark-burst', 'checkmark-land', 'tier-unlock', 'ambient-loop'];
            var html = '<div class="bb-debug-subsection-title">Preview All Sounds</div>' +
                '<p style="font-size: 10px; color: #888; margin-bottom: 10px;">Click to preview each sound effect.</p>' +
                '<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px;">';
            
            actions.forEach(function(action) {
                // Skip ambient-loop in grid (has its own control)
                if (action === 'ambient-loop') return;
                html += '<button class="bb-sound-preview-action" data-sound="' + action + '" style="padding: 8px; font-size: 9px; text-align: left;">' +
                    '▶ ' + action + '</button>';
            });
            
            html += '</div>' +
                '<div style="margin-top: 12px;">' +
                '<button id="btn-play-all-sounds" style="width: 100%;">🔊 Play All Sounds Sequence</button>' +
                '</div>' +
                '<div style="margin-top: 16px; padding-top: 12px; border-top: 1px solid #333;">' +
                '<div class="bb-debug-subsection-title">Ambient Loop</div>' +
                '<p style="font-size: 10px; color: #888; margin-bottom: 10px;">Background music that loops continuously.</p>' +
                '<button id="btn-toggle-ambient" style="width: 100%; padding: 10px;">🎵 Start Ambient Loop</button>' +
                '</div>';
            
            return html;
        }
        
        panel.innerHTML = 
            '<div class="bb-debug-header">' +
                '<div class="bb-debug-header-left">' +
                    '<span class="bb-debug-header-title">Debug Controls</span>' +
                    '<span class="bb-debug-tier-badge">TIER <span id="debug-tier">' + tierIndex + '</span></span>' +
                '</div>' +
                '<div class="bb-debug-header-right">' +
                    '<div class="bb-debug-autosave-indicator" id="autosave-indicator">✓ Auto-saved</div>' +
                    '<div class="bb-debug-unsaved-dot" id="unsaved-dot" title="Unsaved changes"></div>' +
                    '<button class="bb-minimize-btn" id="btn-minimize" title="Expand">+</button>' +
                '</div>' +
            '</div>' +
            '<div class="bb-debug-lock-bar">' +
                '<label class="bb-debug-lock-toggle">' +
                    '<input type="checkbox" id="chk-lock-all-tiers">' +
                    '<span class="bb-debug-lock-label">🔒 Apply to ALL Tiers</span>' +
                '</label>' +
                '<button id="btn-copy-to-all" class="bb-debug-copy-all-btn">Copy → All</button>' +
            '</div>' +
            '<div class="bb-debug-content">' +
            
            // ===== BALATRO CATEGORY =====
            category('balatro', '🎰', 'Balatro', {
                'textpos': {
                    label: 'Text Position',
                    content: '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">% OFF Display</div>' +
                        ctrl('Text X', 'input-percent-text-x', 'slider-percent-text-x', shakeSettings.percentTextX !== undefined ? shakeSettings.percentTextX : 0, -20, 20, 1, 'px') +
                        ctrl('Text Y', 'input-percent-text-y', 'slider-percent-text-y', shakeSettings.percentTextY !== undefined ? shakeSettings.percentTextY : 0, -20, 20, 1, 'px') +
                        ctrl('Shadow X', 'input-percent-shadow-x', 'slider-percent-shadow-x', shakeSettings.percentShadowX !== undefined ? shakeSettings.percentShadowX : 0, -10, 10, 1, 'px') +
                        ctrl('Shadow Y', 'input-percent-shadow-y', 'slider-percent-shadow-y', shakeSettings.percentShadowY !== undefined ? shakeSettings.percentShadowY : 3, -10, 20, 1, 'px') +
                        '</div>' +
                        '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Savings Display</div>' +
                        ctrl('Text X', 'input-savings-text-x', 'slider-savings-text-x', shakeSettings.savingsTextX !== undefined ? shakeSettings.savingsTextX : -6, -20, 20, 1, 'px') +
                        ctrl('Text Y', 'input-savings-text-y', 'slider-savings-text-y', shakeSettings.savingsTextY !== undefined ? shakeSettings.savingsTextY : -1, -20, 20, 1, 'px') +
                        ctrl('Shadow X', 'input-savings-shadow-x', 'slider-savings-shadow-x', shakeSettings.savingsShadowX !== undefined ? shakeSettings.savingsShadowX : -2, -10, 10, 1, 'px') +
                        ctrl('Shadow Y', 'input-savings-shadow-y', 'slider-savings-shadow-y', shakeSettings.savingsShadowY !== undefined ? shakeSettings.savingsShadowY : 7, -10, 20, 1, 'px') +
                        '</div>'
                },
                'flames': {
                    label: 'Flames',
                    content: '<div class="bb-debug-tabs">' +
                        '<button class="bb-debug-tab both-tab' + (savedFireTab === 'both' ? ' active' : '') + '" data-tab="both">Both</button>' +
                        '<button class="bb-debug-tab discount-tab' + (savedFireTab === 'discount' ? ' active' : '') + '" data-tab="discount">% Disc</button>' +
                        '<button class="bb-debug-tab savings-tab' + (savedFireTab === 'savings' ? ' active' : '') + '" data-tab="savings">£ Save</button>' +
                        '</div>' +
                        '<div class="bb-debug-tab-content' + (savedFireTab === 'both' ? ' active' : '') + '" id="fire-tab-both">' +
                        fireControls('both', tierIntensity, true) +
                        '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Savings Button Colors</div>' +
                        colorCtrl('Background', 'both-savings-bg', tierIntensity.savingsBgColor || '#FB4C45') +
                        colorCtrl('Shadow', 'both-savings-shadow', tierIntensity.savingsShadowColor || '#B02823') +
                        '</div></div>' +
                        '<div class="bb-debug-tab-content' + (savedFireTab === 'discount' ? ' active' : '') + '" id="fire-tab-discount">' +
                        fireControls('discount', tierIntensity, true) +
                        '</div>' +
                        '<div class="bb-debug-tab-content' + (savedFireTab === 'savings' ? ' active' : '') + '" id="fire-tab-savings">' +
                        fireControls('savings', tierIntensity, false) +
                        '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Button Colors</div>' +
                        colorCtrl('Background', 'input-savings-bg', tierIntensity.savingsBgColor || '#FB4C45') +
                        colorCtrl('Shadow', 'input-savings-shadow', tierIntensity.savingsShadowColor || '#B02823') +
                        '</div></div>'
                },
                'pop': {
                    label: 'Text Pop',
                    content: ctrl('Scale', 'input-pop-scale', 'slider-pop-scale', tierIntensity.popScale || 1.6, 1, 2, 0.05) +
                        ctrl('Duration', 'input-pop-duration', 'slider-pop-duration', tierIntensity.popDuration || 200, 100, 1000, 50, 'ms') +
                        ctrl('Stagger', 'input-pop-stagger', 'slider-pop-stagger', tierIntensity.popStagger || 50, 0, 200, 10, 'ms') +
                        '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Transform Origin</div>' +
                        ctrl('Origin X', 'input-origin-x', 'slider-origin-x', shakeSettings.originX || 50, 0, 100, 1, '%') +
                        ctrl('Origin Y', 'input-origin-y', 'slider-origin-y', shakeSettings.originY || 60, 0, 100, 1, '%') +
                        '<div class="bb-debug-control-row" style="margin-top: 8px;">' +
                        '<label style="display: flex; align-items: center; gap: 8px; font-size: 10px; color: #888;">' +
                        '<input type="checkbox" id="chk-show-origin" ' + (shakeSettings.showOrigin ? 'checked' : '') + '> Show Origin Marker</label></div>' +
                        '</div>' +
                        '<button id="btn-pop" style="width: 100%; margin-top: 10px;">Trigger Pop!</button>'
                },
                'wave': {
                    label: 'Char Wave',
                    content: ctrl('Travel', 'input-hover-travel', 'slider-hover-travel', tierIntensity.hoverTravel || 1.7, 0, 10, 0.1, 'px') +
                        ctrl('Rotation', 'input-hover-rotation', 'slider-hover-rotation', tierIntensity.hoverRotation || 0, 0, 10, 0.1, '°') +
                        ctrl('Duration', 'input-hover-duration', 'slider-hover-duration', tierIntensity.hoverDuration || 4400, 100, 8000, 50, 'ms') +
                        ctrl('Stagger', 'input-hover-stagger', 'slider-hover-stagger', tierIntensity.hoverStagger || 850, 0, 2000, 10, 'ms')
                },
                'pixel': {
                    label: 'Pixel Border',
                    content: '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">% OFF Display</div>' +
                        ctrl('Pixel Size', 'input-percent-pixel-mult', 'slider-percent-pixel-mult', 4, 1, 8, 1) +
                        ctrl('Radius', 'input-percent-radius', 'slider-percent-radius', 4, 1, 20, 1) +
                        ctrl('Padding X', 'input-percent-padding-x', 'slider-percent-padding-x', 16, 0, 60, 1, 'px') +
                        ctrl('Padding Y', 'input-percent-padding-y', 'slider-percent-padding-y', 6, 0, 40, 1, 'px') +
                        ctrl('Min Width', 'input-percent-width', 'slider-percent-width', 0, 0, 300, 1, 'px') +
                        ctrl('Min Height', 'input-percent-height', 'slider-percent-height', 48, 20, 100, 1, 'px') +
                        '<button id="btn-apply-percent-radius" class="secondary" style="width: 100%; margin-top: 8px;">Apply</button>' +
                        '</div>' +
                        '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Savings Display</div>' +
                        ctrl('Pixel Size', 'input-savings-pixel-mult', 'slider-savings-pixel-mult', 4, 1, 8, 1) +
                        ctrl('Radius', 'input-savings-radius', 'slider-savings-radius', 4, 1, 20, 1) +
                        ctrl('Padding X', 'input-savings-padding-x', 'slider-savings-padding-x', 0, 0, 60, 1, 'px') +
                        ctrl('Padding Y', 'input-savings-padding-y', 'slider-savings-padding-y', 0, 0, 40, 1, 'px') +
                        ctrl('Min Width', 'input-savings-width', 'slider-savings-width', 160, 0, 300, 1, 'px') +
                        ctrl('Min Height', 'input-savings-height', 'slider-savings-height', 70, 20, 100, 1, 'px') +
                        '<button id="btn-apply-savings-radius" class="secondary" style="width: 100%; margin-top: 8px;">Apply</button>' +
                        '</div>' +
                        '<button id="btn-copy-clippath" style="width: 100%; margin-top: 12px;">📋 Copy Clip-Path CSS</button>'
                }
            }) +
            
            // ===== CARDS CATEGORY =====
            category('cards', '🃏', 'Cards', {
                'scrolltilt': {
                    label: '3D Scroll Tilt',
                    content: '<div class="bb-debug-subsection">' +
                        ctrl('Max Angle', 'input-tilt-angle', 'slider-tilt-angle', carouselState.tiltMaxAngle || 25, 0, 90, 1, '°') +
                        ctrl('Distance', 'input-tilt-dist', 'slider-tilt-dist', carouselState.tiltDistance || 400, 100, 1000, 10, 'px') +
                        ctrl('Curve (Power)', 'input-tilt-curve', 'slider-tilt-curve', carouselState.tiltCurve || 1, 0.1, 3, 0.1) +
                        '</div><div class="bb-debug-import-hint" style="margin-top:8px;">' +
                        'Distance: How far from center to reach max tilt.<br>' +
                        'Curve: 1=Linear, >1=Flat Center (Ease In), <1=Sharp Center (Ease Out)</div>'
                },
                'float': {
                    label: 'Floating Card',
                    content: ctrl('Travel', 'input-card-travel', 'slider-card-travel', tierIntensity.cardTravel || 2, 0, 50, 1, 'px') +
                        ctrl('Duration', 'input-card-duration', 'slider-card-duration', tierIntensity.cardDuration || 3000, 500, 10000, 100, 'ms') +
                        ctrl('Stagger', 'input-card-stagger', 'slider-card-stagger', tierIntensity.cardStagger || 2650, 0, 5000, 50, 'ms') +
                        '<div class="bb-debug-subsection"><div class="bb-debug-subsection-title">Shake & Jitter</div>' +
                        ctrl('Travel', 'input-shake-travel', 'slider-shake-travel', tierIntensity.shakeTravel || 0, 0, 10, 0.1, 'px') +
                        ctrl('Rotation', 'input-shake-rotation', 'slider-shake-rotation', tierIntensity.shakeRotation || 0, 0, 15, 0.1, '°') +
                        ctrl('Stagger', 'input-shake-stagger', 'slider-shake-stagger', tierIntensity.shakeStagger || 0, 0, 100, 5, 'ms') +
                        ctrl('Speed', 'input-shake-speed', 'slider-shake-speed', tierIntensity.shakeSpeed || 105, 10, 200, 5, 'ms') +
                        '</div>'
                },
                'glow': {
                    label: 'Light & Glow',
                    content: ctrl('Idle Flicker', 'input-idle-intensity', 'slider-idle-intensity', tierIntensity.idleIntensity || 0.05, 0, 1, 0.01) +
                        ctrl('Hover Glow', 'input-hover-glow', 'slider-hover-glow', tierIntensity.hoverGlow || 0.15, 0, 1, 0.01) +
                        ctrl('Selected Glow', 'input-selected-glow', 'slider-selected-glow', tierIntensity.selectedGlow || 0.15, 0, 1, 0.01) +
                        ctrl('Selected Flicker', 'input-selected-flicker', 'slider-selected-flicker', tierIntensity.selectedFlicker || 0.05, 0, 1, 0.01)
                }
            }) +
            
            // ===== SOUND CATEGORY =====
            category('sound', '🔊', 'Sound', {
                'mixer': {
                    label: 'Mixer',
                    content: buildSoundMixer()
                },
                'upload': {
                    label: 'Upload',
                    content: buildSoundUpload()
                },
                'preview': {
                    label: 'Preview',
                    content: buildSoundPreview()
                }
            }) +
            
            // ===== PERFORMANCE CATEGORY =====
            simpleCategory('perf', '⚡', 'Performance',
                '<div class="bb-perf-meter">' +
                '  <span class="bb-perf-label">LIVE FPS:</span>' +
                '  <span class="bb-perf-value" id="bb-perf-fps" style="font-size: 18px; min-width: 40px;">--</span>' +
                '</div>' +
                '<div class="bb-debug-subsection-title" style="margin-top: 12px;">Benchmark Report</div>' +
                '<div class="bb-perf-report" id="bb-perf-report" style="font-size: 11px; background: rgba(0,0,0,0.3); padding: 8px; border-radius: 4px; margin-bottom: 10px; font-family: monospace;">' +
                '  <div>Status: <span id="bb-bench-status" style="color: #ffca28;">Measuring...</span></div>' +
                '  <div>Tier: <span id="bb-perf-bench" style="color: #888;">PENDING</span></div>' +
                '  <div>Avg FPS: <span id="bb-bench-avg">--</span></div>' +
                '  <div>Min FPS: <span id="bb-bench-min">--</span></div>' +
                '  <div>Max FPS: <span id="bb-bench-max">--</span></div>' +
                '  <div>CPU Cores: <span id="bb-bench-cores">--</span></div>' +
                '  <div>Frames: <span id="bb-bench-frames">--</span></div>' +
                '</div>' +
                '<div class="bb-debug-subsection-title">How Tier is Determined</div>' +
                '<div style="font-size: 10px; color: #aaa; margin-bottom: 10px; line-height: 1.4;">' +
                '  <div>• <span style="color:#4ade80">HIGH</span>: Avg FPS ≥55 & CPU ≥4 cores → All effects ON</div>' +
                '  <div>• <span style="color:#ffca28">MEDIUM</span>: Avg FPS 35-55 → Tilt/Shadows OFF, Fire/Particles ON</div>' +
                '  <div>• <span style="color:#ff4c4c">LOW</span>: Avg FPS &lt;35 or CPU &lt;4 → Wave/Fire/Particles OFF</div>' +
                '</div>' +
                '<div class="bb-debug-subsection-title">Effect Toggles</div>' +
                '<div class="bb-debug-control-row">' +
                '  <label class="bb-debug-control-label">' +
                '    <span>Scroll Tilt (3D)</span>' +
                '    <input type="checkbox" id="chk-perf-tilt">' +
                '  </label>' +
                '</div>' +
                '<div class="bb-debug-control-row">' +
                '  <label class="bb-debug-control-label">' +
                '    <span>Idle Wave (Float)</span>' +
                '    <input type="checkbox" id="chk-perf-wave" checked>' +
                '  </label>' +
                '</div>' +
                '<div class="bb-debug-control-row">' +
                '  <label class="bb-debug-control-label">' +
                '    <span>Shadows & Glows</span>' +
                '    <input type="checkbox" id="chk-perf-shadows" checked>' +
                '  </label>' +
                '</div>' +
                '<div class="bb-debug-control-row">' +
                '  <label class="bb-debug-control-label">' +
                '    <span>Fire Effect</span>' +
                '    <input type="checkbox" id="chk-perf-fire" checked>' +
                '  </label>' +
                '</div>' +
                '<div class="bb-debug-control-row">' +
                '  <label class="bb-debug-control-label">' +
                '    <span>Particles (Stars/Sparks)</span>' +
                '    <input type="checkbox" id="chk-perf-particles" checked>' +
                '  </label>' +
                '</div>' +
                '<div class="bb-debug-control-row">' +
                '  <label class="bb-debug-control-label">' +
                '    <span>Text Shake</span>' +
                '    <input type="checkbox" id="chk-perf-shake" checked>' +
                '  </label>' +
                '</div>'
            ) +
            
            // ===== IMPORT/EXPORT CATEGORY =====
            simpleCategory('io', '💾', 'Import / Export',
                '<div class="bb-debug-button-row">' +
                '<button id="btn-export" class="secondary">Export All</button>' +
                '</div>' +
                '<div class="bb-debug-import-area">' +
                '<div class="bb-debug-subsection-title">Import Tier Settings</div>' +
                '<textarea id="import-textarea" placeholder="Paste tier JSON here..."></textarea>' +
                '<div class="bb-debug-import-hint">Paste a tier object from exported settings, then click Import.</div>' +
                '<div class="bb-debug-import-error" id="import-error"></div>' +
                '<div class="bb-debug-import-success" id="import-success"></div>' +
                '<button id="btn-import" style="width: 100%; margin-top: 8px;">Import to Tier <span id="import-tier-label">' + tierIndex + '</span></button>' +
                '</div>'
            ) +
            
            // ===== LEADERBOARD TEST CATEGORY =====
            simpleCategory('leaderboard', '🏆', 'Leaderboard Test',
                '<div class="bb-debug-subsection-title">Team Savings (' + config.currencySymbol + ')</div>' +
                '<div class="bb-ldb-team-row" data-team="feline">' +
                '  <span class="bb-ldb-emoji">🐱</span>' +
                '  <span class="bb-ldb-name">Feline</span>' +
                '  <button class="bb-ldb-btn" data-team="feline" data-delta="-10">−</button>' +
                '  <span class="bb-ldb-value" id="ldb-val-feline">' + config.currencySymbol + '0</span>' +
                '  <button class="bb-ldb-btn" data-team="feline" data-delta="10">+</button>' +
                '</div>' +
                '<div class="bb-ldb-team-row" data-team="amphibian">' +
                '  <span class="bb-ldb-emoji">🐸</span>' +
                '  <span class="bb-ldb-name">Amphibian</span>' +
                '  <button class="bb-ldb-btn" data-team="amphibian" data-delta="-10">−</button>' +
                '  <span class="bb-ldb-value" id="ldb-val-amphibian">' + config.currencySymbol + '38</span>' +
                '  <button class="bb-ldb-btn" data-team="amphibian" data-delta="10">+</button>' +
                '</div>' +
                '<div class="bb-ldb-team-row" data-team="mammal">' +
                '  <span class="bb-ldb-emoji">🐰</span>' +
                '  <span class="bb-ldb-name">Mammal</span>' +
                '  <button class="bb-ldb-btn" data-team="mammal" data-delta="-10">−</button>' +
                '  <span class="bb-ldb-value" id="ldb-val-mammal">' + config.currencySymbol + '0</span>' +
                '  <button class="bb-ldb-btn" data-team="mammal" data-delta="10">+</button>' +
                '</div>' +
                '<div class="bb-ldb-team-row" data-team="avian">' +
                '  <span class="bb-ldb-emoji">🐣</span>' +
                '  <span class="bb-ldb-name">Avian</span>' +
                '  <button class="bb-ldb-btn" data-team="avian" data-delta="-10">−</button>' +
                '  <span class="bb-ldb-value" id="ldb-val-avian">' + config.currencySymbol + '0</span>' +
                '  <button class="bb-ldb-btn" data-team="avian" data-delta="10">+</button>' +
                '</div>' +
                '<button id="btn-ldb-reset" style="width: 100%; margin-top: 10px; background: rgba(239,68,68,0.2); border: 1px solid #ef4444; color: #ef4444;">Reset All to 0</button>' +
                '<style>' +
                '.bb-ldb-team-row { display: flex; align-items: center; gap: 8px; padding: 6px 0; border-bottom: 1px solid rgba(255,255,255,0.1); }' +
                '.bb-ldb-emoji { font-size: 18px; }' +
                '.bb-ldb-name { flex: 1; font-size: 11px; color: #aaa; }' +
                '.bb-ldb-value { min-width: 50px; text-align: center; color: #22c55e; font-weight: bold; font-size: 12px; }' +
                '.bb-ldb-btn { width: 26px; height: 26px; border-radius: 4px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: #fff; cursor: pointer; font-size: 16px; display: flex; align-items: center; justify-content: center; }' +
                '.bb-ldb-btn:hover { background: rgba(255,255,255,0.2); }' +
                '.bb-ldb-btn[data-delta="10"] { color: #22c55e; }' +
                '.bb-ldb-btn[data-delta="-10"] { color: #ef4444; }' +
                '</style>'
            ) +
            
            '</div>' +
            '<div class="bb-debug-resize-handle"></div>';
        
        // Append to bundle builder container (not body) so it appears above the fixed container
        container.appendChild(panel);
        
        // Initialize performance toggles
        setTimeout(function() {
            function bindPerfToggle(id, key) {
                var el = document.getElementById(id);
                if (el) {
                    el.checked = Perf[key];
                    el.addEventListener('change', function() {
                        Perf[key] = this.checked;
                        if (key === 'enableShadows') toggleShadows(this.checked);
                        if (key === 'enableFire') toggleFire(this.checked);
                        
                        // PERFORMANCE FIX: Restart animation loops when re-enabled
                        if (this.checked) {
                            if (key === 'enableCardWave' || key === 'enable3DTilt') {
                                if (window._restartCardWaveAnimation) window._restartCardWaveAnimation();
                            }
                            if (key === 'enableTextShake') {
                                if (window._restartShakeAnimation) window._restartShakeAnimation();
                            }
                            if (key === 'enableParticles') {
                                if (window._restartStarAnimation) window._restartStarAnimation();
                                if (window._restartSparkAnimation) window._restartSparkAnimation();
                            }
                        } else {
                            // PERFORMANCE FIX: Clean up when disabling particles
                            if (key === 'enableParticles') {
                                if (window._clearAllParticles) window._clearAllParticles();
                            }
                        }
                    });
                }
            }
            
            bindPerfToggle('chk-perf-tilt', 'enable3DTilt');
            bindPerfToggle('chk-perf-wave', 'enableCardWave');
            bindPerfToggle('chk-perf-shadows', 'enableShadows');
            bindPerfToggle('chk-perf-fire', 'enableFire');
            bindPerfToggle('chk-perf-particles', 'enableParticles');
            bindPerfToggle('chk-perf-shake', 'enableTextShake');
            
            // ===== LEADERBOARD TEST HANDLERS =====
            var ldbBtns = document.querySelectorAll('.bb-ldb-btn');
            ldbBtns.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var team = this.dataset.team;
                    var delta = parseInt(this.dataset.delta, 10);
                    leaderboardDebugData[team] = Math.max(0, (leaderboardDebugData[team] || 0) + delta);
                    updateLeaderboardDebugUI();
                    triggerLeaderboardDebugUpdate();
                });
            });
            
            var ldbResetBtn = document.getElementById('btn-ldb-reset');
            if (ldbResetBtn) {
                ldbResetBtn.addEventListener('click', function() {
                    leaderboardDebugData = { feline: 0, amphibian: 0, mammal: 0, avian: 0 };
                    previousLeaderboardState = {}; // Reset position tracking for animations
                    updateLeaderboardDebugUI();
                    triggerLeaderboardDebugUpdate();
                });
            }
            
            function updateLeaderboardDebugUI() {
                Object.keys(leaderboardDebugData).forEach(function(team) {
                    var valEl = document.getElementById('ldb-val-' + team);
                    if (valEl) valEl.textContent = config.currencySymbol + leaderboardDebugData[team];
                });
            }
            
            function triggerLeaderboardDebugUpdate() {
                var data = {};
                Object.keys(leaderboardDebugData).forEach(function(team) {
                    data[team] = { totalSavings: leaderboardDebugData[team], checkoutCount: 0 };
                });
                renderLeaderboard(data);
            }
            
            // Initialize display
            updateLeaderboardDebugUI();
        }, 100);

        var autoSaveTimeout = null;
        var hasUnsavedChanges = false;
        
        function showAutoSaveIndicator() {
            var indicator = document.getElementById('autosave-indicator');
            if (indicator) {
                indicator.classList.add('show');
                setTimeout(function() {
                    indicator.classList.remove('show');
                }, 2000);
            }
        }
        
        function autoSave() {
            // Save TIER_INTENSITY to localStorage
            localStorage.setItem(LS_TIER_SETTINGS, JSON.stringify(TIER_INTENSITY));
            hasUnsavedChanges = false;
            var unsavedDot = document.getElementById('unsaved-dot');
            if (unsavedDot) unsavedDot.classList.remove('show');
            showAutoSaveIndicator();
        }
        
        function markChanged() {
            hasUnsavedChanges = true;
            var unsavedDot = document.getElementById('unsaved-dot');
            if (unsavedDot) unsavedDot.classList.add('show');
            
            // Debounce auto-save
            if (autoSaveTimeout) clearTimeout(autoSaveTimeout);
            autoSaveTimeout = setTimeout(autoSave, 1000);
        }
        
        function updateValueDisplay(inputId, value, unit) {
            var valEl = document.getElementById('val-' + inputId);
            if (valEl) {
                valEl.textContent = value + (unit || '');
            }
        }
        
        // ===== LOCK TO ALL TIERS FUNCTIONALITY =====
        var isLockedToAllTiers = false;
        
        function applyToAllTiers(key, value) {
            for (var i = 0; i <= 5; i++) {
                if (!TIER_INTENSITY[i]) TIER_INTENSITY[i] = {};
                TIER_INTENSITY[i][key] = value;
            }
        }
        
        function copyCurrentToAllTiers() {
            var currentTier = shakeState.currentTierIndex || 0;
            var currentSettings = JSON.parse(JSON.stringify(TIER_INTENSITY[currentTier] || {}));
            
            for (var i = 0; i <= 5; i++) {
                TIER_INTENSITY[i] = JSON.parse(JSON.stringify(currentSettings));
            }
            
            markChanged();
            showAutoSaveIndicator();
            
            // Flash the button
            var btn = document.getElementById('btn-copy-to-all');
            if (btn) {
                btn.textContent = '✓ Copied!';
                btn.style.background = '#4ade80';
                setTimeout(function() {
                    btn.textContent = 'Copy → All';
                    btn.style.background = '';
                }, 1500);
            }
        }
        
        // Lock toggle handler
        var lockCheckbox = document.getElementById('chk-lock-all-tiers');
        if (lockCheckbox) {
            lockCheckbox.addEventListener('change', function() {
                isLockedToAllTiers = this.checked;
                var lockBar = panel.querySelector('.bb-debug-lock-bar');
                if (lockBar) {
                    lockBar.classList.toggle('active', isLockedToAllTiers);
                }
            });
        }
        
        // Copy to all button handler
        var copyAllBtn = document.getElementById('btn-copy-to-all');
        if (copyAllBtn) {
            copyAllBtn.addEventListener('click', copyCurrentToAllTiers);
        }
        
        // ===== DRAGGABLE HEADER =====
        var header = panel.querySelector('.bb-debug-header');
        var isDragging = false;
        var dragOffsetX = 0, dragOffsetY = 0;
        
        header.addEventListener('mousedown', function(e) {
            if (e.target.closest('.bb-minimize-btn')) return;
            isDragging = true;
            dragOffsetX = e.clientX - panel.getBoundingClientRect().left;
            dragOffsetY = e.clientY - panel.getBoundingClientRect().top;
            header.style.cursor = 'grabbing';
        });
        
        document.addEventListener('mousemove', function(e) {
            if (!isDragging) return;
            var newLeft = e.clientX - dragOffsetX;
            var newTop = e.clientY - dragOffsetY;
            panel.style.left = newLeft + 'px';
            panel.style.top = newTop + 'px';
            panel.style.right = 'auto';
            panel.style.bottom = 'auto';
        });
        
        document.addEventListener('mouseup', function() {
            if (isDragging) {
                isDragging = false;
                header.style.cursor = 'grab';
                // Save position
                localStorage.setItem(LS_PANEL_POS, JSON.stringify({
                    left: parseInt(panel.style.left),
                    top: parseInt(panel.style.top)
                }));
            }
        });
        
        // ===== RESIZE OBSERVER =====
        var resizeObserver = new ResizeObserver(function(entries) {
            for (var entry of entries) {
                localStorage.setItem(LS_PANEL_SIZE, JSON.stringify({
                    width: entry.contentRect.width,
                    height: entry.contentRect.height
                }));
            }
        });
        resizeObserver.observe(panel);
        
        // ===== COLLAPSIBLE SECTIONS =====
        panel.querySelectorAll('.bb-debug-section-header').forEach(function(header) {
            header.addEventListener('click', function() {
                var section = this.closest('.bb-debug-section');
                var sectionId = section.dataset.sectionId;
                section.classList.toggle('collapsed');
                
                // Save collapsed state
                var collapsed = JSON.parse(localStorage.getItem(LS_COLLAPSED) || '{}');
                collapsed[sectionId] = section.classList.contains('collapsed');
                localStorage.setItem(LS_COLLAPSED, JSON.stringify(collapsed));
            });
        });
        
        // ===== COLLAPSIBLE CATEGORIES =====
        panel.querySelectorAll('.bb-debug-category-header').forEach(function(header) {
            header.addEventListener('click', function() {
                var category = this.closest('.bb-debug-category');
                var categoryId = category.dataset.categoryId;
                category.classList.toggle('collapsed');
                
                // Save collapsed state
                var collapsed = JSON.parse(localStorage.getItem(LS_COLLAPSED) || '{}');
                collapsed['cat-' + categoryId] = category.classList.contains('collapsed');
                localStorage.setItem(LS_COLLAPSED, JSON.stringify(collapsed));
            });
        });
        
        // ===== NESTED TAB SWITCHING =====
        panel.querySelectorAll('.bb-debug-nested-tab').forEach(function(tab) {
            tab.addEventListener('click', function(e) {
                e.stopPropagation(); // Don't trigger category collapse
                var catId = this.dataset.cat;
                var tabId = this.dataset.tab;
                
                // Update active tab within this category
                panel.querySelectorAll('.bb-debug-nested-tab[data-cat="' + catId + '"]').forEach(function(t) { 
                    t.classList.remove('active'); 
                });
                this.classList.add('active');
                
                // Update active content within this category
                panel.querySelectorAll('.bb-debug-nested-content[data-cat="' + catId + '"]').forEach(function(c) { 
                    c.classList.remove('active'); 
                });
                panel.querySelector('.bb-debug-nested-content[data-cat="' + catId + '"][data-tab-content="' + tabId + '"]').classList.add('active');
                
                // Save tab state for this category
                localStorage.setItem('bb_debug_cat_' + catId + '_tab', tabId);
            });
        });
        
        // ===== SOUND CONTROLS =====
        // Volume sliders
        panel.querySelectorAll('.sound-vol-slider').forEach(function(slider) {
            slider.addEventListener('input', function() {
                var soundName = this.dataset.sound;
                var vol = this.value;
                document.getElementById('vol-' + soundName).textContent = vol + '%';
                localStorage.setItem('bb_sound_vol_' + soundName, vol);
                
                // Apply volume to SoundSystem if available
                if (window.SoundSystem && window.SoundSystem.setVolume) {
                    window.SoundSystem.setVolume(soundName, vol / 100);
                    
                    // Update ambient volume in real-time if it's playing
                    if (soundName === 'ambient-loop' && window.SoundSystem.updateAmbientVolume) {
                        window.SoundSystem.updateAmbientVolume();
                    }
                }
            });
        });
        
        // Sound preview buttons
        panel.querySelectorAll('.bb-sound-preview-btn, .bb-sound-preview-action').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.stopPropagation();
                var soundName = this.dataset.sound;
                if (window.SoundSystem && window.SoundSystem.play) {
                    window.SoundSystem.play(soundName);
                } else {
                    console.log('🔊 Preview sound:', soundName);
                }
            });
        });
        
        // Play all sounds sequence
        var playAllBtn = document.getElementById('btn-play-all-sounds');
        if (playAllBtn) {
            playAllBtn.addEventListener('click', function() {
                var sounds = window.BundleBuilderSounds || {};
                var actions = sounds.actions || ['card-select', 'card-deselect', 'physical-add', 'physical-remove', 'goodies-add', 'goodies-remove', 'checkout-click', 'hover-card', 'button-click', 'progress-grow', 'deck-light', 'number-tick', 'upgrade-slam', 'upgrade-sequence', 'spark-burst', 'checkmark-land', 'tier-unlock'];
                var delay = 0;
                actions.forEach(function(action) {
                    // Skip ambient-loop in sequence
                    if (action === 'ambient-loop') return;
                    setTimeout(function() {
                        if (window.SoundSystem && window.SoundSystem.play) {
                            window.SoundSystem.play(action);
                        }
                        console.log('🔊 Playing:', action);
                    }, delay);
                    delay += 500;
                });
            });
        }
        
        // Ambient loop toggle
        var ambientBtn = document.getElementById('btn-toggle-ambient');
        if (ambientBtn) {
            ambientBtn.addEventListener('click', function() {
                if (window.SoundSystem && window.SoundSystem.toggleAmbient) {
                    var isPlaying = window.SoundSystem.toggleAmbient();
                    this.textContent = isPlaying ? '⏹ Stop Ambient Loop' : '🎵 Start Ambient Loop';
                    this.style.background = isPlaying ? '#fe5f55' : '';
                }
            });
        }
        
        // Sound upload zone
        var uploadZone = document.getElementById('sound-upload-zone');
        var fileInput = document.getElementById('sound-file-input');
        if (uploadZone && fileInput) {
            uploadZone.addEventListener('click', function() {
                fileInput.click();
            });
            
            uploadZone.addEventListener('dragover', function(e) {
                e.preventDefault();
                this.classList.add('dragover');
            });
            
            uploadZone.addEventListener('dragleave', function() {
                this.classList.remove('dragover');
            });
            
            uploadZone.addEventListener('drop', function(e) {
                e.preventDefault();
                this.classList.remove('dragover');
                var files = e.dataTransfer.files;
                if (files.length > 0) {
                    handleSoundUpload(files[0]);
                }
            });
            
            fileInput.addEventListener('change', function() {
                if (this.files.length > 0) {
                    handleSoundUpload(this.files[0]);
                }
            });
        }
        
        function handleSoundUpload(file) {
            if (!file.type.startsWith('audio/')) {
                alert('Please upload an audio file');
                return;
            }
            
            var reader = new FileReader();
            reader.onload = function(e) {
                var audioData = e.target.result;
                var soundName = file.name.replace(/\.[^/.]+$/, ''); // Remove extension
                
                // Store in localStorage (limited size, for testing only)
                try {
                    localStorage.setItem('bb_test_sound_' + soundName, audioData);
                    updateUploadedSoundsList();
                    console.log('🔊 Uploaded test sound:', soundName);
                } catch (err) {
                    alert('File too large for local storage. Try a smaller file.');
                }
            };
            reader.readAsDataURL(file);
        }
        
        function updateUploadedSoundsList() {
            var list = document.getElementById('uploaded-sounds-list');
            if (!list) return;
            
            var html = '';
            for (var key in localStorage) {
                if (key.startsWith('bb_test_sound_')) {
                    var soundName = key.replace('bb_test_sound_', '');
                    html += '<div class="bb-sound-list-item">' +
                        '<span class="bb-sound-list-item-name">' + soundName + '</span>' +
                        '<div class="bb-sound-list-item-actions">' +
                        '<button class="bb-sound-list-item-btn play" data-sound="' + soundName + '">▶</button>' +
                        '<button class="bb-sound-list-item-btn delete" data-sound="' + soundName + '">✕</button>' +
                        '</div></div>';
                }
            }
            list.innerHTML = html;
            
            // Add event listeners
            list.querySelectorAll('.bb-sound-list-item-btn.play').forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var soundName = this.dataset.sound;
                    var audioData = localStorage.getItem('bb_test_sound_' + soundName);
                    if (audioData) {
                        var audio = new Audio(audioData);
                        audio.play();
                    }
                });
            });
            
            list.querySelectorAll('.bb-sound-list-item-btn.delete').forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var soundName = this.dataset.sound;
                    localStorage.removeItem('bb_test_sound_' + soundName);
                    updateUploadedSoundsList();
                });
            });
        }
        
        // Initialize uploaded sounds list
        updateUploadedSoundsList();
        
        // ===== TAB SWITCHING FOR FIRE CONTROLS =====
        panel.querySelectorAll('.bb-debug-tab').forEach(function(tab) {
            tab.addEventListener('click', function() {
                var tabId = this.dataset.tab;
                
                // Update active tab
                panel.querySelectorAll('.bb-debug-tab').forEach(function(t) { t.classList.remove('active'); });
                this.classList.add('active');
                
                // Update active content
                panel.querySelectorAll('.bb-debug-tab-content').forEach(function(c) { c.classList.remove('active'); });
                document.getElementById('fire-tab-' + tabId).classList.add('active');
                
                // Save tab state
                localStorage.setItem(LS_FIRE_TAB, tabId);
            });
        });
        
        // ===== SYNC INPUT <-> SLIDER HELPERS (with auto-save) =====
        function syncPair(inputId, sliderId, callback, unit, tierKey) {
            var input = document.getElementById(inputId);
            var slider = document.getElementById(sliderId);
            if (!input || !slider) return;
            
            function handleChange(val) {
                updateValueDisplay(inputId, val, unit);
                callback(val);
                
                // If locked to all tiers and we have a tier key, apply to all
                if (isLockedToAllTiers && tierKey) {
                    applyToAllTiers(tierKey, val);
                }
                
                markChanged();
            }
            
            input.addEventListener('input', function() {
                var val = parseFloat(this.value) || 0;
                slider.value = val;
                if (val > parseFloat(slider.max)) slider.max = val * 1.5;
                handleChange(val);
            });
            
            slider.addEventListener('input', function() {
                var val = parseFloat(this.value);
                input.value = val;
                handleChange(val);
            });
        }
        
        // ===== TIER SHAKE CONTROLS =====
        syncPair('input-shake-travel', 'slider-shake-travel', function(val) {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            TIER_INTENSITY[ti].shakeTravel = val;
        }, 'px');
        
        syncPair('input-shake-rotation', 'slider-shake-rotation', function(val) {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            TIER_INTENSITY[ti].shakeRotation = val;
        }, '°');
        
        syncPair('input-shake-stagger', 'slider-shake-stagger', function(val) {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            TIER_INTENSITY[ti].shakeStagger = val;
        }, 'ms');
        
        syncPair('input-shake-speed', 'slider-shake-speed', function(val) {
            shakeSettings.shakeSpeed = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].shakeSpeed = val;
        }, 'ms');
        
        // ===== GLOBAL HOVER CONTROLS =====
        syncPair('input-hover-travel', 'slider-hover-travel', function(val) {
            shakeSettings.hoverTravel = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].hoverTravel = val;
        }, 'px');
        
        syncPair('input-hover-rotation', 'slider-hover-rotation', function(val) {
            shakeSettings.hoverRotation = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].hoverRotation = val;
        }, '°');
        
        syncPair('input-hover-duration', 'slider-hover-duration', function(val) {
            shakeSettings.hoverDuration = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].hoverDuration = val;
        }, 'ms');
        
        syncPair('input-hover-stagger', 'slider-hover-stagger', function(val) {
            shakeSettings.hoverStagger = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].hoverStagger = val;
        }, 'ms');
        
        // ===== SCROLL TILT CONTROLS =====
        syncPair('input-tilt-angle', 'slider-tilt-angle', function(val) {
            carouselState.tiltMaxAngle = val;
        }, '°');
        
        syncPair('input-tilt-dist', 'slider-tilt-dist', function(val) {
            carouselState.tiltDistance = val;
        }, 'px');
        
        syncPair('input-tilt-curve', 'slider-tilt-curve', function(val) {
            carouselState.tiltCurve = val;
        });
        
        // ===== CARD WAVE CONTROLS =====
        syncPair('input-card-travel', 'slider-card-travel', function(val) {
            shakeSettings.cardTravel = val;
            // Global setting - no tier update needed
        }, 'px');
        
        syncPair('input-card-duration', 'slider-card-duration', function(val) {
            shakeSettings.cardDuration = val;
            // Global setting - no tier update needed
        }, 'ms');
        
        syncPair('input-card-stagger', 'slider-card-stagger', function(val) {
            shakeSettings.cardStagger = val;
            // Global setting - no tier update needed
        }, 'ms');
        
        // ===== GLOW INTENSITY CONTROLS =====
        syncPair('input-idle-intensity', 'slider-idle-intensity', function(val) {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            TIER_INTENSITY[ti].idleIntensity = val;
            var bb = document.querySelector('.bundle-builder');
            if (bb) bb.style.setProperty('--idle-intensity', val);
        });
        
        syncPair('input-hover-glow', 'slider-hover-glow', function(val) {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            TIER_INTENSITY[ti].hoverGlow = val;
            var bb = document.querySelector('.bundle-builder');
            if (bb) bb.style.setProperty('--hover-glow', val);
        });
        
        syncPair('input-selected-glow', 'slider-selected-glow', function(val) {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            TIER_INTENSITY[ti].selectedGlow = val;
            var bb = document.querySelector('.bundle-builder');
            if (bb) bb.style.setProperty('--selected-glow', val);
        });
        
        syncPair('input-selected-flicker', 'slider-selected-flicker', function(val) {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            TIER_INTENSITY[ti].selectedFlicker = val;
            var bb = document.querySelector('.bundle-builder');
            if (bb) bb.style.setProperty('--selected-flicker', val);
        });

        // ===== POP & ORIGIN CONTROLS =====
        syncPair('input-pop-scale', 'slider-pop-scale', function(val) {
            shakeSettings.popScale = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].popScale = val;
        });
        
        syncPair('input-pop-duration', 'slider-pop-duration', function(val) {
            shakeSettings.popDuration = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].popDuration = val;
        }, 'ms');
        
        syncPair('input-pop-stagger', 'slider-pop-stagger', function(val) {
            shakeSettings.popStagger = val;
            var ti = shakeState.currentTierIndex || 0;
            if (TIER_INTENSITY[ti]) TIER_INTENSITY[ti].popStagger = val;
        }, 'ms');
        
        syncPair('input-origin-x', 'slider-origin-x', function(val) {
            shakeSettings.originX = val;
        }, '%');
        
        syncPair('input-origin-y', 'slider-origin-y', function(val) {
            shakeSettings.originY = val;
        }, '%');
        
        var chkShowOrigin = document.getElementById('chk-show-origin');
        if (chkShowOrigin) {
            chkShowOrigin.addEventListener('change', function() {
                shakeSettings.showOrigin = this.checked;
                markChanged();
            });
        }
        
        // ===== FIRE EFFECT CONTROLS =====
        function hexToRgba(hex) {
            if (!hex || hex.length < 7) return [1, 1, 1, 1];
            return [
                parseInt(hex.slice(1,3), 16) / 255,
                parseInt(hex.slice(3,5), 16) / 255,
                parseInt(hex.slice(5,7), 16) / 255,
                1.0
            ];
        }
        
        function updateDiscountFireEffect() {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            
            // Get values from discount tab inputs
            var flameHeight = parseFloat(document.getElementById('discount-fire-height')?.value) || 0.3;
            var scale = parseFloat(document.getElementById('discount-fire-scale')?.value) || 0.05;
            var speedY = parseFloat(document.getElementById('discount-fire-speed')?.value) || 0.03;
            var wobble = parseFloat(document.getElementById('discount-fire-wobble')?.value) || 0.05;
            var threshold = parseFloat(document.getElementById('discount-fire-threshold')?.value) || 1.1;
            var detail = parseFloat(document.getElementById('discount-fire-detail')?.value) || 1.1;
            var aperture = parseFloat(document.getElementById('discount-fire-aperture')?.value) || 0.2;
            var softness = parseFloat(document.getElementById('discount-fire-softness')?.value) || 0.1;
            var sideFade = parseFloat(document.getElementById('discount-fire-sidefade')?.value) || 0.3;
            var alpha = parseFloat(document.getElementById('discount-fire-alpha')?.value) || 1;
            var colorTop = document.getElementById('discount-color-top')?.value || '#0093fe';
            var colorMid = document.getElementById('discount-color-mid')?.value || '#00ffff';
            var colorBot = document.getElementById('discount-color-bot')?.value || '#00ffff';
            var offsetX = parseFloat(document.getElementById('discount-offset-x')?.value) || 0;
            var offsetY = parseFloat(document.getElementById('discount-offset-y')?.value) || -131;
            var width = parseFloat(document.getElementById('discount-width')?.value) || 100;
            var height = parseFloat(document.getElementById('discount-height')?.value) || 185;
            
            // Save to tier
            TIER_INTENSITY[ti].fireFlameHeight = flameHeight;
            TIER_INTENSITY[ti].fireScale = scale;
            TIER_INTENSITY[ti].fireSpeedY = speedY;
            TIER_INTENSITY[ti].fireWobble = wobble;
            TIER_INTENSITY[ti].fireThreshold = threshold;
            TIER_INTENSITY[ti].fireDetail = detail;
            TIER_INTENSITY[ti].fireAperture = aperture;
            TIER_INTENSITY[ti].fireSoftness = softness;
            TIER_INTENSITY[ti].fireSideFade = sideFade;
            TIER_INTENSITY[ti].fireAlpha = alpha;
            TIER_INTENSITY[ti].fireColorTop = colorTop;
            TIER_INTENSITY[ti].fireColorMid = colorMid;
            TIER_INTENSITY[ti].fireColorBot = colorBot;
            TIER_INTENSITY[ti].fireOffsetX = offsetX;
            TIER_INTENSITY[ti].fireOffsetY = offsetY;
            TIER_INTENSITY[ti].fireWidth = width;
            TIER_INTENSITY[ti].fireHeight = height;
            
            // Update fire instance
            if (window.balatroFireInstance) {
                window.balatroFireInstance.updateConfig({
                    flameHeight: flameHeight,
                    scale: scale,
                    speedY: speedY,
                    wobbleStrength: wobble,
                    threshold: threshold,
                    detail: detail,
                    aperture: aperture,
                    softness: softness,
                    sideFade: sideFade,
                    alpha: alpha,
                    colorTop: hexToRgba(colorTop),
                    colorMid: hexToRgba(colorMid),
                    colorBot: hexToRgba(colorBot)
                });
            }
            
            // Update canvas position
            var canvas = document.getElementById('balatro-fire-canvas');
            if (canvas) {
                canvas.style.left = offsetX + 'px';
                canvas.style.top = offsetY + 'px';
                canvas.style.width = width + '%';
                canvas.style.height = height + '%';
            }
        }
        
        function updateSavingsFireEffect() {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            
            // Get values from savings tab inputs
            var flameHeight = parseFloat(document.getElementById('savings-fire-height')?.value) || 0.3;
            var scale = parseFloat(document.getElementById('savings-fire-scale')?.value) || 0.05;
            var speedY = parseFloat(document.getElementById('savings-fire-speed')?.value) || 0.03;
            var wobble = parseFloat(document.getElementById('savings-fire-wobble')?.value) || 0.05;
            var threshold = parseFloat(document.getElementById('savings-fire-threshold')?.value) || 1.1;
            var detail = parseFloat(document.getElementById('savings-fire-detail')?.value) || 1.1;
            var aperture = parseFloat(document.getElementById('savings-fire-aperture')?.value) || 0.2;
            var softness = parseFloat(document.getElementById('savings-fire-softness')?.value) || 0.1;
            var sideFade = parseFloat(document.getElementById('savings-fire-sidefade')?.value) || 0.3;
            var alpha = parseFloat(document.getElementById('savings-fire-alpha')?.value) || 1;
            var colorTop = document.getElementById('savings-color-top')?.value || '#ff4c40';
            var colorMid = document.getElementById('savings-color-mid')?.value || '#fea948';
            var colorBot = document.getElementById('savings-color-bot')?.value || '#feffda';
            var offsetX = parseFloat(document.getElementById('savings-offset-x')?.value) || 0;
            var offsetY = parseFloat(document.getElementById('savings-offset-y')?.value) || -131;
            var width = parseFloat(document.getElementById('savings-width')?.value) || 100;
            var height = parseFloat(document.getElementById('savings-height')?.value) || 185;
            
            // Save to tier (savings uses same flame params but different colors/position)
            // The savings fire shares flame params with discount, but has separate colors and position
            TIER_INTENSITY[ti].savingsFireColorTop = colorTop;
            TIER_INTENSITY[ti].savingsFireColorMid = colorMid;
            TIER_INTENSITY[ti].savingsFireColorBot = colorBot;
            TIER_INTENSITY[ti].savingsFireOffsetX = offsetX;
            TIER_INTENSITY[ti].savingsFireOffsetY = offsetY;
            TIER_INTENSITY[ti].savingsFireWidth = width;
            TIER_INTENSITY[ti].savingsFireHeight = height;
            
            // Update savings fire instance
            if (window.balatroFireInstanceSavings) {
                window.balatroFireInstanceSavings.updateConfig({
                    flameHeight: flameHeight,
                    scale: scale,
                    speedY: speedY,
                    wobbleStrength: wobble,
                    threshold: threshold,
                    detail: detail,
                    aperture: aperture,
                    softness: softness,
                    sideFade: sideFade,
                    alpha: alpha,
                    colorTop: hexToRgba(colorTop),
                    colorMid: hexToRgba(colorMid),
                    colorBot: hexToRgba(colorBot)
                });
            }
            
            // Update canvas position
            var canvasSavings = document.getElementById('balatro-fire-canvas-savings');
            if (canvasSavings) {
                canvasSavings.style.left = offsetX + 'px';
                canvasSavings.style.top = offsetY + 'px';
                canvasSavings.style.width = width + '%';
                canvasSavings.style.height = height + '%';
            }
        }
        
        // ===== BOTH FIRES - Updates both discount and savings at once =====
        function updateBothFiresEffect() {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            
            // Get values from "both" tab inputs
            var flameHeight = parseFloat(document.getElementById('both-fire-height')?.value) || 0.3;
            var scale = parseFloat(document.getElementById('both-fire-scale')?.value) || 0.05;
            var speedY = parseFloat(document.getElementById('both-fire-speed')?.value) || 0.03;
            var wobble = parseFloat(document.getElementById('both-fire-wobble')?.value) || 0.05;
            var threshold = parseFloat(document.getElementById('both-fire-threshold')?.value) || 1.1;
            var detail = parseFloat(document.getElementById('both-fire-detail')?.value) || 1.1;
            var aperture = parseFloat(document.getElementById('both-fire-aperture')?.value) || 0.2;
            var softness = parseFloat(document.getElementById('both-fire-softness')?.value) || 0.1;
            var sideFade = parseFloat(document.getElementById('both-fire-sidefade')?.value) || 0.3;
            var alpha = parseFloat(document.getElementById('both-fire-alpha')?.value) || 1;
            var colorTop = document.getElementById('both-color-top')?.value || '#0093fe';
            var colorMid = document.getElementById('both-color-mid')?.value || '#00ffff';
            var colorBot = document.getElementById('both-color-bot')?.value || '#00ffff';
            var offsetX = parseFloat(document.getElementById('both-offset-x')?.value) || 0;
            var offsetY = parseFloat(document.getElementById('both-offset-y')?.value) || -131;
            var width = parseFloat(document.getElementById('both-width')?.value) || 100;
            var height = parseFloat(document.getElementById('both-height')?.value) || 185;
            
            // Save to tier - BOTH discount and savings fire settings
            TIER_INTENSITY[ti].fireFlameHeight = flameHeight;
            TIER_INTENSITY[ti].fireScale = scale;
            TIER_INTENSITY[ti].fireSpeedY = speedY;
            TIER_INTENSITY[ti].fireWobble = wobble;
            TIER_INTENSITY[ti].fireThreshold = threshold;
            TIER_INTENSITY[ti].fireDetail = detail;
            TIER_INTENSITY[ti].fireAperture = aperture;
            TIER_INTENSITY[ti].fireSoftness = softness;
            TIER_INTENSITY[ti].fireSideFade = sideFade;
            TIER_INTENSITY[ti].fireAlpha = alpha;
            TIER_INTENSITY[ti].fireColorTop = colorTop;
            TIER_INTENSITY[ti].fireColorMid = colorMid;
            TIER_INTENSITY[ti].fireColorBot = colorBot;
            TIER_INTENSITY[ti].fireOffsetX = offsetX;
            TIER_INTENSITY[ti].fireOffsetY = offsetY;
            TIER_INTENSITY[ti].fireWidth = width;
            TIER_INTENSITY[ti].fireHeight = height;
            
            // Also save to savings fire (same values for position/size, colors from both tab)
            TIER_INTENSITY[ti].savingsFireColorTop = colorTop;
            TIER_INTENSITY[ti].savingsFireColorMid = colorMid;
            TIER_INTENSITY[ti].savingsFireColorBot = colorBot;
            TIER_INTENSITY[ti].savingsFireOffsetX = offsetX;
            TIER_INTENSITY[ti].savingsFireOffsetY = offsetY;
            TIER_INTENSITY[ti].savingsFireWidth = width;
            TIER_INTENSITY[ti].savingsFireHeight = height;
            
            // Update BOTH fire instances
            var fireConfig = {
                flameHeight: flameHeight,
                scale: scale,
                speedY: speedY,
                wobbleStrength: wobble,
                threshold: threshold,
                detail: detail,
                aperture: aperture,
                softness: softness,
                sideFade: sideFade,
                alpha: alpha,
                colorTop: hexToRgba(colorTop),
                colorMid: hexToRgba(colorMid),
                colorBot: hexToRgba(colorBot)
            };
            
            if (window.balatroFireInstance) {
                window.balatroFireInstance.updateConfig(fireConfig);
            }
            if (window.balatroFireInstanceSavings) {
                window.balatroFireInstanceSavings.updateConfig(fireConfig);
            }
            
            // Update BOTH canvas positions
            var canvas = document.getElementById('balatro-fire-canvas');
            if (canvas) {
                canvas.style.left = offsetX + 'px';
                canvas.style.top = offsetY + 'px';
                canvas.style.width = width + '%';
                canvas.style.height = height + '%';
            }
            
            var canvasSavings = document.getElementById('balatro-fire-canvas-savings');
            if (canvasSavings) {
                canvasSavings.style.left = offsetX + 'px';
                canvasSavings.style.top = offsetY + 'px';
                canvasSavings.style.width = width + '%';
                canvasSavings.style.height = height + '%';
            }
            
            // Also sync the individual tabs' inputs so they stay in sync
            function syncInput(id, val) {
                var el = document.getElementById(id);
                if (el) el.value = val;
            }
            
            // Sync discount tab
            syncInput('discount-fire-height', flameHeight);
            syncInput('slider-discount-fire-height', flameHeight);
            syncInput('discount-fire-scale', scale);
            syncInput('slider-discount-fire-scale', scale);
            syncInput('discount-fire-speed', speedY);
            syncInput('slider-discount-fire-speed', speedY);
            syncInput('discount-fire-wobble', wobble);
            syncInput('slider-discount-fire-wobble', wobble);
            syncInput('discount-fire-threshold', threshold);
            syncInput('slider-discount-fire-threshold', threshold);
            syncInput('discount-fire-detail', detail);
            syncInput('slider-discount-fire-detail', detail);
            syncInput('discount-fire-aperture', aperture);
            syncInput('slider-discount-fire-aperture', aperture);
            syncInput('discount-fire-softness', softness);
            syncInput('slider-discount-fire-softness', softness);
            syncInput('discount-fire-sidefade', sideFade);
            syncInput('slider-discount-fire-sidefade', sideFade);
            syncInput('discount-fire-alpha', alpha);
            syncInput('slider-discount-fire-alpha', alpha);
            syncInput('discount-color-top', colorTop);
            syncInput('discount-color-mid', colorMid);
            syncInput('discount-color-bot', colorBot);
            syncInput('discount-offset-x', offsetX);
            syncInput('slider-discount-offset-x', offsetX);
            syncInput('discount-offset-y', offsetY);
            syncInput('slider-discount-offset-y', offsetY);
            syncInput('discount-width', width);
            syncInput('slider-discount-width', width);
            syncInput('discount-height', height);
            syncInput('slider-discount-height', height);
            
            // Sync savings tab
            syncInput('savings-fire-height', flameHeight);
            syncInput('slider-savings-fire-height', flameHeight);
            syncInput('savings-fire-scale', scale);
            syncInput('slider-savings-fire-scale', scale);
            syncInput('savings-fire-speed', speedY);
            syncInput('slider-savings-fire-speed', speedY);
            syncInput('savings-fire-wobble', wobble);
            syncInput('slider-savings-fire-wobble', wobble);
            syncInput('savings-fire-threshold', threshold);
            syncInput('slider-savings-fire-threshold', threshold);
            syncInput('savings-fire-detail', detail);
            syncInput('slider-savings-fire-detail', detail);
            syncInput('savings-fire-aperture', aperture);
            syncInput('slider-savings-fire-aperture', aperture);
            syncInput('savings-fire-softness', softness);
            syncInput('slider-savings-fire-softness', softness);
            syncInput('savings-fire-sidefade', sideFade);
            syncInput('slider-savings-fire-sidefade', sideFade);
            syncInput('savings-fire-alpha', alpha);
            syncInput('slider-savings-fire-alpha', alpha);
            syncInput('savings-color-top', colorTop);
            syncInput('savings-color-mid', colorMid);
            syncInput('savings-color-bot', colorBot);
            syncInput('savings-offset-x', offsetX);
            syncInput('slider-savings-offset-x', offsetX);
            syncInput('savings-offset-y', offsetY);
            syncInput('slider-savings-offset-y', offsetY);
            syncInput('savings-width', width);
            syncInput('slider-savings-width', width);
            syncInput('savings-height', height);
            syncInput('slider-savings-height', height);
        }
        
        // Both fire controls
        syncPair('both-fire-height', 'slider-both-fire-height', updateBothFiresEffect);
        syncPair('both-fire-scale', 'slider-both-fire-scale', updateBothFiresEffect);
        syncPair('both-fire-speed', 'slider-both-fire-speed', updateBothFiresEffect);
        syncPair('both-fire-wobble', 'slider-both-fire-wobble', updateBothFiresEffect);
        syncPair('both-fire-threshold', 'slider-both-fire-threshold', updateBothFiresEffect);
        syncPair('both-fire-detail', 'slider-both-fire-detail', updateBothFiresEffect);
        syncPair('both-fire-aperture', 'slider-both-fire-aperture', updateBothFiresEffect);
        syncPair('both-fire-softness', 'slider-both-fire-softness', updateBothFiresEffect);
        syncPair('both-fire-sidefade', 'slider-both-fire-sidefade', updateBothFiresEffect);
        syncPair('both-fire-alpha', 'slider-both-fire-alpha', updateBothFiresEffect);
        syncPair('both-offset-x', 'slider-both-offset-x', updateBothFiresEffect, 'px');
        syncPair('both-offset-y', 'slider-both-offset-y', updateBothFiresEffect, 'px');
        syncPair('both-width', 'slider-both-width', updateBothFiresEffect, '%');
        syncPair('both-height', 'slider-both-height', updateBothFiresEffect, '%');
        
        // Both fire color controls
        ['both-color-top', 'both-color-mid', 'both-color-bot'].forEach(function(id) {
            var el = document.getElementById(id);
            if (el) {
                el.addEventListener('input', function() {
                    updateBothFiresEffect();
                    markChanged();
                });
            }
        });
        
        // Both savings button colors
        var bothSavingsBg = document.getElementById('both-savings-bg');
        var bothSavingsShadow = document.getElementById('both-savings-shadow');
        
        function updateBothSavingsButtonColors() {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            
            var bgColor = bothSavingsBg?.value || '#FB4C45';
            var shadowColor = bothSavingsShadow?.value || '#B02823';
            
            TIER_INTENSITY[ti].savingsBgColor = bgColor;
            TIER_INTENSITY[ti].savingsShadowColor = shadowColor;
            
            // Sync to savings tab
            var savingsBgInput = document.getElementById('input-savings-bg');
            var savingsShadowInput = document.getElementById('input-savings-shadow');
            if (savingsBgInput) savingsBgInput.value = bgColor;
            if (savingsShadowInput) savingsShadowInput.value = shadowColor;
            
            var savingsDisplay = document.querySelector('.bb-tier-savings-display');
            if (savingsDisplay) {
                savingsDisplay.style.setProperty('--savings-bg', bgColor);
                savingsDisplay.style.setProperty('--savings-shadow', shadowColor);
            }
            markChanged();
        }
        
        if (bothSavingsBg) bothSavingsBg.addEventListener('input', updateBothSavingsButtonColors);
        if (bothSavingsShadow) bothSavingsShadow.addEventListener('input', updateBothSavingsButtonColors);
        
        // Discount fire controls
        syncPair('discount-fire-height', 'slider-discount-fire-height', updateDiscountFireEffect);
        syncPair('discount-fire-scale', 'slider-discount-fire-scale', updateDiscountFireEffect);
        syncPair('discount-fire-speed', 'slider-discount-fire-speed', updateDiscountFireEffect);
        syncPair('discount-fire-wobble', 'slider-discount-fire-wobble', updateDiscountFireEffect);
        syncPair('discount-fire-threshold', 'slider-discount-fire-threshold', updateDiscountFireEffect);
        syncPair('discount-fire-detail', 'slider-discount-fire-detail', updateDiscountFireEffect);
        syncPair('discount-fire-aperture', 'slider-discount-fire-aperture', updateDiscountFireEffect);
        syncPair('discount-fire-softness', 'slider-discount-fire-softness', updateDiscountFireEffect);
        syncPair('discount-fire-sidefade', 'slider-discount-fire-sidefade', updateDiscountFireEffect);
        syncPair('discount-fire-alpha', 'slider-discount-fire-alpha', updateDiscountFireEffect);
        syncPair('discount-offset-x', 'slider-discount-offset-x', updateDiscountFireEffect, 'px');
        syncPair('discount-offset-y', 'slider-discount-offset-y', updateDiscountFireEffect, 'px');
        syncPair('discount-width', 'slider-discount-width', updateDiscountFireEffect, '%');
        syncPair('discount-height', 'slider-discount-height', updateDiscountFireEffect, '%');
        
        // Discount fire color controls
        ['discount-color-top', 'discount-color-mid', 'discount-color-bot'].forEach(function(id) {
            var el = document.getElementById(id);
            if (el) {
                el.addEventListener('input', function() {
                    updateDiscountFireEffect();
                    markChanged();
                });
            }
        });
        
        // Savings fire controls
        syncPair('savings-fire-height', 'slider-savings-fire-height', updateSavingsFireEffect);
        syncPair('savings-fire-scale', 'slider-savings-fire-scale', updateSavingsFireEffect);
        syncPair('savings-fire-speed', 'slider-savings-fire-speed', updateSavingsFireEffect);
        syncPair('savings-fire-wobble', 'slider-savings-fire-wobble', updateSavingsFireEffect);
        syncPair('savings-fire-threshold', 'slider-savings-fire-threshold', updateSavingsFireEffect);
        syncPair('savings-fire-detail', 'slider-savings-fire-detail', updateSavingsFireEffect);
        syncPair('savings-fire-aperture', 'slider-savings-fire-aperture', updateSavingsFireEffect);
        syncPair('savings-fire-softness', 'slider-savings-fire-softness', updateSavingsFireEffect);
        syncPair('savings-fire-sidefade', 'slider-savings-fire-sidefade', updateSavingsFireEffect);
        syncPair('savings-fire-alpha', 'slider-savings-fire-alpha', updateSavingsFireEffect);
        syncPair('savings-offset-x', 'slider-savings-offset-x', updateSavingsFireEffect, 'px');
        syncPair('savings-offset-y', 'slider-savings-offset-y', updateSavingsFireEffect, 'px');
        syncPair('savings-width', 'slider-savings-width', updateSavingsFireEffect, '%');
        syncPair('savings-height', 'slider-savings-height', updateSavingsFireEffect, '%');
        
        // Savings fire color controls
        ['savings-color-top', 'savings-color-mid', 'savings-color-bot'].forEach(function(id) {
            var el = document.getElementById(id);
            if (el) {
                el.addEventListener('input', function() {
                    updateSavingsFireEffect();
                    markChanged();
                });
            }
        });
        
        // Savings button colors
        var savingsBgInput = document.getElementById('input-savings-bg');
        var savingsShadowInput = document.getElementById('input-savings-shadow');
        
        function updateSavingsButtonColors() {
            var ti = shakeState.currentTierIndex || 0;
            if (!TIER_INTENSITY[ti]) TIER_INTENSITY[ti] = {};
            
            var bgColor = savingsBgInput?.value || '#FB4C45';
            var shadowColor = savingsShadowInput?.value || '#B02823';
            
            TIER_INTENSITY[ti].savingsBgColor = bgColor;
            TIER_INTENSITY[ti].savingsShadowColor = shadowColor;
            
            var savingsDisplay = document.querySelector('.bb-tier-savings-display');
            if (savingsDisplay) {
                savingsDisplay.style.setProperty('--savings-bg', bgColor);
                savingsDisplay.style.setProperty('--savings-shadow', shadowColor);
            }
            markChanged();
        }
        
        if (savingsBgInput) savingsBgInput.addEventListener('input', updateSavingsButtonColors);
        if (savingsShadowInput) savingsShadowInput.addEventListener('input', updateSavingsButtonColors);
        
        // ===== TEXT POSITION CONTROLS =====
        function updatePercentTextPosition() {
            var offsetX = parseFloat(document.getElementById('input-percent-text-x')?.value) || 0;
            var offsetY = parseFloat(document.getElementById('input-percent-text-y')?.value) || 0;
            
            // Update global settings
            shakeSettings.percentTextX = offsetX;
            shakeSettings.percentTextY = offsetY;
            
            var percentMain = document.querySelector('.bb-tier-percent-main');
            if (percentMain) {
                percentMain.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px)';
            }
        }
        
        function updateSavingsTextPosition() {
            var offsetX = parseFloat(document.getElementById('input-savings-text-x')?.value) || 0;
            var offsetY = parseFloat(document.getElementById('input-savings-text-y')?.value) || 0;
            
            // Update global settings
            shakeSettings.savingsTextX = offsetX;
            shakeSettings.savingsTextY = offsetY;
            
            var savingsMain = document.querySelector('.bb-tier-savings-main');
            if (savingsMain) {
                savingsMain.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px)';
            }
        }
        
        syncPair('input-percent-text-x', 'slider-percent-text-x', updatePercentTextPosition, 'px');
        syncPair('input-percent-text-y', 'slider-percent-text-y', updatePercentTextPosition, 'px');
        syncPair('input-savings-text-x', 'slider-savings-text-x', updateSavingsTextPosition, 'px');
        syncPair('input-savings-text-y', 'slider-savings-text-y', updateSavingsTextPosition, 'px');
        
        // ===== TEXT SHADOW OFFSET CONTROLS =====
        function updatePercentShadowOffset() {
            var inputX = document.getElementById('input-percent-shadow-x');
            var inputY = document.getElementById('input-percent-shadow-y');
            if (!inputX || !inputY) return;
            
            var offsetX = parseFloat(inputX.value) || 0;
            var offsetY = parseFloat(inputY.value) || 3;
            
            // Update global settings
            shakeSettings.percentShadowX = offsetX;
            shakeSettings.percentShadowY = offsetY;
            
            var percentShadow = document.querySelector('.bb-tier-percent-shadow');
            if (percentShadow) {
                percentShadow.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px)';
            }
        }
        
        function updateSavingsShadowOffset() {
            var inputX = document.getElementById('input-savings-shadow-x');
            var inputY = document.getElementById('input-savings-shadow-y');
            if (!inputX || !inputY) return;
            
            var offsetX = parseFloat(inputX.value) || 0;
            var offsetY = parseFloat(inputY.value) || 3;
            
            // Update global settings
            shakeSettings.savingsShadowX = offsetX;
            shakeSettings.savingsShadowY = offsetY;
            
            var savingsShadow = document.querySelector('.bb-tier-savings-shadow');
            if (savingsShadow) {
                savingsShadow.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px)';
            }
        }
        
        syncPair('input-percent-shadow-x', 'slider-percent-shadow-x', updatePercentShadowOffset, 'px');
        syncPair('input-percent-shadow-y', 'slider-percent-shadow-y', updatePercentShadowOffset, 'px');
        syncPair('input-savings-shadow-x', 'slider-savings-shadow-x', updateSavingsShadowOffset, 'px');
        syncPair('input-savings-shadow-y', 'slider-savings-shadow-y', updateSavingsShadowOffset, 'px');
        
        // Initialize text positions and shadow offsets on load
        setTimeout(function() {
            updatePercentTextPosition();
            updateSavingsTextPosition();
            updatePercentShadowOffset();
            updateSavingsShadowOffset();
            updateDiscountFireEffect();
            updateSavingsFireEffect();
        }, 500);
        
        // ===== MINIMIZE BUTTON =====
        document.getElementById('btn-minimize').addEventListener('click', function(e) {
            e.stopPropagation();
            var panel = document.querySelector('.bb-debug-panel');
            var btn = this;
            if (panel.classList.contains('minimized')) {
                panel.classList.remove('minimized');
                btn.textContent = '−';
                btn.title = 'Minimize';
            } else {
                panel.classList.add('minimized');
                btn.textContent = '+';
                btn.title = 'Expand';
            }
        });
        
        // ===== BUTTONS =====
        document.getElementById('btn-pop').addEventListener('click', function() {
            shakeState.isPopping = true;
            shakeState.popStartTime = Date.now();
        });
        
        document.getElementById('btn-export').addEventListener('click', function() {
            // Export only TIER_INTENSITY since each tier has all settings explicitly defined
            var jsCode = "// ===== EXPORTED TIER SETTINGS =====\n\nvar TIER_INTENSITY = " + JSON.stringify(TIER_INTENSITY, null, 2) + ";";
            
            navigator.clipboard.writeText(jsCode).then(function() {
                alert("Settings copied to clipboard!");
            }).catch(function(err) {
                console.error('Copy failed:', err);
                // Fallback: show in console
                console.log(jsCode);
                alert('Copy failed. Check console for output.');
            });
        });
        
        // ===== IMPORT BUTTON =====
        document.getElementById('btn-import').addEventListener('click', function() {
            var textarea = document.getElementById('import-textarea');
            var errorEl = document.getElementById('import-error');
            var successEl = document.getElementById('import-success');
            var ti = shakeState.currentTierIndex || 0;
            
            // Reset messages
            errorEl.style.display = 'none';
            successEl.style.display = 'none';
            
            var input = textarea.value.trim();
            if (!input) {
                errorEl.textContent = '❌ Please paste tier settings JSON first.';
                errorEl.style.display = 'block';
                return;
            }
            
            try {
                // Try to parse JSON
                var parsed = JSON.parse(input);
                
                // Validate it has at least some expected keys
                var validKeys = ['shakeTravel', 'shakeRotation', 'fireFlameHeight', 'idleIntensity', 'hoverGlow'];
                var hasValidKey = validKeys.some(function(key) { return parsed.hasOwnProperty(key); });
                
                if (!hasValidKey) {
                    errorEl.innerHTML = '❌ Invalid format. JSON must contain tier settings like:<br><code>shakeTravel, shakeRotation, fireFlameHeight</code>, etc.';
                    errorEl.style.display = 'block';
                    return;
                }
                
                // Apply to current tier
                TIER_INTENSITY[ti] = parsed;
                
                // Update the debug panel to reflect new values
                if (typeof window.updateDebugPanelTier === 'function') {
                    window.updateDebugPanelTier(ti);
                }
                
                successEl.textContent = '✓ Successfully imported settings to Tier ' + ti + '!';
                successEl.style.display = 'block';
                textarea.value = '';
                
            } catch (e) {
                errorEl.innerHTML = '❌ JSON Parse Error: ' + e.message + '<br><br><strong>Tip:</strong> Make sure you copy just the tier object { }, not the whole export.';
                errorEl.style.display = 'block';
            }
        });
        
        // ===== PIXELATED BORDER RADIUS FUNCTIONS (from lukeb.co.uk generator) =====
        function generatePixelPoints(radius, pixelSize) {
            var coords = [];
            var lastCoords = { x: -1, y: -1 };
            
            for (var i = 270; i > 225; i--) {
                var x = parseInt(radius * Math.sin((2 * Math.PI * i) / 360) + radius + 0.5) * pixelSize;
                var y = parseInt(radius * Math.cos((2 * Math.PI * i) / 360) + radius + 0.5) * pixelSize;
                
                if (x !== lastCoords.x || y !== lastCoords.y) {
                    lastCoords.x = x;
                    lastCoords.y = y;
                    coords.push({ x: x, y: y });
                }
            }
            
            // Merge redundant points
            coords = coords.reduce(function(result, point, index) {
                if (index !== coords.length - 1 && point.x === 0 && coords[index + 1].x === 0) return result;
                if (index !== 0 && point.y === 0 && coords[index - 1].y === 0) return result;
                if (index !== 0 && index !== coords.length - 1 && point.x === coords[index - 1].x && point.x === coords[index + 1].x) return result;
                result.push(point);
                return result;
            }, []);
            
            // Add corners
            coords = coords.reduce(function(result, point, i) {
                result.push(point);
                if (coords.length > 1 && i < coords.length - 1 && coords[i + 1].x !== point.x && coords[i + 1].y !== point.y) {
                    result.push({ x: coords[i + 1].x, y: point.y });
                }
                return result;
            }, []);
            
            return coords;
        }
        
        function flipPixelCoords(coords) {
            var flipped = coords.concat(coords.map(function(c) { return { x: c.y, y: c.x }; }).reverse());
            return flipped.filter(function(c, i, arr) {
                return !i || arr[i - 1].x !== c.x || arr[i - 1].y !== c.y;
            });
        }
        
        function edgeCoord(n) {
            return n === 0 ? "100%" : "calc(100% - " + n + "px)";
        }
        
        function mirrorPixelCoords(coords) {
            var result = [];
            // Top-left
            coords.forEach(function(c) { result.push({ x: c.x + "px", y: c.y + "px" }); });
            // Top-right
            coords.forEach(function(c) { result.push({ x: edgeCoord(c.y), y: c.x + "px" }); });
            // Bottom-right
            coords.forEach(function(c) { result.push({ x: edgeCoord(c.x), y: edgeCoord(c.y) }); });
            // Bottom-left
            coords.forEach(function(c) { result.push({ x: c.y + "px", y: edgeCoord(c.x) }); });
            return result;
        }
        
        function generatePixelClipPath(radius, pixelSize) {
            var points = generatePixelPoints(radius, pixelSize);
            var flipped = flipPixelCoords(points);
            var mirrored = mirrorPixelCoords(flipped);
            mirrored.reverse();
            
            return "polygon(" + mirrored.map(function(p) { return p.x + " " + p.y; }).join(", ") + ")";
        }
        
        // Store current clip-paths for copying
        var currentPercentClipPath = '';
        var currentSavingsClipPath = '';
        
        // Store current settings for copying
        var currentPercentSettings = { clipPath: '', paddingX: 16, paddingY: 6, width: 0, height: 48 };
        var currentSavingsSettings = { clipPath: '', paddingX: 0, paddingY: 0, width: 160, height: 70 };
        
        // Live apply function for percent display
        function applyPercentStyles() {
            var pixelMult = parseInt(document.getElementById('input-percent-pixel-mult').value) || 4;
            var radius = parseInt(document.getElementById('input-percent-radius').value) || 4;
            var paddingX = parseInt(document.getElementById('input-percent-padding-x').value) || 0;
            var paddingY = parseInt(document.getElementById('input-percent-padding-y').value) || 0;
            var minWidth = parseInt(document.getElementById('input-percent-width').value) || 0;
            var minHeight = parseInt(document.getElementById('input-percent-height').value) || 48;
            
            var clipPath = generatePixelClipPath(radius, pixelMult);
            currentPercentClipPath = clipPath;
            currentPercentSettings = { clipPath: clipPath, paddingX: paddingX, paddingY: paddingY, width: minWidth, height: minHeight };
            
            var styleId = 'pixel-radius-percent-style';
            var styleEl = document.getElementById(styleId);
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = styleId;
                document.head.appendChild(styleEl);
            }
            var widthStyle = minWidth > 0 ? "min-width: " + minWidth + "px !important; " : "";
            styleEl.textContent = 
                ".bundle-builder.balatro-theme .bb-tier-percent-display { padding: " + paddingY + "px " + paddingX + "px !important; " + widthStyle + "min-height: " + minHeight + "px !important; }" +
                ".bundle-builder.balatro-theme .bb-tier-percent-display::before, .bundle-builder.balatro-theme .bb-tier-percent-display::after { clip-path: " + clipPath + " !important; }";
        }
        
        // Live apply function for savings display
        function applySavingsStyles() {
            var pixelMult = parseInt(document.getElementById('input-savings-pixel-mult').value) || 4;
            var radius = parseInt(document.getElementById('input-savings-radius').value) || 4;
            var paddingX = parseInt(document.getElementById('input-savings-padding-x').value) || 0;
            var paddingY = parseInt(document.getElementById('input-savings-padding-y').value) || 0;
            var minWidth = parseInt(document.getElementById('input-savings-width').value) || 0;
            var minHeight = parseInt(document.getElementById('input-savings-height').value) || 70;
            
            var clipPath = generatePixelClipPath(radius, pixelMult);
            currentSavingsClipPath = clipPath;
            currentSavingsSettings = { clipPath: clipPath, paddingX: paddingX, paddingY: paddingY, width: minWidth, height: minHeight };
            
            var styleId = 'pixel-radius-savings-style';
            var styleEl = document.getElementById(styleId);
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = styleId;
                document.head.appendChild(styleEl);
            }
            var widthStyle = minWidth > 0 ? "min-width: " + minWidth + "px !important; " : "";
            styleEl.textContent = 
                ".bundle-builder.balatro-theme .bb-tier-savings-display { padding: " + paddingY + "px " + paddingX + "px !important; " + widthStyle + "min-height: " + minHeight + "px !important; }" +
                ".bundle-builder.balatro-theme .bb-tier-savings-display::before, .bundle-builder.balatro-theme .bb-tier-savings-display::after { clip-path: " + clipPath + " !important; }";
        }
        
        // Sync sliders for pixel radius controls - apply live on change
        syncPair('input-percent-pixel-mult', 'slider-percent-pixel-mult', applyPercentStyles);
        syncPair('input-percent-radius', 'slider-percent-radius', applyPercentStyles);
        syncPair('input-percent-padding-x', 'slider-percent-padding-x', applyPercentStyles);
        syncPair('input-percent-padding-y', 'slider-percent-padding-y', applyPercentStyles);
        syncPair('input-percent-width', 'slider-percent-width', applyPercentStyles);
        syncPair('input-percent-height', 'slider-percent-height', applyPercentStyles);
        syncPair('input-savings-pixel-mult', 'slider-savings-pixel-mult', applySavingsStyles);
        syncPair('input-savings-radius', 'slider-savings-radius', applySavingsStyles);
        syncPair('input-savings-padding-x', 'slider-savings-padding-x', applySavingsStyles);
        syncPair('input-savings-padding-y', 'slider-savings-padding-y', applySavingsStyles);
        syncPair('input-savings-width', 'slider-savings-width', applySavingsStyles);
        syncPair('input-savings-height', 'slider-savings-height', applySavingsStyles);
        
        // Apply buttons now just show confirmation
        document.getElementById('btn-apply-percent-radius').addEventListener('click', function() {
            applyPercentStyles();
            this.textContent = '✓ Applied!';
            var btn = this;
            setTimeout(function() { btn.textContent = 'Apply to % Display'; }, 1000);
        });
        
        document.getElementById('btn-apply-savings-radius').addEventListener('click', function() {
            applySavingsStyles();
            this.textContent = '✓ Applied!';
            var btn = this;
            setTimeout(function() { btn.textContent = 'Apply to Savings Display'; }, 1000);
        });
        
        // Copy clip-path CSS
        document.getElementById('btn-copy-clippath').addEventListener('click', function() {
            var css = "/* Pixelated Border Radius CSS */\\n\\n";
            
            if (currentPercentClipPath) {
                css += "/* Percent Display */\\n";
                css += ".bundle-builder.balatro-theme .bb-tier-percent-display {\\n";
                css += "  padding: " + currentPercentSettings.paddingY + "px " + currentPercentSettings.paddingX + "px;\\n";
                if (currentPercentSettings.width > 0) {
                    css += "  min-width: " + currentPercentSettings.width + "px;\\n";
                }
                css += "  min-height: " + currentPercentSettings.height + "px;\\n";
                css += "}\\n";
                css += ".bundle-builder.balatro-theme .bb-tier-percent-display::before,\\n";
                css += ".bundle-builder.balatro-theme .bb-tier-percent-display::after {\\n";
                css += "  clip-path: " + currentPercentClipPath + ";\\n";
                css += "}\\n\\n";
            }
            
            if (currentSavingsClipPath) {
                css += "/* Savings Display */\\n";
                css += ".bundle-builder.balatro-theme .bb-tier-savings-display {\\n";
                css += "  padding: " + currentSavingsSettings.paddingY + "px " + currentSavingsSettings.paddingX + "px;\\n";
                if (currentSavingsSettings.width > 0) {
                    css += "  min-width: " + currentSavingsSettings.width + "px;\\n";
                }
                css += "  min-height: " + currentSavingsSettings.height + "px;\\n";
                css += "}\\n";
                css += ".bundle-builder.balatro-theme .bb-tier-savings-display::before,\\n";
                css += ".bundle-builder.balatro-theme .bb-tier-savings-display::after {\\n";
                css += "  clip-path: " + currentSavingsClipPath + ";\\n";
                css += "}\\n";
            }
            
            if (!currentPercentClipPath && !currentSavingsClipPath) {
                alert('Apply a radius first before copying!');
                return;
            }
            
            navigator.clipboard.writeText(css.replace(/\\\\n/g, '\\n')).then(function() {
                alert('Clip-path CSS copied to clipboard!');
            }).catch(function() {
                console.log(css.replace(/\\\\n/g, '\\n'));
                alert('Copy failed. Check console for output.');
            });
        });
        
        // ===== EXPOSE UPDATE FUNCTION FOR EXTERNAL CALLS =====
        window.updateDebugPanelTier = function(newTierIndex) {
            shakeState.currentTierIndex = newTierIndex;
            var ti = TIER_INTENSITY[newTierIndex] || TIER_INTENSITY[0];
            
            // Helper to safely set element value
            function setVal(id, val) {
                var el = document.getElementById(id);
                if (el) el.value = val;
            }
            
            // Update tier badge
            setVal('debug-tier', newTierIndex);
            var tierBadge = document.getElementById('debug-tier');
            if (tierBadge) tierBadge.textContent = newTierIndex;
            
            setVal('import-tier-label', newTierIndex);
            var importLabel = document.getElementById('import-tier-label');
            if (importLabel) importLabel.textContent = newTierIndex;
            
            // Shake
            setVal('input-shake-travel', ti.shakeTravel || 0);
            setVal('slider-shake-travel', ti.shakeTravel || 0);
            setVal('input-shake-rotation', ti.shakeRotation || 0);
            setVal('slider-shake-rotation', ti.shakeRotation || 0);
            setVal('input-shake-stagger', ti.shakeStagger || 0);
            setVal('slider-shake-stagger', ti.shakeStagger || 0);
            setVal('input-shake-speed', ti.shakeSpeed || 105);
            setVal('slider-shake-speed', ti.shakeSpeed || 105);
            
            // Light/Glow
            setVal('input-idle-intensity', ti.idleIntensity !== undefined ? ti.idleIntensity : 0.05);
            setVal('slider-idle-intensity', ti.idleIntensity !== undefined ? ti.idleIntensity : 0.05);
            setVal('input-hover-glow', ti.hoverGlow !== undefined ? ti.hoverGlow : 0.15);
            setVal('slider-hover-glow', ti.hoverGlow !== undefined ? ti.hoverGlow : 0.15);
            setVal('input-selected-glow', ti.selectedGlow !== undefined ? ti.selectedGlow : 0.15);
            setVal('slider-selected-glow', ti.selectedGlow !== undefined ? ti.selectedGlow : 0.15);
            setVal('input-selected-flicker', ti.selectedFlicker !== undefined ? ti.selectedFlicker : 0.05);
            setVal('slider-selected-flicker', ti.selectedFlicker !== undefined ? ti.selectedFlicker : 0.05);
            
            // Wave
            setVal('input-hover-travel', ti.hoverTravel || 1.7);
            setVal('slider-hover-travel', ti.hoverTravel || 1.7);
            setVal('input-hover-rotation', ti.hoverRotation || 0);
            setVal('slider-hover-rotation', ti.hoverRotation || 0);
            setVal('input-hover-duration', ti.hoverDuration || 4400);
            setVal('slider-hover-duration', ti.hoverDuration || 4400);
            setVal('input-hover-stagger', ti.hoverStagger || 850);
            setVal('slider-hover-stagger', ti.hoverStagger || 850);
            
            // Card Wave (GLOBAL)
            setVal('input-card-travel', shakeSettings.cardTravel !== undefined ? shakeSettings.cardTravel : 2);
            setVal('slider-card-travel', shakeSettings.cardTravel !== undefined ? shakeSettings.cardTravel : 2);
            setVal('input-card-duration', shakeSettings.cardDuration !== undefined ? shakeSettings.cardDuration : 3000);
            setVal('slider-card-duration', shakeSettings.cardDuration !== undefined ? shakeSettings.cardDuration : 3000);
            setVal('input-card-stagger', shakeSettings.cardStagger !== undefined ? shakeSettings.cardStagger : 2650);
            setVal('slider-card-stagger', shakeSettings.cardStagger !== undefined ? shakeSettings.cardStagger : 2650);
            
            // Pop
            setVal('input-pop-scale', ti.popScale || 1.6);
            setVal('slider-pop-scale', ti.popScale || 1.6);
            setVal('input-pop-duration', ti.popDuration || 200);
            setVal('slider-pop-duration', ti.popDuration || 200);
            setVal('input-pop-stagger', ti.popStagger || 50);
            setVal('slider-pop-stagger', ti.popStagger || 50);
            
            // Discount Fire (using new IDs)
            setVal('discount-fire-height', ti.fireFlameHeight || 0.3);
            setVal('slider-discount-fire-height', ti.fireFlameHeight || 0.3);
            setVal('discount-fire-scale', ti.fireScale || 0.05);
            setVal('slider-discount-fire-scale', ti.fireScale || 0.05);
            setVal('discount-fire-speed', ti.fireSpeedY || 0.03);
            setVal('slider-discount-fire-speed', ti.fireSpeedY || 0.03);
            setVal('discount-fire-wobble', ti.fireWobble || 0.05);
            setVal('slider-discount-fire-wobble', ti.fireWobble || 0.05);
            setVal('discount-fire-threshold', ti.fireThreshold || 1.1);
            setVal('slider-discount-fire-threshold', ti.fireThreshold || 1.1);
            setVal('discount-fire-detail', ti.fireDetail || 1.1);
            setVal('slider-discount-fire-detail', ti.fireDetail || 1.1);
            setVal('discount-fire-aperture', ti.fireAperture || 0.2);
            setVal('slider-discount-fire-aperture', ti.fireAperture || 0.2);
            setVal('discount-fire-softness', ti.fireSoftness || 0.1);
            setVal('slider-discount-fire-softness', ti.fireSoftness || 0.1);
            setVal('discount-fire-sidefade', ti.fireSideFade || 0.3);
            setVal('slider-discount-fire-sidefade', ti.fireSideFade || 0.3);
            setVal('discount-fire-alpha', ti.fireAlpha || 1);
            setVal('slider-discount-fire-alpha', ti.fireAlpha || 1);
            setVal('discount-color-top', ti.fireColorTop || '#0093fe');
            setVal('discount-color-mid', ti.fireColorMid || '#00ffff');
            setVal('discount-color-bot', ti.fireColorBot || '#00ffff');
            setVal('discount-offset-x', ti.fireOffsetX || 0);
            setVal('slider-discount-offset-x', ti.fireOffsetX || 0);
            setVal('discount-offset-y', ti.fireOffsetY || -131);
            setVal('slider-discount-offset-y', ti.fireOffsetY || -131);
            setVal('discount-width', ti.fireWidth || 100);
            setVal('slider-discount-width', ti.fireWidth || 100);
            setVal('discount-height', ti.fireHeight || 185);
            setVal('slider-discount-height', ti.fireHeight || 185);
            
            // Savings Fire (using new IDs)
            setVal('savings-fire-height', ti.fireFlameHeight || 0.3);
            setVal('slider-savings-fire-height', ti.fireFlameHeight || 0.3);
            setVal('savings-fire-scale', ti.fireScale || 0.05);
            setVal('slider-savings-fire-scale', ti.fireScale || 0.05);
            setVal('savings-fire-speed', ti.fireSpeedY || 0.03);
            setVal('slider-savings-fire-speed', ti.fireSpeedY || 0.03);
            setVal('savings-fire-wobble', ti.fireWobble || 0.05);
            setVal('slider-savings-fire-wobble', ti.fireWobble || 0.05);
            setVal('savings-fire-threshold', ti.fireThreshold || 1.1);
            setVal('slider-savings-fire-threshold', ti.fireThreshold || 1.1);
            setVal('savings-fire-detail', ti.fireDetail || 1.1);
            setVal('slider-savings-fire-detail', ti.fireDetail || 1.1);
            setVal('savings-fire-aperture', ti.fireAperture || 0.2);
            setVal('slider-savings-fire-aperture', ti.fireAperture || 0.2);
            setVal('savings-fire-softness', ti.fireSoftness || 0.1);
            setVal('slider-savings-fire-softness', ti.fireSoftness || 0.1);
            setVal('savings-fire-sidefade', ti.fireSideFade || 0.3);
            setVal('slider-savings-fire-sidefade', ti.fireSideFade || 0.3);
            setVal('savings-fire-alpha', ti.fireAlpha || 1);
            setVal('slider-savings-fire-alpha', ti.fireAlpha || 1);
            setVal('savings-color-top', ti.savingsFireColorTop || '#ff4c40');
            setVal('savings-color-mid', ti.savingsFireColorMid || '#fea948');
            setVal('savings-color-bot', ti.savingsFireColorBot || '#feffda');
            setVal('savings-offset-x', ti.savingsFireOffsetX || 0);
            setVal('slider-savings-offset-x', ti.savingsFireOffsetX || 0);
            setVal('savings-offset-y', ti.savingsFireOffsetY || -131);
            setVal('slider-savings-offset-y', ti.savingsFireOffsetY || -131);
            setVal('savings-width', ti.savingsFireWidth || 100);
            setVal('slider-savings-width', ti.savingsFireWidth || 100);
            setVal('savings-height', ti.savingsFireHeight || 185);
            setVal('slider-savings-height', ti.savingsFireHeight || 185);
            
            // Savings button colors
            setVal('input-savings-bg', ti.savingsBgColor || '#FB4C45');
            setVal('input-savings-shadow', ti.savingsShadowColor || '#B02823');
            
            // Text Position - Percent (GLOBAL)
            setVal('input-percent-text-x', shakeSettings.percentTextX !== undefined ? shakeSettings.percentTextX : 0);
            setVal('slider-percent-text-x', shakeSettings.percentTextX !== undefined ? shakeSettings.percentTextX : 0);
            setVal('input-percent-text-y', shakeSettings.percentTextY !== undefined ? shakeSettings.percentTextY : 0);
            setVal('slider-percent-text-y', shakeSettings.percentTextY !== undefined ? shakeSettings.percentTextY : 0);
            setVal('input-percent-shadow-x', shakeSettings.percentShadowX !== undefined ? shakeSettings.percentShadowX : 0);
            setVal('slider-percent-shadow-x', shakeSettings.percentShadowX !== undefined ? shakeSettings.percentShadowX : 0);
            setVal('input-percent-shadow-y', shakeSettings.percentShadowY !== undefined ? shakeSettings.percentShadowY : 3);
            setVal('slider-percent-shadow-y', shakeSettings.percentShadowY !== undefined ? shakeSettings.percentShadowY : 3);
            
            // Text Position - Savings (GLOBAL)
            setVal('input-savings-text-x', shakeSettings.savingsTextX !== undefined ? shakeSettings.savingsTextX : 0);
            setVal('slider-savings-text-x', shakeSettings.savingsTextX !== undefined ? shakeSettings.savingsTextX : 0);
            setVal('input-savings-text-y', shakeSettings.savingsTextY !== undefined ? shakeSettings.savingsTextY : 0);
            setVal('slider-savings-text-y', shakeSettings.savingsTextY !== undefined ? shakeSettings.savingsTextY : 0);
            setVal('input-savings-shadow-x', shakeSettings.savingsShadowX !== undefined ? shakeSettings.savingsShadowX : 0);
            setVal('slider-savings-shadow-x', shakeSettings.savingsShadowX !== undefined ? shakeSettings.savingsShadowX : 0);
            setVal('input-savings-shadow-y', shakeSettings.savingsShadowY !== undefined ? shakeSettings.savingsShadowY : 3);
            setVal('slider-savings-shadow-y', shakeSettings.savingsShadowY !== undefined ? shakeSettings.savingsShadowY : 3);
            
            // Apply text positions to elements
            var percentMain = document.querySelector('.bb-tier-percent-main');
            var savingsMain = document.querySelector('.bb-tier-savings-main');
            
            var pTextX = shakeSettings.percentTextX !== undefined ? shakeSettings.percentTextX : 0;
            var pTextY = shakeSettings.percentTextY !== undefined ? shakeSettings.percentTextY : 0;
            if (percentMain) {
                percentMain.style.transform = 'translate(' + pTextX + 'px, ' + pTextY + 'px)';
            }
            
            var sTextX = shakeSettings.savingsTextX !== undefined ? shakeSettings.savingsTextX : 0;
            var sTextY = shakeSettings.savingsTextY !== undefined ? shakeSettings.savingsTextY : 0;
            if (savingsMain) {
                savingsMain.style.transform = 'translate(' + sTextX + 'px, ' + sTextY + 'px)';
            }
            
            // Apply shadow offsets to elements
            var percentShadow = document.querySelector('.bb-tier-percent-shadow');
            var savingsShadow = document.querySelector('.bb-tier-savings-shadow');
            
            var pShadowX = shakeSettings.percentShadowX !== undefined ? shakeSettings.percentShadowX : 0;
            var pShadowY = shakeSettings.percentShadowY !== undefined ? shakeSettings.percentShadowY : 3;
            if (percentShadow) {
                percentShadow.style.transform = 'translate(' + pShadowX + 'px, ' + pShadowY + 'px)';
            }
            
            var sShadowX = shakeSettings.savingsShadowX !== undefined ? shakeSettings.savingsShadowX : 0;
            var sShadowY = shakeSettings.savingsShadowY !== undefined ? shakeSettings.savingsShadowY : 3;
            if (savingsShadow) {
                savingsShadow.style.transform = 'translate(' + sShadowX + 'px, ' + sShadowY + 'px)';
            }
            
            // Apply fire settings to the instance
            if (window.balatroFireInstance) {
                function hexToRgba(hex) {
                    return [
                        parseInt(hex.slice(1,3), 16) / 255,
                        parseInt(hex.slice(3,5), 16) / 255,
                        parseInt(hex.slice(5,7), 16) / 255,
                        1.0
                    ];
                }
                
                window.balatroFireInstance.updateConfig({
                    flameHeight: ti.fireFlameHeight || shakeSettings.fireFlameHeight,
                    scale: ti.fireScale || shakeSettings.fireScale,
                    speedY: ti.fireSpeedY || shakeSettings.fireSpeedY,
                    wobbleStrength: ti.fireWobble || shakeSettings.fireWobble,
                    threshold: ti.fireThreshold || shakeSettings.fireThreshold,
                    detail: ti.fireDetail || shakeSettings.fireDetail,
                    aperture: ti.fireAperture || shakeSettings.fireAperture,
                    softness: ti.fireSoftness || shakeSettings.fireSoftness,
                    sideFade: ti.fireSideFade || shakeSettings.fireSideFade,
                    alpha: ti.fireAlpha || shakeSettings.fireAlpha,
                    colorTop: hexToRgba(ti.fireColorTop || shakeSettings.fireColorTop),
                    colorMid: hexToRgba(ti.fireColorMid || shakeSettings.fireColorMid),
                    colorBot: hexToRgba(ti.fireColorBot || shakeSettings.fireColorBot)
                });
                
                // Update fire position
                var canvas = document.getElementById('balatro-fire-canvas');
                if (canvas) {
                    canvas.style.left = (ti.fireOffsetX || shakeSettings.fireOffsetX) + 'px';
                    canvas.style.top = (ti.fireOffsetY || shakeSettings.fireOffsetY) + 'px';
                    canvas.style.width = (ti.fireWidth || shakeSettings.fireWidth) + '%';
                    canvas.style.height = (ti.fireHeight || shakeSettings.fireHeight) + '%';
                }
            }
        };
    }

    // Initialize
    if (config.queueEnabled) {
        runQueue();
    } else {
        startApp();
    }


    // ========================================================================
    // Queue Screen
    // ========================================================================
    function runQueue() {
      let position = config.queueStart;
      
      const interval = setInterval(function() {
        position -= Math.floor(Math.random() * 5) + 1; // Slower decrement for small queue
        if (position < 1) position = 1;
        
        if (els.queueCount) {
          els.queueCount.textContent = position;
        }
        
        if (position === 1) {
          clearInterval(interval);
          setTimeout(function() {
            if (els.queueScreen) els.queueScreen.classList.add('bb-hidden');
            startApp();
          }, 500);
        }
      }, 200); // Slower tick for realism with small numbers
    }

    // Apply fire settings for a given tier index
    function applyFireSettingsForTier(tierIndex) {
      if (!window.balatroFireInstance) return;
      
      var ti = TIER_INTENSITY[tierIndex] || TIER_INTENSITY[0] || {};
      
      // Convert hex colors to RGBA arrays
      function hexToRgba(hex) {
        if (!hex || hex.length < 7) return [1, 1, 1, 1];
        return [
          parseInt(hex.slice(1,3), 16) / 255,
          parseInt(hex.slice(3,5), 16) / 255,
          parseInt(hex.slice(5,7), 16) / 255,
          1.0
        ];
      }
      
      // Pause/resume fire based on fireAlpha to save GPU resources
      var fireAlpha = ti.fireAlpha !== undefined ? ti.fireAlpha : shakeSettings.fireAlpha;
      if (fireAlpha === 0 || fireAlpha <= 0) {
        // Pause fire effect when alpha is 0 (tier 0)
        if (window.balatroFireInstance && typeof window.balatroFireInstance.pause === 'function') {
          window.balatroFireInstance.pause();
        }
        if (window.balatroFireInstanceSavings && typeof window.balatroFireInstanceSavings.pause === 'function') {
          window.balatroFireInstanceSavings.pause();
        }
        console.log('🔥 Fire paused for tier', tierIndex, '(alpha: 0)');
        return; // No need to update config when paused
      } else {
        // Resume fire effect when alpha > 0
        if (window.balatroFireInstance && typeof window.balatroFireInstance.resume === 'function') {
          window.balatroFireInstance.resume();
        }
        if (window.balatroFireInstanceSavings && typeof window.balatroFireInstanceSavings.resume === 'function') {
          window.balatroFireInstanceSavings.resume();
        }
      }
      
      window.balatroFireInstance.updateConfig({
        flameHeight: ti.fireFlameHeight !== undefined ? ti.fireFlameHeight : shakeSettings.fireFlameHeight,
        scale: ti.fireScale !== undefined ? ti.fireScale : shakeSettings.fireScale,
        speedY: ti.fireSpeedY !== undefined ? ti.fireSpeedY : shakeSettings.fireSpeedY,
        wobbleStrength: ti.fireWobble !== undefined ? ti.fireWobble : shakeSettings.fireWobble,
        threshold: ti.fireThreshold !== undefined ? ti.fireThreshold : shakeSettings.fireThreshold,
        detail: ti.fireDetail !== undefined ? ti.fireDetail : shakeSettings.fireDetail,
        aperture: ti.fireAperture !== undefined ? ti.fireAperture : shakeSettings.fireAperture,
        softness: ti.fireSoftness !== undefined ? ti.fireSoftness : shakeSettings.fireSoftness,
        sideFade: ti.fireSideFade !== undefined ? ti.fireSideFade : shakeSettings.fireSideFade,
        alpha: ti.fireAlpha !== undefined ? ti.fireAlpha : shakeSettings.fireAlpha,
        colorTop: hexToRgba(ti.fireColorTop || shakeSettings.fireColorTop),
        colorMid: hexToRgba(ti.fireColorMid || shakeSettings.fireColorMid),
        colorBot: hexToRgba(ti.fireColorBot || shakeSettings.fireColorBot)
      });
      
      // Update main fire canvas position
      var canvas = document.getElementById('balatro-fire-canvas');
      if (canvas) {
        var offsetX = ti.fireOffsetX !== undefined ? ti.fireOffsetX : shakeSettings.fireOffsetX;
        var offsetY = ti.fireOffsetY !== undefined ? ti.fireOffsetY : shakeSettings.fireOffsetY;
        var fireWidth = ti.fireWidth !== undefined ? ti.fireWidth : shakeSettings.fireWidth;
        var fireHeight = ti.fireHeight !== undefined ? ti.fireHeight : shakeSettings.fireHeight;
        
        canvas.style.left = offsetX + 'px';
        canvas.style.top = offsetY + 'px';
        canvas.style.width = fireWidth + '%';
        canvas.style.height = fireHeight + '%';
      }
      
      // Apply savings fire instance with SEPARATE colors
      if (window.balatroFireInstanceSavings) {
        window.balatroFireInstanceSavings.updateConfig({
          flameHeight: ti.fireFlameHeight !== undefined ? ti.fireFlameHeight : shakeSettings.fireFlameHeight,
          scale: ti.fireScale !== undefined ? ti.fireScale : shakeSettings.fireScale,
          speedY: ti.fireSpeedY !== undefined ? ti.fireSpeedY : shakeSettings.fireSpeedY,
          wobbleStrength: ti.fireWobble !== undefined ? ti.fireWobble : shakeSettings.fireWobble,
          threshold: ti.fireThreshold !== undefined ? ti.fireThreshold : shakeSettings.fireThreshold,
          detail: ti.fireDetail !== undefined ? ti.fireDetail : shakeSettings.fireDetail,
          aperture: ti.fireAperture !== undefined ? ti.fireAperture : shakeSettings.fireAperture,
          softness: ti.fireSoftness !== undefined ? ti.fireSoftness : shakeSettings.fireSoftness,
          sideFade: ti.fireSideFade !== undefined ? ti.fireSideFade : shakeSettings.fireSideFade,
          alpha: ti.fireAlpha !== undefined ? ti.fireAlpha : shakeSettings.fireAlpha,
          // Use savings-specific fire colors
          colorTop: hexToRgba(ti.savingsFireColorTop || '#f9c846'),
          colorMid: hexToRgba(ti.savingsFireColorMid || '#ff6b35'),
          colorBot: hexToRgba(ti.savingsFireColorBot || '#ff3366')
        });
      }
      
      // Update savings fire canvas position (SEPARATE position settings)
      var canvasSavings = document.getElementById('balatro-fire-canvas-savings');
      if (canvasSavings) {
        var savingsOffsetX = ti.savingsFireOffsetX !== undefined ? ti.savingsFireOffsetX : (shakeSettings.savingsFireOffsetX !== undefined ? shakeSettings.savingsFireOffsetX : (ti.fireOffsetX !== undefined ? ti.fireOffsetX : shakeSettings.fireOffsetX));
        var savingsOffsetY = ti.savingsFireOffsetY !== undefined ? ti.savingsFireOffsetY : (shakeSettings.savingsFireOffsetY !== undefined ? shakeSettings.savingsFireOffsetY : (ti.fireOffsetY !== undefined ? ti.fireOffsetY : shakeSettings.fireOffsetY));
        var savingsFireWidth = ti.savingsFireWidth !== undefined ? ti.savingsFireWidth : (shakeSettings.savingsFireWidth !== undefined ? shakeSettings.savingsFireWidth : (ti.fireWidth !== undefined ? ti.fireWidth : shakeSettings.fireWidth));
        var savingsFireHeight = ti.savingsFireHeight !== undefined ? ti.savingsFireHeight : (shakeSettings.savingsFireHeight !== undefined ? shakeSettings.savingsFireHeight : (ti.fireHeight !== undefined ? ti.fireHeight : shakeSettings.fireHeight));
        
        canvasSavings.style.left = savingsOffsetX + 'px';
        canvasSavings.style.top = savingsOffsetY + 'px';
        canvasSavings.style.width = savingsFireWidth + '%';
        canvasSavings.style.height = savingsFireHeight + '%';
      }
      
      // Update savings display button colors via CSS variables
      var savingsDisplay = document.querySelector('.bb-tier-savings-display');
      if (savingsDisplay) {
        savingsDisplay.style.setProperty('--savings-bg', ti.savingsBgColor || '#f9c846');
        savingsDisplay.style.setProperty('--savings-shadow', ti.savingsShadowColor || '#c49b30');
      }
    }

    // ========================================================================
    // FLOATING SETTINGS WIDGET - Performance & Volume Controls
    // Winamp-style aesthetic, draggable, positioned next to music player
    // ========================================================================
    function createFloatingWidget() {
      // Check if widget already exists
      if (document.getElementById('bb-floating-widget')) return;
      
      var widget = document.createElement('div');
      widget.id = 'bb-floating-widget';
      widget.innerHTML = 
        '<style>' +
        '#bb-floating-widget {' +
        '  position: fixed;' +
        '  top: 16px;' +
        '  right: 16px;' +
        '  z-index: 10001;' + // Above intro overlay (10000) +
        '  font-family: monospace;' +
        '  font-size: 10px;' +
        '  user-select: none;' +
        '}' +
        /* Winamp-style gear button */
        '#bb-floating-widget .gear-btn {' +
        '  width: 28px;' +
        '  height: 28px;' +
        '  border: none;' +
        '  background: linear-gradient(180deg, #3a3a3a 0%, #292929 50%, #1a1a1a 100%);' +
        '  border: 1px solid #505050;' +
        '  border-bottom-color: #101010;' +
        '  border-right-color: #101010;' +
        '  box-shadow: 0 2px 8px rgba(0,0,0,0.5);' +
        '  cursor: pointer;' +
        '  padding: 0;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  justify-content: center;' +
        '  z-index: 10002;' +
        '  transition: background 0.15s;' +
        '}' +
        '#bb-floating-widget .gear-btn:hover {' +
        '  background: linear-gradient(180deg, #4a4a4a 0%, #3a3a3a 50%, #2a2a2a 100%);' +
        '}' +
        '#bb-floating-widget .gear-btn.open {' +
        '  background: linear-gradient(180deg, #2a2a2a 0%, #1a1a1a 50%, #0a0a0a 100%);' +
        '}' +
        '#bb-floating-widget .gear-icon {' +
        '  width: 18px;' +
        '  height: 18px;' +
        '  fill: #c5bfcd;' +
        '  transition: transform 0.3s;' +
        '}' +
        '#bb-floating-widget .gear-btn:hover .gear-icon { transform: rotate(45deg); }' +
        '#bb-floating-widget .gear-btn.open .gear-icon { transform: rotate(90deg); }' +
        '#bb-floating-widget .settings-menu {' +
        '  position: absolute;' +
        '  top: 32px;' +
        '  right: 0;' +
        '  background: linear-gradient(180deg, #2a2a2a 0%, #1a1a1a 100%);' +
        '  border: 1px solid #505050;' +
        '  border-bottom-color: #101010;' +
        '  border-right-color: #101010;' +
        '  box-shadow: 0 4px 12px rgba(0,0,0,0.5);' +
        '  display: none;' +
        '  flex-direction: column;' +
        '  min-width: 180px;' +
        '  overflow: hidden;' +
        '  z-index: 10001;' +
        '}' +
        '#bb-floating-widget .settings-menu.open {' +
        '  display: flex;' +
        '}' +
        '#bb-floating-widget .menu-section {' +
        '  padding: 6px 0;' +
        '  border-bottom: 1px solid #333;' +
        '}' +
        '#bb-floating-widget .menu-section:last-child { border-bottom: none; }' +
        '#bb-floating-widget .menu-label {' +
        '  font-size: 8px;' +
        '  color: #0f0;' +
        '  padding: 4px 10px;' +
        '  text-transform: uppercase;' +
        '  letter-spacing: 1px;' +
        '  background: #000;' +
        '  border: 1px solid #333;' +
        '  margin: 2px 6px;' +
        '}' +
        '#bb-floating-widget .menu-option {' +
        '  padding: 6px 10px;' +
        '  font-size: 10px;' +
        '  color: #888;' +
        '  cursor: pointer;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 8px;' +
        '  transition: all 0.15s;' +
        '}' +
        '#bb-floating-widget .menu-option:hover { background: #222; color: #0f0; }' +
        '#bb-floating-widget .menu-option.active { color: #0f0; }' +
        '#bb-floating-widget .menu-option[data-tier="off"].active .dot { background: #666; }' +
        '#bb-floating-widget .menu-option[data-tier="low"].active .dot { background: #ff0; }' +
        '#bb-floating-widget .menu-option[data-tier="medium"].active .dot { background: #ff0; }' +
        '#bb-floating-widget .menu-option[data-tier="high"].active .dot { background: #0f0; }' +
        '#bb-floating-widget .dot {' +
        '  width: 6px;' +
        '  height: 6px;' +
        '  border-radius: 50%;' +
        '  background: #333;' +
        '  flex-shrink: 0;' +
        '}' +
        '#bb-floating-widget .vol-row {' +
        '  padding: 6px 10px;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 8px;' +
        '  cursor: pointer;' +
        '  transition: background 0.15s;' +
        '}' +
        '#bb-floating-widget .vol-row:hover { background: #222; }' +
        '#bb-floating-widget .vol-row.muted { opacity: 0.5; }' +
        '#bb-floating-widget .vol-icon {' +
        '  font-size: 12px;' +
        '  cursor: pointer;' +
        '}' +
        '#bb-floating-widget .sound-slider-row {' +
        '  padding: 4px 10px;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 6px;' +
        '}' +
        '#bb-floating-widget .sound-slider-row.disabled { opacity: 0.4; pointer-events: none; }' +
        '#bb-floating-widget .sound-slider-label {' +
        '  font-size: 9px;' +
        '  color: #888;' +
        '  min-width: 45px;' +
        '}' +
        '#bb-floating-widget .sound-slider {' +
        '  flex: 1;' +
        '  height: 4px;' +
        '  -webkit-appearance: none;' +
        '  appearance: none;' +
        '  background: #000;' +
        '  border: 1px solid #333;' +
        '  cursor: pointer;' +
        '}' +
        '#bb-floating-widget .sound-slider::-webkit-slider-thumb {' +
        '  -webkit-appearance: none;' +
        '  width: 10px;' +
        '  height: 10px;' +
        '  background: linear-gradient(180deg, #4a4a4a 0%, #2a2a2a 100%);' +
        '  border: 1px solid #0f0;' +
        '  cursor: pointer;' +
        '}' +
        '#bb-floating-widget .sound-slider::-moz-range-thumb {' +
        '  width: 10px;' +
        '  height: 10px;' +
        '  background: linear-gradient(180deg, #4a4a4a 0%, #2a2a2a 100%);' +
        '  border: 1px solid #0f0;' +
        '  cursor: pointer;' +
        '}' +
        '#bb-floating-widget .sound-slider-val {' +
        '  font-size: 9px;' +
        '  color: #0f0;' +
        '  min-width: 28px;' +
        '  text-align: right;' +
        '}' +
        '#bb-floating-widget .sound-toggle-icon {' +
        '  font-size: 11px;' +
        '  cursor: pointer;' +
        '  opacity: 0.8;' +
        '  transition: opacity 0.15s;' +
        '  position: relative;' +
        '}' +
        '#bb-floating-widget .sound-toggle-icon:hover { opacity: 1; }' +
        '#bb-floating-widget .sound-toggle-icon.off { opacity: 0.4; }' +
        '@media (hover: hover) {' +
        '  #bb-floating-widget .sound-toggle-icon:not(.off):hover::after {' +
        '    content: "🔇";' +
        '    position: absolute;' +
        '    left: 0;' +
        '    top: 0;' +
        '    background: #1a1a1a;' +
        '  }' +
        '}' +
        '@media (max-width: 768px) {' +
        '  #bb-floating-widget {' +
        '    top: 10px !important;' +
        '    right: auto !important;' +
        '    left: 10px !important;' +
        '  }' +
        '  #bb-floating-widget .gear-btn {' +
        '    background: none;' +
        '    border: none;' +
        '    box-shadow: none;' +
        '  }' +
        '  #bb-floating-widget .settings-menu {' +
        '    min-width: 330px !important;' +
        '    left: 0 !important;' +
        '    right: auto !important;' +
        '    top: 52px !important;' +
        '    border-radius: 12px !important;' +
        '    padding: 8px 0 !important;' +
        '  }' +
        '}' +
        '</style>' +
        '<button class="gear-btn" id="bb-gear-btn" title="Settings">' +
        '  <svg class="gear-icon" viewBox="0 0 48 48">' +
        '    <path d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97l-.75-5.3c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3c-1.22.51-2.35 1.17-3.38 1.97l-4.98-2.01c-.45-.17-.97 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31c-.08.64-.14 1.29-.14 1.95s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3c1.22-.51 2.35-1.17 3.38-1.97l4.98 2.01c.45.17.97 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zm-14.86 5.05c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>' +
        '  </svg>' +
        '</button>' +
        '<div class="settings-menu" id="bb-settings-menu">' +
        '  <div class="menu-section">' +
        '    <div class="menu-label">⚡ Performance</div>' +
        '    <div class="menu-option" data-tier="high"><span class="dot"></span>High</div>' +
        '    <div class="menu-option" data-tier="medium"><span class="dot"></span>Medium</div>' +
        '    <div class="menu-option" data-tier="low"><span class="dot"></span>Low</div>' +
        '    <div class="menu-option" data-tier="off"><span class="dot"></span>Off</div>' +
        '  </div>' +
        '  <div class="menu-section">' +
        '    <div class="menu-label">🔊 Sound</div>' +
        '    <div class="vol-row" id="bb-vol-row" title="Toggle All Sound">' +
        '      <span class="vol-icon" id="bb-vol-btn">🔊</span>' +
        '      <span style="font-size: 10px; color: #888;" id="bb-vol-label">All Sound</span>' +
        '    </div>' +
        '    <div class="sound-slider-row" id="bb-effects-row">' +
        '      <span class="sound-toggle-icon" id="bb-effects-toggle" title="Toggle Effects">🔊</span>' +
        '      <span class="sound-slider-label">Effects</span>' +
        '      <input type="range" class="sound-slider" id="bb-effects-slider" min="0" max="100" value="100">' +
        '      <span class="sound-slider-val" id="bb-effects-val">100%</span>' +
        '    </div>' +
        // Music controls now shown on mobile (Web Audio volume works on iOS)
        '    <div class="sound-slider-row" id="bb-music-row">' +
        '      <span class="sound-toggle-icon" id="bb-music-toggle" title="Toggle Music">🔊</span>' +
        '      <span class="sound-slider-label">Music</span>' +
        '      <input type="range" class="sound-slider" id="bb-music-slider" min="0" max="100" value="' + (Perf.isMobile ? '30' : '50') + '">' +
        '      <span class="sound-slider-val" id="bb-music-val">' + (Perf.isMobile ? '30' : '50') + '%</span>' +
        '    </div>' +
        '  </div>' +
        '</div>';
      
      document.body.appendChild(widget);
      
      var gearBtn = document.getElementById('bb-gear-btn');
      var menu = document.getElementById('bb-settings-menu');
      var isMuted = false;
      var previousVolume = 0.5;
      
      // Click to open menu
      gearBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        menu.classList.toggle('open');
        gearBtn.classList.toggle('open');
      });
      
      document.addEventListener('click', function() {
        menu.classList.remove('open');
        gearBtn.classList.remove('open');
      });
      
      menu.addEventListener('click', function(e) {
        e.stopPropagation();
      });
      
      // Tier selection
      var tierOptions = menu.querySelectorAll('.menu-option[data-tier]');
      tierOptions.forEach(function(option) {
        option.addEventListener('click', function() {
          var tier = this.dataset.tier;
          tierOptions.forEach(function(o) { o.classList.remove('active'); });
          this.classList.add('active');
          applyWidgetPerformanceSettings(tier);
        });
      });
      
      // Set initial tier
      var currentTier = Perf.tier || 'high';
      var initialOption = menu.querySelector('[data-tier="' + currentTier + '"]');
      if (initialOption) initialOption.classList.add('active');
      
      // All sound toggle - entire row is clickable
      var volRow = document.getElementById('bb-vol-row');
      var volIcon = document.getElementById('bb-vol-btn');
      var volLabel = document.getElementById('bb-vol-label');
      var effectsRow = document.getElementById('bb-effects-row');
      var musicRow = document.getElementById('bb-music-row');
      
      // Initialize from SoundSystem state
      function updateAllSoundUI() {
        if (window.SoundSystem) {
          var isEnabled = window.SoundSystem.isEnabled ? window.SoundSystem.isEnabled() : true;
          if (volIcon) volIcon.textContent = isEnabled ? '🔊' : '🔇';
          if (volRow) volRow.classList.toggle('muted', !isEnabled);
          if (volLabel) volLabel.textContent = isEnabled ? 'All Sound' : 'Muted';
          if (effectsRow) effectsRow.classList.toggle('disabled', !isEnabled);
          if (musicRow) musicRow.classList.toggle('disabled', !isEnabled);
        }
      }
      
      if (volRow) {
        volRow.addEventListener('click', function() {
          if (window.SoundSystem && window.SoundSystem.toggle) {
            var isEnabled = window.SoundSystem.toggle();
            updateAllSoundUI();
            // Also mute/unmute music player
            if (window.BBMusicPlayer && window.BBMusicPlayer.setVolume) {
              if (!isEnabled) {
                // Mute music player (save current volume first)
                window.BBMusicPlayer._savedVolume = window.BBMusicPlayer.getVolume ? window.BBMusicPlayer.getVolume() : 0.125;
                window.BBMusicPlayer.setVolume(0);
              } else {
                // Restore music player volume
                var savedVol = window.BBMusicPlayer._savedVolume || 0.125;
                window.BBMusicPlayer.setVolume(savedVol);
              }
            }
          }
        });
      }
      
      // Effects slider and toggle
      var effectsSlider = document.getElementById('bb-effects-slider');
      var effectsVal = document.getElementById('bb-effects-val');
      var effectsToggle = document.getElementById('bb-effects-toggle');
      
      if (effectsSlider && effectsToggle) {
        // Initialize effects slider from saved value
        if (window.SoundSystem && window.SoundSystem.getEffectsVolume) {
          var savedEffectsVol = Math.round(window.SoundSystem.getEffectsVolume() * 100);
          effectsSlider.value = savedEffectsVol;
          if (effectsVal) effectsVal.textContent = savedEffectsVol + '%';
        }
        
        // Initialize effects toggle state
        var updateEffectsToggleUI = function() {
          if (window.SoundSystem && window.SoundSystem.isEffectsEnabled) {
            var isEnabled = window.SoundSystem.isEffectsEnabled();
            if (effectsToggle) {
              effectsToggle.classList.toggle('off', !isEnabled);
              effectsToggle.textContent = isEnabled ? '🔊' : '🔇';
            }
          }
        };
        updateEffectsToggleUI();
        
        effectsSlider.addEventListener('input', function() {
          var val = parseInt(this.value);
          if (effectsVal) effectsVal.textContent = val + '%';
          if (window.SoundSystem && window.SoundSystem.setEffectsVolume) {
            window.SoundSystem.setEffectsVolume(val / 100);
          }
        });
        
        effectsToggle.addEventListener('click', function(e) {
          e.stopPropagation();
          if (window.SoundSystem && window.SoundSystem.toggleEffects) {
            window.SoundSystem.toggleEffects();
            updateEffectsToggleUI();
          }
        });
      }
      
      // Music slider and toggle - now enabled on mobile (Web Audio volume works on iOS)
      var musicSlider = document.getElementById('bb-music-slider');
      var musicVal = document.getElementById('bb-music-val');
      var musicToggle = document.getElementById('bb-music-toggle');
      
      if (musicSlider && musicToggle) {
        // Initialize music slider from saved value AND sync BBMusicPlayer
        if (window.SoundSystem && window.SoundSystem.getMusicVolume) {
          var savedMusicVol = Math.round(window.SoundSystem.getMusicVolume() * 100);
          musicSlider.value = savedMusicVol;
          musicVal.textContent = savedMusicVol + '%';
          
          // IMPORTANT: Also sync BBMusicPlayer to match slider on init
          // This fixes the bug where music plays quieter than the slider shows
          if (window.BBMusicPlayer && window.BBMusicPlayer.setVolume) {
            window.BBMusicPlayer.setVolume(savedMusicVol / 100);
          }
        }
        
        // Initialize music toggle state
        function updateMusicToggleUI() {
          if (window.SoundSystem && window.SoundSystem.isMusicEnabled) {
            var isEnabled = window.SoundSystem.isMusicEnabled();
            musicToggle.classList.toggle('off', !isEnabled);
            musicToggle.textContent = isEnabled ? '🔊' : '🔇';
          }
        }
        updateMusicToggleUI();
        
        musicSlider.addEventListener('input', function() {
          var val = parseInt(this.value);
          musicVal.textContent = val + '%';
          if (window.SoundSystem && window.SoundSystem.setMusicVolume) {
            window.SoundSystem.setMusicVolume(val / 100);
          }
          // Also update music player volume
          if (window.BBMusicPlayer && window.BBMusicPlayer.setVolume) {
            window.BBMusicPlayer.setVolume(val / 100);
          }
        });
        
        musicToggle.addEventListener('click', function(e) {
          e.stopPropagation();
          if (window.SoundSystem && window.SoundSystem.toggleMusic) {
            var isEnabled = window.SoundSystem.toggleMusic();
            updateMusicToggleUI();
            // Mute/unmute music player volume (don't pause - preserve playback position)
            if (window.BBMusicPlayer && window.BBMusicPlayer.setVolume) {
              if (!isEnabled) {
                // Mute music player (save current volume first)
                window.BBMusicPlayer._savedVolume = window.BBMusicPlayer.getVolume ? window.BBMusicPlayer.getVolume() : 0.125;
                window.BBMusicPlayer.setVolume(0);
              } else {
                // Restore music player volume
                var savedVol = window.BBMusicPlayer._savedVolume || 0.125;
                window.BBMusicPlayer.setVolume(savedVol);
              }
            }
          }
        });
      }
      
      // Initialize all sound UI
      updateAllSoundUI();
    }
    
    // ========================================================================
    // MINI CART WIDGET - Leaderboard-style compact view with expandable panel
    // Matches the leaderboard popup aesthetic
    // ========================================================================
    function createMiniCart() {
      if (document.getElementById('bb-mini-cart')) return;
      
      var cart = document.createElement('div');
      cart.id = 'bb-mini-cart';
      // SVG cart icon (pixelated style)
      var cartSvgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" style="width:25px;height:25px;fill:#d8d2df;filter:drop-shadow(0px 0px 1px #000a);"><path d="M33.825,28.43v-5.39h-5.4v-5.4h-16.18v5.4h10.79v5.39h5.39v37.75h5.4v-5.39h43.14v-5.4h5.39V50h5.4V28.43H33.825z M82.355,44.61h-5.39V50h-5.39v5.39h-37.75V33.82h48.53V44.61z M23.035,66.18h5.39v5.39h48.54v-5.39h5.39v10.78h-5.39v5.4h-10.79v-5.4h-21.57v5.4h-10.78v-5.4h-10.79V66.18z"/></svg>';
      
      cart.innerHTML = 
        '<style>' +
        /* Container - positioned bottom left, above progress bar */
        '#bb-mini-cart {' +
        '  position: fixed;' +
        '  bottom: 33px;' +
        '  left: 28px;' +
        '  z-index: 10002;' + /* Above settings widget (10001) and intro overlay (10000) */
        '  font-family: "m6x11plus", monospace;' +
        '  cursor: pointer;' +
        '  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);' +
        '}' +
        /* Minimal view - transparent style */
        '#bb-mini-cart .cart-minimal {' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 8px;' +
        '  padding: 8px 14px 8px 30px;' + /* Extra left padding to cover the offset count */
        '  margin-left: -16px;' + /* Pull container left to align visually */
        '  background: none;' +
        '  border: none;' +
        '  border-radius: 6px;' +
        '  box-shadow: none;' +
        '  transition: all 0.2s;' +
        '  cursor: pointer;' +
        '}' +
        '#bb-mini-cart .cart-minimal:hover {' +
        '  transform: translateY(-2px);' +
        '}' +
        '#bb-mini-cart .cart-icon {' +
        '  display: flex;' +
        '  align-items: center;' +
        '  pointer-events: none;' + /* Clicks pass through to parent .cart-minimal */
        '}' +
        '#bb-mini-cart .cart-icon svg {' +
        '  width: 20px;' +
        '  height: 20px;' +
        '  fill: var(--balatro-gold, #f59e0b);' +
        '}' +
        '#bb-mini-cart .cart-count {' +
        '  position: relative;' +
        '  left: -22px;' +
        '  top: -13px;' +
        '  font-size: 1rem;' +
        '  font-weight: 100;' +
        '  color: #0f0;' +
        '  font-family: "m6x11plus", monospace;' +
        '  min-width: 16px;' +
        '  text-shadow: 0 0 6px rgb(0 0 0 / 50%);' +
        '  pointer-events: none;' + /* Clicks pass through to parent .cart-minimal */
        '}' +
        '#bb-mini-cart .cart-count.empty {' +
        '  color: #666;' +
        '  text-shadow: none;' +
        '}' +
        /* Expanded panel - matches leaderboard expanded style */
        '#bb-mini-cart.expanded {' +
        '  bottom: 70px;' +
        '  cursor: default;' +
        '}' +
        '#bb-mini-cart.expanded .cart-minimal {' +
        '  display: none;' +
        '}' +
        '#bb-mini-cart .cart-panel {' +
        '  display: none;' +
        '  flex-direction: column;' +
        '  width: 300px;' +
        '  max-height: calc(100vh - 200px);' +
        '  background: linear-gradient(145deg, rgba(26, 26, 46, 0.98), rgba(22, 33, 62, 0.98));' +
        '  border: 2px solid rgba(255, 255, 255, 0.15);' +
        '  border-radius: 16px;' +
        '  backdrop-filter: blur(12px);' +
        '  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);' +
        '  overflow: hidden;' +
        '}' +
        '#bb-mini-cart.expanded .cart-panel {' +
        '  display: flex;' +
        '}' +
        /* Header - matching leaderboard style */
        '#bb-mini-cart .cart-header {' +
        '  display: flex;' +
        '  align-items: center;' +
        '  justify-content: space-between;' +
        '  padding: 14px 16px;' +
        '  border-bottom: 1px solid rgba(255, 255, 255, 0.1);' +
        '}' +
        '#bb-mini-cart .cart-title {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 1rem;' +
        '  color: var(--balatro-gold, #f59e0b);' +
        '  text-transform: uppercase;' +
        '  letter-spacing: 1px;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 10px;' +
        '}' +
        '#bb-mini-cart .cart-title svg {' +
        '  width: 22px;' +
        '  height: 22px;' +
        '  fill: var(--balatro-gold, #f59e0b);' +
        '}' +
        '#bb-mini-cart .cart-close {' +
        '  width: 28px;' +
        '  height: 28px;' +
        '  background: rgba(255, 255, 255, 0.1);' +
        '  border: 1px solid rgba(255, 255, 255, 0.2);' +
        '  border-radius: 6px;' +
        '  cursor: pointer;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  justify-content: center;' +
        '  transition: all 0.2s;' +
        '  color: #fff;' +
        '  font-size: 14px;' +
        '}' +
        '#bb-mini-cart .cart-close:hover {' +
        '  background: rgba(255, 255, 255, 0.2);' +
        '}' +
        /* Items list */
        '#bb-mini-cart .cart-items {' +
        '  flex: 1;' +
        '  overflow-y: auto;' +
        '  padding: 12px;' +
        '  display: flex;' +
        '  flex-direction: column;' +
        '  gap: 8px;' +
        '}' +
        '#bb-mini-cart .cart-items::-webkit-scrollbar { width: 6px; }' +
        '#bb-mini-cart .cart-items::-webkit-scrollbar-track { background: rgba(0,0,0,0.2); border-radius: 3px; }' +
        '#bb-mini-cart .cart-items::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 3px; }' +
        /* Individual item - like leaderboard team row */
        '#bb-mini-cart .cart-item {' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 10px;' +
        '  padding: 10px 12px;' +
        '  background: rgba(0, 0, 0, 0.3);' +
        '  border-radius: 8px;' +
        '  transition: all 0.2s;' +
        '}' +
        '#bb-mini-cart .cart-item:hover {' +
        '  background: rgba(0, 0, 0, 0.5);' +
        '}' +
        /* Complete Package item - highlighted gold border */
        '#bb-mini-cart .cart-item-complete-package {' +
        '  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(234, 179, 8, 0.1));' +
        '  border: 1px solid rgba(245, 158, 11, 0.4);' +
        '  box-shadow: 0 0 10px rgba(245, 158, 11, 0.2);' +
        '}' +
        '#bb-mini-cart .cart-item-complete-package:hover {' +
        '  background: linear-gradient(135deg, rgba(245, 158, 11, 0.25), rgba(234, 179, 8, 0.15));' +
        '}' +
        '#bb-mini-cart .cart-item-complete-package .cart-item-title {' +
        '  color: var(--balatro-gold, #f59e0b);' +
        '}' +
        '#bb-mini-cart .cart-item-emoji {' +
        '  font-size: 1.3rem;' +
        '  flex-shrink: 0;' +
        '}' +
        '#bb-mini-cart .cart-item-info {' +
        '  flex: 1;' +
        '  min-width: 0;' +
        '}' +
        '#bb-mini-cart .cart-item-title {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.85rem;' +
        '  font-weight: 100;' +
        '  color: #fff;' +
        '  white-space: nowrap;' +
        '  overflow: hidden;' +
        '  text-overflow: ellipsis;' +
        '}' +
        '#bb-mini-cart .cart-item-type {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.7rem;' +
        '  color: #888;' +
        '  text-transform: uppercase;' +
        '  letter-spacing: 0.5px;' +
        '  margin-top: 2px;' +
        '}' +
        '#bb-mini-cart .cart-item-prices {' +
        '  display: flex;' +
        '  flex-direction: column;' +
        '  align-items: flex-end;' +
        '  gap: 2px;' +
        '  flex-shrink: 0;' +
        '}' +
        '#bb-mini-cart .cart-item-price {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.85rem;' +
        '  font-weight: 100;' +
        '  color: #22c55e;' +
        '}' +
        '#bb-mini-cart .cart-item-original {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.65rem;' +
        '  color: #888;' +
        '  text-decoration: line-through;' +
        '  opacity: 0.7;' +
        '}' +
        '#bb-mini-cart .cart-item-saving {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.65rem;' +
        '  color: #f59e0b;' +
        '  opacity: 0.9;' +
        '}' +
        /* Cart Summary */
        '#bb-mini-cart .cart-summary {' +
        '  margin-top: 12px;' +
        '  padding: 12px;' +
        '  background: rgba(0, 0, 0, 0.4);' +
        '  border-radius: 8px;' +
        '  border-top: 1px solid rgba(255, 255, 255, 0.1);' +
        '}' +
        '#bb-mini-cart .cart-summary-row {' +
        '  display: flex;' +
        '  justify-content: space-between;' +
        '  align-items: center;' +
        '  padding: 4px 0;' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.8rem;' +
        '}' +
        '#bb-mini-cart .cart-summary-label {' +
        '  color: #888;' +
        '}' +
        '#bb-mini-cart .cart-summary-value {' +
        '  color: #fff;' +
        '  font-weight: 100;' +
        '}' +
        '#bb-mini-cart .cart-summary-strikethrough {' +
        '  text-decoration: line-through;' +
        '  opacity: 0.6;' +
        '}' +
        '#bb-mini-cart .cart-summary-discount {' +
        '  color: #22c55e;' +
        '}' +
        '#bb-mini-cart .cart-summary-discount .cart-summary-label,' +
        '#bb-mini-cart .cart-summary-discount .cart-summary-value {' +
        '  color: #22c55e;' +
        '}' +
        '#bb-mini-cart .cart-summary-total {' +
        '  border-top: 1px solid rgba(255, 255, 255, 0.2);' +
        '  margin-top: 8px;' +
        '  padding-top: 8px;' +
        '}' +
        '#bb-mini-cart .cart-summary-total .cart-summary-label {' +
        '  color: #fff;' +
        '  font-size: 0.9rem;' +
        '}' +
        '#bb-mini-cart .cart-summary-total .cart-summary-value {' +
        '  color: #22c55e;' +
        '  font-size: 1.1rem;' +
        '  text-shadow: 0 0 10px rgba(34, 197, 94, 0.5);' +
        '}' +
        '#bb-mini-cart .cart-summary-savings {' +
        '  text-align: center;' +
        '  padding: 8px;' +
        '  margin-top: 8px;' +
        '  background: linear-gradient(135deg, rgba(34, 197, 94, 0.2), rgba(16, 185, 129, 0.1));' +
        '  border-radius: 6px;' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.85rem;' +
        '  color: #22c55e;' +
        '  font-weight: 100;' +
        '}' +
        /* Checkout button in cart */
        '#bb-mini-cart .cart-checkout-btn {' +
        '  width: 100%;' +
        '  margin-top: 12px;' +
        '  padding: 14px 20px;' +
        '  border: none;' +
        '  border-radius: 8px;' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 1rem;' +
        '  font-weight: 800;' +
        '  letter-spacing: 1px;' +
        '  cursor: pointer;' +
        '  color: #fff;' +
        '  text-shadow: 0 2px 4px rgba(0,0,0,0.5), 0 0 10px rgba(255,255,255,0.3);' +
        '  background: linear-gradient(90deg, #ff6b6b, #feca57, #48dbfb, #ff9ff3, #54a0ff, #5f27cd, #ff6b6b);' +
        '  background-size: 300% 100%;' +
        '  animation: bb-rainbow-shift 3s ease infinite, bb-cart-checkout-glow 2s ease-in-out infinite;' +
        '  transition: transform 0.2s, filter 0.2s;' +
        '}' +
        '#bb-mini-cart .cart-checkout-btn:hover {' +
        '  transform: translateY(-2px) scale(1.02);' +
        '  filter: brightness(1.15);' +
        '}' +
        '#bb-mini-cart .cart-checkout-btn:active {' +
        '  transform: translateY(1px) scale(0.98);' +
        '}' +
        '@keyframes bb-cart-checkout-glow {' +
        '  0%, 100% { box-shadow: 0 4px 15px rgba(255, 100, 150, 0.4); }' +
        '  50% { box-shadow: 0 4px 25px rgba(100, 200, 255, 0.6); }' +
        '}' +
        /* Free Hat Banner */
        '.bb-free-hat-banner {' +
        '  background: linear-gradient(135deg, rgba(234, 179, 8, 0.2), rgba(245, 158, 11, 0.1));' +
        '  border: 1px solid rgba(234, 179, 8, 0.4);' +
        '  border-radius: 8px;' +
        '  padding: 12px;' +
        '  margin-bottom: 12px;' +
        '  animation: bb-hat-pulse 2s ease-in-out infinite;' +
        '}' +
        '.bb-hat-content {' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 10px;' +
        '}' +
        '.bb-hat-icon {' +
        '  font-size: 2rem;' +
        '  animation: bb-hat-wobble 1s ease-in-out infinite;' +
        '}' +
        '.bb-hat-text {' +
        '  flex: 1;' +
        '}' +
        '.bb-hat-title {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.9rem;' +
        '  font-weight: 800;' +
        '  color: #fbbf24;' +
        '  text-shadow: 0 2px 0 rgba(0,0,0,0.5);' +
        '}' +
        '.bb-hat-subtitle {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.7rem;' +
        '  color: #888;' +
        '  margin-top: 2px;' +
        '}' +
        '.bb-hat-selector {' +
        '  flex-shrink: 0;' +
        '}' +
        '.bb-hat-select {' +
        '  background: rgba(0,0,0,0.4);' +
        '  border: 1px solid rgba(234, 179, 8, 0.4);' +
        '  border-radius: 4px;' +
        '  color: #fff;' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.75rem;' +
        '  padding: 6px 10px;' +
        '  cursor: pointer;' +
        '}' +
        '.bb-hat-select:focus {' +
        '  outline: none;' +
        '  border-color: #fbbf24;' +
        '}' +
        '.bb-hat-checkmark {' +
        '  color: #22c55e;' +
        '  font-size: 1.2rem;' +
        '  font-weight: bold;' +
        '}' +
        '@keyframes bb-hat-pulse {' +
        '  0%, 100% { box-shadow: 0 0 10px rgba(234, 179, 8, 0.2); }' +
        '  50% { box-shadow: 0 0 20px rgba(234, 179, 8, 0.4); }' +
        '}' +
        '@keyframes bb-hat-wobble {' +
        '  0%, 100% { transform: rotate(-5deg); }' +
        '  50% { transform: rotate(5deg); }' +
        '}' +
        /* Free Shipping Badge */
        '.bb-free-shipping-badge {' +
        '  display: inline-flex;' +
        '  align-items: center;' +
        '  gap: 6px;' +
        '  background: linear-gradient(135deg, rgba(34, 197, 94, 0.2), rgba(16, 185, 129, 0.1));' +
        '  border: 1px solid rgba(34, 197, 94, 0.4);' +
        '  border-radius: 6px;' +
        '  padding: 8px 12px;' +
        '  margin-top: 10px;' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.8rem;' +
        '  color: #22c55e;' +
        '  font-weight: 100;' +
        '  text-shadow: 0 2px 0 rgba(0,0,0,0.5);' +
        '}' +
        '.bb-shipping-icon {' +
        '  font-size: 1.1rem;' +
        '}' +
        /* Remove button */
        '#bb-mini-cart .cart-item-remove {' +
        '  width: 22px;' +
        '  height: 22px;' +
        '  background: rgba(239, 68, 68, 0.2);' +
        '  border: 1px solid rgba(239, 68, 68, 0.4);' +
        '  border-radius: 4px;' +
        '  color: #ef4444;' +
        '  font-size: 12px;' +
        '  cursor: pointer;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  justify-content: center;' +
        '  flex-shrink: 0;' +
        '  opacity: 0.6;' +
        '  transition: all 0.2s;' +
        '}' +
        '#bb-mini-cart .cart-item-remove:hover {' +
        '  opacity: 1;' +
        '  background: rgba(239, 68, 68, 0.4);' +
        '  transform: scale(1.1);' +
        '}' +
        /* Section headers */
        '#bb-mini-cart .cart-section {' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.7rem;' +
        '  color: #888;' +
        '  text-transform: uppercase;' +
        '  letter-spacing: 1px;' +
        '  padding: 8px 4px 4px;' +
        '  margin-top: 4px;' +
        '}' +
        '#bb-mini-cart .cart-section:first-child { margin-top: 0; }' +
        /* Empty state */
        '#bb-mini-cart .cart-empty {' +
        '  padding: 30px 20px;' +
        '  text-align: center;' +
        '  color: #888;' +
        '  font-family: "m6x11plus", monospace;' +
        '  font-size: 0.85rem;' +
        '}' +
        '#bb-mini-cart .cart-empty-icon {' +
        '  font-size: 2rem;' +
        '  margin-bottom: 8px;' +
        '  opacity: 0.5;' +
        '}' +
        /* Mobile backdrop for click-outside */
        '#bb-mini-cart-backdrop {' +
        '  display: none;' +
        '  position: fixed;' +
        '  top: 0;' +
        '  left: 0;' +
        '  right: 0;' +
        '  bottom: 0;' +
        '  background: rgba(0, 0, 0, 0.5);' +
        '  z-index: 99;' +
        '}' +
        '#bb-mini-cart-backdrop.visible { display: block; }' +
        /* Mobile adjustments - cart on right, hide mute button */
        '@media (max-width: 768px) {' +
        '  #bb-mini-cart { top: 10px; bottom: auto; left: unset !important; right: -20px; }' +
        '  #bb-mini-cart.expanded {' +
        '    top: 10px;' +
        '    left: 10px;' +
        '    right: 10px;' +
        '    bottom: auto;' +
        '    z-index: 10100;' +
        '  }' +
        '  #bb-mini-cart .cart-panel {' +
        '    width: auto;' +
        '    max-height: calc(100vh - 250px);' +
        '  }' +
        '  /* Hide mute button and music player on mobile */' +
        '  #bb-sound-toggle { display: none !important; }' +
        '  #bb-music-player { display: none !important; }' +
        '}' +
        '</style>' +
        '<div class="cart-minimal" id="bb-cart-minimal">' +
        '  <span class="cart-icon">' + cartSvgIcon + '</span>' +
        '  <span class="cart-count empty" id="bb-cart-count">0</span>' +
        '</div>' +
        '<div class="cart-panel" id="bb-cart-panel">' +
        '  <div class="cart-header">' +
        '    <span class="cart-title">' + cartSvgIcon + ' Your Bundle</span>' +
        '    <button class="cart-close" id="bb-cart-close">✕</button>' +
        '  </div>' +
        '  <div class="cart-items" id="bb-cart-items">' +
        '    <div class="cart-empty">' +
        '      <div class="cart-empty-icon">📦</div>' +
        '      No items added yet' +
        '    </div>' +
        '  </div>' +
        '</div>';
      
      // Create backdrop for mobile
      var backdrop = document.createElement('div');
      backdrop.id = 'bb-mini-cart-backdrop';
      document.body.appendChild(backdrop);
      
      document.body.appendChild(cart);
      
      var cartMinimal = document.getElementById('bb-cart-minimal');
      var cartPanel = document.getElementById('bb-cart-panel');
      var cartClose = document.getElementById('bb-cart-close');
      
      function closeCart() {
        cart.classList.remove('expanded');
        backdrop.classList.remove('visible');
      }
      
      // Click on minimal view to expand
      cartMinimal.addEventListener('click', function(e) {
        e.stopPropagation();
        cart.classList.add('expanded');
        updateMiniCartDisplay();
        if (window.innerWidth <= 768) {
          backdrop.classList.add('visible');
        }
      });
      
      // Close button
      cartClose.addEventListener('click', function(e) {
        e.stopPropagation();
        closeCart();
      });
      
      // Backdrop click to close
      backdrop.addEventListener('click', function(e) {
        e.stopPropagation();
        closeCart();
      });
      
      // Close when clicking outside (desktop) - but NOT when clicking on product cards
      document.addEventListener('click', function(e) {
        if (cart.classList.contains('expanded') && !cart.contains(e.target)) {
          // Don't close if clicking on a product card (adding/removing items)
          if (e.target.closest('.bb-balatro-card') || 
              e.target.closest('.bb-product-card') || 
              e.target.closest('.bb-upgrade-card') ||
              e.target.closest('.bb-physical-card') ||
              e.target.closest('.bb-goodie-card')) {
            return;
          }
          closeCart();
        }
      });
    }
    
    // Update mini cart display
    function updateMiniCartDisplay() {
      var cartCount = document.getElementById('bb-cart-count');
      var cartItems = document.getElementById('bb-cart-items');
      if (!cartCount || !cartItems) return;
      
      // Build lists of items NOT in complete packages
      var activePackages = state.activeCompletePackages || [];
      var skipDigitalIds = [];
      var skipVideoIds = [];
      var skipPhysicalIds = [];
      
      activePackages.forEach(function(pkg) {
        skipDigitalIds.push(String(pkg.digitalVariantId));
        skipVideoIds.push(String(pkg.videoVariantId));
        skipPhysicalIds.push(String(pkg.physicalVariantId));
      });
      
      // Filter out items that are part of complete packages
      var standaloneProducts = state.selectedProducts.filter(function(p) {
        return skipDigitalIds.indexOf(String(p.variantId)) === -1;
      });
      var standaloneUpgrades = state.selectedUpgrades.filter(function(u) {
        return skipVideoIds.indexOf(String(u.variantId)) === -1;
      });
      var standalonePhysical = (state.selectedPhysical || []).filter(function(p) {
        return skipPhysicalIds.indexOf(String(p.variantId)) === -1;
      });
      
      // Count all items (complete packages count as 3 items each for tier purposes)
      var total = state.selectedProducts.length + 
                  state.selectedUpgrades.length + 
                  (state.selectedPhysical ? state.selectedPhysical.length : 0) + 
                  (state.selectedDigitalGoodies ? state.selectedDigitalGoodies.length : 0);
      
      // Update count badge
      cartCount.textContent = total;
      cartCount.classList.toggle('empty', total === 0);
      
      // Calculate totals for summary
      var subtotalBeforeDiscount = 0;
      var totalAfterDiscount = 0;
      var discountMultiplier = 1 - (state.discountTier / 100);
      
      // Build item list with new leaderboard-style layout
      var html = '';
      
      if (total === 0) {
        html = '<div class="cart-empty">' +
          '<div class="cart-empty-icon">📦</div>' +
          'No items added yet' +
        '</div>';
      } else {
        // Complete Packages (shown first, highlighted)
        if (activePackages.length > 0) {
          html += '<div class="cart-section">⭐ Complete Packages (' + activePackages.length + ')</div>';
          activePackages.forEach(function(pkg, i) {
            var originalPrice = pkg.completePackageComparePrice || pkg.completePackagePrice;
            var discountedPrice = pkg.completePackagePrice * discountMultiplier;
            var saving = originalPrice - discountedPrice;
            subtotalBeforeDiscount += originalPrice;
            totalAfterDiscount += discountedPrice;
            
            html += '<div class="cart-item cart-item-complete-package">' +
              '<span class="cart-item-emoji">🎁</span>' +
              '<div class="cart-item-info">' +
                '<div class="cart-item-title">' + pkg.deckName + '</div>' +
                '<div class="cart-item-type">Digital + Video + Physical</div>' +
              '</div>' +
              '<div class="cart-item-prices">' +
                '<span class="cart-item-price">' + formatMoneyWithSymbol(discountedPrice) + '</span>' +
                (saving > 0 ? '<span class="cart-item-original">' + formatMoneyWithSymbol(originalPrice) + '</span><span class="cart-item-saving">' + formatMoneyWithSymbol(saving) + ' saved</span>' : '') +
              '</div>' +
            '</div>';
          });
        }
        
        // Standalone Products (Digital Decks not in a complete package)
        if (standaloneProducts.length > 0) {
          html += '<div class="cart-section">🃏 Digital Decks (' + standaloneProducts.length + ')</div>';
          standaloneProducts.forEach(function(p, i) {
            var displayTitle = p.title || 'Product';
            var variantInfo = p.variantTitle || 'Digital Only';
            var originalPrice = p.comparePrice || p.price || 0;
            var discountedPrice = (p.price || 0) * discountMultiplier;
            var saving = originalPrice - discountedPrice;
            subtotalBeforeDiscount += originalPrice;
            totalAfterDiscount += discountedPrice;
            
            html += '<div class="cart-item">' +
              '<span class="cart-item-emoji">🎴</span>' +
              '<div class="cart-item-info">' +
                '<div class="cart-item-title">' + displayTitle + '</div>' +
                '<div class="cart-item-type">' + variantInfo + '</div>' +
              '</div>' +
              '<div class="cart-item-prices">' +
                '<span class="cart-item-price">' + formatMoneyWithSymbol(discountedPrice) + '</span>' +
                (saving > 0 ? '<span class="cart-item-original">' + formatMoneyWithSymbol(originalPrice) + '</span><span class="cart-item-saving">' + formatMoneyWithSymbol(saving) + ' saved</span>' : '') +
              '</div>' +
            '</div>';
          });
        }
        
        // Standalone Physical Products (not in a complete package)
        if (standalonePhysical.length > 0) {
          var totalPhysicalQty = standalonePhysical.reduce(function(sum, p) { return sum + (p.quantity || 1); }, 0);
          html += '<div class="cart-section">📦 Physical Decks (' + totalPhysicalQty + ')</div>';
          standalonePhysical.forEach(function(p, i) {
            var qty = p.quantity || 1;
            var physVariant = p.variantTitle || 'Physical Deck';
            var qtyLabel = qty > 1 ? ' x' + qty : '';
            var originalPrice = (p.comparePrice || p.price || 0) * qty;
            var discountedPrice = (p.price || 0) * qty * discountMultiplier;
            var saving = originalPrice - discountedPrice;
            subtotalBeforeDiscount += originalPrice;
            totalAfterDiscount += discountedPrice;
            
            html += '<div class="cart-item">' +
              '<span class="cart-item-emoji">🎁</span>' +
              '<div class="cart-item-info">' +
                '<div class="cart-item-title">' + (p.title || 'Physical Item').replace(' (Physical)', '') + qtyLabel + '</div>' +
                '<div class="cart-item-type">' + physVariant + '</div>' +
              '</div>' +
              '<div class="cart-item-prices">' +
                '<span class="cart-item-price">' + formatMoneyWithSymbol(discountedPrice) + '</span>' +
                (saving > 0 ? '<span class="cart-item-original">' + formatMoneyWithSymbol(originalPrice) + '</span><span class="cart-item-saving">' + formatMoneyWithSymbol(saving) + ' saved</span>' : '') +
              '</div>' +
            '</div>';
          });
        }
        
        // Digital Goodies
        if (state.selectedDigitalGoodies && state.selectedDigitalGoodies.length > 0) {
          html += '<div class="cart-section">✨ Goodies (' + state.selectedDigitalGoodies.length + ')</div>';
          state.selectedDigitalGoodies.forEach(function(g, i) {
            var goodieVariant = g.variantTitle || 'Digital';
            var originalPrice = g.comparePrice || g.price || 0;
            var discountedPrice = (g.price || 0) * discountMultiplier;
            var saving = originalPrice - discountedPrice;
            subtotalBeforeDiscount += originalPrice;
            totalAfterDiscount += discountedPrice;
            
            html += '<div class="cart-item">' +
              '<span class="cart-item-emoji">💎</span>' +
              '<div class="cart-item-info">' +
                '<div class="cart-item-title">' + (g.title || 'Digital Goodie') + '</div>' +
                '<div class="cart-item-type">' + goodieVariant + '</div>' +
              '</div>' +
              '<div class="cart-item-prices">' +
                '<span class="cart-item-price">' + formatMoneyWithSymbol(discountedPrice) + '</span>' +
                (saving > 0 ? '<span class="cart-item-original">' + formatMoneyWithSymbol(originalPrice) + '</span><span class="cart-item-saving">' + formatMoneyWithSymbol(saving) + ' saved</span>' : '') +
              '</div>' +
            '</div>';
          });
        }
        
        // Standalone Upgrades (Video Libraries not in a complete package)
        if (standaloneUpgrades.length > 0) {
          html += '<div class="cart-section">🎬 Upgrades (' + standaloneUpgrades.length + ')</div>';
          standaloneUpgrades.forEach(function(u, i) {
            var baseTitle = (u.title || 'Upgrade').split(' Videos')[0].split(' Templates')[0];
            var originalPrice = u.comparePrice || u.price || 0;
            var discountedPrice = (u.price || 0) * discountMultiplier;
            var saving = originalPrice - discountedPrice;
            subtotalBeforeDiscount += originalPrice;
            totalAfterDiscount += discountedPrice;
            
            html += '<div class="cart-item">' +
              '<span class="cart-item-emoji">📹</span>' +
              '<div class="cart-item-info">' +
                '<div class="cart-item-title">' + baseTitle + '</div>' +
                '<div class="cart-item-type">Videos & Templates</div>' +
              '</div>' +
              '<div class="cart-item-prices">' +
                '<span class="cart-item-price">' + formatMoneyWithSymbol(discountedPrice) + '</span>' +
                (saving > 0 ? '<span class="cart-item-original">' + formatMoneyWithSymbol(originalPrice) + '</span><span class="cart-item-saving">' + formatMoneyWithSymbol(saving) + ' saved</span>' : '') +
              '</div>' +
            '</div>';
          });
        }
        
        // Add summary section
        var totalSavings = subtotalBeforeDiscount - totalAfterDiscount;
        html += '<div class="cart-summary">' +
          '<div class="cart-summary-row">' +
            '<span class="cart-summary-label">Subtotal (RRP)</span>' +
            '<span class="cart-summary-value cart-summary-strikethrough">' + formatMoneyWithSymbol(subtotalBeforeDiscount) + '</span>' +
          '</div>' +
          (state.discountTier > 0 ? 
            '<div class="cart-summary-row cart-summary-discount">' +
              '<span class="cart-summary-label">Discount (' + state.discountTier + '% off)</span>' +
              '<span class="cart-summary-value">-' + formatMoneyWithSymbol(totalSavings) + '</span>' +
            '</div>' : '') +
          '<div class="cart-summary-row cart-summary-total">' +
            '<span class="cart-summary-label">Your Total</span>' +
            '<span class="cart-summary-value">' + formatMoneyWithSymbol(totalAfterDiscount) + '</span>' +
          '</div>' +
          (totalSavings > 0 ? 
            '<div class="cart-summary-savings">' +
              '🎉 You save ' + formatMoneyWithSymbol(totalSavings) + ' today!' +
            '</div>' : '') +
        '</div>' +
        // Add checkout button
        '<button class="cart-checkout-btn" id="bb-cart-checkout-btn">🛒 Checkout</button>';
      }
      
      cartItems.innerHTML = html;
      
      // Attach checkout button listener
      var cartCheckoutBtn = document.getElementById('bb-cart-checkout-btn');
      if (cartCheckoutBtn) {
        cartCheckoutBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          window.SoundSystem && window.SoundSystem.play('button-click', null, 1.0);
          handleCheckout();
        });
      }
    }
    
    /**
     * Robust card deselection - finds and deselects ALL matching cards
     * Handles carousel clones and different card class variations
     */
    function deselectDigitalCard(variantId) {
      // Try all possible selectors for digital/product cards
      var selectors = [
        '.bb-balatro-card[data-variant-id="' + variantId + '"]',
        '.bb-product-card[data-variant-id="' + variantId + '"]',
        '[data-variant-id="' + variantId + '"]'
      ];
      
      selectors.forEach(function(sel) {
        // Use querySelectorAll to get ALL matching elements (including clones)
        var cards = container.querySelectorAll(sel);
        cards.forEach(function(card) {
          card.classList.remove('selected');
        });
        // Also search document-wide for any stray elements
        document.querySelectorAll(sel).forEach(function(card) {
          card.classList.remove('selected');
        });
      });
    }
    
    function deselectUpgradeCard(variantId) {
      var selectors = [
        '.bb-upgrade-item[data-variant-id="' + variantId + '"]',
        '.bb-upgrade-card[data-variant-id="' + variantId + '"]',
        '[data-variant-id="' + variantId + '"].selected'
      ];
      
      selectors.forEach(function(sel) {
        container.querySelectorAll(sel).forEach(function(card) {
          card.classList.remove('selected');
        });
        document.querySelectorAll(sel).forEach(function(card) {
          card.classList.remove('selected');
        });
      });
    }
    
    function deselectPhysicalCard(productId, variantId) {
      var selectors = [
        '.bb-model-card[data-product-id="' + productId + '"]',
        '.bb-model-card[data-variant-id="' + variantId + '"]'
      ];
      
      selectors.forEach(function(sel) {
        container.querySelectorAll(sel).forEach(function(card) {
          card.classList.remove('bb-model-selected');
          var addBtn = card.querySelector('.bb-model-add-btn');
          if (addBtn) {
            addBtn.innerHTML = '<span class="bb-model-add-icon">+</span> Add to Bundle';
            addBtn.classList.remove('bb-model-btn-selected');
          }
          var qtyContainer = card.querySelector('.bb-model-qty-container');
          if (qtyContainer) {
            qtyContainer.classList.remove('bb-qty-visible');
            var qtyDisplay = qtyContainer.querySelector('.bb-model-qty-value');
            if (qtyDisplay) qtyDisplay.textContent = '1';
          }
        });
      });
    }
    
    // Remove item from cart
    function removeFromMiniCart(type, index, deckName) {
      var removed = null;
      
      switch(type) {
        case 'complete-package':
          // Remove all 3 components of the complete package
          var pkg = (state.activeCompletePackages || []).find(function(p) { return p.deckName === deckName; });
          if (pkg) {
            // Remove digital
            var digitalIdx = state.selectedProducts.findIndex(function(p) { return String(p.variantId) === String(pkg.digitalVariantId); });
            if (digitalIdx !== -1) {
              var digitalRemoved = state.selectedProducts.splice(digitalIdx, 1)[0];
              if (digitalRemoved) {
                deselectDigitalCard(digitalRemoved.variantId);
              }
            }
            // Remove video
            var videoIdx = state.selectedUpgrades.findIndex(function(u) { return String(u.variantId) === String(pkg.videoVariantId); });
            if (videoIdx !== -1) {
              var videoRemoved = state.selectedUpgrades.splice(videoIdx, 1)[0];
              if (videoRemoved) {
                deselectUpgradeCard(videoRemoved.variantId);
              }
            }
            // Remove physical
            if (state.selectedPhysical) {
              var physIdx = state.selectedPhysical.findIndex(function(p) { return String(p.variantId) === String(pkg.physicalVariantId); });
              if (physIdx !== -1) {
                var physRemoved = state.selectedPhysical.splice(physIdx, 1)[0];
                if (physRemoved) {
                  deselectPhysicalCard(physRemoved.productId, physRemoved.variantId);
                }
              }
            }
            // Also remove from detected packages tracking
            var trackIdx = state.detectedCompletePackages.indexOf(deckName);
            if (trackIdx !== -1) state.detectedCompletePackages.splice(trackIdx, 1);
          }
          break;
        case 'product':
          removed = state.selectedProducts.splice(index, 1)[0];
          if (removed) {
            deselectDigitalCard(removed.variantId);
          }
          break;
        case 'upgrade':
          removed = state.selectedUpgrades.splice(index, 1)[0];
          if (removed) {
            deselectUpgradeCard(removed.variantId);
          }
          break;
        case 'physical':
          if (state.selectedPhysical) {
            removed = state.selectedPhysical.splice(index, 1)[0];
            if (removed) {
              deselectPhysicalCard(removed.productId, removed.variantId);
            }
          }
          break;
        case 'goodies':
          if (state.selectedDigitalGoodies) {
            removed = state.selectedDigitalGoodies.splice(index, 1)[0];
            if (removed) {
              var selectors = [
                '.bb-goodies-item[data-variant-id="' + removed.variantId + '"]',
                '.bb-goodie-card[data-variant-id="' + removed.variantId + '"]'
              ];
              selectors.forEach(function(sel) {
                container.querySelectorAll(sel).forEach(function(card) {
                  card.classList.remove('selected');
                });
              });
            }
          }
          break;
      }
      
      // Play deselect sound
      if (window.SoundSystem) {
        window.SoundSystem.play('card-deselect', null, 0.5);
      }
      
      // Update calculations and display
      updateCalculation(true);
      updateMiniCartDisplay();
    }
    
    // ========================================================================
    // MUSIC PLAYER WIDGET - Minimal Winamp-style player
    // Pulls ambient-loop tracks from Strapi and reads ID3 metadata
    // 3 states: collapsed (cube) → expanded (row) → expanded+playlist
    // ========================================================================
    function createMusicPlayer() {
      // Check if player already exists
      if (document.getElementById('bb-music-player')) return;
      
      // Tracks will be loaded from Strapi
      var TRACKS = [];
      var currentTrackIndex = 0;
      var isPlaying = false;
      var expandState = 0; // 0 = cube, 1 = row, 2 = row+playlist
      var expandDirection = 1; // 1 = expanding, -1 = collapsing
      var audioContext = null;
      var analyser = null;
      var animationFrame = null;
      var tracksLoaded = false;
      var autoplayPending = true; // Will autoplay when tracks load
      
      // Mobile detection (consistent with bb-sound.js)
      var isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                 (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      // Skip creation entirely on mobile if music is disabled
      if (isMobile) {
        console.log('📱 Mobile detected - Music player disabled');
        return;
      }
      
      // ========== ID3 METADATA PARSER ==========
      // Parses ID3v1 and ID3v2 tags from MP3 files
      function parseID3(arrayBuffer) {
        var view = new DataView(arrayBuffer);
        var result = { title: '', artist: '' };
        
        // Try ID3v2 first (at start of file)
        if (view.byteLength > 10) {
          var id3v2 = String.fromCharCode(view.getUint8(0), view.getUint8(1), view.getUint8(2));
          if (id3v2 === 'ID3') {
            var version = view.getUint8(3);
            var size = ((view.getUint8(6) & 0x7f) << 21) | 
                       ((view.getUint8(7) & 0x7f) << 14) | 
                       ((view.getUint8(8) & 0x7f) << 7) | 
                       (view.getUint8(9) & 0x7f);
            
            var offset = 10;
            var maxOffset = Math.min(offset + size, view.byteLength);
            
            while (offset < maxOffset - 10) {
              var frameId = String.fromCharCode(
                view.getUint8(offset), view.getUint8(offset + 1),
                view.getUint8(offset + 2), view.getUint8(offset + 3)
              );
              
              if (frameId === '\0\0\0\0') break;
              
              var frameSize;
              if (version === 4) {
                frameSize = ((view.getUint8(offset + 4) & 0x7f) << 21) |
                            ((view.getUint8(offset + 5) & 0x7f) << 14) |
                            ((view.getUint8(offset + 6) & 0x7f) << 7) |
                            (view.getUint8(offset + 7) & 0x7f);
              } else {
                frameSize = (view.getUint8(offset + 4) << 24) |
                            (view.getUint8(offset + 5) << 16) |
                            (view.getUint8(offset + 6) << 8) |
                            view.getUint8(offset + 7);
              }
              
              if (frameSize <= 0 || frameSize > maxOffset - offset) break;
              
              var headerSize = 10;
              var dataStart = offset + headerSize;
              var encoding = view.getUint8(dataStart);
              var textStart = dataStart + 1;
              var textEnd = dataStart + frameSize;
              
              if (frameId === 'TIT2' || frameId === 'TPE1') {
                var text = '';
                if (encoding === 0 || encoding === 3) {
                  // ISO-8859-1 or UTF-8
                  for (var i = textStart; i < textEnd; i++) {
                    var c = view.getUint8(i);
                    if (c === 0) break;
                    text += String.fromCharCode(c);
                  }
                } else if (encoding === 1 || encoding === 2) {
                  // UTF-16
                  for (var i = textStart + 2; i < textEnd - 1; i += 2) {
                    var c = view.getUint16(i, encoding === 2);
                    if (c === 0) break;
                    text += String.fromCharCode(c);
                  }
                }
                
                if (frameId === 'TIT2') result.title = text.trim();
                if (frameId === 'TPE1') result.artist = text.trim();
              }
              
              offset += headerSize + frameSize;
            }
          }
        }
        
        // Try ID3v1 if v2 didn't work (last 128 bytes)
        if (!result.title && !result.artist && view.byteLength >= 128) {
          var tagOffset = view.byteLength - 128;
          var tag = String.fromCharCode(
            view.getUint8(tagOffset), view.getUint8(tagOffset + 1), view.getUint8(tagOffset + 2)
          );
          
          if (tag === 'TAG') {
            var title = '';
            var artist = '';
            for (var i = 0; i < 30; i++) {
              var c = view.getUint8(tagOffset + 3 + i);
              if (c !== 0) title += String.fromCharCode(c);
            }
            for (var i = 0; i < 30; i++) {
              var c = view.getUint8(tagOffset + 33 + i);
              if (c !== 0) artist += String.fromCharCode(c);
            }
            result.title = title.trim();
            result.artist = artist.trim();
          }
        }
        
        return result;
      }
      
      // Fetch metadata from MP3 URL
      async function fetchMetadata(url) {
        try {
          // Fetch first 64KB for ID3v2 tags
          var response = await fetch(url, {
            headers: { 'Range': 'bytes=0-65535' }
          });
          var buffer = await response.arrayBuffer();
          return parseID3(buffer);
        } catch (e) {
          console.log('Could not fetch metadata:', e);
          return { title: '', artist: '' };
        }
      }
      
      // Load tracks from Strapi
      async function loadTracksFromStrapi() {
        var soundConfig = window.BundleBuilderSounds || {};
        var strapiUrl = soundConfig.strapiUrl;
        var apiToken = soundConfig.strapiApiToken;
        
        if (!strapiUrl) {
          console.log('🎵 Music player: No Strapi URL configured');
          return;
        }
        
        try {
          var headers = {};
          if (apiToken) headers['Authorization'] = 'Bearer ' + apiToken;
          
          var res = await fetch(strapiUrl + '/api/upload/files?pagination[limit]=500', { headers: headers });
          if (!res.ok) throw new Error('Strapi API error');
          
          var files = await res.json();
          
          // Filter for ambient-loop files, dedupe by URL
          var pattern = /^ambient[_-]loop[_-]tier[_-](\d+)[_-](\d+)x\./i;
          var seen = new Set();
          var ambientFiles = [];
          
          files.forEach(function(file) {
            var match = file.name.match(pattern);
            if (match && !seen.has(file.url)) {
              seen.add(file.url);
              ambientFiles.push({
                url: file.url.startsWith('http') ? file.url : strapiUrl + file.url,
                filename: file.name,
                tier: parseInt(match[1]),
                variant: parseInt(match[2])
              });
            }
          });
          
          // Sort by tier then variant
          ambientFiles.sort(function(a, b) {
            if (a.tier !== b.tier) return a.tier - b.tier;
            return a.variant - b.variant;
          });
          
          if (ambientFiles.length === 0) {
            console.log('🎵 Music player: No ambient-loop files found in Strapi');
            return;
          }
          
          // Fetch metadata for each track
          console.log('🎵 Loading metadata for ' + ambientFiles.length + ' tracks...');
          
          for (var i = 0; i < ambientFiles.length; i++) {
            var file = ambientFiles[i];
            var meta = await fetchMetadata(file.url);
            
            TRACKS.push({
              url: file.url,
              title: meta.title || 'Track ' + (i + 1),
              artist: meta.artist || 'Unknown Artist',
              filename: file.filename
            });
          }
          
          tracksLoaded = true;
          console.log('🎵 Loaded ' + TRACKS.length + ' tracks from Strapi');
          
          // Update UI and autoplay - start on random track
          if (TRACKS.length > 0) {
            var randomStart = Math.floor(Math.random() * TRACKS.length);
            loadTrack(randomStart);
            updateDisplay();
            updatePlaylist();
            
            // Autoplay after user has interacted (wait for forceUnlock)
            if (autoplayPending) {
              // Try to autoplay - will work if user has interacted
              setTimeout(function() {
                if (autoplayPending && !isPlaying) {
                  play();
                  autoplayPending = false;
                }
              }, 500);
            }
          }
          
        } catch (e) {
          console.log('🎵 Music player: Error loading from Strapi:', e);
        }
      }
      
      var player = document.createElement('div');
      player.id = 'bb-music-player';
      player.innerHTML = 
        '<style>' +
        '#bb-music-player {' +
        '  position: fixed;' +
        '  top: 16px;' +
        '  right: 50px;' + // Position to left of settings gear (inline)
        '  z-index: 10001;' + // Above intro overlay (10000) +
        '  font-family: monospace;' +
        '  font-size: 10px;' +
        '  user-select: none;' +
        '  display: flex;' +
        '  flex-direction: column;' +
        '  align-items: flex-end;' +
        '}' +
        /* State 0: Cube - just expand button with visualizer */
        '#bb-music-player.state-0 .mp-bar {' +
        '  width: 28px;' +
        '  padding: 2px;' +
        '}' +
        '#bb-music-player.state-0 .mp-display,' +
        '#bb-music-player.state-0 .mp-play-btn,' +
        '#bb-music-player.state-0 .mp-next-btn {' +
        '  display: none;' +
        '}' +
        '#bb-music-player.state-0 .mp-expand-btn {' +
        '  width: 24px;' +
        '  height: 24px;' +
        '}' +
        /* State 1: Row - full player bar */
        '#bb-music-player.state-1 .mp-bar {' +
        '  width: 220px;' +
        '}' +
        '#bb-music-player.state-1 .mp-playlist {' +
        '  max-height: 0;' +
        '}' +
        /* State 2: Row + Playlist */
        '#bb-music-player.state-2 .mp-bar {' +
        '  width: 220px;' +
        '}' +
        '#bb-music-player.state-2 .mp-playlist {' +
        '  max-height: 150px;' +
        '}' +
        '#bb-music-player .mp-bar {' +
        '  display: flex;' +
        '  align-items: center;' +
        '  height: 28px;' +
        '  background: linear-gradient(180deg, #3a3a3a 0%, #292929 50%, #1a1a1a 100%);' +
        '  border: 1px solid #505050;' +
        '  border-bottom-color: #101010;' +
        '  border-right-color: #101010;' +
        '  box-shadow: 0 2px 8px rgba(0,0,0,0.5);' +
        '  padding: 0 4px;' +
        '  gap: 4px;' +
        '  transition: width 0.2s ease;' +
        '}' +
        '#bb-music-player .mp-btn {' +
        '  width: 20px;' +
        '  height: 20px;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  justify-content: center;' +
        '  background: linear-gradient(180deg, #4a4a4a 0%, #2a2a2a 100%);' +
        '  border: 1px solid #111;' +
        '  border-radius: 2px;' +
        '  cursor: pointer;' +
        '  color: #0f0;' +
        '  font-size: 9px;' +
        '  flex-shrink: 0;' +
        '}' +
        '#bb-music-player .mp-btn:hover { background: linear-gradient(180deg, #5a5a5a 0%, #3a3a3a 100%); }' +
        '#bb-music-player .mp-btn:active { background: #222; }' +
        '#bb-music-player .mp-display {' +
        '  flex: 1;' +
        '  height: 18px;' +
        '  background: #000;' +
        '  border: 1px solid #555;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  padding: 0 4px;' +
        '  overflow: hidden;' +
        '  box-shadow: inset 0 1px 3px rgba(0,0,0,0.8);' +
        '}' +
        '#bb-music-player .mp-viz {' +
        '  width: 20px;' +
        '  height: 14px;' +
        '  margin-right: 6px;' +
        '  flex-shrink: 0;' +
        '}' +
        '#bb-music-player .mp-viz canvas { display: block; }' +
        '#bb-music-player .mp-marquee {' +
        '  flex: 1;' +
        '  overflow: hidden;' +
        '  white-space: nowrap;' +
        '}' +
        '#bb-music-player .mp-marquee-inner {' +
        '  display: inline-block;' +
        '  color: #0f0;' +
        '  font-size: 9px;' +
        '  letter-spacing: 0.5px;' +
        '}' +
        '#bb-music-player .mp-marquee-inner.playing {' +
        '  animation: mp-scroll 10s linear infinite;' +
        '}' +
        '@keyframes mp-scroll {' +
        '  0% { transform: translateX(0); }' +
        '  100% { transform: translateX(-50%); }' +
        '}' +
        '#bb-music-player .mp-playlist {' +
        '  width: 220px;' +
        '  background: #1a1a1a;' +
        '  border: none;' + // Hide border when collapsed
        '  box-shadow: none;' +
        '  max-height: 0;' +
        '  overflow: hidden;' +
        '  transition: max-height 0.2s ease, border 0.1s, box-shadow 0.2s;' +
        '}' +
        '#bb-music-player.state-2 .mp-playlist {' + // Only show border when expanded
        '  border: 1px solid #505050;' +
        '  border-top: none;' +
        '  box-shadow: 0 4px 12px rgba(0,0,0,0.5);' +
        '}' +
        '#bb-music-player .mp-playlist-inner {' +
        '  background: #000;' +
        '  border: 1px solid #444;' +
        '  margin: 4px;' +
        '  max-height: 130px;' +
        '  overflow-y: auto;' +
        '}' +
        '#bb-music-player .mp-track {' +
        '  padding: 4px 8px;' +
        '  color: #888;' +
        '  cursor: pointer;' +
        '  display: flex;' +
        '  align-items: center;' +
        '  gap: 6px;' +
        '  font-size: 9px;' +
        '}' +
        '#bb-music-player .mp-track:hover { background: #222; color: #ccc; }' +
        '#bb-music-player .mp-track.active { background: #003300; color: #0f0; }' +
        '#bb-music-player .mp-track-num { width: 12px; text-align: right; opacity: 0.5; }' +
        '#bb-music-player .mp-track-info { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }' +
        '#bb-music-player .mp-track-spin { animation: mp-spin 2s linear infinite; }' +
        '@keyframes mp-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }' +
        '#bb-music-player .mp-playlist-inner::-webkit-scrollbar { width: 6px; background: #111; }' +
        '#bb-music-player .mp-playlist-inner::-webkit-scrollbar-thumb { background: #444; border: 1px solid #111; }' +
        /* Cube state: show mini visualizer in button */
        '#bb-music-player.state-0 .mp-expand-btn .mp-mini-viz { display: block; }' +
        '#bb-music-player:not(.state-0) .mp-expand-btn .mp-mini-viz { display: none; }' +
        '#bb-music-player .mp-mini-viz {' +
        '  width: 16px;' +
        '  height: 12px;' +
        '}' +
        /* Mobile mute button - shown only on small screens */
        '#bb-music-player .mp-mobile-mute {' +
        '  display: none;' +
        '  width: 32px;' +
        '  height: 32px;' +
        '  background: none;' +
        '  border: none;' +
        '  border-radius: 4px;' +
        '  cursor: pointer;' +
        '  font-size: 20px;' +
        '  color: #c5bfcd;' +
        '  box-shadow: none;' +
        '}' +
        '#bb-music-player .mp-mobile-mute:active { opacity: 0.7; }' +
        '#bb-music-player .mp-mobile-mute.muted { color: #f55; }' +
        /* Mobile: hide full player, show mute button */
        '@media (max-width: 768px) {' +
        '  #bb-music-player .mp-bar { display: none !important; }' +
        '  #bb-music-player .mp-playlist { display: none !important; }' +
        '  #bb-music-player .mp-mobile-mute { display: flex; align-items: center; justify-content: center; }' +
        '}' +
        '</style>' +
        '<button class="mp-mobile-mute" id="mp-mobile-mute" title="Sound On - Tap to mute">🔊</button>' +
        '<div class="mp-bar" id="mp-bar">' +
        '  <button class="mp-btn mp-expand-btn" id="mp-expand" title="Expand">' +
        '    <canvas class="mp-mini-viz" id="mp-mini-canvas" width="16" height="12"></canvas>' +
        '    <span class="mp-expand-icon">▼</span>' +
        '  </button>' +
        '  <div class="mp-display">' +
        '    <div class="mp-viz"><canvas id="mp-canvas" width="20" height="14"></canvas></div>' +
        '    <div class="mp-marquee">' +
        '      <span class="mp-marquee-inner" id="mp-title"></span>' +
        '    </div>' +
        '  </div>' +
        '  <button class="mp-btn mp-play-btn" id="mp-play" title="Play">▶</button>' +
        '  <button class="mp-btn mp-next-btn" id="mp-next" title="Next">⏭</button>' +
        '</div>' +
        '<div class="mp-playlist" id="mp-playlist">' +
        '  <div class="mp-playlist-inner" id="mp-playlist-inner"></div>' +
        '</div>' +
        '<audio id="mp-audio" crossorigin="anonymous"></audio>';
      
      document.body.appendChild(player);
      
      // Elements
      var audio = document.getElementById('mp-audio');
      var canvas = document.getElementById('mp-canvas');
      var miniCanvas = document.getElementById('mp-mini-canvas');
      var ctx = canvas.getContext('2d');
      var miniCtx = miniCanvas.getContext('2d');
      var playBtn = document.getElementById('mp-play');
      var nextBtn = document.getElementById('mp-next');
      var expandBtn = document.getElementById('mp-expand');
      var expandIcon = expandBtn.querySelector('.mp-expand-icon');
      var titleEl = document.getElementById('mp-title');
      var playlistEl = document.getElementById('mp-playlist');
      var playlistInner = document.getElementById('mp-playlist-inner');
      var mpBar = document.getElementById('mp-bar');
      var mobileMuteBtn = document.getElementById('mp-mobile-mute');
      var isMobileMuted = false;
      
      // Set initial volume from SoundSystem musicVolume (with logarithmic scaling)
      // Default: 50% desktop (0.5^3 = 0.125), 30% mobile (0.3^3 = 0.027)
      var initialMusicVol = (window.SoundSystem && window.SoundSystem.getMusicVolume) 
        ? window.SoundSystem.getMusicVolume() 
        : (Perf.isMobile ? 0.3 : 0.5);
      audio.volume = Math.pow(initialMusicVol, 3); // Logarithmic scaling
      
      // Update expand state class and icon
      function updateExpandState() {
        player.className = 'state-' + expandState;
        if (expandState === 0) {
          expandIcon.textContent = '▶'; // Will expand
          expandBtn.title = 'Expand player';
        } else if (expandState === 1) {
          // Show direction arrow based on which way we'll go next
          expandIcon.textContent = expandDirection === 1 ? '▼' : '◀';
          expandBtn.title = expandDirection === 1 ? 'Show playlist' : 'Collapse';
        } else {
          expandIcon.textContent = '▲'; // Will collapse
          expandBtn.title = 'Hide playlist';
        }
        // Hide icon in cube state (show visualizer instead)
        expandIcon.style.display = expandState === 0 ? 'none' : 'block';
      }
      
      // Update display
      function updateDisplay() {
        if (TRACKS.length === 0) {
          titleEl.innerHTML = '<span style="color:#550;">Loading tracks from Strapi...</span>';
          titleEl.className = 'mp-marquee-inner';
          playBtn.textContent = '▶';
          return;
        }
        var track = TRACKS[currentTrackIndex];
        var text = (currentTrackIndex + 1) + '. ' + track.artist + ' - ' + track.title;
        titleEl.innerHTML = '<span>' + text + '</span><span style="color:#050;margin:0 12px;">♦</span><span>' + text + '</span><span style="color:#050;margin:0 12px;">♦</span>';
        titleEl.className = 'mp-marquee-inner' + (isPlaying ? ' playing' : '');
        playBtn.textContent = isPlaying ? '❚❚' : '▶';
        playBtn.title = isPlaying ? 'Pause' : 'Play';
        updatePlaylist();
      }
      
      // Update playlist
      function updatePlaylist() {
        var html = '';
        TRACKS.forEach(function(track, i) {
          var isActive = i === currentTrackIndex;
          html += '<div class="mp-track' + (isActive ? ' active' : '') + '" data-index="' + i + '">' +
            '<span class="mp-track-num">' + (i + 1) + '.</span>' +
            '<span class="mp-track-info">' + track.artist + ' - ' + track.title + '</span>' +
            (isActive && isPlaying ? '<span class="mp-track-spin">◉</span>' : '') +
          '</div>';
        });
        playlistInner.innerHTML = html;
        
        // Add click handlers
        playlistInner.querySelectorAll('.mp-track').forEach(function(el) {
          el.addEventListener('click', function() {
            selectTrack(parseInt(this.dataset.index));
          });
        });
      }
      
      // Load track
      function loadTrack(index) {
        if (TRACKS.length === 0) return;
        currentTrackIndex = index;
        audio.src = TRACKS[index].url;
        updateDisplay();
      }
      
      // Select and play track
      function selectTrack(index) {
        loadTrack(index);
        play();
      }
      
      // Play
      function play() {
        if (TRACKS.length === 0) return;
        initAudioContext();
        audio.play().then(function() {
          isPlaying = true;
          updateDisplay();
          startVisualizer();
        }).catch(function(e) {
          console.log('Play error:', e);
        });
      }
      
      // Pause
      function pause() {
        audio.pause();
        isPlaying = false;
        updateDisplay();
        stopVisualizer();
      }
      
      // Toggle play/pause
      function togglePlay() {
        if (isPlaying) pause();
        else play();
      }
      
      // Next track
      function nextTrack() {
        if (TRACKS.length === 0) return;
        loadTrack((currentTrackIndex + 1) % TRACKS.length);
        play();
      }
      
      // Audio context for visualizer
      function initAudioContext() {
        if (audioContext) return;
        try {
          var AudioContext = window.AudioContext || window.webkitAudioContext;
          audioContext = new AudioContext();
          analyser = audioContext.createAnalyser();
          analyser.fftSize = 64;
          analyser.smoothingTimeConstant = 0.5;
          var source = audioContext.createMediaElementSource(audio);
          source.connect(analyser);
          analyser.connect(audioContext.destination);
        } catch(e) {
          console.log('Audio context error:', e);
        }
      }
      
      // Visualizer - draws on both main and mini canvas
      function drawVisualizer() {
        if (!analyser) return;
        
        var bufferLength = analyser.frequencyBinCount;
        var dataArray = new Uint8Array(bufferLength);
        analyser.getByteFrequencyData(dataArray);
        
        // Draw main canvas
        var width = canvas.width;
        var height = canvas.height;
        ctx.clearRect(0, 0, width, height);
        
        var barWidth = 3;
        var gap = 1;
        var freqIndices = [2, 6, 12, 18, 24];
        
        freqIndices.forEach(function(freqIndex, i) {
          var value = dataArray[freqIndex] || 0;
          var barHeight = Math.max(2, (value / 255) * height);
          var x = i * (barWidth + gap);
          var y = height - barHeight;
          
          var gradient = ctx.createLinearGradient(0, height, 0, 0);
          gradient.addColorStop(0, '#00ff00');
          gradient.addColorStop(0.5, '#ffff00');
          gradient.addColorStop(1, '#ff0000');
          ctx.fillStyle = gradient;
          ctx.fillRect(x, y, barWidth, barHeight);
        });
        
        // Draw mini canvas (for cube state)
        var miniWidth = miniCanvas.width;
        var miniHeight = miniCanvas.height;
        miniCtx.clearRect(0, 0, miniWidth, miniHeight);
        
        var miniBarWidth = 2;
        var miniGap = 1;
        var miniFreqIndices = [2, 8, 14, 20, 26];
        
        miniFreqIndices.forEach(function(freqIndex, i) {
          var value = dataArray[freqIndex] || 0;
          var barHeight = Math.max(1, (value / 255) * miniHeight);
          var x = i * (miniBarWidth + miniGap);
          var y = miniHeight - barHeight;
          
          var gradient = miniCtx.createLinearGradient(0, miniHeight, 0, 0);
          gradient.addColorStop(0, '#00ff00');
          gradient.addColorStop(0.5, '#ffff00');
          gradient.addColorStop(1, '#ff0000');
          miniCtx.fillStyle = gradient;
          miniCtx.fillRect(x, y, miniBarWidth, barHeight);
        });
        
        if (isPlaying) {
          animationFrame = requestAnimationFrame(drawVisualizer);
        }
      }
      
      function startVisualizer() {
        if (audioContext && audioContext.state === 'suspended') {
          audioContext.resume();
        }
        drawVisualizer();
      }
      
      function stopVisualizer() {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }
      }
      
      // Event handlers
      playBtn.addEventListener('click', togglePlay);
      nextBtn.addEventListener('click', nextTrack);
      expandBtn.addEventListener('click', function() {
        // Bidirectional: 0 ↔ 1 ↔ 2, reverse direction at ends
        expandState += expandDirection;
        if (expandState >= 2) {
          expandState = 2;
          expandDirection = -1; // Start collapsing
        } else if (expandState <= 0) {
          expandState = 0;
          expandDirection = 1; // Start expanding
        }
        updateExpandState();
      });
      audio.addEventListener('ended', nextTrack);
      
      // Mobile mute button handler - toggles all sound (effects + music player)
      // On iOS, volume control doesn't work - must pause/play instead
      var lastMuteTime = 0;
      function handleMobileMute(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        
        // Debounce - prevent double-firing from touch + click
        var now = Date.now();
        if (now - lastMuteTime < 300) return;
        lastMuteTime = now;
        
        // Toggle mute state
        isMobileMuted = !isMobileMuted;
        
        // Toggle SoundSystem (for SFX) - pass explicit state
        if (window.SoundSystem && window.SoundSystem.toggle) {
          window.SoundSystem.toggle(!isMobileMuted);
        }
        
        // For music player: pause/play because iOS doesn't support volume control
        // Skip on mobile since music player is disabled
        if (!Perf.isMobile) {
          if (isMobileMuted) {
            // MUTING - pause audio
            mobileMuteBtn._wasPlaying = !audio.paused;
            audio.pause();
          } else {
            // UNMUTING - resume if was playing before
            if (mobileMuteBtn._wasPlaying) {
              audio.play().catch(function(){});
            }
          }
        }
        
        // Update UI
        mobileMuteBtn.textContent = isMobileMuted ? '🔇' : '🔊';
        mobileMuteBtn.classList.toggle('muted', isMobileMuted);
        mobileMuteBtn.title = isMobileMuted ? 'Sound Off - Tap to unmute' : 'Sound On - Tap to mute';
      }
      
      // Single click handler - works on both mobile and desktop
      mobileMuteBtn.onclick = handleMobileMute;
      
      // Initialize - start in cube state, load from Strapi
      expandState = 0;
      updateExpandState();
      updateDisplay();
      loadTracksFromStrapi();
      
      // Expose to window for SoundSystem integration
      window.BBMusicPlayer = {
        play: play,
        pause: pause,
        toggle: togglePlay,
        next: nextTrack,
        isPlaying: function() { return isPlaying; },
        setVolume: function(vol) { 
          // Apply logarithmic scaling for natural volume feel
          audio.volume = vol <= 0 ? 0 : vol >= 1 ? 1 : Math.pow(vol, 3); 
        },
        getVolume: function() { return audio.volume; },
        isLoaded: function() { return tracksLoaded && TRACKS.length > 0; },
        getTrackCount: function() { return TRACKS.length; },
        // Called by Enter button to trigger autoplay
        startAutoplay: function() {
          if (tracksLoaded && TRACKS.length > 0 && !isPlaying) {
            // Don't reload - use the already-selected random track
            play();
          } else {
            autoplayPending = true;
          }
        },
        // Expand from cube state
        expand: function() {
          if (expandState === 0) {
            expandState = 1;
            updateExpandState();
          }
        }
      };
      
      // Sync mobile mute button with SoundSystem state (respects localStorage)
      if (window.SoundSystem && window.SoundSystem.isEnabled) {
        var isEnabled = window.SoundSystem.isEnabled();
        isMobileMuted = !isEnabled;
        mobileMuteBtn.textContent = isMobileMuted ? '🔇' : '🔊';
        mobileMuteBtn.classList.toggle('muted', isMobileMuted);
        mobileMuteBtn.title = isMobileMuted ? 'Sound Off - Tap to unmute' : 'Sound On - Tap to mute';
      }
    }
    
    function applyWidgetPerformanceSettings(tier) {
      var perfControls = window.BBPerf;
      if (!perfControls) return;
      
      perfControls.tier = tier;
      
      if (tier === 'off') {
        // All effects off
        perfControls.enable3DTilt = false;
        perfControls.enableCardWave = false;
        perfControls.enableShadows = false;
        perfControls.enableFire = false;
        perfControls.enableParticles = false;
        perfControls.enableTextShake = false;
        document.body.classList.add('bb-perf-low'); // Disable CSS effects
        toggleShadows(false);
        toggleFire(false);
        // IMPORTANT: Stop any running particle animations
        if (window._clearAllParticles) window._clearAllParticles();
        // Hide other users' avatars for performance
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(false);
        }
      } else if (tier === 'low') {
        perfControls.enable3DTilt = false;
        perfControls.enableCardWave = false; // Wave OFF for low tier
        perfControls.enableShadows = false;
        perfControls.enableFire = false;
        perfControls.enableParticles = false;
        perfControls.enableTextShake = false; // Text shake OFF for low tier
        document.body.classList.add('bb-perf-low'); // Disable CSS effects
        toggleShadows(false);
        toggleFire(false);
        // IMPORTANT: Stop any running particle animations
        if (window._clearAllParticles) window._clearAllParticles();
        // Hide other users' avatars for performance
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(false);
        }
      } else if (tier === 'medium') {
        perfControls.enable3DTilt = false;
        perfControls.enableCardWave = true;
        perfControls.enableShadows = false;
        perfControls.enableFire = true;
        perfControls.enableParticles = true; // Particles ON for medium
        perfControls.enableTextShake = true;
        document.body.classList.remove('bb-perf-low'); // Re-enable CSS effects
        toggleShadows(false);
        toggleFire(true);
        // Show other users' avatars
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(true);
        }
      } else {
        // High - all on
        perfControls.enable3DTilt = true;
        perfControls.enableCardWave = true;
        document.body.classList.remove('bb-perf-low'); // Re-enable CSS effects
        perfControls.enableShadows = true;
        perfControls.enableFire = true;
        perfControls.enableParticles = true;
        perfControls.enableTextShake = true;
        toggleShadows(true);
        toggleFire(true);
        // Show other users' avatars
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(true);
        }
        
        // Re-initialize spark system if it wasn't initialized on page load (e.g. iOS)
        if (!window._sparkSystemInitialized) {
          console.log('✨ Re-initializing spark system for HIGH tier');
          initSparkSystem();
        } else if (window._restartSparkAnimation) {
          window._restartSparkAnimation();
        }
      }
      
      // Sync debug panel checkboxes if open
      updatePerfControls();
      
      console.log('🎮 Performance tier set to:', tier.toUpperCase());
    }

    function startApp() {
      // Clear cart on every bundle builder visit - fresh start each time
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function() {
        console.log('[BB] Cart cleared on page load');
      }).catch(function(e) {
        console.warn('[BB] Failed to clear cart:', e);
      });
      
      // NOTE: We no longer restore saved selections - every visit is a fresh start
      // restoreSavedSelections();
      
      // Initialize floating settings widget
      createFloatingWidget();
      
      // Initialize mini cart widget
      createMiniCart();
      
      // Initialize music player widget
      createMusicPlayer();
      
      // Initialize Balatro Fire Effect for percent display
      // Skip on low-performance devices to prevent memory/GPU issues
      if (typeof window.BalatroFire === 'function' && Perf.enableFire) {
        window.balatroFireInstance = new window.BalatroFire('balatro-fire-canvas');
        // Initialize second fire instance for savings display
        window.balatroFireInstanceSavings = new window.BalatroFire('balatro-fire-canvas-savings');
        
        // IMMEDIATELY pause fire on creation - tier 0 should have no fire
        // This prevents the flash of fire before applyFireSettingsForTier runs
        if (window.balatroFireInstance && typeof window.balatroFireInstance.pause === 'function') {
          window.balatroFireInstance.pause();
        }
        if (window.balatroFireInstanceSavings && typeof window.balatroFireInstanceSavings.pause === 'function') {
          window.balatroFireInstanceSavings.pause();
        }
        
        // Apply tier 0 fire settings (will keep fire paused since fireAlpha = 0)
        applyFireSettingsForTier(0);
      } else if (!Perf.enableFire) {
        console.log('🔥 Fire effects disabled (performance tier: ' + Perf.tier + ')');
        // Hide fire canvas elements to save memory
        var fireCanvases = document.querySelectorAll('[id*="balatro-fire-canvas"]');
        fireCanvases.forEach(function(canvas) {
          canvas.style.display = 'none';
        });
      }

      // Initialize random flicker delays for all cards
      document.querySelectorAll('.bb-balatro-card').forEach(function(card, index) {
        // Random delay between 0s and 5s for idle flicker
        card.style.setProperty('--idle-delay', (Math.random() * 5).toFixed(2) + 's');
        // Random duration between 2s and 5s (faster frequency)
        card.style.setProperty('--idle-duration', (Math.random() * 3 + 2).toFixed(2) + 's');
        // Random intensity between 0.02 and 0.08
        card.style.setProperty('--idle-intensity', (Math.random() * 0.06 + 0.02).toFixed(3));
        
        // Random stagger for card wave animation (0 to cardStagger)
        // Assign a random float between 0 and 1 to multiply with cardStagger later
        card.dataset.waveOffset = Math.random();
      });
      
      // ========================================================================
      // CAROUSEL SYSTEM - Horizontal infinite scroll
      // ========================================================================
      initCarousel();
      
      // ========================================================================
      // SPARK PARTICLE SYSTEM - Gold pixel sparks on card selection
      // ========================================================================
      initSparkSystem();
      
      // ========================================================================
      // CARD STATE INITIALIZATION - Track all card states from DOM
      // ========================================================================
      initializeCardStates();

      // Start card wave animation loop (if enabled)
      // PERFORMANCE FIX: Uses helper that checks if effects are enabled
      if (Perf.enableCardWave || Perf.enable3DTilt) {
        cardWaveAnimationRunning = true;
        requestAnimationFrame(updateCardWave);
      }

      // Populate currency code in savings display
      var currencyEl = document.querySelector('.bb-tier-savings-currency[data-currency]');
      if (currencyEl) {
        var currencyCode = currencyEl.getAttribute('data-currency') || '';
        if (currencyCode) {
          currencyEl.textContent = currencyCode;
        }
      }
      
      // Handle multi-character currency symbols (update prefix if needed)
      var prefixEl = document.querySelector('.bb-tier-savings-prefix[data-currency-symbol]');
      if (prefixEl) {
        var symbol = prefixEl.getAttribute('data-currency-symbol') || '';
        if (symbol && symbol.length > 1) {
          // Multi-character symbol - create individual char spans
          var charHtml = '';
          for (var i = 0; i < symbol.length; i++) {
            charHtml += '<span class="bb-char">' + symbol[i] + '</span>';
          }
          prefixEl.innerHTML = charHtml;
        }
      }

      // Debug Panel - DISABLED for production
      // To re-enable, uncomment the lines below:
      // if (typeof renderDebugPanel === 'function') {
      //   renderDebugPanel();
      // }

      if (els.header) els.header.classList.remove('bb-hidden');
      if (els.main) els.main.classList.remove('bb-hidden');
      if (els.footer) els.footer.classList.remove('bb-hidden');
      
      bindEvents();
      startTimer();
      updateCalculation();
    }

    // ========================================================================
    // CARD INFO POPUP - Shows product description for deck selection cards
    // ========================================================================
    function showCardInfoPopup(card) {
      // Get card data
      var title = card.dataset.title || (card.querySelector('.bb-card-title') ? card.querySelector('.bb-card-title').textContent : 'Product');
      var variantId = card.dataset.variantId;
      var cardType = card.dataset.cardType || 'product';
      var infoBtn = card.querySelector('.bb-card-info-btn');
      var description = infoBtn ? infoBtn.dataset.productDescription : '';
      var imageEl = card.querySelector('.bb-card-img');
      var imageSrc = imageEl ? imageEl.src : null;
      
      // Check if card is already selected
      var isSelected = card.classList.contains('selected');
      
      // Remove existing popup if any
      var existingPopup = document.querySelector('.bb-card-info-popup-overlay');
      if (existingPopup) existingPopup.remove();
      
      // Create overlay
      var overlay = document.createElement('div');
      overlay.className = 'bb-card-info-popup-overlay';
      
      // Create popup
      var popup = document.createElement('div');
      popup.className = 'bb-card-info-popup';
      
      // Close button
      var closeBtn = document.createElement('button');
      closeBtn.className = 'bb-card-info-popup-close';
      closeBtn.innerHTML = '✕';
      closeBtn.addEventListener('click', function() {
        overlay.classList.remove('bb-card-info-popup-visible');
        setTimeout(function() { overlay.remove(); }, 300);
      });
      popup.appendChild(closeBtn);
      
      // Product image
      if (imageSrc) {
        var imgContainer = document.createElement('div');
        imgContainer.className = 'bb-card-info-popup-image';
        var img = document.createElement('img');
        img.src = imageSrc;
        img.alt = title;
        img.draggable = false;
        imgContainer.appendChild(img);
        popup.appendChild(imgContainer);
      }
      
      // Title
      var titleEl = document.createElement('div');
      titleEl.className = 'bb-card-info-popup-title';
      titleEl.textContent = title;
      popup.appendChild(titleEl);
      
      // Scrollable description - use innerHTML for rich text
      var descContainer = document.createElement('div');
      descContainer.className = 'bb-card-info-popup-desc';
      if (description && description.trim()) {
        descContainer.innerHTML = description;
      } else {
        descContainer.innerHTML = '<p>No description available for this product.</p>';
      }
      popup.appendChild(descContainer);
      
      // Learn more link - opens product page in new tab
      var productHandle = card.dataset.handle;
      if (productHandle) {
        var learnMoreLink = document.createElement('a');
        learnMoreLink.className = 'bb-card-info-learn-more';
        learnMoreLink.href = '/products/' + productHandle;
        learnMoreLink.target = '_blank';
        learnMoreLink.rel = 'noopener noreferrer';
        learnMoreLink.innerHTML = 'Learn more <svg class="bb-external-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';
        popup.appendChild(learnMoreLink);
      }
      
      // Add to Bundle button
      var addBtn = document.createElement('button');
      addBtn.className = 'bb-card-info-popup-add-btn' + (isSelected ? ' bb-card-info-btn-selected' : '');
      addBtn.innerHTML = isSelected 
        ? '<span class="bb-card-info-check">✓</span> Added to Bundle' 
        : '<span class="bb-card-info-plus">+</span> Add to Bundle';
      addBtn.addEventListener('click', function() {
        // Toggle selection on the actual card
        toggleSelection(card, cardType);
        
        // Update button state
        var nowSelected = card.classList.contains('selected');
        if (nowSelected) {
          addBtn.classList.add('bb-card-info-btn-selected');
          addBtn.innerHTML = '<span class="bb-card-info-check">✓</span> Added to Bundle';
        } else {
          addBtn.classList.remove('bb-card-info-btn-selected');
          addBtn.innerHTML = '<span class="bb-card-info-plus">+</span> Add to Bundle';
        }
        
        // Close popup after a short delay
        setTimeout(function() {
          overlay.classList.remove('bb-card-info-popup-visible');
          setTimeout(function() { overlay.remove(); }, 300);
        }, 500);
      });
      popup.appendChild(addBtn);
      
      overlay.appendChild(popup);
      document.body.appendChild(overlay);
      
      // Close on overlay click (outside popup)
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          overlay.classList.remove('bb-card-info-popup-visible');
          setTimeout(function() { overlay.remove(); }, 300);
        }
      });
      
      // Close on Escape key
      var escHandler = function(e) {
        if (e.key === 'Escape') {
          overlay.classList.remove('bb-card-info-popup-visible');
          setTimeout(function() { overlay.remove(); }, 300);
          document.removeEventListener('keydown', escHandler);
        }
      };
      document.addEventListener('keydown', escHandler);
      
      // Animate in
      setTimeout(function() {
        overlay.classList.add('bb-card-info-popup-visible');
      }, 10);
      
      // Play a subtle sound
      if (window.SoundSystem) {
        window.SoundSystem.play('button-click', null, 0.3);
      }
    }

    // ========================================================================
    // Event Binding
    // ========================================================================
    function bindEvents() {
      // Product card clicks (original layout)
      container.querySelectorAll('.bb-product-card').forEach(function(card) {
        card.addEventListener('click', function(e) {
          // Don't trigger selection if clicking on expand toggle
          if (e.target.closest('.bb-expand-toggle')) return;
          if (e.target.closest('.bb-card-details')) return;
          
          const cardType = card.dataset.cardType;
          const isAvailable = card.dataset.available !== 'false';
          
          if (!isAvailable) return;
          
          toggleSelection(card, cardType);
        });
      });
      
      // Balatro 3D card clicks and mouse tracking
      container.querySelectorAll('.bb-balatro-card').forEach(function(card) {
        // Click handler for selection with bounce animation
        card.addEventListener('click', function(e) {
          // Ignore click if we were dragging the carousel
          if (carouselState.wasDragging) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          
          // ========================================
          // INFO BUTTON CLICK - Show description popup
          // ========================================
          if (e.target.closest('.bb-card-info-btn')) {
            e.preventDefault();
            e.stopPropagation();
            showCardInfoPopup(card);
            return;
          }
          
          // ========================================
          // STATE-BASED INTERACTION GUARD
          // Check if card can be interacted with (blocks during animations)
          // ========================================
          if (!canInteractWithCard(card)) {
            e.preventDefault();
            e.stopPropagation();
              return;
            }
            
          // Get current card state from our state management
          var cardStateInfo = getCardState(card);
          var currentCardState = cardStateInfo ? cardStateInfo.state : CARD_STATE.UNSELECTED;
          
          // ========================================
          // UPGRADED CARD in Selection Mode
          // Can't interact here - go forward to upgrade step
          // ========================================
          if (currentCardState === CARD_STATE.UPGRADED && !state.upgradeMode) {
            console.log('[BB State] Upgraded card clicked in selection - going to upgrade step');
            window.SoundSystem.play('card-select', null, 0.5);
            enterUpgradeMode();
            return;
          }
          
          // ========================================
          // UPGRADE MODE - State-based handling
          // ========================================
          if (state.upgradeMode) {
            // UPGRADED CARD - show downgrade confirmation or trigger downgrade
            if (currentCardState === CARD_STATE.UPGRADED) {
              // If confirmation overlay is showing, trigger actual downgrade
              if (card.classList.contains('downgrade-confirm')) {
                console.log('[BB State] Downgrade confirmed - triggering downgrade');
                card.classList.remove('downgrade-confirm');
                // Clear any pending timeout
                if (card._downgradeTimeout) {
                  clearTimeout(card._downgradeTimeout);
                  card._downgradeTimeout = null;
                }
              triggerDowngradeAnimation(card);
              return;
            }
            
              // First click - show confirmation overlay
              console.log('[BB State] Upgraded card clicked - showing downgrade confirmation');
              card.classList.add('downgrade-confirm');
              
              // Auto-dismiss after 5 seconds
              card._downgradeTimeout = setTimeout(function() {
                card.classList.remove('downgrade-confirm');
                card._downgradeTimeout = null;
                console.log('[BB State] Downgrade confirmation timed out');
              }, 5000);
              
              return;
            }
            
            // UPGRADEABLE CARD - trigger upgrade
            if (currentCardState === CARD_STATE.UPGRADEABLE) {
            const productTitle = card.dataset.title;
            const upgradeData = DIGITAL_UPGRADE_MAP[productTitle];
            
              if (upgradeData) {
                console.log('[BB State] Upgradeable card clicked - triggering upgrade');
                triggerUpgradeAnimation(card, upgradeData);
              }
              return;
            }
            
            // UNSELECTED CARD - return to selection step
            if (currentCardState === CARD_STATE.UNSELECTED) {
              console.log('[BB State] Unselected card clicked - returning to selection');
              window.SoundSystem.play('card-deselect', null, 0.5);
              exitUpgradeMode();
              return;
            }
            
            // SELECTED card (no upgrade data) - do nothing
            if (currentCardState === CARD_STATE.SELECTED) {
              console.log('[BB State] Selected card has no upgrade option');
              return;
            }
            
            return;
          }
          
          // ========================================
          // SELECTION MODE - Normal card selection
          // ========================================
          
          // SAFETY: Block upgraded cards from being toggled in selection mode
          if (currentCardState === CARD_STATE.UPGRADED) {
            console.log('[BB State] BLOCKED: Cannot toggle upgraded card in selection mode');
            return;
          }
          
          const cardType = card.dataset.cardType;
          const isAvailable = card.dataset.available !== 'false';
          
          if (!isAvailable) return;
          
          // Determine if selecting or deselecting based on state
          const isCurrentlySelected = currentCardState === CARD_STATE.SELECTED;
          
          if (!isCurrentlySelected) {
            // If we're interrupting a deselection, cancel it immediately
            if (card.classList.contains('deselecting')) {
              card.classList.remove('deselecting');
            }
            
            // Selecting - apply snappy bounce
            card.classList.remove('clicking');
            void card.offsetWidth;
            card.classList.add('clicking');
            setTimeout(function() {
              card.classList.remove('clicking');
            }, 200);
            
            // Trigger gold spark explosion on selection
            if (window.explodeCardSparks) {
              window.explodeCardSparks(card);
              window.SoundSystem.play('spark-burst', null, 0.6);
            }
          }
          
          toggleSelection(card, cardType);
        });
        
        // Hover sound (desktop only - no hover on touch devices)
        // Use 'mouseenter' which only fires once when entering, not on every move
        let hasPlayedHoverSound = false;
        card.addEventListener('mouseenter', function() {
          // Skip on touch devices (they don't have real hover)
          if (window.matchMedia('(hover: none)').matches) return;
          
          // Only play if we haven't already (reset on mouseleave)
          if (!hasPlayedHoverSound) {
            hasPlayedHoverSound = true;
            window.SoundSystem.play('hover-card', null, 0.3); // Lower volume for subtle effect
          }
          
          // ========================================
          // TOOLTIP POSITIONING - Adjust translateY to prevent clipping
          // Keeps tooltip above card but pushes it down if near top of viewport
          // ========================================
          const tooltip = card.querySelector('.bb-card-tooltip');
          if (tooltip) {
            // Calculate card position
            const cardRect = card.getBoundingClientRect();
            
            // Tooltip height - use actual measurement or generous fallback
            const tooltipHeight = Math.max(tooltip.offsetHeight, 280);
            
            // CSS positions tooltip: bottom: calc(100% + 15px)
            const tooltipMargin = 15;
            
            // Small buffer from viewport edge
            const viewportBuffer = 15;
            
            // Where tooltip top would naturally be (above card)
            const naturalTooltipTop = cardRect.top - tooltipHeight - tooltipMargin;
            
            // Calculate offset: if clipping, push down; otherwise no offset needed
            let offsetY = 0; // Default: no offset (CSS handles -5px animation)
            if (naturalTooltipTop < viewportBuffer) {
              // Push tooltip down by the amount it would overflow + buffer
              offsetY = viewportBuffer - naturalTooltipTop;
            }
            
            // Set CSS variable for the transform
            tooltip.style.setProperty('--tooltip-offset-y', offsetY + 'px');
          }
        });
        
        // 3D mouse tracking effect (Optimized with requestAnimationFrame)
        let rafId = null;
        
        card.addEventListener('mousemove', function(e) {
          // PERFORMANCE: Skip only on touch devices where scrolling conflicts
          // On desktop, we want hover effects while dragging for a nice feel
          if (window.matchMedia('(hover: none)').matches && (carouselState.isDragging || carouselState.wasDragging)) return;
          
          // Throttle updates to screen refresh rate
          if (rafId) return;
          
          rafId = requestAnimationFrame(function() {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const centerX = rect.width / 2;
            const centerY = rect.height / 2;
            
            // Calculate rotation (max ±15 degrees)
            // Invert X axis for natural tilt
            const rotateY = ((x - centerX) / centerX) * 10; // Reduced to 10deg for smoother feel
            const rotateX = ((centerY - y) / centerY) * 10;
            
            // Calculate shine position (percentage)
            const shineX = (x / rect.width) * 100;
            const shineY = (y / rect.height) * 100;
            
            card.style.setProperty('--rotate-x', rotateX + 'deg');
            card.style.setProperty('--rotate-y', rotateY + 'deg');
            card.style.setProperty('--mouse-x', shineX + '%');
            card.style.setProperty('--mouse-y', shineY + '%');
            card.style.setProperty('--shine-opacity', '1');
            
            // Shadow moves OPPOSITE to tilt for 3D depth effect
            card.style.setProperty('--shadow-x', (-rotateY * 1.5) + 'px');
            card.style.setProperty('--shadow-y', (rotateX * 1.5 + 12) + 'px');
            
            rafId = null;
          });
        });
        
        // Reset on mouse leave
        card.addEventListener('mouseleave', function() {
          // Reset hover sound flag so it can play again on next enter
          hasPlayedHoverSound = false;
          
          if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
          // Smooth reset
          requestAnimationFrame(function() {
            card.style.setProperty('--rotate-x', '0deg');
            card.style.setProperty('--rotate-y', '0deg');
            card.style.setProperty('--shine-opacity', '0');
            card.style.setProperty('--shadow-x', '0px');
            card.style.setProperty('--shadow-y', '0px');
          });
          
          // Reset tooltip positioning offset
          const tooltip = card.querySelector('.bb-card-tooltip');
          if (tooltip) {
            tooltip.style.removeProperty('--tooltip-offset-y');
          }
        });
      });

      // Expand toggle for product details
      container.querySelectorAll('.bb-expand-toggle').forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.stopPropagation();
          const card = toggle.closest('.bb-product-card');
          const details = card.querySelector('.bb-card-details');
          
          if (details) {
            const isExpanded = details.style.display !== 'none';
            details.style.display = isExpanded ? 'none' : 'block';
            toggle.classList.toggle('expanded', !isExpanded);
            
            const text = toggle.querySelector('.bb-expand-text');
            if (text) {
              text.textContent = isExpanded ? 'See Details & Benefits' : 'Hide Details';
            }
          }
        });
      });

      // Upgrade toggles
      container.querySelectorAll('.bb-upgrade-list-item').forEach(function(item) {
        item.addEventListener('click', function() {
          toggleUpgrade(item);
        });
      });

      // Vault toggles
      container.querySelectorAll('.bb-vault-item').forEach(function(item) {
        item.addEventListener('click', function() {
          toggleVault(item);
        });
      });

      // Navigation buttons
      container.querySelectorAll('[data-action="next-step"]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          console.log('[BB DEBUG] Next/Skip button clicked!', {
            isDigitalGoodiesMode: isDigitalGoodiesMode,
            isPhysicalMode: isPhysicalMode,
            isUpgradeMode: isUpgradeMode,
            isSkipMode: isSkipMode,
            currentStep: state.currentStep,
            selectedProducts: state.selectedProducts.length,
            buttonDisabled: btn.disabled
          });
          
          // In digital goodies mode, checkout button goes to checkout
          if (isDigitalGoodiesMode) {
            console.log('[BB DEBUG] Going to checkout...');
            window.SoundSystem.play('button-click', null, 1.0);
            handleCheckout();
            return;
          }
          console.log('[BB DEBUG] Calling nextStep()...');
          window.SoundSystem.play('button-click', null, 0.8);
          nextStep();
        });
        console.log('[BB DEBUG] Click listener attached to next-step button');
      });

      container.querySelectorAll('[data-action="prev-step"]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          window.SoundSystem.play('button-click', null, 0.6);
          prevStep();
        });
      });

      // Back button - exits current sub-mode (Physical → Upgrade → Select)
      container.querySelectorAll('[data-action="exit-upgrade-mode"]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          window.SoundSystem.play('button-click', null, 0.6);
          
          // Check which mode we're in and exit appropriately
          if (isDigitalGoodiesMode) {
            exitDigitalGoodiesMode();
          } else if (isPhysicalMode) {
            // In skip mode, go directly back to card select (skip upgrade)
            if (isSkipMode) {
              exitPhysicalModeToCardSelect();
            } else {
              exitPhysicalMode();
            }
          } else if (isUpgradeMode) {
            exitUpgradeMode();
          }
        });
      });

      // Step nav clicks
      els.stepNavItems.forEach(function(item) {
        item.addEventListener('click', function() {
          const targetStep = parseInt(item.dataset.step);
          if (targetStep < state.currentStep) {
            goToStep(targetStep);
          }
        });
      });

      // Add all upgrades button
      const addAllBtn = container.querySelector('[data-action="add-all-upgrades"]');
      if (addAllBtn) {
        addAllBtn.addEventListener('click', function() {
          window.SoundSystem.play('button-click', null, 0.8);
          addAllUpgrades();
        });
      }

      // Checkout button
      const checkoutBtn = container.querySelector('[data-action="checkout"]');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function() {
          window.SoundSystem.play('button-click', null, 1.0);
          handleCheckout();
        });
      }
      
      // Close button
      const closeBtn = container.querySelector('[data-action="close"]');
      if (closeBtn) {
        closeBtn.addEventListener('click', handleClose);
      }
    }
    
    // ========================================================================
    // Close Handler
    // ========================================================================
    function handleClose() {
      const hasSelections = state.selectedProducts.length > 0 || 
                           state.selectedUpgrades.length > 0 || 
                           state.selectedAddons.length > 0 || 
                           state.selectedVault.length > 0 ||
                           state.selectedDigitalGoodies.length > 0;
      
      const closeUrl = container.dataset.closeUrl;
      const confirmMessage = container.dataset.closeMessage || "You'll lose your bundle progress. Are you sure?";
      
      if (hasSelections) {
        if (!confirm(confirmMessage)) {
          return;
        }
      }
      
      // Stop timer
      if (state.timerInterval) {
        clearInterval(state.timerInterval);
      }
      
      // Redirect or go back
      if (closeUrl) {
        window.location.href = closeUrl;
      } else {
        window.history.back();
      }
    }

    // ========================================================================
    // Selection Handlers
    // ========================================================================
    
    // Update all selected cards to show the current tier color
    function updateSelectedCardsTier(cardCount) {
      // Calculate tier (1-10)
      var tier = Math.min(Math.max(cardCount, 1), 10);
      
      // Find all selected product cards
      var selectedCards = container.querySelectorAll('.bb-balatro-card.selected, .bb-product-card.selected');
      
      // Use requestAnimationFrame to batch all class changes in a single render frame
      // This prevents intermediate states that can cause clip-path rendering glitches
      requestAnimationFrame(function() {
      selectedCards.forEach(function(card) {
          // Get current tier class to check if we're changing from tier-10 (animated)
          var currentTier = null;
        for (var i = 1; i <= 10; i++) {
            if (card.classList.contains('tier-' + i)) {
              currentTier = i;
              break;
            }
          }
          
          // If changing from tier-10, force a style recalc to stop animation cleanly
          // before changing classes to prevent clip-path glitch
          if (currentTier === 10 && tier !== 10) {
            var card3d = card.querySelector('.bb-card-3d');
            if (card3d) {
              // Force the pseudo-element to acknowledge the animation stop
              card3d.style.animation = 'none';
              void card3d.offsetHeight; // Force reflow
              card3d.style.animation = '';
            }
          }
          
          // Remove all tier classes atomically using className manipulation
          // This is faster and prevents intermediate render states
          var classList = card.className.split(' ').filter(function(cls) {
            return !cls.match(/^tier-\d+$/);
          });
          classList.push('tier-' + tier);
          card.className = classList.join(' ');
      });
      
      console.log('🎨 Updated ' + selectedCards.length + ' cards to tier ' + tier);
      });
    }
    
    function toggleSelection(card, type) {
      const variantId = card.dataset.variantId;
      const productId = card.dataset.productId;
      const price = parseFloat(card.dataset.price) || 0;
      const comparePrice = parseFloat(card.dataset.comparePrice) || price;
      const title = card.dataset.title;
      const variantTitle = card.dataset.variantTitle || '';
      const handle = card.dataset.handle;
      
      // Track product click for analytics
      if (handle && window.BB && window.BB.trackProductClick) {
        window.BB.trackProductClick(handle, title);
      }
      
      let targetArray;
      switch (type) {
        case 'product':
          targetArray = state.selectedProducts;
          break;
        case 'addon':
          targetArray = state.selectedAddons;
          break;
        case 'vault':
          targetArray = state.selectedVault;
          break;
        default:
          targetArray = state.selectedProducts;
      }
      
      const existingIndex = targetArray.findIndex(function(item) {
        return item.variantId === variantId;
      });
      
      if (existingIndex > -1) {
        // DESELECT - Remove from array and update state
        targetArray.splice(existingIndex, 1);
        
        // PERFORMANCE FIX: Clear particles immediately on deselection
        // This prevents zombie particles from running after the card is deselected
        if (window.clearCardParticles) {
          window.clearCardParticles(card);
        }
        
        // Update card state to UNSELECTED
        setCardState(card, CARD_STATE.UNSELECTED);
        
        // For DESELECT: play sound with PREVIOUS tier (the tier we're leaving)
        // e.g., going from 2→1 cards plays deselect-tier-2, going 1→0 plays deselect-tier-1
        var previousTier = window.SoundSystem.getTier();
        window.SoundSystem.play('card-deselect', previousTier, 0.7);
        
        // NOW update tier to the new count
        // Secret tiers go up to 14!
        if (type === 'product') {
          var newTier = Math.max(1, Math.min(state.selectedProducts.length, 14));
          window.SoundSystem.setTier(newTier);
          
          // Update avatar tier (de-evolution)
          if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.evolveMyAvatar) {
            MultiplayerSystem.evolveMyAvatar(state.selectedProducts.length);
          }
          
          // Update ALL selected cards to the new tier color
          updateSelectedCardsTier(state.selectedProducts.length);
        }
        
        // Add deselecting class for animation (state already updated)
        card.classList.add('deselecting');
        
        // Remove deselecting class after animation completes
        setTimeout(function() {
          card.classList.remove('deselecting');
        }, 800);
        
        // If removing a product, also remove its upgrade
        if (type === 'product') {
          state.selectedUpgrades = state.selectedUpgrades.filter(function(u) {
            return u.baseProductId !== productId;
          });
        }
      } else {
        // SELECT - Add to array and update state
        targetArray.push({
          variantId: variantId,
          productId: productId,
          price: price,
          comparePrice: comparePrice,
          title: title,
          variantTitle: variantTitle,
          handle: handle,
          type: type
        });
        
        // Update card state to SELECTED
        setCardState(card, CARD_STATE.SELECTED);
        
        // Update ALL selected cards to the new tier color
        if (type === 'product') {
          updateSelectedCardsTier(state.selectedProducts.length);
        }
        
        // Make avatar jump when selecting a card! Pass product title for floating message
        if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
          MultiplayerSystem.jumpMyAvatar(title);
        }
        
        // Evolve avatar based on card count!
        if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.evolveMyAvatar && type === 'product') {
          MultiplayerSystem.evolveMyAvatar(state.selectedProducts.length);
        }
        
        // Update tier BEFORE playing sound so it uses the correct tier
        // Tier is based on product count: 1 item = tier 1, 2 items = tier 2, etc
        // Secret tiers go up to 14!
        var previousTierForSound = window.SoundSystem.getTier();
        if (type === 'product') {
          var newTier = Math.min(state.selectedProducts.length, 14);
          window.SoundSystem.setTier(newTier);
        }
        
        // PRIMARY: Play select sound immediately (uses the updated tier)
        window.SoundSystem.play('card-select');
        
        // PRIMARY: Play checkmark land sound when checkmark finishes bouncing (~400ms into animation)
        setTimeout(function() {
          window.SoundSystem.play('checkmark-land', null, 0.5);
        }, 400);
        
        // SECONDARY: Progress bar updates after a short delay (200ms)
        setTimeout(function() {
          updateCalculation(true); // true = play progress sound
        }, 200);
        
        // TERTIARY: Deck lights up after progress bar (400ms) - only tier 2+ has sound
        if (type === 'product') {
          setTimeout(function() {
            var currentTier = window.SoundSystem.getTier();
            if (currentTier >= 2) {
              window.SoundSystem.play('deck-light', null, 0.4);
            }
            checkTierUpgrade();
          }, 400);
        }
        
        return; // Skip the immediate updateCalculation below
      }
      
      // For deselection, update calculation after a short delay too
      setTimeout(function() {
        updateCalculation(true);
      }, 200);
      
      // Trigger particle effect on tier decrease
      if (type === 'product') {
        setTimeout(function() {
          var currentTier = window.SoundSystem.getTier();
          if (currentTier >= 2) {
            window.SoundSystem.play('deck-light', null, 0.3);
          }
          checkTierUpgrade();
        }, 400);
      }
    }

    function toggleUpgrade(item) {
      const variantId = item.dataset.variantId;
      const baseProductId = item.dataset.baseProductId;
      const price = parseFloat(item.dataset.price) || 0;
      const comparePrice = parseFloat(item.dataset.comparePrice) || price;
      const title = item.dataset.title;
      
      const existingIndex = state.selectedUpgrades.findIndex(function(u) {
        return u.variantId === variantId;
      });
      
      if (existingIndex > -1) {
        state.selectedUpgrades.splice(existingIndex, 1);
        item.classList.remove('selected');
      } else {
        state.selectedUpgrades.push({
          variantId: variantId,
          baseProductId: baseProductId,
          price: price,
          comparePrice: comparePrice,
          title: title,
          type: 'upgrade'
        });
        item.classList.add('selected');
        
        // Show floating message for upgrade selection
        if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
          MultiplayerSystem.jumpMyAvatar(title);
        }
      }
      
      updateCalculation();
    }

    function toggleVault(item) {
      const variantId = item.dataset.variantId;
      const productId = item.dataset.productId;
      const price = parseFloat(item.dataset.price) || 0;
      const comparePrice = parseFloat(item.dataset.comparePrice) || price;
      const title = item.dataset.title;
      const handle = item.dataset.handle;
      
      const existingIndex = state.selectedVault.findIndex(function(v) {
        return v.variantId === variantId;
      });
      
      if (existingIndex > -1) {
        state.selectedVault.splice(existingIndex, 1);
        item.classList.remove('selected');
      } else {
        state.selectedVault.push({
          variantId: variantId,
          productId: productId,
          price: price,
          comparePrice: comparePrice,
          title: title,
          handle: handle,
          type: 'vault'
        });
        item.classList.add('selected');
        
        // Show floating message for vault selection
        if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
          MultiplayerSystem.jumpMyAvatar(title);
        }
      }
      
      updateCalculation();
    }

    function addAllUpgrades() {
      // Select all visible upgrade items that aren't already selected
      container.querySelectorAll('.bb-upgrade-item:not(.selected)').forEach(function(item) {
        toggleUpgrade(item);
      });
    }

    // ========================================================================
    // Complete Package Detection
    // ========================================================================
    
    /**
     * Detects when all 3 components of a deck (Digital + Video + Physical) are selected.
     * Returns an array of detected complete packages.
     */
    function detectCompletePackages() {
      var detectedPackages = [];
      
      completePackageMappings.forEach(function(mapping) {
        var hasDigital = state.selectedProducts.some(function(p) {
          return String(p.variantId) === String(mapping.digitalVariantId);
        });
        var hasVideo = state.selectedUpgrades.some(function(u) {
          return String(u.variantId) === String(mapping.videoVariantId);
        });
        var hasPhysical = state.selectedPhysical && state.selectedPhysical.some(function(p) {
          return String(p.variantId) === String(mapping.physicalVariantId);
        });
        
        if (hasDigital && hasVideo && hasPhysical) {
          detectedPackages.push(mapping);
        }
      });
      
      return detectedPackages;
    }
    
    /**
     * Shows a toast notification when a Complete Package is unlocked.
     */
    function showCompletePackageUnlocked(deckName) {
      // Don't show duplicate toasts
      if (container.querySelector('.bb-complete-package-toast[data-deck="' + deckName + '"]')) {
        return;
      }
      
      // Play a celebratory sound
      if (window.SoundSystem && window.SoundSystem.play) {
        window.SoundSystem.play('tier-unlock');
      }
      
      // Create toast notification
      var toast = document.createElement('div');
      toast.className = 'bb-complete-package-toast';
      toast.setAttribute('data-deck', deckName);
      toast.innerHTML = 
        '<span class="bb-toast-icon">🎁</span>' +
        '<span class="bb-toast-text">Complete Package Unlocked: ' + deckName + '!</span>' +
        '<span class="bb-toast-savings">You save even more!</span>';
      container.appendChild(toast);
      
      // Remove after animation
      setTimeout(function() {
        if (toast.parentNode) {
          toast.classList.add('bb-toast-exit');
          setTimeout(function() {
            if (toast.parentNode) {
              toast.remove();
            }
          }, 300);
        }
      }, 4000);
      
      console.log('[BB Complete Package] Unlocked:', deckName);
    }
    
    /**
     * Checks for complete packages and shows notifications for newly detected ones.
     */
    function checkForCompletePackages() {
      var currentDetected = detectCompletePackages();
      var previouslyDetected = state.detectedCompletePackages || [];
      
      // Find newly detected packages
      currentDetected.forEach(function(pkg) {
        var wasAlreadyDetected = previouslyDetected.some(function(prev) {
          return prev.deckName === pkg.deckName;
        });
        
        if (!wasAlreadyDetected) {
          showCompletePackageUnlocked(pkg.deckName);
        }
      });
      
      // Update state
      state.detectedCompletePackages = currentDetected;
      
      return currentDetected;
    }

    // ========================================================================
    // Calculation & Pricing
    // ========================================================================
    function updateCalculation(playProgressSound) {
      // Check for complete packages after any selection change
      checkForCompletePackages();
      // NOTE: We no longer persist selections - every visit is a fresh start
      // saveBundleToStorage();
      
      // Count products + digital goodies + physical towards tier
      const digitalGoodiesCount = state.selectedDigitalGoodies ? state.selectedDigitalGoodies.length : 0;
      // Physical count includes quantity (each item counts toward tier)
      const physicalCount = state.selectedPhysical ? state.selectedPhysical.reduce(function(sum, p) { return sum + (p.quantity || 1); }, 0) : 0;
      const upgradesCount = state.selectedUpgrades ? state.selectedUpgrades.length : 0;
      const vaultCount = state.selectedVault ? state.selectedVault.length : 0;
      // Product count includes digital, physical, AND upgrades (video libraries) for tier calculation
      const productCount = state.selectedProducts.length + digitalGoodiesCount + physicalCount + upgradesCount;
      
      // Total items for evolution (includes everything in cart)
      const totalItemsForEvolution = productCount + upgradesCount + vaultCount;
      
      // Evolve avatar based on TOTAL items in cart (not just products)
      if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.evolveMyAvatar) {
        MultiplayerSystem.evolveMyAvatar(totalItemsForEvolution);
      }
      
      // Calculate discount tier based on total item count
      let discount = 0;
      if (productCount >= 5) discount = config.tiers[5];
      else if (productCount === 4) discount = config.tiers[4];
      else if (productCount === 3) discount = config.tiers[3];
      else if (productCount === 2) discount = config.tiers[2];
      
      const previousTier = state.discountTier;
      state.discountTier = discount;
      
      // Update progress bar (pass previous tier for shake animation)
      updateProgressBar(productCount, discount, previousTier);
      
      // Play progress bar grow sound (secondary action)
      if (playProgressSound && productCount > 0) {
        window.SoundSystem.play('progress-grow', null, 0.35);
      }
      
      // Trigger particles and shockwave on tier increase (Pac-Man eating mechanic)
      if (discount > previousTier) {
        spawnParticles();
        triggerShockwave();
        window.SoundSystem.play('tier-unlock');
      }
      
      // Update digital goodies prices if tier changed and we're in that mode
      if (discount !== previousTier && isDigitalGoodiesMode) {
        updateDigitalGoodiesPrices(discount);
      }
      
      // Update physical prices - always update to check for FREE offers (partial complete packages)
      // This runs on every selection change, not just tier changes
      if (isPhysicalMode) {
        updatePhysicalPrices(discount);
      }
      
      // Calculate totals
      let totalValue = 0;
      let totalPay = 0;
      
      // Detect complete packages and build skip lists for individual items
      var detectedPackages = detectCompletePackages();
      var skipDigitalIds = [];
      var skipVideoIds = [];
      var skipPhysicalIds = [];
      
      // Process complete packages first - use package price instead of 3 individual prices
      detectedPackages.forEach(function(pkg) {
        // Mark component variant IDs to skip in individual calculations
        skipDigitalIds.push(String(pkg.digitalVariantId));
        skipVideoIds.push(String(pkg.videoVariantId));
        skipPhysicalIds.push(String(pkg.physicalVariantId));
        
        // Use Complete Package price (already includes all 3 components)
        var pkgComparePrice = pkg.completePackageComparePrice || pkg.completePackagePrice;
        totalValue += pkgComparePrice;
        totalPay += pkg.completePackagePrice * (1 - discount / 100);
      });
      
      // Store detected packages for summary display
      state.activeCompletePackages = detectedPackages;
      
      // Products (with discount) - skip items in complete packages
      state.selectedProducts.forEach(function(p) {
        if (skipDigitalIds.indexOf(String(p.variantId)) !== -1) return;
        totalValue += p.comparePrice || p.price;
        totalPay += p.price * (1 - discount / 100);
      });
      
      // Upgrades (with tier discount) - skip items in complete packages
      state.selectedUpgrades.forEach(function(u) {
        if (skipVideoIds.indexOf(String(u.variantId)) !== -1) return;
        totalValue += u.comparePrice || u.price;
        totalPay += u.price * (1 - discount / 100);
      });
      
      // Addons (no discount)
      state.selectedAddons.forEach(function(a) {
        totalValue += a.comparePrice || a.price;
        totalPay += a.price;
      });
      
      // Physical variants (with same discount as products) - skip items in complete packages
      if (state.selectedPhysical && state.selectedPhysical.length > 0) {
        state.selectedPhysical.forEach(function(p) {
          if (skipPhysicalIds.indexOf(String(p.variantId)) !== -1) return;
          var qty = p.quantity || 1;
          totalValue += (p.comparePrice || p.price) * qty;
          totalPay += p.price * qty * (1 - discount / 100);
        });
      }
      
      // Digital goodies (with same discount as products - they count towards tier!)
      if (state.selectedDigitalGoodies && state.selectedDigitalGoodies.length > 0) {
        state.selectedDigitalGoodies.forEach(function(g) {
          totalValue += g.comparePrice || g.price;
          totalPay += g.price * (1 - discount / 100);
        });
      }
      
      // Vault items
      state.selectedVault.forEach(function(v) {
        totalValue += v.comparePrice || v.price;
        totalPay += v.price;
      });
      
      const savings = totalValue - totalPay;
      
      // Update all price displays with cash register animation
      els.navPrices.forEach(function(el) {
        animatePriceTicker(el, totalPay, { duration: 400, playSound: true });
      });
      
      // Update subtotal display (original price before discounts)
      els.navSubtotals.forEach(function(el) {
        el.textContent = formatMoney(totalValue).replace(/[£$€]/, '');
      });
      
      // Show/hide subtotal based on whether there are savings
      els.subtotalValues.forEach(function(el) {
        if (savings > 0 && totalValue > 0) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });
      
      els.navSavings.forEach(function(el) {
        el.textContent = formatMoney(savings);
      });
      
      // Update savings display in sticky bar with individual character spans
      // Store whether savings changed for pop trigger later
      var savingsChanged = false;
      if (els.tierSavingsValue) {
        // User requested no decimals for savings display
        var savingsStr = Math.floor(savings / 100).toString();
        var previousSavingsStr = els.tierSavingsValue.textContent;
        var charHtml = '';
        for (var i = 0; i < savingsStr.length; i++) {
          charHtml += '<span class="bb-char">' + savingsStr[i] + '</span>';
        }
        // Only update HTML if content changed
        if (previousSavingsStr !== savingsStr) {
          els.tierSavingsValue.innerHTML = charHtml;
          savingsChanged = true;
          
          // Play subtle number tick sound (cash register flutter)
          window.SoundSystem.play('number-tick', null, 0.15);
          
          // Update shadow value
          if (els.tierSavingsShadow) {
              const shadowVal = els.tierSavingsShadow.querySelector('.bb-tier-shadow-value');
              if (shadowVal) shadowVal.innerHTML = charHtml;
          }
          
          // Refresh cache since DOM nodes changed
          cacheShakeElements();
        }
      }
      
      // Trigger pop immediately if savings changed (before updateProgressBar is called)
      if (savingsChanged && typeof shakeState !== 'undefined') {
        shakeState.isPopping = true;
        shakeState.popStartTime = Date.now();
      }
      
      // Update summary if on that step
      updateSummary(totalPay, savings);
      
      // Enable/disable nav buttons based on step and selections
      const hasItems = productCount > 0;
      const hasProductCards = state.selectedProducts.length > 0;
      
      els.navBtns.forEach(function(btn) {
        if (state.currentStep === 1) {
          // Digital Goodies mode = CHECKOUT button (disabled only if cart is empty)
          if (isDigitalGoodiesMode) {
            btn.innerHTML = '🛒 <span class="bb-btn-label">Checkout</span>';
            // Disable checkout only if there are 0 items in cart
            const hasNoItems = productCount === 0;
            btn.disabled = hasNoItems;
            if (hasNoItems) {
              btn.classList.remove('bb-btn-checkout-rainbow');
              btn.classList.add('bb-btn-checkout-disabled');
            } else {
              btn.classList.add('bb-btn-checkout-rainbow');
              btn.classList.remove('bb-btn-checkout-disabled');
            }
          } else {
            // All other modes (Card Select, Upgrade, Physical) - always show "Next"
            btn.disabled = false;
            btn.innerHTML = '<span class="bb-btn-label">Next </span>→';
            btn.classList.remove('bb-btn-checkout-rainbow');
            btn.classList.remove('bb-btn-checkout-disabled');
          }
        } else {
          btn.disabled = false;
          btn.classList.remove('bb-btn-checkout-rainbow');
          btn.classList.remove('bb-btn-checkout-disabled');
        }
      });
      
      // Update mini cart display
      updateMiniCartDisplay();
    }

    function updateProgressBar(count, discount, previousDiscount) {
      if (!els.tierFill) return;
      
      // Progress bar milestones:
      // 2 items = 25% (first marker)
      // 3 items = 50% (second marker)
      // 4 items = 75% (third marker)
      // 5+ items = 100% (fourth marker)
      // Progress between milestones shows partial fill
      let width = 0;
      if (count >= 5) {
        width = 100;
      } else if (count === 4) {
        width = 75;
      } else if (count === 3) {
        width = 50;
      } else if (count === 2) {
        width = 25;
      } else if (count === 1) {
        // Show progress toward first milestone (halfway to 25%)
        width = 12.5;
      }
      
      els.tierFill.style.width = width + '%';
      // Hide bar at extremely low widths to avoid pixelated corner artifacts
      els.tierFill.style.opacity = width > 2 ? 1 : 0;
      
      // Reset intensity classes - MUST use correct wrapper class name
      els.tierFill.className = 'bb-tier-bar-fill-wrapper';
      if (width >= 25) els.tierFill.classList.add('intensity-1');
      if (width >= 50) els.tierFill.classList.add('intensity-2');
      if (width >= 100) els.tierFill.classList.add('intensity-3');
      
      // SECRET TIERS (6-14) - Increasingly crazy effects!
      if (count >= 6) els.tierFill.classList.add('secret-tier-6');
      if (count >= 7) els.tierFill.classList.add('secret-tier-7');
      if (count >= 8) els.tierFill.classList.add('secret-tier-8');
      if (count >= 9) els.tierFill.classList.add('secret-tier-9');
      if (count >= 10) els.tierFill.classList.add('secret-tier-10');
      if (count >= 11) els.tierFill.classList.add('secret-tier-11');
      if (count >= 12) els.tierFill.classList.add('secret-tier-12');
      if (count >= 13) els.tierFill.classList.add('secret-tier-13');
      if (count >= 14) els.tierFill.classList.add('secret-tier-14'); // FULL RAVE MODE!
      
      // Update tier markers
      container.querySelectorAll('.bb-tier-marker').forEach(function(marker) {
        const tierNum = parseInt(marker.dataset.tier);
        marker.classList.toggle('reached', count >= tierNum);
      });
      
      // Update percentage display above bar with individual character spans
      var percentChanged = false;
      if (els.tierPercentValue) {
        var percentStr = discount + '%';
        var charHtml = '';
        for (var i = 0; i < percentStr.length; i++) {
          charHtml += '<span class="bb-char">' + percentStr[i] + '</span>';
        }
        // Only update HTML if content changed to avoid resetting animations unnecessarily
        if (els.tierPercentValue.textContent !== percentStr) {
            els.tierPercentValue.innerHTML = charHtml;
            percentChanged = true;
            // Trigger pop immediately when percent changes
            if (typeof shakeState !== 'undefined') {
                shakeState.isPopping = true;
                shakeState.popStartTime = Date.now();
            }
            
            // Update shadow value
            if (els.tierPercentShadow) {
                const shadowVal = els.tierPercentShadow.querySelector('.bb-tier-shadow-value');
                if (shadowVal) shadowVal.innerHTML = charHtml;
            }
            
            // Refresh cache since DOM nodes changed
            cacheShakeElements();
        }
        
        // Update shake intensity based on count/tier
        // Tier logic: 0 items = Tier 0, 1 item = Tier 1, 2 items = Tier 2, etc.
        // Visual effects only have 5 tiers, but sounds support up to 14 (secret tiers)
        var visualTier = count;
        if (visualTier > 5) visualTier = 5; // Cap visual effects at tier 5
        
        var soundTier = Math.min(count, 14); // Sounds support secret tiers up to 14!
        
        // Update shakeState tier index (used by animation loop)
        if (typeof shakeState !== 'undefined') {
            shakeState.currentTierIndex = visualTier;
        }
        
        // Update sound system tier for tier-specific sounds (supports tiers 1-14)
        window.SoundSystem.setTier(soundTier);
        
        // Apply tier-specific CSS variables to container (visual effects use capped tier)
        if (typeof TIER_INTENSITY !== 'undefined' && TIER_INTENSITY[visualTier]) {
            const ti = TIER_INTENSITY[visualTier];
            const container = document.querySelector('.bundle-builder');
            if (container) {
                container.style.setProperty('--idle-intensity', ti.idleIntensity || 0.05);
                container.style.setProperty('--hover-glow', ti.hoverGlow || 0.15);
                container.style.setProperty('--selected-glow', ti.selectedGlow || 0.15);
                container.style.setProperty('--selected-flicker', ti.selectedFlicker || 0.05);
            }
        }
        
        // Update debug panel if the function exists (visual effects use capped tier)
        if (typeof window.updateDebugPanelTier === 'function') {
            window.updateDebugPanelTier(visualTier);
        }
        
        // Apply fire settings for the current tier (visual effects use capped tier)
        if (typeof applyFireSettingsForTier === 'function') {
            applyFireSettingsForTier(visualTier);
        }
        
        // Pop animation is now triggered immediately when values change (above)
        // No need for delayed trigger here
      }
      
      // Update legacy status text (for backwards compatibility)
      if (els.tierStatus) {
        if (count >= 5) {
          els.tierStatus.textContent = els.tierStatus.dataset.maxText || 'MAX DISCOUNT UNLOCKED!';
          if (els.tierNext) els.tierNext.style.display = 'none';
        } else {
          const nextTier = count < 2 ? 2 : count + 1;
          const nextDiscount = config.tiers[nextTier] || config.tiers[5];
          els.tierStatus.textContent = 'Unlock ' + discount + '% OFF';
          if (els.tierNext) {
            els.tierNext.textContent = 'Next: ' + nextDiscount + '%';
            els.tierNext.style.display = '';
          }
        }
      }
    }

    function checkTierUpgrade() {
      // This is called after product selection to potentially trigger effects
    }

    // ========================================================================
    // Navigation
    // ========================================================================
    
    // Track if we're in "upgrade mode" (after first next click)
    var isUpgradeMode = false;
    // Track if we're in "physical mode" (after second next click, showing 3D models)
    var isPhysicalMode = false;
    // Track if we're in "digital goodies mode" (after third next click, showing digital products)
    var isDigitalGoodiesMode = false;
    // Track if user used "skip mode" (skipped card selection with 0 cards)
    var isSkipMode = false;
    
    function nextStep() {
      console.log('[BB DEBUG] nextStep() called, currentStep:', state.currentStep, 'totalSteps:', state.totalSteps);
      
      // NOTE: Fly-off animation and leaderboard recording now happen ONLY at checkout (handleCheckout)
      
      // Step 1 has four sub-states: Select → Upgrade → Physical → Digital Goodies (if enabled)
      // These sub-modes happen WITHIN step 1, so don't block based on totalSteps yet
      if (state.currentStep === 1) {
        console.log('[BB DEBUG] Step 1 logic, selectedProducts:', state.selectedProducts.length, 'isPhysicalMode:', isPhysicalMode, 'isDigitalGoodiesMode:', isDigitalGoodiesMode);
        
        // SKIP mode: No cards selected = skip directly to Physical Mode
        if (state.selectedProducts.length === 0 && !isPhysicalMode) {
          console.log('[BB DEBUG] SKIP mode - entering Physical Mode');
          // Skip upgrade, go straight to Physical Mode
          isSkipMode = true;
          isUpgradeMode = true; // Mark as passed through
          enterPhysicalMode();
          return;
        }
        
        // Already in Physical mode (skip or normal flow) - check for Digital Goodies
        if (isPhysicalMode && !isDigitalGoodiesMode) {
          var goodiesData = getDigitalGoodiesData();
          if (goodiesData && goodiesData.enabled && goodiesData.products && goodiesData.products.length > 0) {
            enterDigitalGoodiesMode();
            return;
          }
          // Digital Goodies not enabled, fall through to Step 2
        }
        
        if (!isUpgradeMode) {
          // Select Mode → Upgrade Mode
          enterUpgradeMode();
          return;
        } else if (!isPhysicalMode) {
          // Upgrade Mode → Physical Mode (3D deck reveal)
          enterPhysicalMode();
          return;
        } else if (!isDigitalGoodiesMode) {
          // Physical Mode → Digital Goodies Mode (if enabled)
          var goodiesData = getDigitalGoodiesData();
          if (goodiesData && goodiesData.enabled && goodiesData.products && goodiesData.products.length > 0) {
            enterDigitalGoodiesMode();
            return;
          }
          // Digital Goodies not enabled, fall through to Step 2
        }
        // Digital Goodies Mode → Step 2 (fall through to goToStep)
        // NOTE: Leaderboard recording now happens at checkout only
      }
      
      // Only allow going to next step if there are more steps
      if (state.currentStep >= state.totalSteps) {
        console.log('[BB DEBUG] Cannot advance: at last step');
        return;
      }
      
      goToStep(state.currentStep + 1);
    }
    
    // Get Digital Goodies configuration from JSON data
    function getDigitalGoodiesData() {
      var dataEl = document.getElementById('bb-digital-goodies-' + sectionId);
      if (!dataEl) return null;
      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('[BB] Failed to parse digital goodies data:', e);
        return null;
      }
    }
    
    // ========================================================================
    // Record Savings from Digital Goodies Step (for Team Leaderboard)
    // ========================================================================
    function recordSavingsFromDigitalGoodies() {
      console.log('🏆 [Leaderboard] recordSavingsFromDigitalGoodies CALLED');
      
      // Get player info
      var playerName = window.BB && window.BB.Player ? window.BB.Player.getName() : 'Anonymous';
      var playerSprite = window.BB && window.BB.Player ? window.BB.Player.getSprite() : { chainId: 'feline', emoji: '🐱' };
      var team = playerSprite.chainId || 'feline';
      
      console.log('🏆 [Leaderboard] Player:', playerName, 'Team:', team);
      console.log('🏆 [Leaderboard] State:', {
        products: state.selectedProducts.length,
        upgrades: state.selectedUpgrades.length,
        physical: (state.selectedPhysical || []).length,
        goodies: (state.selectedDigitalGoodies || []).length,
        vault: state.selectedVault.length,
        discountTier: state.discountTier
      });
      
      // Calculate current savings from state
      var discount = state.discountTier || 0;
      var totalValue = 0;
      var totalPay = 0;
      
      // Products (with discount)
      state.selectedProducts.forEach(function(p) {
        totalValue += p.comparePrice || p.price;
        totalPay += p.price * (1 - discount / 100);
      });
      
      // Upgrades (no additional discount - already discounted)
      state.selectedUpgrades.forEach(function(u) {
        totalValue += u.comparePrice || u.price;
        totalPay += u.price;
      });
      
      // Physical variants (with discount)
      if (state.selectedPhysical && state.selectedPhysical.length > 0) {
        state.selectedPhysical.forEach(function(p) {
          var qty = p.quantity || 1;
          totalValue += (p.comparePrice || p.price) * qty;
          totalPay += p.price * qty * (1 - discount / 100);
        });
      }
      
      // Digital goodies (with discount)
      if (state.selectedDigitalGoodies && state.selectedDigitalGoodies.length > 0) {
        state.selectedDigitalGoodies.forEach(function(g) {
          totalValue += g.comparePrice || g.price;
          totalPay += g.price * (1 - discount / 100);
        });
      }
      
      // Vault items (no discount, but included in savings)
      state.selectedVault.forEach(function(v) {
        totalValue += v.comparePrice || v.price;
        totalPay += v.price;
      });
      
      var savingsInLocalCurrency = Math.round((totalValue - totalPay) / 100); // Convert from cents
      var savingsInGBP = normalizeToGBP(savingsInLocalCurrency, config.currency);
      
      console.log('🏆 [Leaderboard] Calculated:', {
        totalValue: totalValue,
        totalPay: totalPay,
        savingsLocal: savingsInLocalCurrency,
        savingsGBP: savingsInGBP,
        currency: config.currency
      });
      
      // Only record if there are actual savings
      if (savingsInGBP > 0) {
        recordSavingsToLeaderboard(team, savingsInGBP, savingsInLocalCurrency, config.currency, playerName);
        console.log('🏆 [Leaderboard] SENT to Firebase:', savingsInGBP, 'GBP for team', team);
      } else {
        console.log('🏆 [Leaderboard] NOT SENT - savings is 0 or negative');
      }
    }
    
    // ========================================================================
    // CARD POSITIONING SYSTEM - For smooth reflow animations (responsive)
    // ========================================================================
    var upgradeResizeHandler = null;
    var cachedGridLayout = null; // Cache layout before grid display changes
    
    function getGridLayout(grid, useCache) {
      // Return cached layout if requested and available
      if (useCache && cachedGridLayout) {
        return cachedGridLayout;
      }
      
      if (!grid) return { columns: 2, columnGap: 16, rowGap: 16, cardWidth: 126, cardHeight: 176 };
      
      var computedStyle = window.getComputedStyle(grid);
      var columnGap = parseInt(computedStyle.columnGap) || parseInt(computedStyle.gap) || 16;
      var rowGap = parseInt(computedStyle.rowGap) || parseInt(computedStyle.gap) || 16;
      
      // If grid is no longer display:grid, use cached gaps or CSS-defined values
      if (grid.style.display === 'block' && cachedGridLayout) {
        columnGap = cachedGridLayout.columnGap;
        rowGap = cachedGridLayout.rowGap;
      }
      
      // Get card dimensions from first visible card
      var firstCard = grid.querySelector('.bb-balatro-card:not([style*="display: none"])');
      if (!firstCard) firstCard = grid.querySelector('.bb-balatro-card');
      
      var cardWidth = firstCard ? firstCard.offsetWidth : 126;
      var cardHeight = firstCard ? firstCard.offsetHeight : 176;
      
      // Calculate available width
      var gridPaddingLeft = parseInt(computedStyle.paddingLeft) || 20;
      var gridPaddingRight = parseInt(computedStyle.paddingRight) || 20;
      var gridWidth = grid.offsetWidth - gridPaddingLeft - gridPaddingRight;
      
      // Calculate how many columns can fit
      // columns = floor((gridWidth + gap) / (cardWidth + gap))
      var columns = Math.floor((gridWidth + columnGap) / (cardWidth + columnGap));
      columns = Math.max(1, columns); // At least 1 column
      
      // Cap columns based on breakpoint (match CSS)
      var viewportWidth = window.innerWidth;
      if (viewportWidth >= 900) {
        columns = Math.min(columns, 3); // Desktop: max 3 columns
      } else if (viewportWidth >= 600) {
        columns = Math.min(columns, 3); // Tablet: max 3 columns
      } else {
        columns = Math.min(columns, 2); // Mobile: max 2 columns
      }
      
      return {
        columns: columns,
        columnGap: columnGap,
        rowGap: rowGap,
        cardWidth: cardWidth,
        cardHeight: cardHeight,
        gridPaddingLeft: gridPaddingLeft,
        gridPaddingRight: gridPaddingRight,
        gridPaddingTop: parseInt(computedStyle.paddingTop) || 20,
        gridWidth: gridWidth
      };
    }
    
    function calculateCardPosition(index, layout, totalCards) {
      var col = index % layout.columns;
      var row = Math.floor(index / layout.columns);
      
      // Calculate how many cards are in this specific row
      var totalRows = Math.ceil(totalCards / layout.columns);
      var isLastRow = (row === totalRows - 1);
      var cardsInThisRow = isLastRow ? (totalCards - (row * layout.columns)) : layout.columns;
      
      // Calculate row width for centering
      var rowWidth = (cardsInThisRow * layout.cardWidth) + ((cardsInThisRow - 1) * layout.columnGap);
      var offsetX = (layout.gridWidth - rowWidth) / 2;
      
      // Ensure offset is not negative
      offsetX = Math.max(0, offsetX);
      
      var x = offsetX + (col * (layout.cardWidth + layout.columnGap));
      var y = row * (layout.cardHeight + layout.rowGap);
      
      return { x: x, y: y };
    }
    
    // Store original positions captured from CSS grid
    var originalCardPositions = new Map();
    
    function captureCardPositions(grid, cards) {
      if (!grid || !cards.length) return;
      
      var gridRect = grid.getBoundingClientRect();
      
      cards.forEach(function(card) {
        var cardRect = card.getBoundingClientRect();
        originalCardPositions.set(card, {
          left: cardRect.left - gridRect.left,
          top: cardRect.top - gridRect.top
        });
      });
    }
    
    function positionCardsAbsolutely(grid, cards, animate, useOriginalPositions) {
      if (!grid || !cards.length) return;
      
      // Use cached layout to ensure consistent gaps after grid display changes
      var layout = getGridLayout(grid, true);
      var visibleCards = Array.from(cards).filter(function(card) {
        return !card.classList.contains('bb-card-disappearing') && card.style.display !== 'none';
      });
      
      if (visibleCards.length === 0) return;
      
      // Calculate total height needed
      var rows = Math.ceil(visibleCards.length / layout.columns);
      var totalHeight = (rows * layout.cardHeight) + ((rows - 1) * layout.rowGap) + (layout.gridPaddingTop * 2);
      
      // Set grid to relative positioning with calculated height
      grid.style.position = 'relative';
      grid.style.height = totalHeight + 'px';
      grid.style.display = 'block'; // Override grid display
      
      visibleCards.forEach(function(card, index) {
        var left, top;
        
        if (useOriginalPositions && originalCardPositions.has(card)) {
          // Use the captured position from CSS grid
          var origPos = originalCardPositions.get(card);
          left = origPos.left;
          top = origPos.top;
        } else {
          // Calculate new position
          var pos = calculateCardPosition(index, layout, visibleCards.length);
          left = layout.gridPaddingLeft + pos.x;
          top = layout.gridPaddingTop + pos.y;
        }
        
        // Set card to absolute positioning
        card.style.position = 'absolute';
        
        if (animate) {
          card.style.transition = 'left 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), top 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        } else {
          card.style.transition = 'none';
        }
        
        card.style.left = left + 'px';
        card.style.top = top + 'px';
      });
    }
    
    function resetCardPositioning(grid, cards) {
      if (!grid) return;
      
      // Remove resize handler
      if (upgradeResizeHandler) {
        window.removeEventListener('resize', upgradeResizeHandler);
        upgradeResizeHandler = null;
      }
      
      // Clear cached layout and positions
      cachedGridLayout = null;
      originalCardPositions.clear();
      
      grid.style.position = '';
      grid.style.height = '';
      grid.style.display = '';
      
      cards.forEach(function(card) {
        card.style.position = '';
        card.style.left = '';
        card.style.top = '';
        card.style.transition = '';
      });
    }
    
    function setupUpgradeResizeHandler(grid, selectedCards) {
      // Remove any existing handler
      if (upgradeResizeHandler) {
        window.removeEventListener('resize', upgradeResizeHandler);
      }
      
      // Debounced resize handler
      var resizeTimeout;
      upgradeResizeHandler = function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if (state.upgradeMode) {
            // Temporarily restore grid display to recalculate layout
            var oldDisplay = grid.style.display;
            grid.style.display = '';
            cachedGridLayout = getGridLayout(grid, false);
            grid.style.display = oldDisplay;
            
            positionCardsAbsolutely(grid, selectedCards, false, false); // Recalculate positions
          }
        }, 100);
      };
      
      window.addEventListener('resize', upgradeResizeHandler);
    }

    // ========================================================================
    // UPGRADE ANIMATION SEQUENCE
    // States: upgrade-mode → upgrade-charging (2s) → upgrade-release → upgrade-complete
    // ========================================================================
    
    var upgradeFlashOverlay = null;
    var upgradeParticleSystem = null;
    
    // Create fullscreen flash overlay (once, reused)
    function getOrCreateFlashOverlay() {
      if (!upgradeFlashOverlay) {
        upgradeFlashOverlay = document.createElement('div');
        upgradeFlashOverlay.className = 'bb-upgrade-flash-overlay';
        container.appendChild(upgradeFlashOverlay);
      }
      return upgradeFlashOverlay;
    }
    
    // Trigger the full upgrade animation sequence
    function triggerUpgradeAnimation(card, upgradeData) {
      var CHARGE_DURATION = 2000; // 2 seconds
      var RELEASE_DURATION = 600;
      var chargeStartTime = Date.now();
      
      // Set animation lock to prevent any other interactions
      isAnimationLocked = true;
      
      // Update state to UPGRADING
      setCardState(card, CARD_STATE.UPGRADING);
      
      // Start upgrade sound (uses existing upgrade-add sound)
      window.SoundSystem.play('upgrade-add');
      
      // PHASE 1: CHARGING
      card.classList.add('upgrade-charging');
      card.classList.remove('upgrade-mode', 'upgradeable'); // Remove base styling for animation
      
      // Start streaming particles during charge
      if (window.startUpgradeChargeParticles) {
        window.startUpgradeChargeParticles(card, CHARGE_DURATION);
      }
      
      console.log('⚡ Upgrade charging:', upgradeData.title, 'at', chargeStartTime);
      
      // PHASE 2: RELEASE (after charge completes)
      setTimeout(function() {
        var releaseTime = Date.now();
        console.log('⏱️ Release triggered after', (releaseTime - chargeStartTime), 'ms (expected:', CHARGE_DURATION, 'ms)');
        card.classList.remove('upgrade-charging');
        card.classList.add('upgrade-release');
        
        // Trigger fullscreen flash
        var flash = getOrCreateFlashOverlay();
        flash.classList.add('active');
        setTimeout(function() {
          flash.classList.remove('active');
          flash.classList.add('fading');
        }, 50);
        setTimeout(function() {
          flash.classList.remove('fading');
        }, 1550);
        
        // Explosion particles
        if (window.explodeUpgradeParticles) {
          window.explodeUpgradeParticles(card);
        }
        
        // Add shockwave element
        var shockwave = document.createElement('div');
        shockwave.className = 'bb-upgrade-shockwave explode';
        shockwave.innerHTML = '<div class="bb-upgrade-shockwave-ring"></div>';
        card.appendChild(shockwave);
        setTimeout(function() {
          shockwave.remove();
        }, 800);
        
        console.log('💥 Upgrade release:', upgradeData.title);
        
        // PHASE 3: COMPLETE (after release settles)
        setTimeout(function() {
          // Update state to UPGRADED (this syncs CSS classes)
          setCardState(card, CARD_STATE.UPGRADED);
          card.classList.add('upgrade-mode'); // Keep upgrade-mode since we're still in upgrade step
          
          // Add to selectedUpgrades
          state.selectedUpgrades.push({
            variantId: upgradeData.variantId,
            productId: upgradeData.productId,
            price: upgradeData.price,
            title: upgradeData.title,
            originalProduct: card.dataset.title,
            image: upgradeData.image
          });
          
          // Release animation lock
          isAnimationLocked = false;
          
          // Recalculate totals
          updateCalculation();
          
          // Show floating message for upgrade applied
          if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
            MultiplayerSystem.jumpMyAvatar(upgradeData.title);
          }
          
          console.log('✨ Upgrade complete:', upgradeData.title, 'Total upgrades:', state.selectedUpgrades.length);
          
        }, RELEASE_DURATION);
        
      }, CHARGE_DURATION);
    }
    
    // Downgrade animation - removes upgrade with soft transition (like card deselection)
    function triggerDowngradeAnimation(card) {
      var productTitle = card.dataset.title;
      
      // Set animation lock
      isAnimationLocked = true;
      
      // Set state to DOWNGRADING
      setCardState(card, CARD_STATE.DOWNGRADING);
      
      // Play deselect sound
      window.SoundSystem.play('card-deselect', null, 0.7);
      
      // PERFORMANCE FIX: Clear all particles for this card
      if (window.clearCardParticles) {
        window.clearCardParticles(card);
      }
      
      // Stop ambient particles (legacy)
      if (window.stopUpgradeAmbientParticles) {
        window.stopUpgradeAmbientParticles(card);
      }
      
      // Add downgrading class for soft animation
      card.classList.add('downgrading');
      
      // Remove upgrade classes on next frame so CSS knows starting state
      requestAnimationFrame(function() {
        card.classList.remove('upgrade-complete', 'upgraded');
        
        // Reset the white overlay and polychrome
        var polychrome = card.querySelector('.bb-card-polychrome');
        if (polychrome) {
          polychrome.style.opacity = '0';
        }
      });
      
      // Remove from selectedUpgrades
      state.selectedUpgrades = state.selectedUpgrades.filter(function(u) {
        return u.originalProduct !== productTitle;
      });
      
      // Reset Video Library badge text
      var upgradeVariant = card.querySelector('.bb-card-ui--upgrade .bb-card-variant');
      if (upgradeVariant) {
        upgradeVariant.textContent = upgradeVariant.dataset.originalText || 'Video Library';
      }
      
      // After animation completes, update state to UPGRADEABLE
      setTimeout(function() {
        // Check if card has upgrade data - if so, it's upgradeable again
        var upgradeData = DIGITAL_UPGRADE_MAP[productTitle];
        if (upgradeData) {
          setCardState(card, CARD_STATE.UPGRADEABLE);
        } else {
          setCardState(card, CARD_STATE.SELECTED);
        }
        
        // Release animation lock
        isAnimationLocked = false;
        
        console.log('⬇️ Downgrade complete:', productTitle, 'Total upgrades:', state.selectedUpgrades.length);
      }, 800);
      
      // Recalculate totals
      updateCalculation();
    }

    // ========================================================================
    // DEBUG TRANSITION PANEL - Step through upgrade mode transition
    // ========================================================================
    var debugTransitionEnabled = false; // SET TO TRUE TO RE-ENABLE DEBUG MODE
    var debugPanel = null;
    var debugState = {
      currentStep: 0,
      paused: true,
      data: {}
    };
    
    function createDebugPanel() {
      if (debugPanel) return debugPanel;
      
      debugPanel = document.createElement('div');
      debugPanel.id = 'bb-debug-transition-panel';
      debugPanel.innerHTML = '\
        <style>\
          #bb-debug-transition-panel {\
            position: fixed;\
            top: 10px;\
            right: 10px;\
            width: 400px;\
            max-height: 90vh;\
            background: rgba(0,0,0,0.95);\
            border: 2px solid #0ff;\
            border-radius: 8px;\
            padding: 15px;\
            z-index: 999999;\
            font-family: monospace;\
            font-size: 12px;\
            color: #0ff;\
            overflow-y: auto;\
          }\
          #bb-debug-transition-panel h3 {\
            margin: 0 0 10px 0;\
            color: #ff0;\
            font-size: 14px;\
          }\
          #bb-debug-transition-panel .debug-step {\
            background: rgba(0,255,255,0.1);\
            padding: 8px;\
            margin: 5px 0;\
            border-radius: 4px;\
            border-left: 3px solid #666;\
          }\
          #bb-debug-transition-panel .debug-step.active {\
            border-left-color: #0ff;\
            background: rgba(0,255,255,0.2);\
          }\
          #bb-debug-transition-panel .debug-step.done {\
            border-left-color: #0f0;\
            opacity: 0.6;\
          }\
          #bb-debug-transition-panel button {\
            background: #0ff;\
            color: #000;\
            border: none;\
            padding: 8px 16px;\
            margin: 5px;\
            border-radius: 4px;\
            cursor: pointer;\
            font-weight: bold;\
            font-family: monospace;\
          }\
          #bb-debug-transition-panel button:hover {\
            background: #fff;\
          }\
          #bb-debug-transition-panel button:disabled {\
            background: #666;\
            cursor: not-allowed;\
          }\
          #bb-debug-transition-panel .debug-info {\
            background: rgba(255,255,0,0.1);\
            padding: 8px;\
            margin: 10px 0;\
            border-radius: 4px;\
            white-space: pre-wrap;\
            word-break: break-all;\
            max-height: 200px;\
            overflow-y: auto;\
          }\
          #bb-debug-transition-panel .debug-controls {\
            display: flex;\
            gap: 5px;\
            margin: 10px 0;\
            flex-wrap: wrap;\
          }\
          #bb-debug-transition-panel .card-info {\
            font-size: 10px;\
            color: #aaa;\
          }\
        </style>\
        <h3>🔧 UPGRADE TRANSITION DEBUG</h3>\
        <div class="debug-controls">\
          <button id="debug-next-step">▶ Next Step</button>\
          <button id="debug-run-all">⏩ Run All</button>\
          <button id="debug-reset">↺ Reset</button>\
          <button id="debug-close">✕ Close</button>\
        </div>\
        <div id="debug-current-info" class="debug-info">Ready to start...</div>\
        <div id="debug-steps-list"></div>\
      ';
      document.body.appendChild(debugPanel);
      
      document.getElementById('debug-next-step').addEventListener('click', function() {
        debugState.paused = false;
        if (debugState.nextStepCallback) {
          debugState.nextStepCallback();
        }
      });
      
      document.getElementById('debug-run-all').addEventListener('click', function() {
        debugTransitionEnabled = false;
        debugState.paused = false;
        if (debugState.nextStepCallback) {
          debugState.nextStepCallback();
        }
      });
      
      document.getElementById('debug-reset').addEventListener('click', function() {
        location.reload();
      });
      
      document.getElementById('debug-close').addEventListener('click', function() {
        debugPanel.style.display = 'none';
      });
      
      return debugPanel;
    }
    
    function updateDebugInfo(info) {
      var infoEl = document.getElementById('debug-current-info');
      if (infoEl) {
        infoEl.textContent = info;
      }
    }
    
    function updateDebugSteps(steps, currentIndex) {
      var listEl = document.getElementById('debug-steps-list');
      if (!listEl) return;
      
      listEl.innerHTML = steps.map(function(step, i) {
        var className = 'debug-step';
        if (i < currentIndex) className += ' done';
        if (i === currentIndex) className += ' active';
        return '<div class="' + className + '">' + (i + 1) + '. ' + step + '</div>';
      }).join('');
    }
    
    function debugWaitForNext(stepName, info, callback) {
      if (!debugTransitionEnabled) {
        callback();
        return;
      }
      
      updateDebugInfo('STEP ' + debugState.currentStep + ': ' + stepName + '\n\n' + info + '\n\n[Click Next Step to continue]');
      debugState.paused = true;
      debugState.nextStepCallback = function() {
        debugState.currentStep++;
        callback();
      };
    }
    
    function enterUpgradeMode() {
      // ========================================================================
      // SIMPLIFIED UPGRADE MODE - Cards stay in place, just enable upgrade clicks
      // State-based: Updates cardStateMap as source of truth
      // ========================================================================
      isUpgradeMode = true;
      state.upgradeMode = true;
      
      var allCards = Array.from(container.querySelectorAll('.bb-balatro-card:not(.bb-carousel-clone)'));
      var grid = container.querySelector('.bb-product-grid');
      
      console.log('[BB State] Entering upgrade mode');
      
      // Add upgrade-mode class to container for background transition
      container.classList.add('bb-in-upgrade-mode');
      
      // Add upgrade-mode class to grid for styling hooks
      if (grid) {
        grid.classList.add('bb-upgrade-mode');
      }
      
      // Process ALL cards based on their current state
      allCards.forEach(function(card) {
        var cardState = getCardState(card);
        var currentState = cardState ? cardState.state : CARD_STATE.UNSELECTED;
        var productTitle = card.dataset.title;
        var upgradeData = DIGITAL_UPGRADE_MAP[productTitle];
        
        if (currentState === CARD_STATE.UPGRADED) {
          // Already upgraded - can be downgraded, just add upgrade-mode class
          card.classList.add('upgrade-mode');
          card.classList.remove('upgrade-locked');
          console.log('[BB State] Upgraded card (downgradable):', productTitle);
          
        } else if (currentState === CARD_STATE.SELECTED && upgradeData) {
          // Selected with upgrade data - make upgradeable
          setCardState(card, CARD_STATE.UPGRADEABLE);
          
          // Update the upgrade price display (use variant price from upgrade map)
          var upgradePriceEl = card.querySelector('.bb-card-ui--upgrade .bb-price-value');
          if (upgradePriceEl && upgradeData.price) {
            upgradePriceEl.textContent = formatMoneyNoDecimals(upgradeData.price);
          }
          console.log('[BB State] Now upgradeable:', productTitle);
          
        } else if (currentState === CARD_STATE.SELECTED) {
          // Selected but no upgrade data
          card.classList.add('upgrade-mode');
          console.log('[BB State] Selected (no upgrade):', productTitle);
          
        } else {
          // Unselected - recedes via CSS, clicking returns to selection
          card.classList.add('upgrade-mode');
        }
      });
      
      // Enable back button in sticky footer
      var stickyBackBtn = container.querySelector('.bb-sticky-back');
      if (stickyBackBtn) {
        stickyBackBtn.disabled = false;
      }
                          
      // Animate the title change (with slam effect)
      setTimeout(function() {
        animateTitleToUpgradeMode();
      }, 100);
      
      console.log('[BB State] Upgrade mode active');
    }
    
    function animateTitleToUpgradeMode() {
      var stepTitle = container.querySelector('.bb-step-title');
      var stepDescription = container.querySelector('.bb-step-description');
      
      if (stepTitle) {
        // Store original text for reverting
        stepTitle.dataset.originalText = stepTitle.textContent;
        
        // Add exit animation class
        stepTitle.classList.add('bb-title-exit');
        
        // After exit animation, swap text and slam in
        setTimeout(function() {
          stepTitle.textContent = 'UPGRADE YOUR DECKS';
          stepTitle.classList.remove('bb-title-exit');
          stepTitle.classList.add('bb-title-slam', 'bb-upgrade-title');
          
          // Get the step header for shake effect (shake parent, not text itself)
          var stepHeader = stepTitle.closest('.bb-step-header');
          
          // At impact moment (350ms = when fall ends), trigger shake + sound
          setTimeout(function() {
            window.SoundSystem.play('upgrade-slam');
            
            // Apply shake to parent container for screen shake effect
            if (stepHeader) {
              stepHeader.classList.add('bb-impact-shake');
              
              // Remove shake class after animation
              setTimeout(function() {
                stepHeader.classList.remove('bb-impact-shake');
              }, 300);
            }
          }, 350);
          
          // Remove slam class after full animation (350ms fall + 200ms thud = 550ms)
          setTimeout(function() {
            stepTitle.classList.remove('bb-title-slam');
          }, 600);
        }, 400);
      }
      
      if (stepDescription) {
        // Store original HTML for reverting (use innerHTML to preserve span tags)
        stepDescription.dataset.originalText = stepDescription.innerHTML;
        
        // Add exit animation
        stepDescription.classList.add('bb-description-exit');
        
        // After exit, swap text and fade in
        setTimeout(function() {
          stepDescription.innerHTML = 'Add <span class="bb-highlight">50+ Videos &amp; Templates</span> To Your Selected Decks';
          stepDescription.classList.remove('bb-description-exit');
          stepDescription.classList.add('bb-description-enter');
          
          setTimeout(function() {
            stepDescription.classList.remove('bb-description-enter');
          }, 400);
        }, 400);
      }
    }
    
    function animateTitleToSelectMode() {
      var stepTitle = container.querySelector('.bb-step-title');
      var stepDescription = container.querySelector('.bb-step-description');
      
      if (stepTitle && stepTitle.dataset.originalText) {
        stepTitle.classList.add('bb-title-exit');
        
        setTimeout(function() {
          stepTitle.textContent = stepTitle.dataset.originalText;
          stepTitle.classList.remove('bb-title-exit', 'bb-upgrade-title');
          stepTitle.classList.add('bb-title-enter');
          
          setTimeout(function() {
            stepTitle.classList.remove('bb-title-enter');
          }, 400);
        }, 300);
      }
      
      if (stepDescription && stepDescription.dataset.originalText) {
        stepDescription.classList.add('bb-description-exit');
        
        setTimeout(function() {
          // Restore with highlight for step 1
          stepDescription.innerHTML = 'Add 5+ <span class="bb-highlight">Digital Decks</span> to unlock the maximum <span class="bb-highlight">50% discount</span>.';
          stepDescription.classList.remove('bb-description-exit');
          stepDescription.classList.add('bb-description-enter');
          
          setTimeout(function() {
            stepDescription.classList.remove('bb-description-enter');
          }, 400);
        }, 300);
      }
    }
    
    function exitUpgradeMode() {
      // ========================================================================
      // SIMPLIFIED EXIT - Return to card selection, PRESERVE upgraded cards
      // State-based: Updates cardStateMap, CSS follows state
      // ========================================================================
      isUpgradeMode = false;
      state.upgradeMode = false;
      
      console.log('[BB State] Exiting upgrade mode');
      console.log('[BB State] Preserving', state.selectedUpgrades.length, 'upgraded cards');
      
      // Remove upgrade-mode class from container (restores original background)
      container.classList.remove('bb-in-upgrade-mode');
      
      var allCards = Array.from(container.querySelectorAll('.bb-balatro-card:not(.bb-carousel-clone)'));
      var grid = container.querySelector('.bb-product-grid');
      
      // Disable back button in sticky footer
      var stickyBackBtn = container.querySelector('.bb-sticky-back');
      if (stickyBackBtn) {
        stickyBackBtn.disabled = true;
      }
      
      // Remove upgrade-mode class from grid
      if (grid) {
        grid.classList.remove('bb-upgrade-mode');
      }
      
      // Process cards based on state
      allCards.forEach(function(card) {
        var cardState = getCardState(card);
        var currentState = cardState ? cardState.state : CARD_STATE.UNSELECTED;
        
        // Remove upgrade-mode class from all cards
        card.classList.remove('upgrade-mode');
        
        if (currentState === CARD_STATE.UPGRADED) {
          // UPGRADED: Keep state, add locked class for selection mode
          card.classList.add('upgrade-locked');
          console.log('[BB State] Locked (upgraded):', card.dataset.title);
          
        } else if (currentState === CARD_STATE.UPGRADEABLE) {
          // Was upgradeable, revert to SELECTED
          setCardState(card, CARD_STATE.SELECTED);
          
          // Reset upgrade badge text
          var upgradeVariant = card.querySelector('.bb-card-ui--upgrade .bb-card-variant');
          if (upgradeVariant) {
            upgradeVariant.textContent = upgradeVariant.dataset.originalText || 'Video Library';
          }
          
        } else {
          // Clear any stray classes
          card.classList.remove(
            'upgradeable', 'upgrade-charging', 'upgrade-release',
            'downgrading', 'bb-collecting', 'upgrade-locked'
          );
        }
      });
      
      // Animate title back to selection mode
      animateTitleToSelectMode();
      
      // Recalculate totals
      updateCalculation();
      
      console.log('[BB State] Back to card selection');
    }

    // ========================================================================
    // PHYSICAL MODE - 3D Deck Reveal
    // Third sub-state of Step 1: Select → Upgrade → Physical
    // ========================================================================
    
    // Mobile devices: Disable 3D models entirely to prevent WebGL memory crashes
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    // Dynamic model-viewer loader (deferred to prevent Safari iOS crash on cold start)
    var modelViewerLoaded = false;
    var modelViewerLoading = false;
    function loadModelViewer() {
      return new Promise(function(resolve) {
        if (modelViewerLoaded || customElements.get('model-viewer')) {
          modelViewerLoaded = true;
          resolve();
          return;
        }
        if (modelViewerLoading) {
          // Already loading, wait for it
          var checkInterval = setInterval(function() {
            if (modelViewerLoaded || customElements.get('model-viewer')) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          return;
        }
        modelViewerLoading = true;
        console.log('📦 [BB Physical] Loading model-viewer dynamically...');
        var script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
        script.onload = function() {
          modelViewerLoaded = true;
          modelViewerLoading = false;
          console.log('✅ [BB Physical] model-viewer loaded');
          resolve();
        };
        script.onerror = function() {
          modelViewerLoading = false;
          console.warn('⚠️ [BB Physical] model-viewer failed to load');
          resolve(); // Continue anyway, will show placeholders
        };
        document.head.appendChild(script);
      });
    }
    
    function enterPhysicalMode() {
      console.log('[BB DEBUG] enterPhysicalMode() called');
      isPhysicalMode = true;
      state.physicalMode = true;
      
      // Initialize physical selections array if not exists
      if (!state.selectedPhysical) {
        state.selectedPhysical = [];
      }
      
      console.log('[BB Physical] Entering physical mode (skip mode: ' + isSkipMode + ')');
      
      // Add physical-mode class to container for background transition
      container.classList.add('bb-in-physical-mode');
      container.classList.remove('bb-in-upgrade-mode');
      
      // Enable back button in sticky footer (works in skip mode too)
      var stickyBackBtn = container.querySelector('.bb-sticky-back');
      if (stickyBackBtn) {
        stickyBackBtn.disabled = false;
      }
      
      var grid = container.querySelector('.bb-product-grid');
      var track = container.querySelector('.bb-carousel-track');
      
      // Animate title change
      animateTitleToPhysicalMode();
      
      // After title animation starts, fade out current carousel and create 3D models
      setTimeout(function() {
        // Fade out current card carousel
        if (track) {
          track.classList.add('bb-carousel-fade-out');
        }
        
        // After fade out, load model-viewer if needed (skip on mobile), then create carousel
        setTimeout(function() {
          if (isMobile) {
            // Skip model-viewer on mobile - just use product images
            createPhysicalModeCarousel(grid, track);
          } else {
            loadModelViewer().then(function() {
              createPhysicalModeCarousel(grid, track);
            });
          }
        }, 400);
      }, 200);
      
      console.log('[BB Physical] Physical mode active');
      
      // Show debug panel if debug mode is enabled (via URL param or setting)
      if (window.location.search.includes('debug=true') || container.dataset.debugMode === 'true') {
        setTimeout(function() {
          if (window.BBPhysicalDebug && window.BBPhysicalDebug.openPanel) {
            window.BBPhysicalDebug.openPanel();
          }
        }, 500);
      }
    }
    
    // Keyboard shortcut to open physical model debug panel (press 'M' in physical mode)
    document.addEventListener('keydown', function(e) {
      if (e.key === 'm' || e.key === 'M') {
        if (isPhysicalMode && window.BBPhysicalDebug) {
          window.BBPhysicalDebug.openPanel();
        }
      }
    });
    
    function animateTitleToPhysicalMode() {
      var stepTitle = container.querySelector('.bb-step-title');
      var stepDescription = container.querySelector('.bb-step-description');
      
      if (stepTitle) {
        // Store upgrade mode text for going back
        if (!stepTitle.dataset.upgradeText) {
          stepTitle.dataset.upgradeText = stepTitle.textContent;
        }
        
        // Add exit animation class
        stepTitle.classList.add('bb-title-exit');
        
        // After exit animation, swap text and slam in
        setTimeout(function() {
          stepTitle.textContent = "LET'S GET PHYSICAL";
          stepTitle.classList.remove('bb-title-exit', 'bb-upgrade-title');
          stepTitle.classList.add('bb-title-slam', 'bb-physical-title');
          
          // Get the step header for shake effect
          var stepHeader = stepTitle.closest('.bb-step-header');
          
          // At impact moment, trigger shake + sound
          setTimeout(function() {
            if (window.SoundSystem && window.SoundSystem.play) {
              window.SoundSystem.play('upgrade-slam');
            }
            
            if (stepHeader) {
              stepHeader.classList.add('bb-impact-shake');
              setTimeout(function() {
                stepHeader.classList.remove('bb-impact-shake');
              }, 300);
            }
          }, 350);
          
          // Remove slam class after animation
          setTimeout(function() {
            stepTitle.classList.remove('bb-title-slam');
          }, 600);
        }, 400);
      }
      
      if (stepDescription) {
        // Store upgrade mode text for going back
        if (!stepDescription.dataset.upgradeText) {
          stepDescription.dataset.upgradeText = stepDescription.innerHTML;
        }
        
        stepDescription.classList.add('bb-description-exit');
        
        setTimeout(function() {
          stepDescription.innerHTML = 'Add <span class="bb-highlight">Physical Decks</span> to your bundle';
          stepDescription.classList.remove('bb-description-exit');
          stepDescription.classList.add('bb-description-enter');
          
          setTimeout(function() {
            stepDescription.classList.remove('bb-description-enter');
          }, 400);
        }, 400);
      }
    }
    
    function createPhysicalModeCarousel(grid, track) {
      // Load products from physical collection JSON (set in schema settings)
      var physicalDataEl = document.getElementById('bb-physical-collection-' + config.sectionId);
      var physicalProducts = [];
      
      if (physicalDataEl) {
        try {
          var physicalData = JSON.parse(physicalDataEl.textContent);
          physicalProducts = physicalData.products || [];
        } catch (e) {
          console.warn('[BB Physical] Failed to parse physical collection data:', e);
        }
      }
      
      // Fallback to card select collection if no physical collection configured
      if (physicalProducts.length === 0) {
        console.log('[BB Physical] No physical collection configured, using card select products');
        var allCards = Array.from(container.querySelectorAll('.bb-balatro-card'));
        physicalProducts = allCards.map(function(card) {
          var backFace = card.querySelector('.bb-card-back-face');
          return {
            id: parseInt(card.dataset.productId),
            variantId: parseInt(card.dataset.variantId),
            title: card.dataset.title,
            modelUrl: backFace ? backFace.dataset.modelUrl : null,
            price: 0,
            comparePrice: 0
          };
        });
      }
      
      // Sort physical products: prioritize decks where user has partial complete package (digital or video selected)
      var partialPackages = detectPartialCompletePackages();
      var priorityVariantIds = partialPackages.map(function(p) { return String(p.physicalVariantId); });
      
      if (priorityVariantIds.length > 0) {
        console.log('[BB Physical] Prioritizing physical decks for partial packages:', priorityVariantIds);
        physicalProducts.sort(function(a, b) {
          var aIsPriority = priorityVariantIds.indexOf(String(a.variantId)) !== -1;
          var bIsPriority = priorityVariantIds.indexOf(String(b.variantId)) !== -1;
          if (aIsPriority && !bIsPriority) return -1;
          if (!aIsPriority && bIsPriority) return 1;
          return 0; // Keep original order for non-priority items
        });
      }
      
      // Mobile fix: Disable 3D models entirely to prevent WebGL memory crashes
      console.log('[BB Physical] Creating carousel for', physicalProducts.length, 'products' + (isMobile ? ' (mobile: images only, no 3D)' : ' (with 3D models)'));
      
      // Create a container for 3D model cards
      var modelContainer = document.createElement('div');
      modelContainer.className = 'bb-model-carousel';
      modelContainer.id = 'bb-model-carousel-' + config.sectionId;
      
      var modelsCreated = 0;
      
      physicalProducts.forEach(function(product, index) {
        var modelUrl = product.modelUrl;
        var productTitle = product.title;
        var variantId = product.variantId;
        var productId = product.id;
        
        // Get the LAST variant for physical (we'll need to look this up)
        // For now, store the product info and we'll resolve the physical variant
        
        // Create model card container
        var modelCard = document.createElement('div');
        modelCard.className = 'bb-model-card';
        modelCard.dataset.title = productTitle;
        modelCard.dataset.productId = productId;
        modelCard.dataset.originalVariantId = variantId;
        modelCard.dataset.variantId = variantId; // Also set variantId for FREE offer detection
        
        // Mobile fix: Never use 3D models on mobile, always use product images
        var shouldUse3DModel = modelUrl && !isMobile;
        
        if (shouldUse3DModel) {
          // Create model-viewer element - NO interaction, hover-controlled only
          var modelViewer = document.createElement('model-viewer');
          var settings = window.physicalModelSettings || getDefaultModelSettings();
          
          // Build default orbit string
          var defaultOrbit = settings.defaultX + 'deg ' + settings.defaultY + 'deg ' + settings.defaultZoom + '%';
          
          modelViewer.setAttribute('src', modelUrl);
          modelViewer.setAttribute('alt', productTitle + ' 3D Model');
          
          // Start at default position
          modelViewer.setAttribute('camera-orbit', defaultOrbit);
          modelViewer.setAttribute('camera-target', 'auto auto auto');
          modelViewer.setAttribute('field-of-view', settings.fieldOfView);
          
          // Disable ALL interaction - let carousel handle gestures
          modelViewer.setAttribute('interaction-prompt', 'none');
          modelViewer.setAttribute('disable-tap', '');
          modelViewer.setAttribute('disable-zoom', '');
          modelViewer.setAttribute('disable-pan', '');
          // No camera-controls attribute = no user interaction
          
          // Smooth transitions
          modelViewer.setAttribute('interpolation-decay', settings.interpolationDecay);
          
          // Lighting
          modelViewer.setAttribute('shadow-intensity', settings.shadowIntensity);
          modelViewer.setAttribute('exposure', settings.exposure);
          if (settings.environmentImage && settings.environmentImage !== 'none') {
            modelViewer.setAttribute('environment-image', settings.environmentImage);
          }
          
          // Don't use native auto-rotate - we'll do custom oscillation
          
          modelViewer.style.width = '100%';
          modelViewer.style.height = '100%';
          modelViewer.style.background = 'transparent';
          modelViewer.style.pointerEvents = 'none'; // Let clicks pass through to carousel
          
          // Start invisible, fade in after loaded
          modelViewer.style.opacity = '0';
          modelViewer.style.transition = 'opacity 0.5s ease-out';
          
          modelCard.appendChild(modelViewer);
          
          // Force maximum render quality (prevents dynamic resolution scaling)
          // Must be set after appending to DOM
          modelViewer.minimumRenderScale = 1;    // Never reduce resolution (default can go to 0.5)
          modelViewer.maximumRenderScale = 1;    // Set to 2 for supersampling if needed
          
          // Fade in after model loads
          modelViewer.addEventListener('load', function() {
            modelViewer.style.opacity = '1';
            // #region agent log - H1 model-viewer loaded
            if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:modelViewer', 'Model loaded', { src: modelUrl.substring(0, 50) }, 'H1');
            // #endregion
          });
          
          // #region agent log - H1 WebGL context loss tracking
          modelViewer.addEventListener('error', function(e) {
            if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:modelViewer', 'Model error', { error: String(e).substring(0, 100) }, 'H1');
          });
          // Track WebGL context loss via canvas if available
          setTimeout(function() {
            var canvas = modelViewer.shadowRoot && modelViewer.shadowRoot.querySelector('canvas');
            if (canvas) {
              canvas.addEventListener('webglcontextlost', function(e) {
                if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:webgl', 'WebGL context LOST', { prevented: e.defaultPrevented }, 'H1');
              });
              canvas.addEventListener('webglcontextrestored', function() {
                if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:webgl', 'WebGL context RESTORED', {}, 'H1');
              });
            }
          }, 1000);
          // #endregion
          
          // Add hover effect and oscillation
          addModelHoverEffect(modelCard, modelViewer);
          
          // Start oscillating animation
          if (settings.autoRotate) {
            startModelOscillation(modelCard, modelViewer);
          }
          
          modelsCreated++;
        } else {
          // No 3D model OR mobile device - show product image placeholder
          var placeholder = document.createElement('div');
          placeholder.className = 'bb-model-placeholder bb-model-placeholder-mobile';
          
          // Use product image if available, otherwise show text
          if (product.image) {
            var placeholderImg = document.createElement('img');
            placeholderImg.src = product.image;
            placeholderImg.alt = productTitle;
            placeholderImg.className = 'bb-model-placeholder-img';
            placeholderImg.loading = 'lazy';
            placeholder.appendChild(placeholderImg);
          } else {
            placeholder.innerHTML = '<span class="bb-model-no-3d">Preview Coming Soon</span>';
          }
          
          modelCard.appendChild(placeholder);
        }
        
        // Add product title label
        var titleLabel = document.createElement('div');
        titleLabel.className = 'bb-model-title';
        titleLabel.textContent = productTitle;
        modelCard.appendChild(titleLabel);
        
        // Check if product is available (from Shopify inventory)
        var isAvailable = product.available !== false;
        
        // #region agent log - H6 track out-of-stock cards in physical carousel
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:physicalCard', 'Physical card created', { 
          index: index, 
          title: productTitle.substring(0, 30),
          available: isAvailable,
          hasModel: !!modelUrl,
          uses3D: shouldUse3DModel,
          isLast: index === physicalProducts.length - 1
        }, 'H6');
        // #endregion
        
        // If out of stock, dim the card and show OUT OF STOCK message
        if (!isAvailable) {
          modelCard.classList.add('bb-model-unavailable');
          
          // Add "OUT OF STOCK" overlay
          var outOfStockLabel = document.createElement('div');
          outOfStockLabel.className = 'bb-model-out-of-stock';
          outOfStockLabel.textContent = 'OUT OF STOCK';
          modelCard.appendChild(outOfStockLabel);
        } else {
          // Get price data from product JSON (already has last variant data)
          var physicalPrice = product.price || 0;
          var physicalComparePrice = product.comparePrice || physicalPrice;
          
          // Store price data on card for later updates
          modelCard.dataset.price = physicalPrice;
          modelCard.dataset.comparePrice = physicalComparePrice;
          
          // Add price container with discount display
          var currentDiscount = state.discountTier || 0;
          var discountedPrice = physicalPrice * (1 - currentDiscount / 100);
          var tierNum = 0;
          if (currentDiscount >= 50) tierNum = 5;
          else if (currentDiscount >= 40) tierNum = 4;
          else if (currentDiscount >= 30) tierNum = 3;
          else if (currentDiscount >= 20) tierNum = 2;
          else if (currentDiscount >= 10) tierNum = 1;
          
          var priceContainer = document.createElement('div');
          priceContainer.className = 'bb-model-price';
          
          // Strikethrough original price if discount active
          if (currentDiscount > 0) {
            var originalPrice = document.createElement('span');
            originalPrice.className = 'bb-model-compare-price';
            originalPrice.textContent = formatMoneyWithSymbol(physicalPrice);
            priceContainer.appendChild(originalPrice);
          }
          
          var currentPrice = document.createElement('span');
          currentPrice.className = 'bb-model-current-price';
          currentPrice.style.setProperty('--model-price-color', 'var(--tier-' + tierNum + '-color, #00d4ff)');
          currentPrice.textContent = formatMoneyWithSymbol(discountedPrice);
          priceContainer.appendChild(currentPrice);
          
          // Discount badge
          if (currentDiscount > 0) {
            var badge = document.createElement('span');
            badge.className = 'bb-model-discount-badge';
            badge.textContent = '-' + currentDiscount + '%';
            priceContainer.appendChild(badge);
          }
          
          modelCard.appendChild(priceContainer);
          
          // Check if this product is already selected (for state restoration)
          // Convert to string for comparison since dataset stores as string
          var productIdStr = String(productId);
          var isAlreadySelected = state.selectedPhysical && state.selectedPhysical.some(function(p) {
            return String(p.productId) === productIdStr;
          });
          
          // Get existing quantity if selected
          var existingQuantity = 1;
          if (isAlreadySelected) {
            var existingItem = state.selectedPhysical.find(function(p) { return String(p.productId) === productIdStr; });
            existingQuantity = existingItem && existingItem.quantity ? existingItem.quantity : 1;
          }
          
          // Add "Add to Bundle" button BELOW the model (not overlay)
          var addButton = document.createElement('button');
          addButton.className = 'bb-model-add-btn' + (isAlreadySelected ? ' bb-model-btn-selected' : '');
          addButton.innerHTML = isAlreadySelected 
            ? '<span class="bb-model-add-icon">✓</span> Added!' 
            : '<span class="bb-model-add-icon">+</span> Add to Bundle';
          addButton.dataset.productId = productId;
          modelCard.appendChild(addButton);
          
          // Add quantity controls container (hidden by default, shown when selected)
          var qtyContainer = document.createElement('div');
          qtyContainer.className = 'bb-model-qty-container' + (isAlreadySelected ? ' bb-qty-visible' : '');
          qtyContainer.innerHTML = 
            '<button class="bb-model-qty-btn bb-model-qty-minus" data-action="decrease">−</button>' +
            '<span class="bb-model-qty-value">' + existingQuantity + '</span>' +
            '<button class="bb-model-qty-btn bb-model-qty-plus" data-action="increase">+</button>';
          modelCard.appendChild(qtyContainer);
          
          // Mark card as selected if restored from state
          if (isAlreadySelected) {
            modelCard.classList.add('bb-model-selected');
          }
          
          // Click handler on BUTTON only (not the model itself)
          addButton.addEventListener('click', function(e) {
            e.stopPropagation(); // Don't interfere with model-viewer
            togglePhysicalSelection(modelCard, addButton);
          });
          
          // Quantity button handlers
          qtyContainer.addEventListener('click', function(e) {
            e.stopPropagation();
            var btn = e.target.closest('.bb-model-qty-btn');
            if (!btn) return;
            
            var action = btn.dataset.action;
            var qtyDisplay = qtyContainer.querySelector('.bb-model-qty-value');
            var currentQty = parseInt(qtyDisplay.textContent) || 1;
            
            if (action === 'increase') {
              updatePhysicalQuantity(productId, currentQty + 1, qtyDisplay, modelCard, addButton, qtyContainer);
            } else if (action === 'decrease') {
              if (currentQty > 1) {
                updatePhysicalQuantity(productId, currentQty - 1, qtyDisplay, modelCard, addButton, qtyContainer);
              } else {
                // Quantity 1 and decreasing = remove item
                togglePhysicalSelection(modelCard, addButton);
              }
            }
          });
        }
        
        modelContainer.appendChild(modelCard);
      });
      
      // Hide original track and show model carousel
      if (track) {
        track.style.display = 'none';
      }
      
      // Insert model carousel
      if (grid) {
        grid.appendChild(modelContainer);
        
        // SWAP CAROUSEL STATE to control the 3D model carousel
        // Only save original state if not already swapped (prevents overwriting with the model track itself)
        if (!carouselState.originalTrack) {
          carouselState.originalTrack = carouselState.track;
          carouselState.originalCards = carouselState.cards;
        }
        
        carouselState.track = modelContainer;
        carouselState.cards = Array.from(modelContainer.children);
        
        // Update dimensions and bounds for the new content
        updateCarouselDimensions();
        calculateCarouselBounds();
        
        // Center the first card (same as normal carousel snap behavior)
        // Account for both grid and model carousel padding (differs on mobile)
        var viewportCenter = grid.offsetWidth / 2;
        var gridPaddingLeft = parseInt(getComputedStyle(grid).paddingLeft) || 0;
        var trackPaddingLeft = parseInt(getComputedStyle(modelContainer).paddingLeft) || 0;
        var paddingOffset = gridPaddingLeft + trackPaddingLeft;
        var cardCenter = (carouselState.cardWidth / 2);
        // visualCenter = paddingOffset + cardCenter + initialX = viewportCenter
        var initialX = viewportCenter - paddingOffset - cardCenter;
        
        // Clamp to bounds
        initialX = Math.max(carouselState.minX, Math.min(carouselState.maxX, initialX));
        
        carouselState.translateX = initialX;
        modelContainer.style.transform = 'translate3d(' + initialX + 'px, 0, 0)';
        
        // Fade in model carousel
        setTimeout(function() {
          modelContainer.classList.add('bb-carousel-visible');
        }, 50);
      }
      
      console.log('[BB Physical] Created', modelsCreated, '3D models');
      
      // Update physical prices to show FREE offers for partial complete packages
      // This must run AFTER cards are created to update their price displays
      setTimeout(function() {
        updatePhysicalPrices(state.discountTier || 0);
      }, 100);
    }
    
    // Default settings for physical 3D models
    function getDefaultModelSettings() {
      return {
        // Default camera position (model rests here)
        defaultX: -31,
        defaultY: 108,
        defaultZoom: 100,
        
        // Hover camera position (base for relative movement)
        hoverBaseX: 3,
        hoverBaseY: 96,
        hoverBaseZoom: 100,
        
        // Hover movement multipliers
        hoverThetaMultiplier: 34, // Horizontal range (degrees)
        hoverPhiMultiplier: 29,   // Vertical range (degrees)
        hoverInvertTheta: true,   // Invert horizontal direction
        hoverInvertPhi: true,     // Invert vertical direction
        
        // Camera settings
        fieldOfView: '30deg',
        interpolationDecay: '200', // Smooth transitions
        
        // Auto-rotation (oscillating ±30°)
        autoRotate: true,
        autoRotateSpeed: 5,
        autoRotateRange: 30, // Oscillate ±30° from default
        
        // Lighting
        exposure: '3',
        shadowIntensity: '0',
        environmentImage: getHDRUrls().studio || 'neutral'
      };
    }
    
    // Get HDR URLs from data attributes (set by Liquid)
    function getHDRUrls() {
      var container = document.querySelector('.bundle-builder');
      return {
        nebula: container ? container.dataset.hdrNebula : '',
        nebulaBright: container ? container.dataset.hdrNebulaBright : '',
        studio: container ? container.dataset.hdrStudio : ''
      };
    }
    
    // Available environment presets (lazy-loaded from DOM)
    function getEnvironmentPresets() {
      var urls = getHDRUrls();
      return {
        'nebula': urls.nebula || '',
        'nebula-bright': urls.nebulaBright || '',
        'studio': urls.studio || '',
        'neutral': 'neutral',
        'legacy': 'legacy',
        'none': ''
      };
    }
    
    // Will be populated when needed
    var ENVIRONMENT_PRESETS = null;
    
    // Initialize global settings
    if (!window.physicalModelSettings) {
      window.physicalModelSettings = getDefaultModelSettings();
    }
    
    // Oscillating animation state storage (per model)
    var oscillationStates = new WeakMap();
    
    // Start oscillating animation for a model
    function startModelOscillation(modelCard, modelViewer) {
      var state = {
        active: true,
        paused: false,
        startTime: performance.now(),
        rafId: null
      };
      oscillationStates.set(modelCard, state);
      
      function animate(currentTime) {
        if (!state.active) return;
        
        var s = window.physicalModelSettings || getDefaultModelSettings();
        
        if (!state.paused && s.autoRotate) {
          var elapsed = currentTime - state.startTime;
          // Calculate oscillation: sine wave from -1 to 1
          // Speed controls how fast (degrees per second = full cycle speed)
          var cycleSpeed = (s.autoRotateSpeed || 5) / 60; // Convert to cycles per second (slower)
          var phase = (elapsed / 1000) * cycleSpeed * Math.PI * 2;
          var oscillation = Math.sin(phase); // -1 to 1
          
          // Apply oscillation range
          var range = s.autoRotateRange || 30;
          var thetaOffset = oscillation * range;
          
          var theta = s.defaultX + thetaOffset;
          var orbit = theta.toFixed(1) + 'deg ' + s.defaultY + 'deg ' + s.defaultZoom + '%';
          modelViewer.setAttribute('camera-orbit', orbit);
        }
        
        state.rafId = requestAnimationFrame(animate);
      }
      
      state.rafId = requestAnimationFrame(animate);
    }
    
    // Interactive hover effect for 3D models
    function addModelHoverEffect(modelCard, modelViewer) {
      var rafId = null;
      
      // On enter: pause oscillation, take control
      modelCard.addEventListener('mouseenter', function() {
        var oscState = oscillationStates.get(modelCard);
        if (oscState) {
          oscState.paused = true;
        }
      });
      
      // On move: continuous relative tracking
      modelCard.addEventListener('mousemove', function(e) {
        if (rafId) return;
        
        rafId = requestAnimationFrame(function() {
          var s = window.physicalModelSettings || getDefaultModelSettings();
          var rect = modelViewer.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var y = e.clientY - rect.top;
          var centerX = rect.width / 2;
          var centerY = rect.height / 2;
          
          // Normalized position (-1 to 1)
          var normX = (x - centerX) / centerX;
          var normY = (y - centerY) / centerY;
          
          // Calculate target rotation based on Hover Base + Multipliers
          // Theta (Horizontal)
          var thetaOffset = normX * (s.hoverThetaMultiplier || 34);
          if (s.hoverInvertTheta) thetaOffset = -thetaOffset;
          var targetTheta = (s.hoverBaseX !== undefined ? s.hoverBaseX : 139) + thetaOffset;
          
          // Phi (Vertical)
          var phiOffset = normY * (s.hoverPhiMultiplier || 29);
          if (s.hoverInvertPhi) phiOffset = -phiOffset;
          var targetPhi = (s.hoverBaseY !== undefined ? s.hoverBaseY : 92) + phiOffset;
          
          // Clamp phi (vertical) to prevent flipping
          targetPhi = Math.max(10, Math.min(170, targetPhi));
          
          // Apply orbit
          var zoom = s.hoverBaseZoom !== undefined ? s.hoverBaseZoom : 95;
          var orbit = targetTheta.toFixed(1) + 'deg ' + targetPhi.toFixed(1) + 'deg ' + zoom + '%';
          modelViewer.setAttribute('camera-orbit', orbit);
          
          rafId = null;
        });
      });
      
      // On leave: return to default position, resume oscillation
      modelCard.addEventListener('mouseleave', function() {
        var s = window.physicalModelSettings || getDefaultModelSettings();
        
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        
        // Return to default position (model-viewer will interpolate smoothly)
        var defaultOrbit = s.defaultX + 'deg ' + s.defaultY + 'deg ' + s.defaultZoom + '%';
        modelViewer.setAttribute('camera-orbit', defaultOrbit);
        
        // Resume oscillation after a short delay (let it settle first)
        var oscState = oscillationStates.get(modelCard);
        if (oscState && s.autoRotate) {
          setTimeout(function() {
            oscState.paused = false;
            oscState.startTime = performance.now(); // Reset phase for smooth start
          }, 300); // Small delay for smooth transition
        }
      });
    }
    
    // Create debug panel for 3D model settings
    function createPhysicalModelDebugPanel() {
      var existingPanel = document.getElementById('bb-physical-debug-panel');
      if (existingPanel) existingPanel.remove();
      
      var panel = document.createElement('div');
      panel.id = 'bb-physical-debug-panel';
      var s = window.physicalModelSettings || getDefaultModelSettings();
      
      panel.innerHTML = `
        <div class="bb-debug-header">
          <span>🎲 3D Model Settings</span>
          <button class="bb-debug-close" onclick="this.parentElement.parentElement.remove()">×</button>
        </div>
        <div class="bb-debug-content">
          <div class="bb-debug-section">
            <h4>📷 Default Position (at rest)</h4>
            <label>X
              <input type="range" id="dbg-default-x" min="-180" max="180" step="1" value="${s.defaultX}">
              <span id="dbg-default-x-val">${s.defaultX}°</span>
            </label>
            <label>Y
              <input type="range" id="dbg-default-y" min="0" max="180" step="1" value="${s.defaultY}">
              <span id="dbg-default-y-val">${s.defaultY}°</span>
            </label>
            <label>Zoom
              <input type="range" id="dbg-default-zoom" min="50" max="300" step="5" value="${s.defaultZoom}">
              <span id="dbg-default-zoom-val">${s.defaultZoom}%</span>
            </label>
          </div>
          
          <div class="bb-debug-section">
            <h4>🎯 Hover Base Position (center of hover)</h4>
            <label>Base X
              <input type="range" id="dbg-hover-x" min="-180" max="180" step="1" value="${s.hoverBaseX}">
              <span id="dbg-hover-x-val">${s.hoverBaseX}°</span>
            </label>
            <label>Base Y
              <input type="range" id="dbg-hover-y" min="0" max="180" step="1" value="${s.hoverBaseY}">
              <span id="dbg-hover-y-val">${s.hoverBaseY}°</span>
            </label>
            <label>Base Zoom
              <input type="range" id="dbg-hover-zoom" min="50" max="300" step="5" value="${s.hoverBaseZoom}">
              <span id="dbg-hover-zoom-val">${s.hoverBaseZoom}%</span>
            </label>
            <button id="dbg-copy-to-hover" class="bb-debug-sync-btn">⬆️ Copy Default → Hover</button>
          </div>
          
          <div class="bb-debug-section">
            <h4>✨ Hover Movement</h4>
            <label>X Range
              <input type="range" id="dbg-hover-theta" min="0" max="90" step="1" value="${s.hoverThetaMultiplier || 25}">
              <span id="dbg-hover-theta-val">±${s.hoverThetaMultiplier || 25}°</span>
            </label>
            <label>Y Range
              <input type="range" id="dbg-hover-phi" min="0" max="90" step="1" value="${s.hoverPhiMultiplier || 15}">
              <span id="dbg-hover-phi-val">±${s.hoverPhiMultiplier || 15}°</span>
            </label>
            <label>
              <input type="checkbox" id="dbg-invert-theta" ${s.hoverInvertTheta ? 'checked' : ''}>
              Invert X
            </label>
            <label>
              <input type="checkbox" id="dbg-invert-phi" ${s.hoverInvertPhi ? 'checked' : ''}>
              Invert Y
            </label>
          </div>
          
          <div class="bb-debug-section">
            <h4>💡 Lighting</h4>
            <label>Exposure
              <input type="range" id="dbg-exposure" min="0" max="5" step="0.1" value="${s.exposure}">
              <span id="dbg-exposure-val">${s.exposure}</span>
            </label>
            <label>Shadow Intensity
              <input type="range" id="dbg-shadow" min="0" max="2" step="0.1" value="${s.shadowIntensity}">
              <span id="dbg-shadow-val">${s.shadowIntensity}</span>
            </label>
            <label>Environment
              <select id="dbg-environment">
                <option value="nebula" ${s.environmentImage && s.environmentImage.includes('nebulae') ? 'selected' : ''}>🌌 Blue Nebula</option>
                <option value="nebula-bright" ${s.environmentImage && s.environmentImage.includes('nebular-bright') ? 'selected' : ''}>🌌 Nebula Bright</option>
                <option value="studio" ${s.environmentImage && s.environmentImage.includes('Studio') ? 'selected' : ''}>🎬 Studio</option>
                <option value="neutral" ${s.environmentImage === 'neutral' ? 'selected' : ''}>Neutral</option>
                <option value="legacy" ${s.environmentImage === 'legacy' ? 'selected' : ''}>Legacy</option>
                <option value="none" ${!s.environmentImage || s.environmentImage === 'none' ? 'selected' : ''}>None</option>
              </select>
            </label>
          </div>
          
          <div class="bb-debug-section">
            <h4>🔄 Oscillation (Back & Forth)</h4>
            <label>
              <input type="checkbox" id="dbg-auto-rotate" ${s.autoRotate ? 'checked' : ''}>
              Enable Oscillation
            </label>
            <label>Speed
              <input type="range" id="dbg-rotate-speed" min="1" max="30" step="1" value="${s.autoRotateSpeed || 5}">
              <span id="dbg-rotate-speed-val">${s.autoRotateSpeed || 5}</span>
            </label>
            <label>Range (±degrees)
              <input type="range" id="dbg-rotate-range" min="5" max="90" step="5" value="${s.autoRotateRange || 30}">
              <span id="dbg-rotate-range-val">±${s.autoRotateRange || 30}°</span>
            </label>
          </div>
          
          <div class="bb-debug-section">
            <h4>⚙️ Other</h4>
            <label>Field of View
              <input type="text" id="dbg-fov" value="${s.fieldOfView}">
            </label>
            <label>Interpolation (smoothness)
              <input type="range" id="dbg-interp" min="50" max="500" step="10" value="${s.interpolationDecay}">
              <span id="dbg-interp-val">${s.interpolationDecay}</span>
            </label>
          </div>
          
          <div class="bb-debug-actions">
            <button id="dbg-apply-model">Apply to Models</button>
            <button id="dbg-reset-model">Reset Defaults</button>
          </div>
        </div>
      `;
      
      document.body.appendChild(panel);
      
      // Wire up sliders with live preview
      ['default-x', 'default-y', 'default-zoom', 'hover-x', 'hover-y', 'hover-zoom', 'hover-theta', 'hover-phi', 'rotate-speed', 'rotate-range', 'exposure', 'shadow', 'interp'].forEach(function(id) {
        var input = document.getElementById('dbg-' + id);
        var valSpan = document.getElementById('dbg-' + id + '-val');
        if (input && valSpan) {
          input.addEventListener('input', function() {
            // Determine suffix and prefix
            var suffix = '°';
            var prefix = '';
            if (id.includes('zoom')) suffix = '%';
            else if (id === 'exposure' || id === 'shadow' || id === 'interp' || id === 'rotate-speed') suffix = '';
            else if (id === 'hover-theta' || id === 'hover-phi' || id === 'rotate-range') {
              prefix = '±';
            }
            
            valSpan.textContent = prefix + this.value + suffix;
            
            // Live update default position on models
            if (id.startsWith('default-')) {
              var x = document.getElementById('dbg-default-x').value;
              var y = document.getElementById('dbg-default-y').value;
              var zoom = document.getElementById('dbg-default-zoom').value;
              var orbit = x + 'deg ' + y + 'deg ' + zoom + '%';
              
              document.querySelectorAll('.bb-model-card model-viewer').forEach(function(mv) {
                mv.setAttribute('camera-orbit', orbit);
              });
            }
            
            // Live update exposure/shadow
            if (id === 'exposure') {
              document.querySelectorAll('.bb-model-card model-viewer').forEach(function(mv) {
                mv.setAttribute('exposure', input.value);
              });
            }
            if (id === 'shadow') {
              document.querySelectorAll('.bb-model-card model-viewer').forEach(function(mv) {
                mv.setAttribute('shadow-intensity', input.value);
              });
            }
            
            // Live update oscillation settings (read by animation loop)
            if (id === 'rotate-speed' && window.physicalModelSettings) {
              window.physicalModelSettings.autoRotateSpeed = parseFloat(input.value);
            }
            if (id === 'rotate-range' && window.physicalModelSettings) {
              window.physicalModelSettings.autoRotateRange = parseFloat(input.value);
            }
          });
        }
      });
      
      // Live update oscillation toggle (updates settings, oscillation loop reads it)
      document.getElementById('dbg-auto-rotate').addEventListener('change', function() {
        if (window.physicalModelSettings) {
          window.physicalModelSettings.autoRotate = this.checked;
        }
      });
      
      // "Copy Default → Hover" button
      document.getElementById('dbg-copy-to-hover').addEventListener('click', function() {
        var defX = document.getElementById('dbg-default-x').value;
        var defY = document.getElementById('dbg-default-y').value;
        var defZoom = document.getElementById('dbg-default-zoom').value;
        
        document.getElementById('dbg-hover-x').value = defX;
        document.getElementById('dbg-hover-y').value = defY;
        document.getElementById('dbg-hover-zoom').value = defZoom;
        
        document.getElementById('dbg-hover-x-val').textContent = defX + '°';
        document.getElementById('dbg-hover-y-val').textContent = defY + '°';
        document.getElementById('dbg-hover-zoom-val').textContent = defZoom + '%';
      });
      
      // Apply button
      document.getElementById('dbg-apply-model').addEventListener('click', function() {
        // Resolve environment preset to actual URL
        var envSelection = document.getElementById('dbg-environment').value;
        var presets = getEnvironmentPresets();
        var envImage = presets[envSelection] || envSelection;
        
        window.physicalModelSettings = {
          // Default position
          defaultX: parseFloat(document.getElementById('dbg-default-x').value),
          defaultY: parseFloat(document.getElementById('dbg-default-y').value),
          defaultZoom: parseFloat(document.getElementById('dbg-default-zoom').value),
          // Hover base position
          hoverBaseX: parseFloat(document.getElementById('dbg-hover-x').value),
          hoverBaseY: parseFloat(document.getElementById('dbg-hover-y').value),
          hoverBaseZoom: parseFloat(document.getElementById('dbg-hover-zoom').value),
          // Hover multipliers
          hoverThetaMultiplier: parseFloat(document.getElementById('dbg-hover-theta').value),
          hoverPhiMultiplier: parseFloat(document.getElementById('dbg-hover-phi').value),
          hoverInvertTheta: document.getElementById('dbg-invert-theta').checked,
          hoverInvertPhi: document.getElementById('dbg-invert-phi').checked,
          // Oscillation
          autoRotate: document.getElementById('dbg-auto-rotate').checked,
          autoRotateSpeed: parseFloat(document.getElementById('dbg-rotate-speed').value),
          autoRotateRange: parseFloat(document.getElementById('dbg-rotate-range').value),
          // Other
          fieldOfView: document.getElementById('dbg-fov').value,
          interpolationDecay: document.getElementById('dbg-interp').value,
          exposure: document.getElementById('dbg-exposure').value,
          shadowIntensity: document.getElementById('dbg-shadow').value,
          environmentImage: envImage
        };
        
        var s = window.physicalModelSettings;
        var defaultOrbit = s.defaultX + 'deg ' + s.defaultY + 'deg ' + s.defaultZoom + '%';
        
        // Apply to all existing model-viewers
        document.querySelectorAll('.bb-model-card model-viewer').forEach(function(mv) {
          mv.setAttribute('camera-orbit', defaultOrbit);
          mv.setAttribute('field-of-view', s.fieldOfView);
          mv.setAttribute('interpolation-decay', s.interpolationDecay);
          mv.setAttribute('exposure', s.exposure);
          mv.setAttribute('shadow-intensity', s.shadowIntensity);
          
          if (s.environmentImage && s.environmentImage !== '' && s.environmentImage !== 'none') {
            mv.setAttribute('environment-image', s.environmentImage);
          } else {
            mv.removeAttribute('environment-image');
          }
          // Note: Oscillation is handled by custom JS, not native auto-rotate
        });
        
        console.log('[BB Physical Debug] Settings applied:', window.physicalModelSettings);
      });
      
      // Reset button
      document.getElementById('dbg-reset-model').addEventListener('click', function() {
        window.physicalModelSettings = getDefaultModelSettings();
        panel.remove();
        createPhysicalModelDebugPanel();
      });
    }
    
    // Expose for debug panel access
    window.BBPhysicalDebug = {
      openPanel: createPhysicalModelDebugPanel,
      getSettings: function() { return window.physicalModelSettings; },
      setSettings: function(s) { window.physicalModelSettings = s; }
    };
    
    function togglePhysicalSelection(modelCard, addButton) {
      var productTitle = modelCard.dataset.title;
      var productId = modelCard.dataset.productId; // Always string from dataset
      
      // Find button if not passed
      if (!addButton) {
        addButton = modelCard.querySelector('.bb-model-add-btn');
      }
      
      // Check if already selected (compare as strings for consistency)
      var existingIndex = state.selectedPhysical.findIndex(function(p) {
        return String(p.productId) === productId;
      });
      
      // Find price element for flash effect
      var priceElement = modelCard.querySelector('.bb-model-price');
      
      // Helper to calculate total items for tier-based sounds
      function getTotalItemCount() {
        var digitalGoodiesCount = state.selectedDigitalGoodies ? state.selectedDigitalGoodies.length : 0;
        // Physical count includes quantity
        var physicalCount = state.selectedPhysical ? state.selectedPhysical.reduce(function(sum, p) { return sum + (p.quantity || 1); }, 0) : 0;
        return state.selectedProducts.length + digitalGoodiesCount + physicalCount;
      }
      
      // Find quantity container
      var qtyContainer = modelCard.querySelector('.bb-model-qty-container');
      
      if (existingIndex >= 0) {
        // Deselect
        state.selectedPhysical.splice(existingIndex, 1);
        modelCard.classList.remove('bb-model-selected');
        if (addButton) {
          addButton.innerHTML = '<span class="bb-model-add-icon">+</span> Add to Bundle';
          addButton.classList.remove('bb-model-btn-selected');
        }
        
        // Hide and reset quantity controls
        if (qtyContainer) {
          qtyContainer.classList.remove('bb-qty-visible');
          var qtyDisplay = qtyContainer.querySelector('.bb-model-qty-value');
          if (qtyDisplay) qtyDisplay.textContent = '1';
        }
        
        // Update sound tier based on total items and play physical remove sound
        // Physical mode supports tiers 1-14 for distinct sounds
        var newTier = Math.max(1, Math.min(getTotalItemCount(), 14));
        window.SoundSystem.setTier(newTier);
        window.SoundSystem.play('physical-remove');
        
        console.log('[BB Physical] Removed physical:', productTitle);
      } else {
        // Select - get variant data from model card (stored from physical collection JSON)
        // or fall back to findPhysicalVariant lookup
        var variantId = modelCard.dataset.originalVariantId;
        var price = parseFloat(modelCard.dataset.price) || 0;
        var comparePrice = parseFloat(modelCard.dataset.comparePrice) || price;
        
        // If no price stored on card, try finding via product lookup
        if (!price && !variantId) {
          var physicalVariant = findPhysicalVariant(productId);
          if (physicalVariant) {
            variantId = physicalVariant.variantId;
            price = physicalVariant.price;
            comparePrice = physicalVariant.comparePrice || price;
          }
        }
        
        if (variantId) {
          state.selectedPhysical.push({
            productId: productId,
            variantId: variantId,
            title: productTitle + ' (Physical)',
            price: price,
            comparePrice: comparePrice,
            quantity: 1
          });
          modelCard.classList.add('bb-model-selected');
          if (addButton) {
            addButton.innerHTML = '<span class="bb-model-add-icon">✓</span> Added!';
            addButton.classList.add('bb-model-btn-selected');
          }
          
          // Show quantity controls
          if (qtyContainer) {
            qtyContainer.classList.add('bb-qty-visible');
          }
          
          // Show floating message for physical product
          if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
            MultiplayerSystem.jumpMyAvatar(productTitle + ' (Physical)');
          }
          
          // White flash on price
          if (priceElement) {
            priceElement.classList.remove('bb-price-flash');
            void priceElement.offsetWidth; // Force reflow
            priceElement.classList.add('bb-price-flash');
          }
          
          // Update sound tier based on total items (after adding this one)
          // Physical mode supports tiers 1-14 for distinct add-to-cart sounds
          var newTier = Math.min(getTotalItemCount(), 14);
          window.SoundSystem.setTier(newTier);
          
          // Play physical add sound with current tier (satisfying "add to cart" sound)
          window.SoundSystem.play('physical-add');
          
          // Play checkmark land sound after animation (~400ms)
          setTimeout(function() {
            window.SoundSystem.play('checkmark-land', null, 0.5);
          }, 400);
          
          console.log('[BB Physical] Added physical:', productTitle, 'variant:', variantId);
        } else {
          console.warn('[BB Physical] No physical variant found for:', productTitle);
        }
      }
      
      // Update pricing (delayed slightly to allow sound tier to be set first)
      setTimeout(function() {
        updateCalculation();
      }, 50);
    }
    
    // Update quantity for physical product (called by +/- buttons)
    function updatePhysicalQuantity(productId, newQuantity, qtyDisplay, modelCard, addButton, qtyContainer) {
      // Find the item in state (compare as strings for consistency)
      var productIdStr = String(productId);
      var item = state.selectedPhysical.find(function(p) {
        return String(p.productId) === productIdStr;
      });
      
      if (!item) return;
      
      var oldQuantity = item.quantity || 1;
      item.quantity = newQuantity;
      
      // Update display
      if (qtyDisplay) {
        qtyDisplay.textContent = newQuantity;
      }
      
      // Play sound based on increase/decrease
      if (window.SoundSystem) {
        if (newQuantity > oldQuantity) {
          window.SoundSystem.play('physical-add');
        } else {
          window.SoundSystem.play('physical-remove');
        }
      }
      
      // Show floating message for quantity change
      if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
        var productTitle = item.title.replace(' (Physical)', '');
        MultiplayerSystem.jumpMyAvatar(productTitle + ' x' + newQuantity);
      }
      
      console.log('[BB Physical] Updated quantity:', item.title, 'to', newQuantity);
      
      // Update pricing
      updateCalculation();
    }
    
    function findPhysicalVariant(productId) {
      // Look through our product data for the last variant
      // This data comes from the bb-all-products JSON
      try {
        var productsData = JSON.parse(document.getElementById('bb-all-products-' + config.sectionId).textContent);
        var products = productsData.products.filter(function(p) { return p !== null; });
        
        // Find the product
        var product = products.find(function(p) { return String(p.id) === String(productId); });
        
        if (product) {
          // For now, return the same variant (we'd need to extend the data to include all variants)
          // TODO: Extend bb-all-products to include last variant info
          return {
            variantId: product.variantId,
            price: product.price,
            comparePrice: product.comparePrice || product.price
          };
        }
      } catch (e) {
        console.error('[BB Physical] Error finding physical variant:', e);
      }
      
      return null;
    }
    
    function exitPhysicalMode() {
      isPhysicalMode = false;
      state.physicalMode = false;
      
      console.log('[BB Physical] Exiting physical mode');
      
      // Remove physical-mode class, restore upgrade mode
      container.classList.remove('bb-in-physical-mode');
      container.classList.add('bb-in-upgrade-mode');
      
      var grid = container.querySelector('.bb-product-grid');
      var track = container.querySelector('.bb-carousel-track');
      var modelCarousel = container.querySelector('.bb-model-carousel');
      
      // Animate title back to upgrade mode (start immediately for smooth transition)
      animateTitleBackToUpgradeMode();
      
      // Fade out model carousel, then restore track AFTER model is removed
      // This prevents layout conflicts between both carousels existing simultaneously
      if (modelCarousel) {
        modelCarousel.classList.remove('bb-carousel-visible');
        modelCarousel.classList.add('bb-carousel-fade-out');
        
        setTimeout(function() {
          // Remove model carousel from DOM
          modelCarousel.remove();
          
          // NOW restore the card carousel track (after model is gone)
          // This prevents the flex container from trying to layout both elements
          
          // Restore original track state
          if (carouselState.originalTrack) {
            carouselState.track = carouselState.originalTrack;
            carouselState.cards = carouselState.originalCards;
            carouselState.originalTrack = null;
            carouselState.originalCards = null;
          }
          
          // Restore track visibility with proper transition
          if (track) {
            // Add fade-in class BEFORE making visible (provides transition for the return animation)
            track.classList.add('bb-carousel-fade-in');
            
            // Make visible (still has fade-out class with translateY(-20px) and opacity: 0)
            track.style.display = '';
            
            // Force reflow so browser registers the starting position
            // This ensures the CSS transition animates smoothly from translateY(-20px) to translateY(0)
            void track.offsetHeight;
            
            // Now remove fade-out class to trigger smooth transition down
            // The fade-in class provides the transition properties
            track.classList.remove('bb-carousel-fade-out');
            
            // Remove fade-in class after transition completes (400ms)
            setTimeout(function() {
              track.classList.remove('bb-carousel-fade-in');
            }, 400);
          }
          
          // Recalculate carousel dimensions after track is visible
          updateCarouselDimensions();
          calculateCarouselBounds();
          
          console.log('[BB Physical] Back to upgrade mode');
        }, 400);
      } else {
        // No model carousel to fade out, restore track immediately
        if (carouselState.originalTrack) {
          carouselState.track = carouselState.originalTrack;
          carouselState.cards = carouselState.originalCards;
          carouselState.originalTrack = null;
          carouselState.originalCards = null;
        }
        
        if (track) {
          track.classList.add('bb-carousel-fade-in');
          track.style.display = '';
          void track.offsetHeight;
          track.classList.remove('bb-carousel-fade-out');
          
          setTimeout(function() {
            track.classList.remove('bb-carousel-fade-in');
          }, 400);
        }
        
        updateCarouselDimensions();
        calculateCarouselBounds();
        
        console.log('[BB Physical] Back to upgrade mode');
      }
    }
    
    // Exit physical mode directly to card select (used in skip mode)
    function exitPhysicalModeToCardSelect() {
      isPhysicalMode = false;
      isUpgradeMode = false;
      isSkipMode = false;
      state.physicalMode = false;
      
      console.log('[BB Physical] Exiting physical mode back to card select (skip mode)');
      
      // Remove physical-mode class, go back to card select (no upgrade class)
      container.classList.remove('bb-in-physical-mode');
      container.classList.remove('bb-in-upgrade-mode');
      
      var grid = container.querySelector('.bb-product-grid');
      var track = container.querySelector('.bb-carousel-track');
      var modelCarousel = container.querySelector('.bb-model-carousel');
      
      // Disable back button since we're back at card select
      var stickyBackBtn = container.querySelector('.bb-sticky-back');
      if (stickyBackBtn) {
        stickyBackBtn.disabled = true;
      }
      
      // Animate title back to card select mode (start immediately)
      animateTitleBackToCardSelect();
      
      // Fade out model carousel, then restore track AFTER model is removed
      if (modelCarousel) {
        modelCarousel.classList.remove('bb-carousel-visible');
        modelCarousel.classList.add('bb-carousel-fade-out');
        
        setTimeout(function() {
          // Remove model carousel from DOM
          modelCarousel.remove();
          
          // Restore original track state
          if (carouselState.originalTrack) {
            carouselState.track = carouselState.originalTrack;
            carouselState.cards = carouselState.originalCards;
            carouselState.originalTrack = null;
            carouselState.originalCards = null;
          }
          
          // Restore track visibility with proper transition
          if (track) {
            track.classList.add('bb-carousel-fade-in');
            track.style.display = '';
            void track.offsetHeight;
            track.classList.remove('bb-carousel-fade-out');
            
            setTimeout(function() {
              track.classList.remove('bb-carousel-fade-in');
            }, 400);
          }
          
          // Recalculate carousel dimensions after track is visible
          updateCarouselDimensions();
          calculateCarouselBounds();
          
          // Update calculation to refresh button state
          updateCalculation();
          
          console.log('[BB Physical] Back to card select');
        }, 400);
      } else {
        // No model carousel, restore track immediately
        if (carouselState.originalTrack) {
          carouselState.track = carouselState.originalTrack;
          carouselState.cards = carouselState.originalCards;
          carouselState.originalTrack = null;
          carouselState.originalCards = null;
        }
        
        if (track) {
          track.classList.add('bb-carousel-fade-in');
          track.style.display = '';
          void track.offsetHeight;
          track.classList.remove('bb-carousel-fade-out');
          
          setTimeout(function() {
            track.classList.remove('bb-carousel-fade-in');
          }, 400);
        }
        
        updateCarouselDimensions();
        calculateCarouselBounds();
        updateCalculation();
        
        console.log('[BB Physical] Back to card select');
      }
    }
    
    function animateTitleBackToCardSelect() {
      var stepTitle = container.querySelector('.bb-step-title');
      var stepDescription = container.querySelector('.bb-step-description');
      
      if (stepTitle) {
        stepTitle.classList.remove('bb-physical-title');
        stepTitle.textContent = stepTitle.dataset.originalText || '';
      }
      
      if (stepDescription) {
        // Restore with highlight spans for step 1 (matching animateTitleToSelectMode)
        stepDescription.innerHTML = 'Add 5+ <span class="bb-highlight">Digital Decks</span> to unlock the maximum <span class="bb-highlight">50% discount</span>.';
      }
    }
    
    function animateTitleBackToUpgradeMode() {
      var stepTitle = container.querySelector('.bb-step-title');
      var stepDescription = container.querySelector('.bb-step-description');
      
      if (stepTitle && stepTitle.dataset.upgradeText) {
        stepTitle.classList.add('bb-title-exit');
        
        setTimeout(function() {
          stepTitle.textContent = stepTitle.dataset.upgradeText;
          stepTitle.classList.remove('bb-title-exit', 'bb-physical-title');
          stepTitle.classList.add('bb-title-enter', 'bb-upgrade-title');
          
          setTimeout(function() {
            stepTitle.classList.remove('bb-title-enter');
          }, 400);
        }, 300);
      }
      
      if (stepDescription && stepDescription.dataset.upgradeText) {
        stepDescription.classList.add('bb-description-exit');
        
        setTimeout(function() {
          stepDescription.innerHTML = stepDescription.dataset.upgradeText;
          stepDescription.classList.remove('bb-description-exit');
          stepDescription.classList.add('bb-description-enter');
          
          setTimeout(function() {
            stepDescription.classList.remove('bb-description-enter');
          }, 400);
        }, 300);
      }
    }
    
    // ========================================================================
    // DIGITAL GOODIES MODE - Products from a configurable collection
    // ========================================================================
    
    function enterDigitalGoodiesMode() {
      isDigitalGoodiesMode = true;
      state.digitalGoodiesMode = true;
      
      console.log('[BB Digital Goodies] Entering digital goodies mode');
      
      // Add digital-goodies-mode class to container for background transition
      container.classList.add('bb-in-digital-goodies-mode');
      container.classList.remove('bb-in-physical-mode');
      
      var grid = container.querySelector('.bb-product-grid');
      var modelCarousel = container.querySelector('.bb-model-carousel');
      
      // Animate title change
      animateTitleToDigitalGoodiesMode();
      
      // Update Next button to Checkout rainbow button
      updateCalculation();
      
      // After title animation starts, fade out model carousel and create goodies carousel
      setTimeout(function() {
        // Fade out model carousel
        if (modelCarousel) {
          modelCarousel.classList.remove('bb-carousel-visible');
          modelCarousel.classList.add('bb-carousel-fade-out');
        }
        
        // After fade out, create digital goodies carousel
        setTimeout(function() {
          if (modelCarousel) {
            modelCarousel.style.display = 'none';
          }
          createDigitalGoodiesCarousel(grid);
        }, 400);
      }, 200);
      
      console.log('[BB Digital Goodies] Digital goodies mode active');
    }
    
    function animateTitleToDigitalGoodiesMode() {
      var stepTitle = container.querySelector('.bb-step-title');
      var stepDescription = container.querySelector('.bb-step-description');
      var goodiesData = getDigitalGoodiesData();
      
      if (stepTitle) {
        // Store physical mode text for going back
        if (!stepTitle.dataset.physicalText) {
          stepTitle.dataset.physicalText = stepTitle.textContent;
        }
        
        // Add exit animation class
        stepTitle.classList.add('bb-title-exit');
        
        // After exit animation, swap text and animate in
        setTimeout(function() {
          stepTitle.textContent = goodiesData ? goodiesData.title : 'Limited Time Only: Digital Goodies';
          stepTitle.classList.remove('bb-title-exit', 'bb-physical-title');
          stepTitle.classList.add('bb-title-slam', 'bb-digital-goodies-title');
          
          // Get the step header for shake effect
          var stepHeader = stepTitle.closest('.bb-step-header');
          
          // At impact moment, trigger shake + sound
          setTimeout(function() {
            if (window.SoundSystem && window.SoundSystem.play) {
              window.SoundSystem.play('upgrade-slam');
            }
            if (stepHeader) {
              stepHeader.classList.add('bb-impact-shake');
              setTimeout(function() {
                stepHeader.classList.remove('bb-impact-shake');
              }, 300);
            }
          }, 350);
          
          // Clean up animation class
          setTimeout(function() {
            stepTitle.classList.remove('bb-title-slam');
          }, 600);
        }, 300);
      }
      
      if (stepDescription) {
        // Store physical description
        if (!stepDescription.dataset.physicalText) {
          stepDescription.dataset.physicalText = stepDescription.innerHTML;
        }
        
        stepDescription.classList.add('bb-description-exit');
        
        setTimeout(function() {
          stepDescription.innerHTML = goodiesData ? goodiesData.subtitle : 'Exclusive digital products available with your bundle.';
          stepDescription.classList.remove('bb-description-exit');
          stepDescription.classList.add('bb-description-enter');
          
          setTimeout(function() {
            stepDescription.classList.remove('bb-description-enter');
          }, 400);
        }, 300);
      }
    }
    
    function createDigitalGoodiesCarousel(grid) {
      var goodiesData = getDigitalGoodiesData();
      if (!goodiesData || !goodiesData.products || goodiesData.products.length === 0) {
        console.warn('[BB Digital Goodies] No products found');
        return;
      }
      
      console.log('[BB Digital Goodies] Creating carousel with', goodiesData.products.length, 'products');
      
      // Use formatMoneyWithSymbol for proper currency formatting
      
      // Create wrapper (same structure as card carousel)
      var goodiesWrapper = document.createElement('div');
      goodiesWrapper.className = 'bb-goodies-wrapper';
      
      // Create carousel container (scrollable)
      var goodiesContainer = document.createElement('div');
      goodiesContainer.className = 'bb-goodies-carousel';
      
      // Create track (draggable)
      var goodiesTrack = document.createElement('div');
      goodiesTrack.className = 'bb-goodies-track';
      
      // Create product cards
      goodiesData.products.forEach(function(product) {
        var card = document.createElement('div');
        card.className = 'bb-goodies-card';
        card.dataset.productId = product.id;
        card.dataset.variantId = product.variantId;
        card.dataset.price = product.price;
        card.dataset.comparePrice = product.comparePrice || product.price;
        card.dataset.title = product.title;
        card.dataset.description = product.description || '';
        
        // Check if already selected
        var isSelected = state.selectedDigitalGoodies.some(function(g) {
          return g.variantId == product.variantId;
        });
        if (isSelected) {
          card.classList.add('bb-goodies-selected');
        }
        
        // Content wrapper for image + info (allows horizontal layout on mobile)
        var contentWrapper = document.createElement('div');
        contentWrapper.className = 'bb-goodies-content';
        
        // Product image
        var imageContainer = document.createElement('div');
        imageContainer.className = 'bb-goodies-image';
        if (product.image) {
          var img = document.createElement('img');
          img.src = product.image;
          img.alt = product.title;
          img.loading = 'lazy';
          imageContainer.appendChild(img);
        }
        contentWrapper.appendChild(imageContainer);
        
        // Product info
        var info = document.createElement('div');
        info.className = 'bb-goodies-info';
        
        var title = document.createElement('div');
        title.className = 'bb-goodies-title';
        title.textContent = product.title;
        info.appendChild(title);
        
        // Description subtitle (first 80 chars, strip HTML for preview)
        if (product.description) {
          // Strip HTML for preview text
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = product.description;
          var plainText = tempDiv.textContent || tempDiv.innerText || '';
          
          var needsReadMore = plainText.length > 80 || product.description.includes('<');
          var descText = plainText.length > 80 
            ? plainText.substring(0, 77).trim() 
            : plainText;
          
          var subtitle = document.createElement('div');
          subtitle.className = 'bb-goodies-subtitle';
          
          // Append "Read more" inline if truncated
          if (needsReadMore) {
            subtitle.innerHTML = descText + '... <button class="bb-goodies-read-more">Read more</button>';
            var readMoreBtn = subtitle.querySelector('.bb-goodies-read-more');
            readMoreBtn.addEventListener('click', function(e) {
              e.stopPropagation();
              showGoodiesDescriptionPopup(product);
            });
          } else {
            subtitle.textContent = descText;
          }
          
          info.appendChild(subtitle);
        }
        
        // Calculate discounted price based on current tier
        var currentDiscount = state.discountTier || 0;
        var discountedPrice = product.price * (1 - currentDiscount / 100);
        
        // Calculate tier number for CSS color
        var tierNum = 0;
        if (currentDiscount >= 50) tierNum = 5;
        else if (currentDiscount >= 40) tierNum = 4;
        else if (currentDiscount >= 30) tierNum = 3;
        else if (currentDiscount >= 20) tierNum = 2;
        else if (currentDiscount >= 10) tierNum = 1;
        card.dataset.tier = tierNum;
        
        var priceContainer = document.createElement('div');
        priceContainer.className = 'bb-goodies-price';
        
        // Show original price as strikethrough if there's a tier discount
        if (currentDiscount > 0) {
          var originalPrice = document.createElement('span');
          originalPrice.className = 'bb-goodies-compare-price';
          originalPrice.textContent = formatMoneyWithSymbol(product.price);
          priceContainer.appendChild(originalPrice);
        }
        
        var currentPrice = document.createElement('span');
        currentPrice.className = 'bb-goodies-current-price';
        currentPrice.textContent = formatMoneyWithSymbol(discountedPrice);
        priceContainer.appendChild(currentPrice);
        
        // Add discount label (red text) next to price if there's a discount
        if (currentDiscount > 0) {
          var discountLabel = document.createElement('span');
          discountLabel.className = 'bb-goodies-discount-label';
          discountLabel.innerHTML = '-' + currentDiscount + '<span class="bb-discount-percent">%</span>';
          priceContainer.appendChild(discountLabel);
        }
        
        info.appendChild(priceContainer);
        contentWrapper.appendChild(info);
        card.appendChild(contentWrapper);
        
        // Add button
        var addBtn = document.createElement('button');
        addBtn.className = 'bb-goodies-add-btn' + (isSelected ? ' bb-goodies-btn-selected' : '');
        addBtn.innerHTML = isSelected ? '<span class="bb-goodies-check">✓</span> Added' : '<span class="bb-goodies-plus">+</span> Add to bundle';
        addBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          toggleDigitalGoodieSelection(card, addBtn, product);
        });
        card.appendChild(addBtn);
        
        goodiesTrack.appendChild(card);
      });
      
      goodiesContainer.appendChild(goodiesTrack);
      goodiesWrapper.appendChild(goodiesContainer);
      
      // Insert into grid
      if (grid) {
        grid.appendChild(goodiesWrapper);
        
        // SWAP CAROUSEL STATE to use the same drag system as card selection
        // Store physical mode state (including grid for proper restoration)
        carouselState.physicalTrack = carouselState.track;
        carouselState.physicalCards = carouselState.cards;
        carouselState.physicalGrid = carouselState.grid; // Save grid reference
        
        // Set up for goodies carousel
        // NOTE: Keep grid as .bb-product-grid where event listeners are attached
        // The goodies container is a child of it, so events will bubble up
        carouselState.track = goodiesTrack;
        carouselState.cards = Array.from(goodiesTrack.children);
        // carouselState.grid stays as .bb-product-grid
        
        // Update dimensions and bounds for the new content
        updateCarouselDimensions();
        calculateCarouselBounds();
        
        // Reset position
        carouselState.translateX = 0;
        goodiesTrack.style.transform = 'translateX(0px)';
        
        // Fade in carousel
        setTimeout(function() {
          goodiesWrapper.classList.add('bb-goodies-carousel-visible');
        }, 50);
      }
    }
    
    // Description popup
    function showGoodiesDescriptionPopup(product) {
      // Remove existing popup if any
      var existingPopup = document.querySelector('.bb-goodies-popup-overlay');
      if (existingPopup) existingPopup.remove();
      
      // Check if already selected
      var isSelected = state.selectedDigitalGoodies.some(function(g) {
        return g.variantId == product.variantId;
      });
      
      // Create overlay
      var overlay = document.createElement('div');
      overlay.className = 'bb-goodies-popup-overlay';
      
      // Create popup
      var popup = document.createElement('div');
      popup.className = 'bb-goodies-popup';
      
      // Close button
      var closeBtn = document.createElement('button');
      closeBtn.className = 'bb-goodies-popup-close';
      closeBtn.innerHTML = '✕';
      closeBtn.addEventListener('click', function() {
        overlay.classList.remove('bb-goodies-popup-visible');
        setTimeout(function() { overlay.remove(); }, 300);
      });
      popup.appendChild(closeBtn);
      
      // Product image
      if (product.image) {
        var imgContainer = document.createElement('div');
        imgContainer.className = 'bb-goodies-popup-image';
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title;
        img.draggable = false;
        imgContainer.appendChild(img);
        popup.appendChild(imgContainer);
      }
      
      // Title
      var title = document.createElement('div');
      title.className = 'bb-goodies-popup-title';
      title.textContent = product.title;
      popup.appendChild(title);
      
      // Scrollable description - use innerHTML for rich text
      var descContainer = document.createElement('div');
      descContainer.className = 'bb-goodies-popup-desc';
      descContainer.innerHTML = product.description;
      popup.appendChild(descContainer);
      
      // Add to Cart button
      var addBtn = document.createElement('button');
      addBtn.className = 'bb-goodies-popup-add-btn' + (isSelected ? ' bb-popup-btn-selected' : '');
      addBtn.innerHTML = isSelected 
        ? '<span class="bb-goodies-check">✓</span> Added to Bundle' 
        : '<span class="bb-goodies-plus">+</span> Add to Bundle';
      addBtn.addEventListener('click', function() {
        // Find the card in the carousel to sync state
        var card = container.querySelector('.bb-goodies-card[data-variant-id="' + product.variantId + '"]');
        var cardBtn = card ? card.querySelector('.bb-goodies-add-btn') : null;
        
        // Toggle selection
        var nowSelected = !state.selectedDigitalGoodies.some(function(g) {
          return g.variantId == product.variantId;
        });
        
        if (nowSelected) {
          // Add to selection
          state.selectedDigitalGoodies.push({
            variantId: product.variantId,
            productId: product.id,
            price: product.price,
            comparePrice: product.comparePrice || product.price,
            title: product.title,
            type: 'digital_goodies'
          });
          addBtn.classList.add('bb-popup-btn-selected');
          addBtn.innerHTML = '<span class="bb-goodies-check">✓</span> Added to Bundle';
          if (card) card.classList.add('bb-goodies-selected');
          if (cardBtn) {
            cardBtn.classList.add('bb-goodies-btn-selected');
            cardBtn.innerHTML = '<span class="bb-goodies-check">✓</span> Added';
          }
          
          // Show floating message for digital goodies (popup)
          if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
            MultiplayerSystem.jumpMyAvatar(product.title);
          }
          
          if (window.SoundSystem && window.SoundSystem.play) {
            var newTier = Math.min(state.selectedDigitalGoodies.length, 10);
            window.SoundSystem.setTier(newTier);
            window.SoundSystem.play('goodies-add');
          }
          
          // Auto-close popup after 2 seconds when adding
          setTimeout(function() {
            overlay.classList.remove('bb-goodies-popup-visible');
            setTimeout(function() { overlay.remove(); }, 300);
          }, 2000);
        } else {
          // Remove from selection
          var idx = state.selectedDigitalGoodies.findIndex(function(g) {
            return g.variantId == product.variantId;
          });
          if (idx >= 0) state.selectedDigitalGoodies.splice(idx, 1);
          addBtn.classList.remove('bb-popup-btn-selected');
          addBtn.innerHTML = '<span class="bb-goodies-plus">+</span> Add to Bundle';
          if (card) card.classList.remove('bb-goodies-selected');
          if (cardBtn) {
            cardBtn.classList.remove('bb-goodies-btn-selected');
            cardBtn.innerHTML = '<span class="bb-goodies-plus">+</span> Add to bundle';
          }
          if (window.SoundSystem && window.SoundSystem.play) {
            var newTier = Math.max(1, Math.min(state.selectedDigitalGoodies.length + 1, 10));
            window.SoundSystem.setTier(newTier);
            window.SoundSystem.play('goodies-remove');
          }
        }
        
        // Update calculations
        updateCalculation();
      });
      popup.appendChild(addBtn);
      
      overlay.appendChild(popup);
      document.body.appendChild(overlay);
      
      // Click overlay to close
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          overlay.classList.remove('bb-goodies-popup-visible');
          setTimeout(function() { overlay.remove(); }, 300);
        }
      });
      
      // Animate in
      setTimeout(function() {
        overlay.classList.add('bb-goodies-popup-visible');
      }, 10);
    }
    
    // Update all digital goodies card prices when tier changes
    function updateDigitalGoodiesPrices(newDiscount) {
      var cards = container.querySelectorAll('.bb-goodies-card');
      
      // Calculate tier number (0-5) for color
      var tierNum = 0;
      if (newDiscount >= 50) tierNum = 5;
      else if (newDiscount >= 40) tierNum = 4;
      else if (newDiscount >= 30) tierNum = 3;
      else if (newDiscount >= 20) tierNum = 2;
      else if (newDiscount >= 10) tierNum = 1;
      
      cards.forEach(function(card) {
        var price = parseFloat(card.dataset.price) || 0;
        
        var priceContainer = card.querySelector('.bb-goodies-price');
        if (!priceContainer) return;
        
        // Calculate discounted price
        var discountedPrice = price * (1 - newDiscount / 100);
        
        // Update tier data attribute for CSS color
        card.dataset.tier = tierNum;
        
        // Clear and rebuild price display
        priceContainer.innerHTML = '';
        
        // Original price (always show as strikethrough when there's a discount)
        if (newDiscount > 0) {
          var originalPriceEl = document.createElement('span');
          originalPriceEl.className = 'bb-goodies-compare-price';
          originalPriceEl.textContent = formatMoneyWithSymbol(price);
          priceContainer.appendChild(originalPriceEl);
        }
        
        // Discounted/current price with flash animation
        var currentPriceEl = document.createElement('span');
        currentPriceEl.className = 'bb-goodies-current-price bb-price-flash';
        currentPriceEl.textContent = formatMoneyWithSymbol(discountedPrice);
        priceContainer.appendChild(currentPriceEl);
        
        // Remove flash class after animation
        setTimeout(function() {
          currentPriceEl.classList.remove('bb-price-flash');
        }, 500);
        
        // Add discount label (red text) next to price
        if (newDiscount > 0) {
          var discountLabel = document.createElement('span');
          discountLabel.className = 'bb-goodies-discount-label bb-discount-flash';
          discountLabel.innerHTML = '-' + newDiscount + '<span class="bb-discount-percent">%</span>';
          priceContainer.appendChild(discountLabel);
          
          // Remove flash class after animation
          setTimeout(function() {
            discountLabel.classList.remove('bb-discount-flash');
          }, 500);
        }
      });
      
      console.log('[BB Digital Goodies] Prices updated with', newDiscount + '% discount (tier ' + tierNum + ')');
    }
    
    /**
     * Detect partial complete packages (digital + video selected, missing physical)
     * Returns array of mappings that are 2/3 complete
     */
    function detectPartialCompletePackages() {
      var partialPackages = [];
      
      completePackageMappings.forEach(function(mapping) {
        var hasDigital = state.selectedProducts.some(function(p) {
          return String(p.variantId) === String(mapping.digitalVariantId);
        });
        var hasVideo = state.selectedUpgrades.some(function(u) {
          return String(u.variantId) === String(mapping.videoVariantId);
        });
        var hasPhysical = state.selectedPhysical && state.selectedPhysical.some(function(p) {
          return String(p.variantId) === String(mapping.physicalVariantId);
        });
        
        // Has digital + video but NOT physical = partial package
        if (hasDigital && hasVideo && !hasPhysical) {
          partialPackages.push(mapping);
        }
      });
      
      return partialPackages;
    }
    
    // Update all physical card prices when tier changes
    function updatePhysicalPrices(newDiscount) {
      var cards = container.querySelectorAll('.bb-model-card');
      
      // Detect partial packages (digital + video selected, missing physical)
      var partialPackages = detectPartialCompletePackages();
      
      // Build lookup of physical variant IDs that would complete a package
      var freePhysicalVariants = {};
      partialPackages.forEach(function(pkg) {
        // Calculate savings: (digital + video + physical prices) - complete package price
        var digitalItem = state.selectedProducts.find(function(p) { return String(p.variantId) === String(pkg.digitalVariantId); });
        var videoItem = state.selectedUpgrades.find(function(u) { return String(u.variantId) === String(pkg.videoVariantId); });
        
        var componentsPrice = 0;
        if (digitalItem) componentsPrice += digitalItem.price;
        if (videoItem) componentsPrice += videoItem.price;
        
        // The "savings" is how much less the complete package costs vs buying separately
        // Since they already have digital + video, adding physical "for free" means
        // the package price minus what they've already selected
        var packagePrice = pkg.completePackagePrice;
        var alreadyPaying = componentsPrice;
        var savingsAmount = alreadyPaying - packagePrice; // Negative means they save money
        
        freePhysicalVariants[String(pkg.physicalVariantId)] = {
          deckName: pkg.deckName,
          savings: Math.abs(savingsAmount), // Show positive savings
          packagePrice: packagePrice
        };
      });
      
      // Calculate tier number (0-5) for color
      var tierNum = 0;
      if (newDiscount >= 50) tierNum = 5;
      else if (newDiscount >= 40) tierNum = 4;
      else if (newDiscount >= 30) tierNum = 3;
      else if (newDiscount >= 20) tierNum = 2;
      else if (newDiscount >= 10) tierNum = 1;
      
      cards.forEach(function(card) {
        var price = parseFloat(card.dataset.price) || 0;
        var variantId = card.dataset.variantId;
        
        var priceContainer = card.querySelector('.bb-model-price');
        if (!priceContainer) return;
        
        // Check if this physical card would complete a package
        var freeOffer = freePhysicalVariants[String(variantId)];
        
        // Remove any existing FREE label
        var existingFreeLabel = priceContainer.querySelector('.bb-model-free-label');
        if (existingFreeLabel) existingFreeLabel.remove();
        
        if (freeOffer) {
          // Show "FREE" instead of price!
          priceContainer.innerHTML = '';
          
          var freeLabel = document.createElement('div');
          freeLabel.className = 'bb-model-free-label';
          freeLabel.innerHTML = '<span class="bb-free-text">FREE</span>' +
            '<span class="bb-free-savings">Save ' + formatMoneyWithSymbol(freeOffer.savings) + '</span>';
          priceContainer.appendChild(freeLabel);
          
          // Add pulse class to card
          card.classList.add('bb-model-free-offer');
        } else {
          // Remove free offer class if present
          card.classList.remove('bb-model-free-offer');
          
          // Calculate discounted price
          var discountedPrice = price * (1 - newDiscount / 100);
          
          // Rebuild normal price display
          // Clear and rebuild if it was showing FREE
          var currentPriceEl = priceContainer.querySelector('.bb-model-current-price');
          if (!currentPriceEl) {
            // Rebuild price structure
            priceContainer.innerHTML = '';
            
            if (newDiscount > 0) {
              var comparePriceEl = document.createElement('span');
              comparePriceEl.className = 'bb-model-compare-price';
              comparePriceEl.textContent = formatMoneyWithSymbol(price);
              priceContainer.appendChild(comparePriceEl);
            }
            
            currentPriceEl = document.createElement('span');
            currentPriceEl.className = 'bb-model-current-price';
            priceContainer.appendChild(currentPriceEl);
            
            if (newDiscount > 0) {
              var badgeEl = document.createElement('span');
              badgeEl.className = 'bb-model-discount-badge';
              badgeEl.textContent = '-' + newDiscount + '%';
              priceContainer.appendChild(badgeEl);
            }
          }
          
          // Update current price
          currentPriceEl = priceContainer.querySelector('.bb-model-current-price');
          if (currentPriceEl) {
            currentPriceEl.textContent = formatMoneyWithSymbol(discountedPrice);
            currentPriceEl.style.setProperty('--model-price-color', 'var(--tier-' + tierNum + '-color, #00d4ff)');
            
            // Flash animation
            currentPriceEl.classList.add('bb-price-flash');
            setTimeout(function() {
              currentPriceEl.classList.remove('bb-price-flash');
            }, 400);
          }
          
          // Handle compare price (strikethrough)
          var comparePriceEl = priceContainer.querySelector('.bb-model-compare-price');
          if (newDiscount > 0) {
            if (!comparePriceEl) {
              // Create strikethrough
              comparePriceEl = document.createElement('span');
              comparePriceEl.className = 'bb-model-compare-price';
              comparePriceEl.textContent = formatMoneyWithSymbol(price);
              priceContainer.insertBefore(comparePriceEl, currentPriceEl);
            }
          } else if (comparePriceEl) {
            comparePriceEl.remove();
          }
          
          // Handle discount badge
          var badgeEl = priceContainer.querySelector('.bb-model-discount-badge');
          if (newDiscount > 0) {
            if (!badgeEl) {
              badgeEl = document.createElement('span');
              badgeEl.className = 'bb-model-discount-badge';
              priceContainer.appendChild(badgeEl);
            }
            badgeEl.textContent = '-' + newDiscount + '%';
          } else if (badgeEl) {
            badgeEl.remove();
          }
        }
      });
      
      console.log('[BB Physical] Prices updated with', newDiscount + '% discount (tier ' + tierNum + ')');
    }
    
    function toggleDigitalGoodieSelection(card, button, product) {
      var existingIndex = state.selectedDigitalGoodies.findIndex(function(g) {
        return g.variantId == product.variantId;
      });
      
      if (existingIndex >= 0) {
        // Deselect
        state.selectedDigitalGoodies.splice(existingIndex, 1);
        card.classList.remove('bb-goodies-selected');
        button.classList.remove('bb-goodies-btn-selected');
        button.innerHTML = '<span class="bb-goodies-plus">+</span> Add to bundle';
        
        if (window.SoundSystem && window.SoundSystem.play) {
          // Use dedicated goodies-remove sound (falls back to card-deselect if not uploaded)
          var newTier = Math.max(1, Math.min(state.selectedDigitalGoodies.length + 1, 10));
          window.SoundSystem.setTier(newTier);
          window.SoundSystem.play('goodies-remove');
        }
        console.log('[BB Digital Goodies] Removed:', product.title);
      } else {
        // Select
        state.selectedDigitalGoodies.push({
          variantId: product.variantId,
          productId: product.id,
          price: product.price,
          comparePrice: product.comparePrice || product.price,
          title: product.title,
          type: 'digital_goodies'
        });
        card.classList.add('bb-goodies-selected');
        button.classList.add('bb-goodies-btn-selected');
        button.innerHTML = '<span class="bb-goodies-check">✓</span> Added';
        
        // Show floating message for digital goodies
        if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.jumpMyAvatar) {
          MultiplayerSystem.jumpMyAvatar(product.title);
        }
        
        if (window.SoundSystem && window.SoundSystem.play) {
          // Use dedicated goodies-add sound (falls back to card-select if not uploaded)
          var newTier = Math.min(state.selectedDigitalGoodies.length, 10);
          window.SoundSystem.setTier(newTier);
          window.SoundSystem.play('goodies-add');
        }
        console.log('[BB Digital Goodies] Added:', product.title);
      }
      
      // Update totals
      updateCalculation();
    }
    
    function exitDigitalGoodiesMode() {
      isDigitalGoodiesMode = false;
      state.digitalGoodiesMode = false;
      
      console.log('[BB Digital Goodies] Exiting digital goodies mode');
      
      // Update button text back to Next (removes rainbow checkout styling)
      updateCalculation();
      
      // Remove digital-goodies-mode class, restore physical mode
      container.classList.remove('bb-in-digital-goodies-mode');
      container.classList.add('bb-in-physical-mode');
      
      var grid = container.querySelector('.bb-product-grid');
      var goodiesCarousel = container.querySelector('.bb-goodies-carousel');
      var modelCarousel = container.querySelector('.bb-model-carousel');
      
      // Fade out goodies carousel
      if (goodiesCarousel) {
        goodiesCarousel.classList.remove('bb-goodies-carousel-visible');
        goodiesCarousel.classList.add('bb-goodies-carousel-fade-out');
        
        setTimeout(function() {
          goodiesCarousel.remove();
        }, 400);
      }
      
      // Restore model carousel
      if (modelCarousel) {
        modelCarousel.style.display = '';
        modelCarousel.classList.remove('bb-carousel-fade-out');
        modelCarousel.classList.add('bb-carousel-visible');
        
        // RESTORE CAROUSEL STATE to physical mode
        if (carouselState.physicalTrack) {
          carouselState.track = carouselState.physicalTrack;
          carouselState.cards = carouselState.physicalCards;
          // FIX: Restore grid to .bb-product-grid where event listeners are attached
          // (model carousel is a CHILD of product-grid, not a replacement)
          carouselState.grid = container.querySelector('.bb-product-grid');
          
          // Reset carousel interaction state to prevent stuck state
          carouselState.isDragging = false;
          carouselState.wasDragging = false;
          carouselState.velocity = 0;
          carouselState.enabled = true;
          
          // Cancel any ongoing animations
          if (carouselState.animationFrame) {
            cancelAnimationFrame(carouselState.animationFrame);
            carouselState.animationFrame = null;
          }
          
          // Clear any transition locks
          carouselState.track.style.transition = '';
          
          // Update dimensions for physical carousel
          updateCarouselDimensions();
          calculateCarouselBounds();
          
          // Clamp position to valid bounds
          var clampedX = Math.max(carouselState.minX, Math.min(carouselState.maxX, carouselState.translateX || 0));
          carouselState.translateX = clampedX;
          carouselState.track.style.transform = 'translate3d(' + clampedX + 'px, 0, 0)';
          
          // Clean up any leftover drag classes
          carouselState.grid.classList.remove('is-scrolling', 'bb-carousel-dragging');
        }
      }
      
      // Animate title back to physical mode
      animateTitleBackToPhysicalMode();
      
      console.log('[BB Digital Goodies] Back to physical mode');
    }
    
    function animateTitleBackToPhysicalMode() {
      var stepTitle = container.querySelector('.bb-step-title');
      var stepDescription = container.querySelector('.bb-step-description');
      
      if (stepTitle && stepTitle.dataset.physicalText) {
        stepTitle.classList.add('bb-title-exit');
        
        setTimeout(function() {
          stepTitle.textContent = stepTitle.dataset.physicalText;
          stepTitle.classList.remove('bb-title-exit', 'bb-digital-goodies-title');
          stepTitle.classList.add('bb-title-enter', 'bb-physical-title');
          
          setTimeout(function() {
            stepTitle.classList.remove('bb-title-enter');
          }, 400);
        }, 300);
      }
      
      if (stepDescription && stepDescription.dataset.physicalText) {
        stepDescription.classList.add('bb-description-exit');
        
        setTimeout(function() {
          stepDescription.innerHTML = stepDescription.dataset.physicalText;
          stepDescription.classList.remove('bb-description-exit');
          stepDescription.classList.add('bb-description-enter');
          
          setTimeout(function() {
            stepDescription.classList.remove('bb-description-enter');
          }, 400);
        }, 300);
      }
    }

    function prevStep() {
      if (state.currentStep <= 1) return;
      goToStep(state.currentStep - 1);
    }

    function goToStep(stepNum) {
      // Hide current step - use .bb-step-container to be specific
      const currentContainer = container.querySelector('.bb-step-container[data-step="' + state.currentStep + '"]');
      if (currentContainer) {
        currentContainer.classList.add('bb-hidden');
      }
      
      // Show new step
      state.currentStep = stepNum;
      const newContainer = container.querySelector('.bb-step-container[data-step="' + state.currentStep + '"]');
      if (newContainer) {
        newContainer.classList.remove('bb-hidden');
      }
      
      // Update header nav
      updateHeaderNav();
      
      // Special step handling
      const stepType = newContainer ? newContainer.dataset.stepType : '';
      if (stepType === 'step_upgrades') {
        renderUpgradesStep();
      } else if (stepType === 'step_addons') {
        renderAddonsStep();
      } else if (stepType === 'step_summary') {
        renderSummary();
      }
      
      // Scroll to top
      els.container.scrollTo(0, 0);
    }

    function updateHeaderNav() {
      els.stepNavItems.forEach(function(item, index) {
        const stepNum = index + 1;
        item.classList.remove('active', 'completed');
        
        if (stepNum === state.currentStep) {
          item.classList.add('active');
        } else if (stepNum < state.currentStep) {
          item.classList.add('completed');
        }
      });
    }

    // ========================================================================
    // Dynamic Rendering
    // ========================================================================
    function renderUpgradesStep() {
      // Render upgrade options based on selected products using the DIGITAL_UPGRADE_MAP
      const listContainer = container.querySelector('.bb-digital-list');
      const emptyMessage = container.querySelector('.bb-upgrades-empty');
      
      if (!listContainer) return;
      
      // Clear existing dynamic items
      listContainer.querySelectorAll('.bb-upgrade-item').forEach(function(item) {
        item.remove();
      });
      
      if (state.selectedProducts.length === 0) {
        if (emptyMessage) emptyMessage.style.display = 'block';
        return;
      }
      
      if (emptyMessage) emptyMessage.style.display = 'none';
      
      // Render upgrades for selected products
      let totalOrigValue = 0;
      let totalBundlePrice = 0;
      let upgradesAvailable = 0;
      
      state.selectedProducts.forEach(function(product) {
        // Look up the digital upgrade from our mapping
        const upgradeMapping = DIGITAL_UPGRADE_MAP[product.title];
        
        if (!upgradeMapping) {
          console.log('No digital upgrade found for:', product.title);
          return; // Skip if no mapping exists
        }
        
        // Use prices from the upgrade mapping (variant data)
        const upgradePrice = upgradeMapping.price || 0;
        const upgradeComparePrice = upgradeMapping.comparePrice || upgradePrice;
        
        upgradesAvailable++;
        totalOrigValue += upgradeComparePrice;
        totalBundlePrice += upgradePrice;
        
        const item = document.createElement('div');
        item.className = 'bb-upgrade-item';
        item.dataset.variantId = upgradeMapping.variantId;
        item.dataset.baseProductId = product.productId;
        item.dataset.price = upgradePrice;
        item.dataset.comparePrice = upgradeComparePrice;
        item.dataset.title = upgradeMapping.title;
        item.dataset.cardType = 'upgrade';
        
        // Check if already selected
        const isSelected = state.selectedUpgrades.some(function(u) {
          return u.variantId === upgradeMapping.variantId;
        });
        if (isSelected) item.classList.add('selected');
        
        // Only show strike-through price if there's a compare price different from price
        const showComparePrice = upgradeComparePrice > upgradePrice;
        
        item.innerHTML = `
          <div class="bb-upgrade-content">
            <div class="bb-upgrade-icon">▶</div>
            <div class="bb-upgrade-info">
              <div class="bb-upgrade-title">${upgradeMapping.title}</div>
              <div class="bb-upgrade-subtitle">Video masterclass + templates</div>
            </div>
            <div class="bb-upgrade-pricing">
              ${showComparePrice ? `<span class="strike">${formatMoneyNoDecimals(upgradeComparePrice)}</span>` : ''}
              <span class="text-green">${formatMoneyNoDecimals(upgradePrice)}</span>
            </div>
            <div class="bb-toggle-switch">
              <div class="bb-toggle-track">
                <div class="bb-toggle-thumb"></div>
              </div>
            </div>
          </div>
        `;
        
        item.addEventListener('click', function() {
          toggleUpgrade(item);
        });
        
        listContainer.appendChild(item);
      });
      
      // Hide hero if no upgrades available
      const heroEl = container.querySelector('.bb-upgrade-hero');
      if (heroEl) {
        heroEl.style.display = upgradesAvailable > 0 ? 'flex' : 'none';
      }
      
      // Update hero pricing with actual totals
      updateUpgradeHero(totalOrigValue, totalBundlePrice);
    }

    function updateUpgradeHero(totalOrig, totalPrice) {
      const origEl = container.querySelector('[id^="bb-digital-hero-orig"]');
      const priceEl = container.querySelector('[id^="bb-digital-hero-price"]');
      
      if (origEl && priceEl) {
        // Use passed values if available, otherwise calculate
        if (totalOrig === undefined || totalPrice === undefined) {
          totalOrig = 0;
          totalPrice = 0;
          
          state.selectedProducts.forEach(function(p) {
            totalOrig += p.price;
            totalPrice += Math.round(p.price * 0.3);
          });
        }
        
        origEl.textContent = formatMoney(totalOrig);
        priceEl.textContent = formatMoney(totalPrice);
      }
    }

    // ========================================================================
    // Physical Add-ons Step (Step 3)
    // Shows the LAST variant (Physical) of products selected in Step 1
    // ========================================================================
    function renderAddonsStep() {
      const gridContainer = container.querySelector('.bb-addon-grid');
      const emptyMessage = container.querySelector('.bb-addons-empty');
      
      if (!gridContainer) return;
      
      // Clear existing dynamic cards
      gridContainer.querySelectorAll('.bb-product-card').forEach(function(card) {
        card.remove();
      });
      
      if (state.selectedProducts.length === 0) {
        if (emptyMessage) emptyMessage.style.display = 'block';
        return;
      }
      
      if (emptyMessage) emptyMessage.style.display = 'none';
      
      // Get pre-rendered physical variant data
      const variantDataEl = container.querySelector('[id^="bb-physical-variants"]');
      let physicalVariants = { variants: [] };
      if (variantDataEl) {
        try {
          physicalVariants = JSON.parse(variantDataEl.textContent);
        } catch (e) {
          console.error('Failed to parse physical variants data:', e);
        }
      }
      
      // Render a card for each selected product's physical variant
      state.selectedProducts.forEach(function(selectedProduct) {
        // Find the physical (last) variant for this product
        const physicalData = physicalVariants.variants.find(function(v) {
          return v.productId == selectedProduct.productId;
        });
        
        if (!physicalData) {
          console.log('No physical variant data found for:', selectedProduct.title);
          return;
        }
        
        // Check if already selected as addon
        const isSelected = state.selectedAddons.some(function(a) {
          return a.variantId == physicalData.variantId;
        });
        
        // Create card element
        const card = document.createElement('div');
        card.className = 'bb-product-card' + (isSelected ? ' selected' : '');
        card.dataset.productId = physicalData.productId;
        card.dataset.variantId = physicalData.variantId;
        card.dataset.price = physicalData.price;
        card.dataset.comparePrice = physicalData.comparePrice;
        card.dataset.title = physicalData.productTitle;
        card.dataset.variantTitle = physicalData.variantTitle;
        card.dataset.handle = physicalData.handle;
        card.dataset.cardType = 'addon';
        card.dataset.available = physicalData.available;
        
        const imageContent = physicalData.image 
          ? `<img src="${physicalData.image}" alt="${physicalData.productTitle}" class="bb-prod-img" loading="lazy" width="400" height="400">`
          : `<div class="bb-prod-img bb-no-image"><span>📦</span></div>`;
        
        const variantNameHtml = physicalData.variantTitle && physicalData.variantTitle !== 'Default Title'
          ? `<p class="bb-variant-name">${physicalData.variantTitle}</p>`
          : '';
        
        card.innerHTML = `
          <div class="bb-selection-check"></div>
          <div class="bb-card-main">
            <div class="bb-prod-img-wrapper">
              ${imageContent}
            </div>
            <div class="bb-prod-info">
              <h3 class="bb-prod-title">${physicalData.productTitle}</h3>
              ${variantNameHtml}
              <div class="bb-prod-price-wrapper">
                ${physicalData.comparePrice > physicalData.price 
                  ? `<span class="bb-prod-compare-price strike">${formatMoneyWithSymbol(physicalData.comparePrice)}</span>` 
                  : ''}
                <span class="bb-prod-price">${formatMoneyWithSymbol(physicalData.price)}</span>
              </div>
            </div>
          </div>
        `;
        
        // Add click handler
        card.addEventListener('click', function() {
          toggleSelection(card, 'addon');
        });
        
        gridContainer.appendChild(card);
      });
    }

    function renderSummary() {
      const itemsContainer = container.querySelector('.bb-summary-items');
      const savingsEl = container.querySelector('[id^="bb-final-savings"]');
      const totalEl = container.querySelector('[id^="bb-summary-price"]');
      
      if (!itemsContainer) return;
      
      itemsContainer.innerHTML = '';
      
      let totalValue = 0;
      let totalPay = 0;
      
      // Add products
      state.selectedProducts.forEach(function(p) {
        const discountedPrice = p.price * (1 - state.discountTier / 100);
        totalValue += p.comparePrice || p.price;
        totalPay += discountedPrice;
        
        addSummaryItem(itemsContainer, p.title + ' (' + state.discountTier + '% off)', discountedPrice);
      });
      
      // Add upgrades (with tier discount)
      state.selectedUpgrades.forEach(function(u) {
        const discountedPrice = u.price * (1 - state.discountTier / 100);
        totalValue += u.comparePrice || u.price;
        totalPay += discountedPrice;
        
        addSummaryItem(itemsContainer, u.title + ' (' + state.discountTier + '% off)', discountedPrice);
      });
      
      // Add addons
      state.selectedAddons.forEach(function(a) {
        totalValue += a.comparePrice || a.price;
        totalPay += a.price;
        
        addSummaryItem(itemsContainer, a.title, a.price);
      });
      
      // Add vault items
      state.selectedVault.forEach(function(v) {
        totalValue += v.comparePrice || v.price;
        totalPay += v.price;
        
        addSummaryItem(itemsContainer, 'Vault: ' + v.title, v.price);
      });
      
      const savings = totalValue - totalPay;
      
      if (savingsEl) savingsEl.textContent = formatMoney(savings);
      if (totalEl) totalEl.textContent = formatMoney(totalPay);
      
      // Show empty message if nothing selected
      if (state.selectedProducts.length === 0) {
        itemsContainer.innerHTML = '<p class="bb-summary-empty">Your bundle is empty. Go back and select some products.</p>';
      }
    }

    function addSummaryItem(container, name, price) {
      const item = document.createElement('div');
      item.className = 'bb-summary-item';
      item.innerHTML = `
        <span class="bb-summary-item-name">${name}</span>
        <span class="bb-summary-item-price">${price === 0 ? 'FREE' : formatMoneyWithSymbol(price)}</span>
      `;
      container.appendChild(item);
    }

    function updateSummary(totalPay, savings) {
      const savingsEl = container.querySelector('[id^="bb-final-savings"]');
      const totalEl = container.querySelector('[id^="bb-summary-price"]');
      
      if (savingsEl) savingsEl.textContent = formatMoney(savings);
      if (totalEl) totalEl.textContent = formatMoney(totalPay);
    }

    // ========================================================================
    // Checkout
    // ========================================================================
    // Exchange rates for normalizing savings to GBP
    var EXCHANGE_TO_GBP = {
      'GBP': 1,
      'USD': 0.79,
      'EUR': 0.86,
      'AUD': 0.52,
      'CAD': 0.59,
      'NZD': 0.48,
      'JPY': 0.0053,
      'CHF': 0.89
    };
    
    function normalizeToGBP(amount, currency) {
      var rate = EXCHANGE_TO_GBP[currency] || 1;
      return Math.round(amount * rate);
    }
    
    async function handleCheckout() {
      // Play satisfying checkout sound immediately
      if (window.SoundSystem && window.SoundSystem.play) {
        window.SoundSystem.play('checkout-click');
      }
      
      // Also handle the rainbow checkout button in digital goodies mode
      const checkoutBtn = container.querySelector('[data-action="checkout"]');
      const rainbowBtn = container.querySelector('.bb-btn-checkout-rainbow');
      const btnToUpdate = rainbowBtn || checkoutBtn;
      
      // Store original content and add loading state with "BUILDING" text
      var originalContent = '';
      if (btnToUpdate) {
        originalContent = btnToUpdate.innerHTML;
        btnToUpdate.disabled = true;
        btnToUpdate.classList.add('bb-checkout-loading');
        // Set BUILDING text that will show above the rainbow gradient
        btnToUpdate.innerHTML = '<span class="bb-checkout-building-text">BUILDING...</span>';
      }
      if (checkoutBtn && checkoutBtn !== btnToUpdate) {
        checkoutBtn.disabled = true;
      }
      
      // Get player info for leaderboard
      var playerName = window.BB && window.BB.Player ? window.BB.Player.getName() : 'Anonymous';
      var playerSprite = window.BB && window.BB.Player ? window.BB.Player.getSprite() : { chainId: 'feline', emoji: '🐱' };
      var team = playerSprite.chainId || 'feline';
      
      try {
        // Collect all items to add
        const items = [];
        
        // Calculate savings for leaderboard
        var totalValue = 0;
        var totalPay = 0;
        
        // ================================================================
        // COMPLETE PACKAGE DETECTION - Swap components for bundle product
        // ================================================================
        var detectedPackages = detectCompletePackages();
        var skipVariantIds = {
          products: [],
          upgrades: [],
          physical: []
        };
        
        // Add Complete Package items and mark components for skipping
        detectedPackages.forEach(function(pkg) {
          console.log('[BB Checkout] Complete Package detected:', pkg.deckName);
          
          // Mark component variant IDs to skip
          skipVariantIds.products.push(String(pkg.digitalVariantId));
          skipVariantIds.upgrades.push(String(pkg.videoVariantId));
          skipVariantIds.physical.push(String(pkg.physicalVariantId));
          
          // Calculate savings: components price vs Complete Package price
          var componentsPrice = 0;
          var digitalItem = state.selectedProducts.find(function(p) { return String(p.variantId) === String(pkg.digitalVariantId); });
          var videoItem = state.selectedUpgrades.find(function(u) { return String(u.variantId) === String(pkg.videoVariantId); });
          var physicalItem = state.selectedPhysical && state.selectedPhysical.find(function(p) { return String(p.variantId) === String(pkg.physicalVariantId); });
          
          if (digitalItem) componentsPrice += digitalItem.comparePrice || digitalItem.price;
          if (videoItem) componentsPrice += videoItem.comparePrice || videoItem.price;
          if (physicalItem) componentsPrice += physicalItem.comparePrice || physicalItem.price;
          
          // Use Complete Package price (apply tier discount to it)
          var packagePrice = pkg.completePackagePrice || componentsPrice;
          totalValue += componentsPrice; // Original value is sum of components
          totalPay += packagePrice * (1 - state.discountTier / 100);
          
          // Add the Complete Package variant to cart
          items.push({
            id: parseInt(pkg.completePackageVariantId),
            quantity: 1,
            properties: {
              '_bundle_session': state.bundleSessionId,
              '_bundle_discount_tier': state.discountTier + '%',
              '_bundle_type': 'complete_package',
              '_bb_team': team,
              '_bb_deck': pkg.deckName
            }
          });
          
          console.log('[BB Checkout] Added Complete Package:', pkg.deckName, 'variant:', pkg.completePackageVariantId, 'price:', packagePrice / 100);
        });
        
        // ================================================================
        // Products (skip those that are part of Complete Packages)
        // ================================================================
        state.selectedProducts.forEach(function(p) {
          // Skip if this product is part of a Complete Package
          if (skipVariantIds.products.indexOf(String(p.variantId)) !== -1) {
            console.log('[BB Checkout] Skipping product (in Complete Package):', p.title);
            return;
          }
          
          totalValue += p.comparePrice || p.price;
          totalPay += p.price * (1 - state.discountTier / 100);
          
          items.push({
            id: parseInt(p.variantId),
            quantity: 1,
            properties: {
              '_bundle_session': state.bundleSessionId,
              '_bundle_discount_tier': state.discountTier + '%',
              '_bundle_type': 'product',
              '_bb_team': team
            }
          });
        });
        
        // ================================================================
        // Upgrades (skip those that are part of Complete Packages)
        // ================================================================
        state.selectedUpgrades.forEach(function(u) {
          // Skip if this upgrade is part of a Complete Package
          if (skipVariantIds.upgrades.indexOf(String(u.variantId)) !== -1) {
            console.log('[BB Checkout] Skipping upgrade (in Complete Package):', u.title);
            return;
          }
          
          totalValue += u.comparePrice || u.price;
          totalPay += u.price * (1 - state.discountTier / 100);
          
          if (u.variantId && !u.variantId.includes('-upgrade')) {
            items.push({
              id: parseInt(u.variantId),
              quantity: 1,
              properties: {
                '_bundle_session': state.bundleSessionId,
                '_bundle_discount_tier': state.discountTier + '%',
                '_bundle_type': 'upgrade',
                '_bb_team': team
              }
            });
          }
        });
        
        // Addons
        state.selectedAddons.forEach(function(a) {
          totalValue += a.comparePrice || a.price;
          totalPay += a.price;
          
          items.push({
            id: parseInt(a.variantId),
            quantity: 1,
            properties: {
              '_bundle_session': state.bundleSessionId,
              '_bundle_type': 'addon',
              '_bb_team': team
            }
          });
        });
        
        // Vault items
        state.selectedVault.forEach(function(v) {
          totalValue += v.comparePrice || v.price;
          totalPay += v.price;
          
          items.push({
            id: parseInt(v.variantId),
            quantity: 1,
            properties: {
              '_bundle_session': state.bundleSessionId,
              '_bundle_type': 'vault',
              '_bb_team': team
            }
          });
        });
        
        // Digital goodies
        if (state.selectedDigitalGoodies && state.selectedDigitalGoodies.length > 0) {
          state.selectedDigitalGoodies.forEach(function(g) {
            totalValue += g.comparePrice || g.price;
            totalPay += g.price;
            
            items.push({
              id: parseInt(g.variantId),
              quantity: 1,
              properties: {
                '_bundle_session': state.bundleSessionId,
                '_bundle_type': 'digital_goodies',
                '_bb_team': team
              }
            });
          });
        }
        
        // Physical deck selections (with tier discount, skip those in Complete Packages)
        if (state.selectedPhysical && state.selectedPhysical.length > 0) {
          state.selectedPhysical.forEach(function(p) {
            // Skip if this physical deck is part of a Complete Package
            if (skipVariantIds.physical.indexOf(String(p.variantId)) !== -1) {
              console.log('[BB Checkout] Skipping physical (in Complete Package):', p.title);
              return;
            }
            
            var qty = p.quantity || 1;
            totalValue += (p.comparePrice || p.price) * qty;
            totalPay += p.price * qty * (1 - state.discountTier / 100);
            
            items.push({
              id: parseInt(p.variantId),
              quantity: qty,
              properties: {
                '_bundle_session': state.bundleSessionId,
                '_bundle_discount_tier': state.discountTier + '%',
                '_bundle_type': 'physical',
                '_bb_team': team
              }
            });
          });
        }
        
        // ================================================================
        // DISCOUNT CODE CALCULATION - Based on virtual item count
        // ================================================================
        // Complete Packages count as 3 items (Digital + Video + Physical)
        // We calculate the correct tier and apply the matching discount code
        // This replaces the old phantom item approach
        //
        // Tiers:
        //   2+ items → CYBERFUNDAY20 (20% off)
        //   3+ items → CYBERFUNDAY30 (30% off)
        //   4+ items → CYBERFUNDAY40 (40% off)
        //   5+ items → CYBERFUNDAY50 (50% off)
        // ================================================================
        var numCompletePackages = detectedPackages.length;
        var currentLineItems = items.length;
        
        // Each Complete Package represents 3 items (Digital + Video + Physical)
        var virtualItemsFromPackages = numCompletePackages * 3;
        
        // Other line items (not part of Complete Packages) count as 1 each
        var otherLineItems = currentLineItems - numCompletePackages;
        
        // Total virtual items for tier calculation
        var totalVirtualItems = virtualItemsFromPackages + otherLineItems;
        
        // Determine discount code based on virtual items
        var discountCode = '';
        if (totalVirtualItems >= 5) {
          discountCode = 'CYBERFUNDAY50';
        } else if (totalVirtualItems === 4) {
          discountCode = 'CYBERFUNDAY40';
        } else if (totalVirtualItems === 3) {
          discountCode = 'CYBERFUNDAY30';
        } else if (totalVirtualItems >= 2) {
          discountCode = 'CYBERFUNDAY20';
        }
        
        console.log('[BB Discount] Complete Packages:', numCompletePackages);
        console.log('[BB Discount] Current line items:', currentLineItems);
        console.log('[BB Discount] Virtual items from CPs:', virtualItemsFromPackages);
        console.log('[BB Discount] Other line items:', otherLineItems);
        console.log('[BB Discount] Total virtual items:', totalVirtualItems);
        console.log('[BB Discount] Discount code to apply:', discountCode || 'NONE (less than 2 items)');
        
        // ================================================================
        // FREE HAT - Add for UK customers if cart meets minimum
        // ================================================================
        if (userCountry === 'gb' && config.freeHatEnabled && selectedHatVariant && selectedHatVariant.available) {
          // Calculate cart total (before discounts)
          if (totalValue >= config.freeHatMinCart) {
            items.push({
              id: parseInt(selectedHatVariant.id),
              quantity: 1,
              properties: {
                '_bundle_session': state.bundleSessionId,
                '_bundle_type': 'free_hat_promo',
                '_bb_team': team,
                '_free_hat': 'true',
                '_hat_variant': selectedHatVariant.title
              }
            });
            console.log('[BB Free Hat] ✓ Added free hat to cart:', selectedHatVariant.title);
          } else {
            console.log('[BB Free Hat] Cart value', totalValue, 'below minimum', config.freeHatMinCart, '- hat not added');
          }
        }
        
        if (items.length === 0) {
          alert('Please select at least one product.');
          if (checkoutBtn) {
            checkoutBtn.disabled = false;
            checkoutBtn.textContent = 'Complete Checkout';
          }
          return;
        }
        
        // Calculate savings for cart attributes and leaderboard
        var savingsInLocalCurrency = Math.round((totalValue - totalPay) / 100);
        var savingsInGBP = normalizeToGBP(savingsInLocalCurrency, config.currency);
        
        // *** RECORD TO LEADERBOARD - This is the ONLY place savings are recorded ***
        if (savingsInGBP > 0) {
          recordSavingsToLeaderboard(team, savingsInGBP, savingsInLocalCurrency, config.currency, playerName);
          console.log('🏆 [Checkout] Recorded savings to leaderboard:', savingsInGBP, 'GBP for team', team);
        }
        
        // *** TRIGGER FLY-OFF ANIMATION - Show other users this person checked out ***
        if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.flyOff) {
          MultiplayerSystem.flyOff(savingsInLocalCurrency);
          console.log('🚀 [Checkout] Triggered fly-off animation:', savingsInLocalCurrency);
        }
        
        // Debug: log items being added to cart
        console.log('[BB Checkout] Items to add:', JSON.stringify(items, null, 2));
        console.log('[BB Checkout] Total items:', items.length);
        
        // Validate all items have valid variant IDs
        const invalidItems = items.filter(item => !item.id || isNaN(item.id));
        if (invalidItems.length > 0) {
          console.error('[BB Checkout] Invalid items found:', invalidItems);
        }
        
        // Step 1: Clear existing cart to ensure fresh bundle
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        
        // Step 2: Add items to cart with team attribute
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ 
            items: items,
            attributes: {
              'bb_team': team,
              'bb_player_name': playerName,
              'bb_savings_local': savingsInLocalCurrency.toString(),
              'bb_savings_gbp': savingsInGBP.toString(),
              'bb_currency': config.currency
            }
          })
        });
        
        const responseData = await response.json().catch(() => null);
        console.log('[BB Checkout] Cart response:', response.status, responseData);
        
        if (!response.ok) {
          console.error('[BB Checkout] Cart add failed:', response.status, responseData);
          throw new Error('Failed to add items to cart: ' + JSON.stringify(responseData));
        }
        
        // Step 3: Wait for Shopify to apply automatic discount rules
        // Fetch cart to trigger discount calculation
        await fetch('/cart.js', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        
        // Small delay to ensure Shopify has time to process
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // Clear saved selections since we're checking out
        clearBundleStorage();
        
        // Step 4: Redirect to checkout with discount code
        var checkoutUrl = '/checkout';
        if (discountCode) {
          checkoutUrl += '?discount=' + discountCode;
          console.log('[BB Discount] ✓ Redirecting with discount code:', discountCode);
        }
        window.location.href = checkoutUrl;
        
      } catch (error) {
        console.error('Checkout error:', error);
        // Show more helpful error message
        var errorMsg = 'There was an error adding items to your cart. Please try again.';
        if (error.message && error.message.includes('sold out')) {
          // Extract product name from error
          var match = error.message.match(/"([^"]+)" is already sold out/);
          if (match) {
            errorMsg = 'Sorry, "' + match[1] + '" is sold out. Please deselect it and try again.';
          } else {
            errorMsg = 'One of your selected items is sold out. Please check your selections and try again.';
          }
        }
        alert(errorMsg);
        
        if (btnToUpdate) {
          btnToUpdate.disabled = false;
          btnToUpdate.classList.remove('bb-checkout-loading');
          if (originalContent) {
            btnToUpdate.innerHTML = originalContent;
          }
        }
        if (checkoutBtn && checkoutBtn !== btnToUpdate) {
          checkoutBtn.disabled = false;
        }
      }
    }
    
    // Record savings to Firebase leaderboard
    async function recordSavingsToLeaderboard(team, savingsGBP, savingsLocal, currency, playerName) {
      try {
        var response = await fetch('https://us-central1-pipdecksapp.cloudfunctions.net/recordSavings', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            team: team,
            savings: savingsGBP,
            displaySavings: savingsLocal,
            currency: currency,
            playerName: playerName,
            odId: playerName
          })
        });
        
        if (response.ok) {
          console.log('🏆 Savings recorded to leaderboard:', savingsGBP, 'GBP for team', team);
        }
      } catch (e) {
        console.warn('Failed to record savings:', e);
      }
    }

    // ========================================================================
    // Team Leaderboard
    // ========================================================================
    var TEAM_EMOJI = {
      'feline': '🐱',
      'amphibian': '🐸',
      'mammal': '🐰',
      'avian': '🐣'
    };
    
    var TEAM_NAMES = {
      'feline': 'Team Cat',
      'amphibian': 'Team Frog',
      'mammal': 'Team Rabbit',
      'avian': 'Team Bird'
    };
    
    async function initLeaderboard() {
      // #region agent log - H9 Firebase leaderboard tracking
      if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initLeaderboard', 'Leaderboard init started', {}, 'H9');
      // #endregion
      
      // Fetch initial leaderboard data
      fetchLeaderboard();
      
      // Set up Firebase real-time listener for leaderboard updates
      try {
        // #region agent log - H9 Firebase import tracking
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initLeaderboard', 'Starting Firebase imports', {}, 'H9');
        // #endregion
        var firebase = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js');
        // #region agent log - H9 Firebase import tracking
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initLeaderboard', 'Firebase app imported', {}, 'H9');
        // #endregion
        var firebaseDatabase = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-database.js');
        // #region agent log - H9 Firebase import tracking
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initLeaderboard', 'Firebase database imported', {}, 'H9');
        // #endregion
        
        var firebaseConfig = {
          apiKey: "AIzaSyBXqjZCjJ9vLj1L_mpjZ6_G8BMcKl9PMys",
          authDomain: "pipdecksapp.firebaseapp.com",
          databaseURL: "https://pipdecksapp-default-rtdb.firebaseio.com",
          projectId: "pipdecksapp"
        };
        
        var app;
        try {
          app = firebase.getApp('bb-leaderboard');
        } catch {
          app = firebase.initializeApp(firebaseConfig, 'bb-leaderboard');
        }
        
        var db = firebaseDatabase.getDatabase(app);
        var leaderboardRef = firebaseDatabase.ref(db, 'leaderboard');
        
        // #region agent log - H9 Firebase listener tracking
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initLeaderboard', 'Setting up Firebase listener', {}, 'H9');
        // #endregion
        firebaseDatabase.onValue(leaderboardRef, function(snapshot) {
          // #region agent log - H9 Firebase data received
          window._bbFirebaseConnected = true;
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:onValue', 'Firebase data received', { dataKeys: Object.keys(snapshot.val() || {}).length }, 'H9');
          // #endregion
          var data = snapshot.val() || {};
          renderLeaderboard(data);
        });
        
        console.log('🏆 Leaderboard connected to Firebase');
        
      } catch (e) {
        // #region agent log - H9 Firebase error
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initLeaderboard', 'Firebase error', { error: String(e).substring(0, 100) }, 'H9');
        // #endregion
        console.warn('Leaderboard Firebase connection failed, using polling:', e);
        // Fallback to polling every 30 seconds
        setInterval(fetchLeaderboard, 30000);
      }
    }
    
    async function fetchLeaderboard() {
      try {
        var response = await fetch('https://us-central1-pipdecksapp.cloudfunctions.net/getLeaderboard');
        var data = await response.json();
        
        if (data.leaderboard) {
          var leaderboardObj = {};
          data.leaderboard.forEach(function(item) {
            leaderboardObj[item.team] = {
              totalSavings: item.totalSavings,
              checkoutCount: item.checkoutCount
            };
          });
          renderLeaderboard(leaderboardObj);
        }
      } catch (e) {
        console.warn('Failed to fetch leaderboard:', e);
      }
    }
    
    // Track previous leaderboard state for animations
    var previousLeaderboardState = {};
    var leaderboardAnimationState = {
      isAnimating: false,
      animationTimeout: null,
      pendingUpdate: null,
      cooldownMs: 400 // Minimum time between animations
    };
    
    function renderLeaderboard(data) {
      var teamsContainer = document.getElementById('bb-leaderboard-teams-' + sectionId);
      var leaderboardEl = document.getElementById('bb-leaderboard-' + sectionId);
      if (!teamsContainer || !leaderboardEl) return;
      
      // If animation is in progress, queue this update
      if (leaderboardAnimationState.isAnimating) {
        leaderboardAnimationState.pendingUpdate = data;
        return;
      }
      
      // Get current player's team
      var myTeam = window.BB && window.BB.Player ? window.BB.Player.getSprite().chainId : null;
      
      // Sort teams by savings
      var teams = Object.entries(data)
        .map(function(entry) { return { team: entry[0], data: entry[1] }; })
        .sort(function(a, b) { return (b.data.totalSavings || 0) - (a.data.totalSavings || 0); });
      
      // Ensure all 4 teams are represented
      var allTeams = ['feline', 'amphibian', 'mammal', 'avian'];
      allTeams.forEach(function(teamId) {
        if (!teams.find(function(t) { return t.team === teamId; })) {
          teams.push({ team: teamId, data: { totalSavings: 0, checkoutCount: 0 } });
        }
      });
      
      // Re-sort after adding missing teams
      teams.sort(function(a, b) { return (b.data.totalSavings || 0) - (a.data.totalSavings || 0); });
      
      // Detect position changes for animation
      var positionChanges = {};
      var hasChanges = false;
      teams.forEach(function(item, index) {
        var prevRank = previousLeaderboardState[item.team];
        var newRank = index + 1;
        if (prevRank !== undefined && prevRank !== newRank) {
          positionChanges[item.team] = { 
            from: prevRank, 
            to: newRank, 
            direction: prevRank > newRank ? 'up' : 'down',
            tookCrown: newRank === 1 && prevRank !== 1
          };
          hasChanges = true;
        }
        previousLeaderboardState[item.team] = newRank;
      });
      
      // Mark animation in progress if we have position changes
      if (hasChanges) {
        leaderboardAnimationState.isAnimating = true;
        
        // Clear any existing timeout
        if (leaderboardAnimationState.animationTimeout) {
          clearTimeout(leaderboardAnimationState.animationTimeout);
        }
      }
      
      // Determine winner for persistent glow
      var winnerTeam = teams[0] ? teams[0].team : null;
      
      // Render full leaderboard (for desktop and expanded mobile)
      teamsContainer.innerHTML = teams.map(function(item, index) {
        var rankClass = index === 0 ? 'rank-1' : (index === 1 ? 'rank-2' : (index === 2 ? 'rank-3' : ''));
        var isMyTeam = item.team === myTeam ? ' my-team' : '';
        var savings = item.data.totalSavings || 0;
        var change = positionChanges[item.team];
        var animClass = change ? ' bb-rank-' + change.direction : '';
        var crownClass = change && change.tookCrown ? ' bb-took-crown' : '';
        var winnerClass = item.team === winnerTeam ? ' bb-winner' : '';
        
        return '<div class="bb-leaderboard-team' + isMyTeam + animClass + crownClass + winnerClass + '" data-team="' + item.team + '">' +
          '<div class="bb-leaderboard-team-info">' +
            '<span class="bb-leaderboard-rank ' + rankClass + '">#' + (index + 1) + '</span>' +
            '<span class="bb-leaderboard-emoji">' + (TEAM_EMOJI[item.team] || '❓') + '</span>' +
            '<span class="bb-leaderboard-name">' + (TEAM_NAMES[item.team] || item.team) + '</span>' +
          '</div>' +
          '<span class="bb-leaderboard-savings">£' + savings.toLocaleString() + '</span>' +
        '</div>';
      }).join('');
      
      // Render minimal podium view (for mobile)
      var minimalContainer = leaderboardEl.querySelector('.bb-leaderboard-minimal');
      if (!minimalContainer) {
        minimalContainer = document.createElement('div');
        minimalContainer.className = 'bb-leaderboard-minimal';
        leaderboardEl.appendChild(minimalContainer);
      }
      
      minimalContainer.innerHTML = teams.map(function(item, index) {
        var rank = index + 1;
        var savings = item.data.totalSavings || 0;
        var formattedSavings = savings >= 1000 ? config.currencySymbol + Math.round(savings / 1000) + 'k' : config.currencySymbol + savings;
        var change = positionChanges[item.team];
        var animClass = change ? ' bb-rank-' + change.direction : '';
        var crownClass = change && change.tookCrown ? ' bb-took-crown' : '';
        var winnerClass = item.team === winnerTeam ? ' bb-winner' : '';
        
        return '<div class="bb-leaderboard-podium' + animClass + crownClass + winnerClass + '" data-rank="' + rank + '" data-team="' + item.team + '">' +
          '<span class="bb-podium-medal medal-' + rank + '">' + rank + '</span>' +
          '<span class="bb-podium-price">' + formattedSavings + '</span>' +
          '<div class="bb-podium-emoji-wrap">' +
            '<span class="bb-podium-emoji">' + (TEAM_EMOJI[item.team] || '❓') + '</span>' +
          '</div>' +
        '</div>';
      }).join('');
      
      // Parse emojis with Twemoji for consistent rendering
      if (window.twemoji) {
        window.twemoji.parse(teamsContainer, { folder: 'svg', ext: '.svg', className: 'twemoji' });
        window.twemoji.parse(minimalContainer, { folder: 'svg', ext: '.svg', className: 'twemoji' });
      }
      
      // Add close button if not exists
      var closeBtn = leaderboardEl.querySelector('.bb-leaderboard-close');
      if (!closeBtn) {
        closeBtn = document.createElement('button');
        closeBtn.className = 'bb-leaderboard-close';
        closeBtn.setAttribute('aria-label', 'Close leaderboard');
        leaderboardEl.appendChild(closeBtn);
      }
      
      // Handle animation completion and cooldown
      if (hasChanges) {
        leaderboardAnimationState.animationTimeout = setTimeout(function() {
          // Remove animation classes but keep winner glow
          var animatedEls = leaderboardEl.querySelectorAll('.bb-rank-up, .bb-rank-down, .bb-took-crown');
          animatedEls.forEach(function(el) {
            el.classList.remove('bb-rank-up', 'bb-rank-down', 'bb-took-crown');
          });
          
          // Mark animation complete
          leaderboardAnimationState.isAnimating = false;
          
          // Process any pending update
          if (leaderboardAnimationState.pendingUpdate) {
            var pending = leaderboardAnimationState.pendingUpdate;
            leaderboardAnimationState.pendingUpdate = null;
            renderLeaderboard(pending);
          }
        }, leaderboardAnimationState.cooldownMs);
      }
    }
    
    // Leaderboard debug data (used by debug panel)
    var leaderboardDebugData = {
      feline: 0,
      amphibian: 38,
      mammal: 0,
      avian: 0
    };
    
    // Leaderboard toggle handlers
    function initLeaderboardToggle() {
      var leaderboardEl = document.getElementById('bb-leaderboard-' + sectionId);
      if (!leaderboardEl) return;
      
      // Drag state for desktop
      var dragState = {
        isDragging: false,
        startX: 0,
        startY: 0,
        startLeft: 0,
        startTop: 0
      };
      
      // Create backdrop for click-outside-to-dismiss (mobile)
      // Insert BEFORE the leaderboard so z-index stacking works correctly
      var backdrop = document.createElement('div');
      backdrop.className = 'bb-leaderboard-backdrop';
      leaderboardEl.parentNode.insertBefore(backdrop, leaderboardEl);
      
      // Helper to close leaderboard
      function closeLeaderboard() {
        leaderboardEl.classList.remove('expanded');
        backdrop.classList.remove('visible');
        // Reset position and transform when closing
        leaderboardEl.style.left = '';
        leaderboardEl.style.top = '';
        leaderboardEl.style.transform = '';
      }
      
      // Click on backdrop to close (mobile)
      backdrop.addEventListener('click', function(e) {
        e.stopPropagation();
        closeLeaderboard();
      });
      
      // Click on minimal view to expand (both desktop and mobile)
      leaderboardEl.addEventListener('click', function(e) {
        // Don't expand if clicking close button
        if (e.target.closest('.bb-leaderboard-close')) {
          e.stopPropagation();
          closeLeaderboard();
          return;
        }
        
        // Don't expand if already expanded or if drag just happened
        if (dragState.isDragging) return;
        
        // Expand when clicking on minimal view
        if (!leaderboardEl.classList.contains('expanded')) {
          leaderboardEl.classList.add('expanded');
          // Show backdrop on mobile
          if (window.innerWidth <= 768) {
            backdrop.classList.add('visible');
          }
        }
      });
      
      // Drag functionality for desktop expanded view
      leaderboardEl.addEventListener('mousedown', function(e) {
        // Only drag from header area when expanded and on desktop
        if (!leaderboardEl.classList.contains('expanded')) return;
        if (window.innerWidth <= 768) return;
        
        var header = e.target.closest('.bb-leaderboard-header');
        if (!header) return;
        
        // Don't start drag if clicking close button
        if (e.target.closest('.bb-leaderboard-close')) return;
        
        e.preventDefault();
        dragState.isDragging = true;
        dragState.startX = e.clientX;
        dragState.startY = e.clientY;
        
        var rect = leaderboardEl.getBoundingClientRect();
        dragState.startLeft = rect.left;
        dragState.startTop = rect.top;
        
        // Remove transform centering when dragging starts
        leaderboardEl.style.transform = 'none';
        leaderboardEl.style.left = rect.left + 'px';
        leaderboardEl.style.top = rect.top + 'px';
        
        document.body.style.userSelect = 'none';
      });
      
      document.addEventListener('mousemove', function(e) {
        if (!dragState.isDragging) return;
        
        var deltaX = e.clientX - dragState.startX;
        var deltaY = e.clientY - dragState.startY;
        
        var newLeft = dragState.startLeft + deltaX;
        var newTop = dragState.startTop + deltaY;
        
        // Constrain to viewport
        newLeft = Math.max(10, Math.min(window.innerWidth - 340, newLeft));
        newTop = Math.max(10, Math.min(window.innerHeight - 100, newTop));
        
        leaderboardEl.style.left = newLeft + 'px';
        leaderboardEl.style.top = newTop + 'px';
      });
      
      document.addEventListener('mouseup', function() {
        if (dragState.isDragging) {
          dragState.isDragging = false;
          document.body.style.userSelect = '';
          
          // Small delay to prevent click from firing
          setTimeout(function() {
            dragState.isDragging = false;
          }, 50);
        }
      });
    }
    
    // Initialize leaderboard when page loads
    setTimeout(function() {
      initLeaderboard();
      initLeaderboardToggle();
    }, 1000);

    // ========================================================================
    // Timer with Extension Option
    // ========================================================================
    var hasExtendedTime = false;
    var extensionModalShown = false;
    
    function startTimer() {
      state.timerInterval = setInterval(function() {
        state.timerRemaining--;
        
        const minutes = Math.floor(state.timerRemaining / 60);
        const seconds = state.timerRemaining % 60;
        const display = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        
        if (els.timerValue) {
          els.timerValue.textContent = display;
        }
        
        // DISABLED - no timer popups
        // if (state.timerRemaining === 60 && !hasExtendedTime && !extensionModalShown) {
        //   extensionModalShown = true;
        //   showExtensionModal();
        // }
        
        // Urgent state
        if (state.timerRemaining <= config.timerUrgent) {
          if (els.timer) els.timer.classList.add('urgent');
        }
        
        // Timer expired - just stop the timer, no popup
        if (state.timerRemaining <= 0) {
          clearInterval(state.timerInterval);
          // showTimerExpiredModal(); // Disabled - no "times up" popup
        }
      }, 1000);
    }
    
    // ========================================================================
    // Session Timer - 10-minute gold countdown (starts on page load)
    // ========================================================================
    var sessionTimerSeconds = 10 * 60; // 10 minutes
    var sessionTimerInterval = null;
    var sessionExtended = false; // Track if we've used the one-time extension
    var sessionTimerEl = document.getElementById('bb-session-timer-' + sectionId);
    var sessionTimerValueEl = document.getElementById('bb-session-timer-value-' + sectionId);
    
    function startSessionTimer() {
      if (sessionTimerInterval) return; // Already started
      
      // Show the timer
      if (sessionTimerEl) {
        sessionTimerEl.classList.add('active');
      }
      
      sessionTimerInterval = setInterval(function() {
        sessionTimerSeconds--;
        
        var minutes = Math.floor(sessionTimerSeconds / 60);
        var seconds = sessionTimerSeconds % 60;
        var display = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        
        if (sessionTimerValueEl) {
          sessionTimerValueEl.textContent = display;
        }
        
        // Urgent state - under 2 minutes (only if not expired)
        if (sessionTimerSeconds <= 120 && sessionTimerSeconds > 0 && sessionTimerEl) {
          sessionTimerEl.classList.add('urgent');
        }
        
        // Timer Hit Zero
        if (sessionTimerSeconds <= 0) {
          if (!sessionExtended) {
            // First expiry: Extend once by 10 minutes
            sessionExtended = true;
            sessionTimerSeconds = 10 * 60; // Add 10 minutes
            
            // Visual feedback for extension
            if (sessionTimerEl) {
              sessionTimerEl.classList.remove('urgent'); // Reset urgent state
              sessionTimerEl.classList.add('extending');
              
              // Remove animation class after it plays
              setTimeout(function() {
                sessionTimerEl.classList.remove('extending');
              }, 1000);
            }
            
            // Play success/unlock sound if available
            if (window.SoundSystem) {
              window.SoundSystem.play('tier-unlock');
            }
            
            console.log('⏰ Session timer extended automatically (one-time bonus)');
            
          } else {
            // Second expiry: Game Over / Checkout prompt
            clearInterval(sessionTimerInterval);
            
            if (sessionTimerEl) {
              sessionTimerEl.classList.remove('urgent');
              sessionTimerEl.classList.add('expired');
            }
            
            if (sessionTimerValueEl) {
              sessionTimerValueEl.textContent = "PLEASE CHECKOUT";
            }
            
            // Play expiration sound if available
            if (window.SoundSystem) {
              window.SoundSystem.play('upgrade-slam');
            }
          }
        }
      }, 1000);
    }
    
    // Timer starts on Enter Bundle Builder click (see setupEnterButton)
    
    function showExtensionModal() {
      // Remove any existing modal
      var existingModal = document.querySelector('.bb-extension-modal');
      if (existingModal) existingModal.remove();
      
      var modal = document.createElement('div');
      modal.className = 'bb-extension-modal';
      modal.innerHTML = 
        '<div class="bb-extension-backdrop"></div>' +
        '<div class="bb-extension-content">' +
          '<div class="bb-extension-icon">⏰</div>' +
          '<h3 class="bb-extension-title">Running out of time!</h3>' +
          '<p class="bb-extension-text">You have 1 minute left to complete your bundle. Need more time?</p>' +
          '<div class="bb-extension-buttons">' +
            '<button class="bb-btn-extend" data-action="extend">+5 Minutes</button>' +
            '<button class="bb-btn-continue" data-action="continue">I\'m almost done</button>' +
          '</div>' +
        '</div>';
      
      document.body.appendChild(modal);
      
      // Play alert sound
      if (window.SoundSystem) {
        window.SoundSystem.play('notification', null, 0.5);
      }
      
      // Button handlers
      modal.querySelector('[data-action="extend"]').addEventListener('click', function() {
        extendTime();
        modal.remove();
      });
      
      modal.querySelector('[data-action="continue"]').addEventListener('click', function() {
        modal.remove();
      });
      
      modal.querySelector('.bb-extension-backdrop').addEventListener('click', function() {
        modal.remove();
      });
      
      // Auto-close after 30 seconds if no action
      setTimeout(function() {
        if (document.body.contains(modal)) {
          modal.remove();
        }
      }, 30000);
    }
    
    function extendTime() {
      hasExtendedTime = true;
      state.timerRemaining += 5 * 60; // Add 5 minutes (300 seconds)
      
      // Visual feedback
      if (els.timer) {
        els.timer.classList.remove('urgent');
        els.timer.classList.add('extended');
        setTimeout(function() {
          els.timer.classList.remove('extended');
        }, 2000);
      }
      
      console.log('⏰ Timer extended by 5 minutes');
    }
    
    function showTimerExpiredModal() {
      var modal = document.createElement('div');
      modal.className = 'bb-extension-modal bb-expired-modal';
      modal.innerHTML = 
        '<div class="bb-extension-backdrop"></div>' +
        '<div class="bb-extension-content">' +
          '<div class="bb-extension-icon">⏱️</div>' +
          '<h3 class="bb-extension-title">Time\'s Up!</h3>' +
          '<p class="bb-extension-text">Your session has expired. You can still checkout with what you\'ve selected, or start fresh.</p>' +
          '<div class="bb-extension-buttons">' +
            '<button class="bb-btn-extend" data-action="checkout">Checkout Now</button>' +
            '<button class="bb-btn-continue" data-action="restart">Start Over</button>' +
          '</div>' +
        '</div>';
      
      document.body.appendChild(modal);
      
      modal.querySelector('[data-action="checkout"]').addEventListener('click', function() {
        modal.remove();
        handleCheckout();
      });
      
      modal.querySelector('[data-action="restart"]').addEventListener('click', function() {
        modal.remove();
        window.location.reload();
      });
    }

    // ========================================================================
    // Particle Effects
    // ========================================================================
    
    // Shockwave effect when milestone is eaten (Pac-Man mechanic)
    function triggerShockwave() {
      // Apply to wrapper so it doesn't interrupt the inner visual animation
      const wrapper = container.querySelector('.bb-tier-bar-fill-wrapper');
      if (wrapper) {
        // Remove class if it exists to restart animation
        wrapper.classList.remove('shockwave-active');
        
        // Force reflow to restart animation
        void wrapper.offsetWidth;
        
        // Add class to trigger CSS animation
        wrapper.classList.add('shockwave-active');
        
        // Cleanup after animation
        setTimeout(function() {
          wrapper.classList.remove('shockwave-active');
        }, 600);
      }
    }
    
    function spawnParticles() {
      // Skip if particles disabled in performance settings
      if (!Perf.enableParticles) return;
      
      const progressBar = els.tierFill;
      if (!progressBar) return;
      
      const rect = progressBar.getBoundingClientRect();
      const startX = rect.left + rect.width;
      const startY = rect.top + rect.height / 2;
      
      for (let i = 0; i < 20; i++) {
        const particle = document.createElement('div');
        particle.className = 'bb-particle';
        document.body.appendChild(particle);
        
        const angle = Math.random() * Math.PI * 2;
        const velocity = Math.random() * 8 + 4;
        let x = startX;
        let y = startY;
        let vx = Math.cos(angle) * velocity;
        let vy = Math.sin(angle) * velocity;
        let opacity = 1;
        
        particle.style.left = x + 'px';
        particle.style.top = y + 'px';
        
        const animate = function() {
          x += vx;
          y += vy;
          vy += 0.3; // Gravity
          opacity -= 0.03;
          
          particle.style.left = x + 'px';
          particle.style.top = y + 'px';
          particle.style.opacity = opacity;
          
          if (opacity > 0) {
            requestAnimationFrame(animate);
          } else {
            particle.remove();
          }
        };
        
        requestAnimationFrame(animate);
      }
    }

    // ========================================================================
    // SCROLL HINT STATE - Must be declared before initCarousel uses it
    // ========================================================================
    var scrollHintState = {
      element: null,
      shown: false,
      dismissed: false,
      initialTranslateX: 0
    };
    
    // ========================================================================
    // CAROUSEL SYSTEM
    // ========================================================================
    // CAROUSEL SYSTEM - Native-feel inertia scroll
    // ========================================================================
    function initCarousel() {
      var grid = container.querySelector('.bb-product-grid');
      var track = container.querySelector('.bb-carousel-track');
      
      if (!grid || !track) {
        console.warn('Carousel: Missing grid or track element');
        return;
      }
      
      carouselState.grid = grid;
      carouselState.track = track;
      carouselState.cards = Array.from(track.querySelectorAll('.bb-balatro-card'));
      
      // Cache viewport dimensions
      carouselState.viewportWidth = grid.offsetWidth;
      carouselState.viewportCenter = carouselState.viewportWidth / 2;
      
      if (carouselState.cards.length === 0) {
        console.warn('Carousel: No cards found');
        return;
      }
      
      // Wait for cards to render before calculating dimensions
      setTimeout(function() {
        updateCarouselDimensions();
        
        if (carouselState.cardWidth === 0) {
          console.warn('Carousel: Cards not yet rendered, skipping init');
          return;
        }
        
        calculateCarouselBounds();
        
        carouselState.translateX = 0;
        carouselState.track.style.transform = 'translateX(0px)';
        
        addCarouselListeners();
        
        // Initialize scroll hint for first-time users (after carousel is ready)
        initScrollHint();
        
        console.log('🎠 Carousel initialized with', carouselState.cards.length, 'cards (Apple-style inertia)');
      }, 100);
      
      // Handle resize
      var resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          updateCarouselDimensions();
          calculateCarouselBounds();
          carouselState.translateX = Math.max(carouselState.minX, Math.min(carouselState.maxX, carouselState.translateX));
          carouselState.track.style.transform = 'translate3d(' + carouselState.translateX + 'px, 0, 0)';
        }, 150);
      });
      
      // WATCHDOG: Periodically check if carousel is stuck out of bounds
      // This catches edge cases where bounceBack fails or bounds become stale
      setInterval(function() {
        checkAndFixCarouselPosition();
      }, 2000);
    }
    
    // ========================================================================
    // SCROLL HINT - Shows "swipe/scroll >" on first load, hides after 50px scroll
    // ========================================================================
    function initScrollHint() {
      // Safety check - ensure scrollHintState is defined
      if (typeof scrollHintState === 'undefined' || !scrollHintState) return;
      
      // Only show on card selection step (step 1) and only once per session
      if (scrollHintState.dismissed) return;
      if (state.currentStep !== 1) return;
      
      // Check if already shown this session (disabled for testing)
      // var sessionKey = 'bb_scroll_hint_shown_' + container.dataset.sectionId;
      // if (sessionStorage.getItem(sessionKey)) {
      //   scrollHintState.dismissed = true;
      //   return;
      // }
      
      // Create scroll hint element
      var wrapper = container.querySelector('.bb-product-grid-wrapper');
      if (!wrapper) return;
      
      var hint = document.createElement('div');
      hint.className = 'bb-scroll-hint';
      
      // Detect mobile vs desktop for text
      var isMobile = window.matchMedia('(max-width: 767px)').matches || 
                     ('ontouchstart' in window) || 
                     (navigator.maxTouchPoints > 0);
      var hintText = isMobile ? 'Swipe' : 'Scroll';
      
      hint.innerHTML = '<span class="bb-scroll-hint-text">' + hintText + '</span><span class="bb-scroll-hint-arrow">›</span>';
      
      wrapper.style.position = 'relative'; // Ensure proper positioning
      wrapper.appendChild(hint);
      
      scrollHintState.element = hint;
      scrollHintState.initialTranslateX = carouselState.translateX || 0;
      
      // Show hint after a brief delay for smooth appearance
      setTimeout(function() {
        if (scrollHintState.element && !scrollHintState.dismissed) {
          scrollHintState.element.classList.add('bb-scroll-hint-visible');
          scrollHintState.shown = true;
        }
      }, 500);
      
      // Store in session so it doesn't show again (disabled for testing)
      // sessionStorage.setItem(sessionKey, 'true');
    }
    
    function hideScrollHint() {
      if (typeof scrollHintState === 'undefined' || !scrollHintState) return;
      if (!scrollHintState.element || scrollHintState.dismissed) return;
      
      scrollHintState.dismissed = true;
      scrollHintState.element.classList.remove('bb-scroll-hint-visible');
      scrollHintState.element.classList.add('bb-scroll-hint-hiding');
      
      // Remove from DOM after fade out
      setTimeout(function() {
        if (scrollHintState.element && scrollHintState.element.parentNode) {
          scrollHintState.element.parentNode.removeChild(scrollHintState.element);
        }
        scrollHintState.element = null;
      }, 400);
    }
    
    function checkScrollHintVisibility() {
      if (typeof scrollHintState === 'undefined' || !scrollHintState) return;
      if (!scrollHintState.shown || scrollHintState.dismissed) return;
      
      // Check if scrolled more than 50px from initial position
      var scrollDistance = Math.abs(carouselState.translateX - scrollHintState.initialTranslateX);
      if (scrollDistance >= 50) {
        hideScrollHint();
      }
    }
    
    // Check if carousel is stuck out of bounds and fix it
    function checkAndFixCarouselPosition() {
      if (!carouselState.track || !carouselState.grid) return;
      if (!carouselState.enabled) return;
      if (carouselState.isDragging) return; // Don't interrupt active drag
      
      // Skip if an animation is in progress
      if (carouselState.animationFrame) return;
      if (carouselState.grid.classList.contains('is-scrolling')) return;
      
      // Recalculate bounds to ensure they're fresh
      var oldMinX = carouselState.minX;
      var oldMaxX = carouselState.maxX;
      calculateCarouselBounds();
      
      // If content fits viewport (no scrolling needed), just ensure position is 0
      if (carouselState.minX === 0 && carouselState.maxX === 0) {
        if (carouselState.translateX !== 0) {
          carouselState.track.style.transition = 'transform 0.3s ease-out';
          carouselState.track.style.transform = 'translate3d(0px, 0, 0)';
          carouselState.translateX = 0;
          setTimeout(function() {
            if (carouselState.track) {
              carouselState.track.style.transition = '';
            }
          }, 300);
        }
        return; // Content fits, no scroll bounds to worry about
      }
      
      // Check if bounds changed significantly
      var boundsChanged = Math.abs(oldMinX - carouselState.minX) > 10 || Math.abs(oldMaxX - carouselState.maxX) > 10;
      
      // Check if current position is out of bounds
      var currentX = carouselState.translateX || 0;
      var isOutOfBounds = currentX > carouselState.maxX + 5 || currentX < carouselState.minX - 5;
      
      if (isOutOfBounds || boundsChanged) {
        // Silently fix position - watchdog fires every 2s so avoid log spam
        
        // Clamp to valid bounds
        var targetX = Math.max(carouselState.minX, Math.min(carouselState.maxX, currentX));
        
        // Animate to valid position
        carouselState.track.style.transition = 'transform 0.3s ease-out';
        carouselState.track.style.transform = 'translate3d(' + targetX + 'px, 0, 0)';
        carouselState.translateX = targetX;
        
        setTimeout(function() {
          if (carouselState.track) {
            carouselState.track.style.transition = '';
          }
        }, 300);
      }
    }
    
    function calculateCarouselBounds() {
      // Safety checks
      if (!carouselState.cards || carouselState.cards.length === 0) {
        carouselState.minX = 0;
        carouselState.maxX = 0;
        return;
      }
      
      if (!carouselState.cardWidth || carouselState.cardWidth <= 0) {
        updateCarouselDimensions();
      }
      
      var trackWidth = carouselState.cards.length * (carouselState.cardWidth + carouselState.gap) - carouselState.gap;
      var viewportWidth = carouselState.grid ? carouselState.grid.offsetWidth : window.innerWidth;
      
      // Get padding from computed style (accounts for responsive changes)
      var paddingLeft = 80; // Default
      if (carouselState.grid) {
        var computedPadding = getComputedStyle(carouselState.grid).paddingLeft;
        paddingLeft = parseInt(computedPadding) || 80;
      }
      
      if (trackWidth + (paddingLeft * 2) <= viewportWidth) {
        // Content fits in viewport - allow no scrolling (centered by CSS)
        carouselState.maxX = 0;
        carouselState.minX = 0;
      } else {
        // Content overflows - calculate scroll bounds
        // maxX = 0 means first card at left padding
        // minX = negative value that puts last card at right edge
        carouselState.maxX = 0;
        carouselState.minX = viewportWidth - trackWidth - (paddingLeft * 2);
        
        // Ensure minX is always less than or equal to maxX
        if (carouselState.minX > carouselState.maxX) {
          carouselState.minX = carouselState.maxX;
        }
      }
      
      // Debug log removed - was firing every 2s from watchdog
    }
    
    // Refresh carousel after layout changes (e.g., entering upgrade mode)
    function refreshCarousel() {
      var grid = carouselState.grid;
      var track = carouselState.track;
      
      if (!grid || !track) {
        console.warn('refreshCarousel: Missing grid or track');
        return;
      }
      
      // Cancel any ongoing animations
      if (carouselState.animationFrame) {
        cancelAnimationFrame(carouselState.animationFrame);
        carouselState.animationFrame = null;
      }
      
      // Clear any ongoing transitions
      track.style.transition = 'none';
      
      // Re-query VISIBLE cards only (exclude hidden ones)
      carouselState.cards = Array.from(track.querySelectorAll('.bb-balatro-card:not([style*="display: none"])')).filter(function(card) {
        return card.offsetParent !== null; // Additional check for visibility
      });
      
      if (carouselState.cards.length === 0) {
        console.warn('refreshCarousel: No visible cards found');
        carouselState.enabled = false;
        return;
      }
      
      // Ensure all cards are visible (reset any visibility hiding)
      carouselState.cards.forEach(function(card) {
        card.style.visibility = '';
      });
      
      // Update dimensions from first visible card
      updateCarouselDimensions();
      
      // Recalculate bounds
      calculateCarouselBounds();
      
      // Reset position if out of bounds (clamp to valid range)
      var clampedX = Math.max(carouselState.minX, Math.min(carouselState.maxX, carouselState.translateX || 0));
      carouselState.translateX = clampedX;
      track.style.transform = 'translate3d(' + clampedX + 'px, 0, 0)';
      
      // Clean up state
      carouselState.isDragging = false;
      carouselState.wasDragging = false;
      carouselState.velocity = 0;
      grid.classList.remove('is-scrolling', 'bb-carousel-dragging');
      
      // Re-enable carousel
      carouselState.enabled = true;
      
      // Carousel silently refreshed - bounds: minX to maxX
    }
    
    function updateCarouselDimensions() {
      if (carouselState.cards.length === 0) return;
      var firstCard = carouselState.cards[0];
      carouselState.cardWidth = firstCard.offsetWidth;
      carouselState.gap = parseInt(getComputedStyle(carouselState.track).gap) || 24;
      
      // Update cached viewport dimensions
      if (carouselState.grid) {
        carouselState.viewportWidth = carouselState.grid.offsetWidth;
        carouselState.viewportCenter = carouselState.viewportWidth / 2;
      }
    }
    
    function addCarouselListeners() {
      var grid = carouselState.grid;
      
      // Mouse
      grid.addEventListener('mousedown', onCarouselDragStart);
      document.addEventListener('mousemove', onCarouselDragMove);
      document.addEventListener('mouseup', onCarouselDragEnd);
      
      // Touch
      grid.addEventListener('touchstart', onCarouselDragStart, { passive: true });
      document.addEventListener('touchmove', onCarouselDragMove, { passive: false });
      document.addEventListener('touchend', onCarouselDragEnd);
      
      // Wheel (Trackpad & Mouse Wheel support)
      // Maps vertical scroll (common trackpad gesture) to horizontal carousel scroll
      grid.addEventListener('wheel', onCarouselWheel, { passive: false });
      
      grid.querySelectorAll('img').forEach(function(img) {
        img.addEventListener('dragstart', function(e) { e.preventDefault(); });
      });
    }
    
    // Wheel event handler for trackpad/mouse wheel scrolling
    // Trackpads often generate vertical deltaY even for horizontal intent
    // So we map deltaY to horizontal scrolling for better UX
    var wheelState = {
      endTimeout: null,
      sensitivity: 1.2,      // How fast wheel scrolls (1-2)
      isWheeling: false
    };
    
    function onCarouselWheel(e) {
      if (!carouselState.enabled) return;
      if (!carouselState.track || !carouselState.grid) return;
      
      // If no scrolling is possible (content fits viewport), exit early
      // This prevents the "stuck" carousel effect where it bounces back repeatedly
      if (carouselState.minX === 0 && carouselState.maxX === 0) {
        return; // Let the page scroll normally
      }
      
      // Use deltaX if provided (explicit horizontal scroll), else use deltaY
      // Most trackpads send deltaY for 2-finger swipe
      var delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      
      // Ignore tiny deltas (noise)
      if (Math.abs(delta) < 1) return;
      
      // Prevent page scroll since we're handling it
      e.preventDefault();
      
      // Cancel any ongoing drag/momentum animations
      if (carouselState.animationFrame) {
        cancelAnimationFrame(carouselState.animationFrame);
        carouselState.animationFrame = null;
      }
      
      // Clear any CSS transition so we have direct control
      carouselState.track.style.transition = 'none';
      
      // Mark as scrolling for CSS purposes
      carouselState.grid.classList.add('is-scrolling');
      wheelState.isWheeling = true;
      
      // Convert wheel delta to scroll amount
      // Negative delta = scroll content left (show more right content)
      var scrollAmount = -delta * wheelState.sensitivity;
      
      // Calculate new position
      var newX = carouselState.translateX + scrollAmount;
      
      // Apply rubber-band resistance at edges (gentler than drag)
      if (newX > carouselState.maxX) {
        var diff = newX - carouselState.maxX;
        scrollAmount = scrollAmount * (1 / (1 + (diff * 0.008)));
        newX = carouselState.translateX + scrollAmount;
      } else if (newX < carouselState.minX) {
        var diff = carouselState.minX - newX;
        scrollAmount = scrollAmount * (1 / (1 + (diff * 0.008)));
        newX = carouselState.translateX + scrollAmount;
      }
      
      // Update position immediately
      carouselState.translateX = newX;
      carouselState.track.style.transform = 'translate3d(' + newX + 'px, 0, 0)';
      
      // Check if scroll hint should be hidden
      checkScrollHintVisibility();
      
      // Clear any existing timeout and set a new one
      if (wheelState.endTimeout) {
        clearTimeout(wheelState.endTimeout);
      }
      
      // When wheel events stop, bounce back if needed
      wheelState.endTimeout = setTimeout(function() {
        wheelState.isWheeling = false;
        
        // Check if out of bounds - bounce back
        if (carouselState.translateX > carouselState.maxX || carouselState.translateX < carouselState.minX) {
          bounceBack();
        } else {
          // Clean up
          carouselState.grid.classList.remove('is-scrolling');
        }
      }, 150);
    }
    
    // Visibility Culling - DISABLED
    // Previously caused cards to disappear incorrectly due to calculation errors
    // Modern GPUs handle 10-12 cards with ease, so culling is unnecessary
    function updateVisibleCards() {
      // DISABLED - Just ensure all cards are visible
      if (!carouselState.cards) return;
      carouselState.cards.forEach(function(card) {
        if (card.style.visibility === 'hidden') {
          card.style.visibility = '';
        }
      });
    }
    
    // Safety function to reset carousel to valid state
    function resetCarouselToValidState() {
      if (!carouselState.track || !carouselState.grid) return;
      
      // Cancel any animations
      if (carouselState.animationFrame) {
        cancelAnimationFrame(carouselState.animationFrame);
        carouselState.animationFrame = null;
      }
      
      // Clear transitions
      carouselState.track.style.transition = 'none';
      
      // Recalculate bounds
      updateCarouselDimensions();
      calculateCarouselBounds();
      
      // Clamp current position to valid bounds
      carouselState.translateX = Math.max(carouselState.minX, Math.min(carouselState.maxX, carouselState.translateX || 0));
      carouselState.track.style.transform = 'translate3d(' + carouselState.translateX + 'px, 0, 0)';
      
      // Ensure all cards visible
      updateVisibleCards();
      
      // Re-enable carousel
      carouselState.enabled = true;
      carouselState.isDragging = false;
      carouselState.wasDragging = false;
      carouselState.grid.classList.remove('is-scrolling', 'bb-carousel-dragging');
      
      // Carousel reset silently
    }

    // Velocity tracking buffer
    var velocityBuffer = [];
    var VELOCITY_BUFFER_SIZE = 5;
    
    function onCarouselDragStart(e) {
      if (!carouselState.enabled) return;
      if (!carouselState.track || !carouselState.grid) return;
      
      // IMMEDIATE BOUNDS CHECK: Fix any stuck position before starting drag
      // This catches situations where the carousel got stuck between interactions
      var currentX = carouselState.translateX || 0;
      calculateCarouselBounds(); // Refresh bounds
      if (currentX > carouselState.maxX || currentX < carouselState.minX) {
        // Silently fixing position before drag
        carouselState.translateX = Math.max(carouselState.minX, Math.min(carouselState.maxX, currentX));
        carouselState.track.style.transform = 'translate3d(' + carouselState.translateX + 'px, 0, 0)';
      }
      
      var clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      var clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
      
      carouselState.isDragging = true;
      carouselState.wasDragging = false;
      carouselState.startX = clientX;
      carouselState.startY = clientY; // Track Y for vertical-to-horizontal conversion
      carouselState.currentX = clientX;
      carouselState.currentY = clientY; // Track current Y position
      carouselState.lastX = clientX;
      carouselState.lastTime = Date.now();
      carouselState.velocity = 0;
      carouselState.isLocked = false; // "Locked" means we've started carousel movement
      carouselState.isCarouselScroll = false; // Are we controlling the carousel?
      
      // Reset buffer
      velocityBuffer = [{ x: clientX, time: Date.now() }];
      
      if (carouselState.clickBlockTimeout) {
        clearTimeout(carouselState.clickBlockTimeout);
        carouselState.clickBlockTimeout = null;
      }
      
      // Cancel any ongoing animations
      if (carouselState.animationFrame) {
        cancelAnimationFrame(carouselState.animationFrame);
        carouselState.animationFrame = null;
      }
      
      carouselState.grid.classList.add('bb-carousel-dragging');
      carouselState.track.classList.remove('bb-carousel-snapping');
      // Ensure transition is cleared so direct manipulation is instant
      carouselState.track.style.transition = 'none';
    }
    
    function onCarouselDragMove(e) {
      if (!carouselState.isDragging) return;
      
      // If no scrolling is possible (content fits viewport), cancel drag
      // This prevents the "stuck" carousel effect where it bounces back repeatedly
      if (carouselState.minX === 0 && carouselState.maxX === 0) {
        carouselState.isDragging = false;
        carouselState.grid.classList.remove('bb-carousel-dragging', 'is-scrolling');
        return;
      }
      
      var clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      var clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
      
      // Direction Locking Logic - ACCEPTS BOTH horizontal AND vertical swipes
      // Vertical swipes get converted to horizontal carousel movement
      // This prevents Safari back/forward gesture conflicts
      if (!carouselState.isLocked) {
        var dx = Math.abs(clientX - carouselState.startX);
        var dy = Math.abs(clientY - carouselState.startY);
        
        // If moved enough to decide (5px threshold)
        if (dx > 5 || dy > 5) {
          carouselState.isLocked = true;
          carouselState.isCarouselScroll = true;
          // Lock interaction immediately - we handle BOTH directions
          carouselState.grid.classList.add('is-scrolling');
        } else {
          // Haven't moved enough yet, do nothing (wait)
          return;
        }
      }
      
      // Handle carousel scrolling (both horizontal AND vertical movement)
      if (carouselState.isCarouselScroll) {
        // Prevent default to stop browser nav gestures / pull-to-refresh
        if (e.cancelable) e.preventDefault();
        
        // Calculate delta from BOTH axes
        // Horizontal movement: direct 1:1 mapping
        // Vertical movement: converted to horizontal (swipe up = scroll right)
        var deltaX = clientX - carouselState.currentX;
        var deltaY = clientY - carouselState.currentY;
        
        // Combine both movements - vertical scroll converts to horizontal
        // Negative deltaY (swipe up) = positive carousel movement (scroll right)
        var combinedDelta = deltaX - deltaY;
        
        var now = Date.now();
        
        // Mark as "was dragging" to prevent clicks
        carouselState.wasDragging = true;
        
        // Track velocity buffer (use combined delta for velocity calc)
        velocityBuffer.push({ x: clientX, time: now });
        if (velocityBuffer.length > VELOCITY_BUFFER_SIZE) velocityBuffer.shift();
        
        // Update current positions for both axes
        carouselState.currentX = clientX;
        carouselState.currentY = clientY;
        
        // Apple-style Rubber Banding (Logarithmic)
        var newX = carouselState.translateX + combinedDelta;
        if (newX > carouselState.maxX) {
          // Past left edge
          var diff = newX - carouselState.maxX;
          // Apply log resistance: further you go, harder it gets
          combinedDelta = combinedDelta * (1 / (1 + (diff * 0.005))); 
          newX = carouselState.translateX + combinedDelta;
          // #region agent log - H6 boundary scroll tracking (left edge)
          if (window._bbDebugLog && diff > 50) window._bbDebugLog('bundle-builder.js:carouselDrag', 'Past LEFT edge (first card)', { diff: diff, newX: newX, maxX: carouselState.maxX }, 'H6');
          // #endregion
        } else if (newX < carouselState.minX) {
          // Past right edge (LAST CARD)
          var diff = carouselState.minX - newX;
          combinedDelta = combinedDelta * (1 / (1 + (diff * 0.005)));
          newX = carouselState.translateX + combinedDelta;
          // #region agent log - H6 boundary scroll tracking (RIGHT edge - LAST CARD)
          if (window._bbDebugLog && diff > 50) window._bbDebugLog('bundle-builder.js:carouselDrag', 'Past RIGHT edge (LAST CARD)', { diff: diff, newX: newX, minX: carouselState.minX, cardCount: carouselState.cards ? carouselState.cards.length : 0 }, 'H6');
          // #endregion
        }
        
        carouselState.translateX = newX;
        if (carouselState.track) {
          carouselState.track.style.transform = 'translate3d(' + carouselState.translateX + 'px, 0, 0)';
        }
        
        // Check if scroll hint should be hidden
        checkScrollHintVisibility();
      }
    }
    
    function onCarouselDragEnd(e) {
      if (!carouselState.isDragging) return;
      
      carouselState.isDragging = false;
      carouselState.grid.classList.remove('bb-carousel-dragging');
      
      if (carouselState.wasDragging) {
        // Block clicks
        carouselState.clickBlockTimeout = setTimeout(function() {
          carouselState.wasDragging = false;
        }, 50);
        
        // Calculate Weighted Velocity from Buffer
        var now = Date.now();
        // Filter points from last 100ms
        var recentPoints = velocityBuffer.filter(function(p) { return now - p.time < 100; });
        
        if (recentPoints.length > 1) {
          var first = recentPoints[0];
          var last = recentPoints[recentPoints.length - 1];
          var dt = last.time - first.time;
          var dx = last.x - first.x;
          
          if (dt > 0) {
            carouselState.velocity = dx / dt * 16.67; // px per frame (60fps)
          } else {
            carouselState.velocity = 0;
          }
        } else {
          carouselState.velocity = 0;
        }
        
        // Cap max velocity
        carouselState.velocity = Math.max(-60, Math.min(60, carouselState.velocity));
        
        // Bounce takes priority (out of bounds)
        if (carouselState.translateX > carouselState.maxX || carouselState.translateX < carouselState.minX) {
          bounceBack();
        } 
        // MOBILE: Immediate "Gliding Snap" (Scroll Snap Emulation)
        else if (window.matchMedia('(hover: none)').matches) {
           // Projected landing based on velocity
           var amplitude = carouselState.velocity * 12; 
           var projectedX = carouselState.translateX + amplitude;
           projectedX = Math.max(carouselState.minX, Math.min(carouselState.maxX, projectedX));
           var targetIndex = getNearestCardIndexForPosition(projectedX);
           snapToCard(targetIndex);
        }
        // DESKTOP: Inertia Momentum (no snap)
        else if (Math.abs(carouselState.velocity) > 1) {
          applyMomentum();
        } else {
          setTimeout(function() {
            carouselState.grid.classList.remove('is-scrolling');
          }, 50);
        }
      } else {
        // Was just a click/tap without drag
        setTimeout(function() {
          carouselState.grid.classList.remove('is-scrolling');
        }, 50);
      }
    }
    
    function getNearestCardIndexForPosition(translateX) {
      // Find viewport center relative to track
      var viewportCenter = carouselState.grid.offsetWidth / 2;
      var bestIndex = 0;
      var bestDist = Infinity;
      
      // Get padding offset (grid + track padding when in physical mode)
      var paddingOffset = 0;
      if (carouselState.track && carouselState.track !== carouselState.grid) {
        var gridPaddingLeft = parseInt(getComputedStyle(carouselState.grid).paddingLeft) || 0;
        var trackPaddingLeft = parseInt(getComputedStyle(carouselState.track).paddingLeft) || 0;
        paddingOffset = gridPaddingLeft + trackPaddingLeft;
      }
      
      carouselState.cards.forEach(function(card, index) {
        // card center relative to track content area (after padding)
        var cardCenter = index * (carouselState.cardWidth + carouselState.gap) + (carouselState.cardWidth / 2);
        // visual position = paddingOffset + cardCenter + translateX
        var visualCenter = paddingOffset + cardCenter + translateX;
        var dist = Math.abs(visualCenter - viewportCenter);
        
        if (dist < bestDist) {
          bestDist = dist;
          bestIndex = index;
        }
      });
      
      return bestIndex;
    }

    // Legacy method for compatibility if needed, though mostly superseded by above
    function getNearestCardIndex() {
      return getNearestCardIndexForPosition(carouselState.translateX);
    }

    function snapToCard(targetIndex) {
      // Ensure interaction lock is on during snap
      carouselState.grid.classList.add('is-scrolling');
      
      var viewportCenter = carouselState.grid.offsetWidth / 2;
      var cardCenter = targetIndex * (carouselState.cardWidth + carouselState.gap) + (carouselState.cardWidth / 2);
      
      // Get padding offset for proper centering on mobile
      // When track !== grid (physical mode), we need to account for:
      // 1. Grid's padding (where the track is positioned)
      // 2. Track's own padding (where cards start within track)
      var paddingOffset = 0;
      if (carouselState.track && carouselState.track !== carouselState.grid) {
        var gridPaddingLeft = parseInt(getComputedStyle(carouselState.grid).paddingLeft) || 0;
        var trackPaddingLeft = parseInt(getComputedStyle(carouselState.track).paddingLeft) || 0;
        paddingOffset = gridPaddingLeft + trackPaddingLeft;
      }
      
      // Calculate target translateX to center this card
      // Card visual position = gridPadding + trackPadding + cardCenter + translateX
      // To center: translateX = viewportCenter - paddingOffset - cardCenter
      var targetX = viewportCenter - paddingOffset - cardCenter;
      
      // Clamp bounds
      targetX = Math.max(carouselState.minX, Math.min(carouselState.maxX, targetX));
      
      // Update active state immediately for feedback
      updateActiveSlot(targetIndex);
      
      // Calculate distance for relative aggressiveness
      var dist = Math.abs(carouselState.translateX - targetX);
      
      if (dist > 1) {
        // "Gradual Glide" Logic for Mobile:
        // Use a much gentler bezier and a duration that allows for a smooth settling
        // Duration: Base 0.5s + (distance / 1500) capped at 0.8s
        var duration = Math.min(0.8, 0.5 + (dist / 1500));
        
        // Gentle ease-out-quart/quint for that smooth landing
        carouselState.track.style.transition = 'transform ' + duration + 's cubic-bezier(0.25, 1, 0.5, 1)';
        carouselState.track.style.transform = 'translate3d(' + targetX + 'px, 0, 0)';
        carouselState.translateX = targetX;
        
        // Clean up after transition
        setTimeout(function() {
          carouselState.track.style.transition = '';
          carouselState.grid.classList.remove('is-scrolling');
        }, duration * 1000);
      } else {
        // Already there
        carouselState.grid.classList.remove('is-scrolling');
      }
      
      carouselState.animationFrame = null;
    }
    
    // Wrapper for legacy calls (if any)
    function snapToNearestCard() {
      var index = getNearestCardIndex();
      snapToCard(index);
    }
    
    function updateActiveSlot(activeIndex) {
      carouselState.cards.forEach(function(c, i) {
        if (i === activeIndex) c.classList.add('active-slot');
        else c.classList.remove('active-slot');
      });
    }

    // animateToPosition function removed as it is replaced by CSS transition logic in snapToNearestCard
    
    function bounceBack() {
      // Safety checks
      if (!carouselState.track || !carouselState.grid) {
        console.warn('bounceBack: Missing track or grid');
        return;
      }
      
      // ALWAYS recalculate bounds before bouncing - they may have changed
      calculateCarouselBounds();
      
      // Determine target position
      var targetX;
      var bounceDirection = null;
      if (carouselState.translateX > carouselState.maxX) {
        targetX = carouselState.maxX;
        bounceDirection = 'LEFT_EDGE';
      } else if (carouselState.translateX < carouselState.minX) {
        targetX = carouselState.minX;
        bounceDirection = 'RIGHT_EDGE_LAST_CARD';
        // #region agent log - H6 bounceBack at last card
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:bounceBack', 'Bouncing from RIGHT edge (LAST CARD)', { currentX: carouselState.translateX, targetX: targetX, minX: carouselState.minX }, 'H6');
        // #endregion
      } else {
        // Already within bounds
        carouselState.grid.classList.remove('is-scrolling');
        return;
      }
      
      // Ensure target is a valid number
      if (isNaN(targetX) || !isFinite(targetX)) {
        console.warn('bounceBack: Invalid targetX, resetting to 0');
        targetX = 0;
      }
      
      // Silently bouncing back to valid bounds
      
      // Use CSS transition for bounce - consistent physics
      carouselState.grid.classList.add('is-scrolling');
      carouselState.track.style.transition = 'transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)';
      carouselState.track.style.transform = 'translate3d(' + targetX + 'px, 0, 0)';
      carouselState.translateX = targetX;
      
      // Cancel any momentum animation
      if (carouselState.animationFrame) {
        cancelAnimationFrame(carouselState.animationFrame);
        carouselState.animationFrame = null;
      }
      
      setTimeout(function() {
        if (carouselState.track) {
          carouselState.track.style.transition = '';
        }
        if (carouselState.grid) {
          carouselState.grid.classList.remove('is-scrolling');
        }
        carouselState.wasDragging = false;
      }, 400);
    }
    
    function applyMomentum() {
      // Safety checks
      if (!carouselState.track || !carouselState.grid) {
        console.warn('applyMomentum: Missing track or grid');
        return;
      }
      
      // Calculate momentum based on Exponential Decay (Apple-style)
      var velocity = carouselState.velocity || 0;
      var timeConstant = 325; // ms
      
      // Safety: don't animate if velocity is too low
      if (Math.abs(velocity) < 1) {
        carouselState.grid.classList.remove('is-scrolling');
        return;
      }
      
      // Cancel any existing animation
      if (carouselState.animationFrame) {
        cancelAnimationFrame(carouselState.animationFrame);
        carouselState.animationFrame = null;
      }
      
      // Calculate amplitude (total distance) based on initial velocity
      var amplitude = (velocity / 16.67) * timeConstant;
      var targetX = carouselState.translateX + amplitude;
      var startTime = Date.now();
      var maxDuration = 2000; // Safety: max 2 seconds of animation
      
      // Ensure interaction lock is on
      carouselState.grid.classList.add('is-scrolling');
      
      function animateMomentum() {
        var elapsed = Date.now() - startTime;
        
        // Safety: stop if animation running too long
        if (elapsed > maxDuration) {
          carouselState.velocity = 0;
          carouselState.grid.classList.remove('is-scrolling');
          carouselState.animationFrame = null;
          return;
        }
        
        // Calculate new position using exponential decay
        var decay = Math.exp(-elapsed / timeConstant);
        var newX = targetX - (amplitude * decay);
        
        // Check bounds BEFORE updating position
        if (newX > carouselState.maxX) {
          carouselState.translateX = carouselState.maxX;
          carouselState.velocity = 0;
          bounceBack();
          return;
        } else if (newX < carouselState.minX) {
          carouselState.translateX = carouselState.minX;
          carouselState.velocity = 0;
          bounceBack();
          return;
        }
        
        carouselState.translateX = newX;
        carouselState.track.style.transform = 'translate3d(' + carouselState.translateX + 'px, 0, 0)';
        
        // Check if scroll hint should be hidden
        checkScrollHintVisibility();
        
        // Calculate current velocity for stopping condition
        carouselState.velocity = (amplitude / timeConstant) * decay * 16.67;
        
        // Stop when velocity is very low OR decay is essentially complete
        if (Math.abs(carouselState.velocity) < 0.5 || decay < 0.01) {
          carouselState.velocity = 0;
          carouselState.grid.classList.remove('is-scrolling');
          carouselState.animationFrame = null;
        } else {
          carouselState.animationFrame = requestAnimationFrame(animateMomentum);
        }
      }
      
      carouselState.animationFrame = requestAnimationFrame(animateMomentum);
    }
    
    function disableCarousel() {
      carouselState.enabled = false;
      if (carouselState.animationFrame) {
        cancelAnimationFrame(carouselState.animationFrame);
      }
    }
    
    function enableCarousel() {
      carouselState.enabled = true;
      updateCarouselDimensions();
      // No centerCarousel needed, stays where it is
    }
    
    window.BundleBuilderCarousel = {
      disable: disableCarousel,
      enable: enableCarousel,
      getState: function() { return carouselState; }
    };

    // ========================================================================
    // SPARK PARTICLE SYSTEM
    // Gold pixel sparks that explode from card edges on selection
    // ========================================================================
    function initSparkSystem() {
      // ========================================================================
      // iOS SAFARI MEMORY FIX: Detect low-memory devices and reduce canvas size
      // iOS Safari has a hard 384 MB canvas memory limit that causes crashes
      // ========================================================================
      var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      var isLowMemoryDevice = isIOS || (isSafari && navigator.deviceMemory && navigator.deviceMemory < 4);
      
      // Skip spark system entirely on LOW performance tier or if particles disabled
      if (Perf.tier === 'low' || !Perf.enableParticles) {
        console.log('⚡ Spark system disabled (performance tier: ' + Perf.tier + ')');
        // Remove spark canvases from DOM to save memory
        document.querySelectorAll('.bb-spark-canvas').forEach(function(canvas) {
          canvas.remove();
        });
        // Mark as not initialized so we can re-init later if user enables particles
        window._sparkSystemInitialized = false;
        return;
      }
      
      // Mark spark system as initialized
      window._sparkSystemInitialized = true;
      
      // ========================================================================
      // RACE CONDITION FIX: Local flag to track if spark system was initialized
      // The performance benchmark runs async and may set Perf.enableParticles=false
      // AFTER this function has already decided to enable sparks. Use this local
      // flag instead of Perf.enableParticles for animation decisions.
      // ========================================================================
      var sparkSystemEnabled = true;
      
      // Adaptive canvas padding based on device capability
      // iOS with 3x DPR: 500px padding = ~47MB per card = ~470MB for 10 cards (CRASHES)
      // Desktop: 150px is enough for particles to travel before fading (was 500px - way overkill)
      var adaptivePadding = isLowMemoryDevice ? 80 : 150;
      
      // Cap DPR on iOS to prevent memory explosion (3x DPR = 9x memory usage)
      var maxDPR = isLowMemoryDevice ? 1.5 : (window.devicePixelRatio || 1);
      
      var SPARK_CONFIG = {
        particleCount: isLowMemoryDevice ? 25 : 50,      // Fewer sparks on low-memory devices
        canvasPadding: adaptivePadding,
        gravity: 0.15,
        friction: 0.96,
        colors: ['#ffcc00', '#ffd700', '#ffaa00', '#fff4cc'],
        maxDPR: maxDPR
      };
      
      console.log('✨ Spark system: padding=' + adaptivePadding + 'px, maxDPR=' + maxDPR.toFixed(1) + 
                  (isLowMemoryDevice ? ' (iOS/low-memory mode)' : ''));
      
      // Store particles per card
      var cardParticles = new WeakMap();
      var cardContexts = new WeakMap();
      // Optimization: Only animate cards with active particles
      var activeSparkCards = new Set();
      
      // LAZY INITIALIZATION: Don't create canvases upfront on iOS
      // Instead, initialize only when needed (on first spark trigger)
      var lazyInitMode = isLowMemoryDevice;
      
      if (!lazyInitMode) {
        // Desktop: Initialize canvases for all cards upfront
        document.querySelectorAll('.bb-balatro-card').forEach(function(card) {
          var canvas = card.querySelector('.bb-spark-canvas');
          if (!canvas) return;
          
          var ctx = canvas.getContext('2d');
          cardParticles.set(card, []);
          cardContexts.set(card, ctx);
          
          // Size canvas for retina (with capped DPR)
          resizeCanvas(card, canvas, ctx);
        });
      } else {
        // iOS: Remove canvases from DOM, will create on-demand
        console.log('📱 iOS mode: Spark canvases will be created on-demand');
        document.querySelectorAll('.bb-spark-canvas').forEach(function(canvas) {
          canvas.style.display = 'none'; // Hide but don't remove (keep DOM structure)
        });
      }
      
      // Handle window resize
      window.addEventListener('resize', function() {
        document.querySelectorAll('.bb-balatro-card').forEach(function(card) {
          var canvas = card.querySelector('.bb-spark-canvas');
          var ctx = cardContexts.get(card);
          if (canvas && ctx) {
            resizeCanvas(card, canvas, ctx);
          }
        });
      });
      
      function resizeCanvas(card, canvas, ctx) {
        var padding = SPARK_CONFIG.canvasPadding;
        // Use capped DPR to prevent memory explosion on high-DPR devices
        var dpr = Math.min(window.devicePixelRatio || 1, SPARK_CONFIG.maxDPR);
        // Store LOGICAL dimensions for clearRect (before DPR scaling)
        var logicalWidth = card.offsetWidth + padding * 2;
        var logicalHeight = card.offsetHeight + padding * 2;
        canvas.width = logicalWidth * dpr;
        canvas.height = logicalHeight * dpr;
        // Store logical dimensions and DPR on canvas for efficient clearing
        canvas._logicalWidth = logicalWidth;
        canvas._logicalHeight = logicalHeight;
        canvas._dpr = dpr;
        ctx.scale(dpr, dpr);
      }
      
      // Particle class - scaleFactor affects speed, size, and distance
      function Particle(card, customColor, scaleFactor) {
        var w = card.offsetWidth;
        var h = card.offsetHeight;
        var padding = SPARK_CONFIG.canvasPadding;
        
        // Default scale factor is 1
        scaleFactor = scaleFactor || 1;
        
        // Spawn along perimeter
        var perimeter = (w * 2) + (h * 2);
        var rand = Math.random() * perimeter;
        var spawnX, spawnY, angle;
        
        if (rand < w) {
          // TOP EDGE
          spawnX = rand;
          spawnY = 0;
          angle = -Math.PI / 2; // Up
        } else if (rand < w + h) {
          // RIGHT EDGE
          spawnX = w;
          spawnY = rand - w;
          angle = 0; // Right
        } else if (rand < w + h + w) {
          // BOTTOM EDGE
          spawnX = rand - (w + h);
          spawnY = h;
          angle = Math.PI / 2; // Down
        } else {
          // LEFT EDGE
          spawnX = 0;
          spawnY = rand - (w + h + w);
          angle = Math.PI; // Left
        }
        
        // Add canvas offset
        this.x = spawnX + padding;
        this.y = spawnY + padding;
        
        // Velocity: explode outwards with spread - SCALED by card count for distance
        var spread = 0.8;
        var finalAngle = angle + (Math.random() * spread - spread / 2);
        var baseSpeed = Math.random() * 5 + 2;
        var speed = baseSpeed * scaleFactor; // Speed scales = travels further
        
        this.vx = Math.cos(finalAngle) * speed;
        this.vy = Math.sin(finalAngle) * speed;
        
        // Size scales subtly (sqrt of scale factor for gentler growth)
        var baseSize = Math.random() * 8 + 2; // 2px to 10px
        this.size = baseSize * Math.sqrt(scaleFactor);
        this.life = 1.0;
        // Decay stays constant - distance comes from speed, not longer life
        this.decay = Math.random() * 0.015 + 0.008;
        
        // Use custom color if provided, otherwise random gold
        if (customColor) {
          this.color = customColor;
        } else {
        this.color = SPARK_CONFIG.colors[Math.floor(Math.random() * SPARK_CONFIG.colors.length)];
        }
      }
      
      Particle.prototype.update = function() {
        this.x += this.vx;
        this.y += this.vy;
        this.vy += SPARK_CONFIG.gravity;
        this.vx *= SPARK_CONFIG.friction;
        this.vy *= SPARK_CONFIG.friction;
        this.life -= this.decay;
        this.size *= 0.96;
      };
      
      Particle.prototype.draw = function(ctx) {
        ctx.save();
        ctx.globalAlpha = this.life;
        ctx.shadowBlur = 12;
        ctx.shadowColor = this.color;
        ctx.fillStyle = this.color;
        ctx.fillRect(this.x, this.y, this.size, this.size);
        ctx.restore();
      };
      
      // Tier colors - VIBRANT/SATURATED versions for sparks (richer than border colors)
      const TIER_SPARK_COLORS = [
        '#ffd000', // 0: Vibrant Gold
        '#ffd000', // 1: Vibrant Gold
        '#ff9500', // 2: Vibrant Orange
        '#ff4757', // 3: Vibrant Red
        '#ff2d7a', // 4: Hot Pink
        '#d63aff', // 5: Electric Purple
        '#5352ed', // 6: Vivid Indigo
        '#00f5d4', // 7: Neon Cyan
        '#00ff87', // 8: Neon Green
        '#00d26a', // 9: Vivid Emerald
        '#ffffff'  // 10+: White
      ];
      
      // Explode sparks from a card - scales with card count for selection only
      window.explodeCardSparks = function(card) {
        // RACE CONDITION FIX: Don't create particles if system is disabled
        if (!sparkSystemEnabled) return;
        
        var particles = ensureCardParticlesInit(card);
        if (!particles) return;
        
        // Determine color based on projected count (current + 1)
        // Matches the border color progression
        var currentCount = 0;
        if (typeof state !== 'undefined' && state.selectedProducts) {
          currentCount = state.selectedProducts.length;
        }
        var nextCount = currentCount + 1;
        var colorIndex = Math.min(nextCount, TIER_SPARK_COLORS.length - 1);
        var sparkColor = TIER_SPARK_COLORS[colorIndex];
        
        // SCALING: More cards selected = more particles, faster (travels further)
        // Scale factor: 1.0 at 0 cards, grows to 1.5x at 10 cards
        var scaleFactor = 1 + (currentCount * 0.05);
        scaleFactor = Math.min(scaleFactor, 1.5);
        
        // Particle count: base 50, +10 per card selected, max 150
        var baseParticles = SPARK_CONFIG.particleCount;
        var bonusParticles = Math.min(currentCount * 10, 100);
        var particleCount = baseParticles + bonusParticles;
        
        console.log('[Selection Sparks] Card:', currentCount + 1, '| Particles:', particleCount, '| Scale:', scaleFactor.toFixed(2));
        
        for (var i = 0; i < particleCount; i++) {
          particles.push(new Particle(card, sparkColor, scaleFactor));
        }
        activeSparkCards.add(card);
        ensureAnimationRunning();  // PERFORMANCE FIX: Start loop only when needed
      };
      
      // =======================================================================
      // UPGRADE ANIMATION PARTICLES
      // =======================================================================
      
      var upgradeChargeIntervals = new Map(); // Track charging intervals per card
      
      // Color helpers
      function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      }
      
      function lerpColor(color1, color2, factor) {
        var c1 = hexToRgb(color1);
        var c2 = hexToRgb(color2);
        if (!c1 || !c2) return color2;
        
        var r = Math.round(c1.r + (c2.r - c1.r) * factor);
        var g = Math.round(c1.g + (c2.g - c1.g) * factor);
        var b = Math.round(c1.b + (c2.b - c1.b) * factor);
        return 'rgb(' + r + ',' + g + ',' + b + ')';
      }
      
      function getRandomNeonColor() {
        var h = Math.floor(Math.random() * 360);
        var s = 100;
        var l = 50 + Math.random() * 10;
        return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
      }
      
      // Upgrade Particle class with different types
      function UpgradeParticle(card, type, progress) {
        var w = card.offsetWidth;
        var h = card.offsetHeight;
        var padding = SPARK_CONFIG.canvasPadding;
        
        this.type = type;
        var perimeter = (w * 2) + (h * 2);
        var rand = Math.random() * perimeter;
        var spawnX, spawnY, edgeAngle;
        
        if (type === 'ambient') {
          // Spawn from top edge only
          spawnX = Math.random() * w;
          spawnY = 0;
          edgeAngle = -Math.PI / 2;
        } else {
          // Perimeter spawning
          if (rand < w) {
            spawnX = rand; spawnY = 0; edgeAngle = -Math.PI / 2;
          } else if (rand < w + h) {
            spawnX = w; spawnY = rand - w; edgeAngle = 0;
          } else if (rand < w + h + w) {
            spawnX = rand - (w + h); spawnY = h; edgeAngle = Math.PI / 2;
          } else {
            spawnX = 0; spawnY = rand - (w + h + w); edgeAngle = Math.PI;
          }
        }
        
        this.x = spawnX + padding;
        this.y = spawnY + padding;
        this.life = 1.0;
        
        progress = progress || 0;
        
        if (type === 'stream') {
          // Charging particles - green gradient
          this.size = (Math.random() * 2 + 1) + (progress * 5);
          
          if (progress < 0.7) {
            var localP = progress / 0.7;
            // Brighter green start for visibility
            this.color = lerpColor('#00cc00', '#39ff14', localP);
          } else {
            var localP2 = (progress - 0.7) / 0.3;
            this.color = lerpColor('#39ff14', '#ffffff', localP2);
          }
          
          // Slowed down particle speed for more graceful animation
          var currentSpeed = 1 + (progress * 6);
          var straightVx = (Math.random() - 0.5) * 1.2;
          var straightVy = -1;
          var chaosVx = Math.cos(edgeAngle);
          var chaosVy = Math.sin(edgeAngle);
          
          this.vx = (straightVx * (1 - progress)) + (chaosVx * progress * 2);
          this.vy = (straightVy * currentSpeed) + (chaosVy * progress * 2);
          this.decay = 0.01 + (progress * 0.01); // Slower decay = longer life
          
        } else if (type === 'burst') {
          // Explosion particles - Powerful Green Burst
          this.size = Math.random() * 6 + 4; // Larger particles
          // Mix of bright greens and white
          var greenColors = ['#39ff14', '#00ff00', '#ccff00', '#ffffff', '#00ff88'];
          this.color = greenColors[Math.floor(Math.random() * greenColors.length)];
          
          var angle = edgeAngle + (Math.random() * 2 - 1);
          var speed = 20 * (0.5 + Math.random() * 0.8);
          
          this.vx = Math.cos(angle) * speed;
          this.vy = Math.sin(angle) * speed;
          this.decay = 0.01 + Math.random() * 0.015;
          this.rotation = Math.random() * Math.PI;
          
        } else if (type === 'ambient') {
          // Post-upgrade floating particles
          this.size = Math.random() * 5 + 2;
          this.color = getRandomNeonColor();
          this.vx = (Math.random() - 0.5) * 0.5;
          this.vy = -(Math.random() * 2 + 1); // Float upward
          this.decay = 0.008;
          this.rotation = Math.random() * Math.PI;
        }
      }
      
      UpgradeParticle.prototype.update = function() {
        if (this.type === 'ambient') {
          this.x += this.vx + Math.sin(this.life * 5) * 0.5;
          this.y += this.vy;
          this.rotation = (this.rotation || 0) + 0.1;
        } else {
          this.x += this.vx;
          this.y += this.vy;
          
          if (this.type === 'burst') {
            this.vy += 0.3; // Gravity
            this.vx *= 0.95;
            this.vy *= 0.95;
          }
        }
        
        this.life -= this.decay;
        this.size *= 0.98;
      };
      
      UpgradeParticle.prototype.draw = function(ctx) {
        ctx.save();
        ctx.globalAlpha = this.life;
        
        if (this.type === 'burst' || this.type === 'ambient') {
          ctx.shadowBlur = 10;
          ctx.shadowColor = this.color;
        } else if (this.type === 'stream') {
          ctx.shadowBlur = 15;
          ctx.shadowColor = this.color;
        }
        
        ctx.fillStyle = this.color;
        ctx.translate(this.x + this.size / 2, this.y + this.size / 2);
        
        if (this.rotation) {
          ctx.rotate(this.rotation);
        }
        
        ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size);
        ctx.restore();
      };
      
      // Lazy initialization helper - ensures card has particles initialized
      function ensureCardParticlesInit(card) {
        if (cardParticles.has(card)) {
          return cardParticles.get(card);
        }
        
        // Initialize this card's canvas now
        var canvas = card.querySelector('.bb-spark-canvas');
        if (!canvas) return null;
        
        // Show canvas if it was hidden (iOS lazy mode)
        canvas.style.display = '';
        
        var ctx = canvas.getContext('2d');
        if (!ctx) return null; // Canvas may have been removed or is invalid
        
        cardParticles.set(card, []);
        cardContexts.set(card, ctx);
        
        // Size canvas for retina (with capped DPR to prevent memory issues)
        resizeCanvas(card, canvas, ctx);
        
        console.log('[Sparks] Lazy-initialized particles for card:', card.dataset.title);
        return cardParticles.get(card);
      }
      
      // Start charging particles
      window.startUpgradeChargeParticles = function(card, duration) {
        console.log('[Upgrade Particles] startUpgradeChargeParticles called for:', card.dataset.title);
        console.log('[Upgrade Particles] sparkSystemEnabled:', sparkSystemEnabled);
        
        // RACE CONDITION FIX: Don't create particles if system is disabled
        if (!sparkSystemEnabled) {
          console.log('[Upgrade Particles] Skipped - spark system disabled');
          return;
        }
        
        var particles = ensureCardParticlesInit(card);
        if (!particles) {
          console.warn('[Upgrade Particles] Failed to init particles for card');
          return;
        }
        
        // Clear any existing particles for fresh charge animation
        particles.length = 0;
        
        // Add initial particles immediately to prevent race condition
        // (animate loop removes cards with 0 particles before interval can add any)
        for (var j = 0; j < 5; j++) {
          particles.push(new UpgradeParticle(card, 'stream', 0));
        }
        
        console.log('[Upgrade Particles] Particles array cleared, starting with 5 initial particles');
        activeSparkCards.add(card);
        ensureAnimationRunning();  // PERFORMANCE FIX: Start loop only when needed
        
        var startTime = performance.now();
        var peakRate = 50; // Increased rate for density
        
        // Clear any existing interval
        if (upgradeChargeIntervals.has(card)) {
          clearInterval(upgradeChargeIntervals.get(card));
        }
        
        var interval = setInterval(function() {
          var elapsed = performance.now() - startTime;
          var progress = Math.min(elapsed / duration, 1.0);
          
          // Ramp up particle spawn rate
          var rampCurve = Math.pow(progress, 1.1);
          var currentRate = Math.floor(peakRate * rampCurve);
          
          if (currentRate > 0 || (progress > 0.1 && Math.random() < 0.3)) {
            for (var i = 0; i < currentRate + 1; i++) {
              if (Math.random() < 0.6) {
                particles.push(new UpgradeParticle(card, 'stream', progress));
              }
            }
          }
          
          if (progress >= 1) {
            clearInterval(interval);
            upgradeChargeIntervals.delete(card);
          }
        }, 50);
        
        upgradeChargeIntervals.set(card, interval);
      };
      
      // Explosion particles on release
      window.explodeUpgradeParticles = function(card) {
        console.log('[Upgrade Particles] explodeUpgradeParticles called for:', card.dataset.title);
        
        // RACE CONDITION FIX: Don't create particles if system is disabled
        if (!sparkSystemEnabled) {
          console.log('[Upgrade Particles] Skipped - spark system disabled');
          return;
        }
        
        var particles = ensureCardParticlesInit(card);
        if (!particles) {
          console.warn('[Upgrade Particles] Failed to init for explosion');
          return;
        }
        
        // Clear any leftover charging particles for clean explosion
        particles.length = 0;
        
        console.log('[Upgrade Particles] Creating burst particles (fixed 120 total)');
        activeSparkCards.add(card);
        ensureAnimationRunning();  // PERFORMANCE FIX: Start loop only when needed
        
        // Primary burst - 90 particles
        for (var i = 0; i < 90; i++) {
          particles.push(new UpgradeParticle(card, 'burst'));
        }
        
        // Secondary spark pulse - 30 particles
        setTimeout(function() {
          for (var j = 0; j < 30; j++) {
            particles.push(new UpgradeParticle(card, 'burst'));
          }
        }, 200);
      };
      
      // Ambient particles DISABLED for performance
      // Rainbow border CSS now provides the upgraded visual instead
      var upgradeAmbientIntervals = new Map();
      
      window.startUpgradeAmbientParticles = function(card) {
        // DISABLED - rainbow border CSS replaces this effect
        return;
      };
      
      // Stop ambient particles
      window.stopUpgradeAmbientParticles = function(card) {
        if (upgradeAmbientIntervals.has(card)) {
          clearInterval(upgradeAmbientIntervals.get(card));
          upgradeAmbientIntervals.delete(card);
        }
      };
      
      // Animation loop - PERFORMANCE FIX: Only runs when particles are active
      var animateDebugCounter = 0;
      var sparkAnimationRunning = false;
      
      function animate() {
        // PERFORMANCE FIX: Stop loop entirely when disabled or no active particles
        // RACE CONDITION FIX: Use local sparkSystemEnabled flag instead of Perf.enableParticles
        // because Perf.enableParticles can change AFTER spark system is initialized
        if (!sparkSystemEnabled || activeSparkCards.size === 0) {
          sparkAnimationRunning = false;
          return;  // Don't schedule next frame - saves CPU when not needed
        }

        activeSparkCards.forEach(function(card) {
          var ctx = cardContexts.get(card);
          var particles = cardParticles.get(card);
          
          if (!ctx || !particles) {
              activeSparkCards.delete(card);
              return;
          }
          
          // Debug: log particle count occasionally
          if (animateDebugCounter % 60 === 0 && particles.length > 0) {
            console.log('[Animate] Processing', particles.length, 'particles for card:', card.dataset.title);
          }
          
          // Clear canvas using LOGICAL dimensions (not physical pixels)
          // This is critical: ctx is scaled by DPR, so clearRect(0,0,physicalW,physicalH) would clear DPR^2 times the needed area!
          var dpr = ctx.canvas._dpr || window.devicePixelRatio || 1;
          var logicalW = ctx.canvas._logicalWidth || (ctx.canvas.width / dpr);
          var logicalH = ctx.canvas._logicalHeight || (ctx.canvas.height / dpr);
          ctx.clearRect(0, 0, logicalW, logicalH);
          
          // Stop processing if no particles left
          if (particles.length === 0) {
              activeSparkCards.delete(card);
              return;
          }
          
          // Update and draw particles
          for (var i = particles.length - 1; i >= 0; i--) {
            var p = particles[i];
            p.update();
            p.draw(ctx);
            
            if (p.life <= 0) {
              particles.splice(i, 1);
            }
          }
        });
        
        animateDebugCounter++;
        requestAnimationFrame(animate);
      }
      
      // Helper to ensure animation loop is running when needed
      function ensureAnimationRunning() {
        // RACE CONDITION FIX: Use local sparkSystemEnabled flag instead of Perf.enableParticles
        if (!sparkAnimationRunning && sparkSystemEnabled && activeSparkCards.size > 0) {
          sparkAnimationRunning = true;
          requestAnimationFrame(animate);
        }
      }
      
      // Expose the restart function globally for when particles are enabled
      // RACE CONDITION FIX: This also re-enables the spark system if it was disabled by toggle
      window._restartSparkAnimation = function() {
        sparkSystemEnabled = true; // Re-enable the spark system
        ensureAnimationRunning();
      };
      
      // PERFORMANCE FIX: Clear ALL particles from ALL cards (used when disabling particles toggle)
      window._clearAllParticles = function() {
        console.log('[Particles] Clearing ALL particles from', activeSparkCards.size, 'cards');
        
        // RACE CONDITION FIX: Disable the spark system when clearing
        sparkSystemEnabled = false;
        
        // Clear all intervals
        upgradeChargeIntervals.forEach(function(interval) {
          clearInterval(interval);
        });
        upgradeChargeIntervals.clear();
        
        // Clear all particles and canvases
        activeSparkCards.forEach(function(card) {
          var particles = cardParticles.get(card);
          if (particles) {
            particles.length = 0;
          }
          
          var ctx = cardContexts.get(card);
          if (ctx && ctx.canvas) {
            var logicalW = ctx.canvas._logicalWidth || (ctx.canvas.width / (window.devicePixelRatio || 1));
            var logicalH = ctx.canvas._logicalHeight || (ctx.canvas.height / (window.devicePixelRatio || 1));
            ctx.clearRect(0, 0, logicalW, logicalH);
          }
        });
        
        activeSparkCards.clear();
        sparkAnimationRunning = false;
      };
      
      // PERFORMANCE FIX: Expose function to clear particles when card is deselected
      // This prevents zombie particles from running after deselection
      window.clearCardParticles = function(card) {
        var particles = cardParticles.get(card);
        if (particles) {
          particles.length = 0; // Clear all particles immediately
        }
        activeSparkCards.delete(card);
        
        // Also clear any charging intervals for this card
        if (upgradeChargeIntervals.has(card)) {
          clearInterval(upgradeChargeIntervals.get(card));
          upgradeChargeIntervals.delete(card);
        }
        
        // Clear the canvas immediately
        var ctx = cardContexts.get(card);
        if (ctx && ctx.canvas) {
          var logicalW = ctx.canvas._logicalWidth || (ctx.canvas.width / (window.devicePixelRatio || 1));
          var logicalH = ctx.canvas._logicalHeight || (ctx.canvas.height / (window.devicePixelRatio || 1));
          ctx.clearRect(0, 0, logicalW, logicalH);
        }
      };
    }

    // ========================================================================
    // Utilities
    // ========================================================================
    function generateSessionId() {
      return 'bb_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }

    // ========================================================================
    // Global Tooltip removed - reverting to CSS-based tooltip
    // ========================================================================
    
    // No longer need resize listener for fixed positioning calculation
    // as it's calculated on mouseenter now
    
    function debounce(fn, delay) {
      let timeoutId;
      return function() {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(fn, delay);
      };
    }

    function formatMoney(cents) {
      // Convert cents to dollars/pounds
      // Shopify stores prices in cents (e.g., 4900 = £49.00)
      const amount = (cents / 100).toFixed(2);
      return amount;
    }
    
    function stripHtmlTags(str) {
      // Strip HTML tags from string (Shopify money_format often includes <span class=money>)
      // This prevents raw HTML from showing when using textContent
      return str.replace(/<[^>]*>/g, '');
    }

    function formatMoneyWithSymbol(cents) {
      const amount = formatMoney(cents);
      // Use the money format from config if available
      let formatted = config.moneyFormat.replace('{{amount}}', amount);
      formatted = formatted.replace('{{amount_no_decimals}}', Math.round(cents / 100));
      formatted = formatted.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
      // Strip HTML tags - Shopify money_format often contains <span class=money>
      return stripHtmlTags(formatted);
    }
    
    function formatMoneyNoDecimals(cents) {
      // Format money without decimal places (e.g., $29 instead of $29.00)
      const amount = Math.round(cents / 100);
      // Use money format but replace all amount placeholders with whole number
      let formatted = config.moneyFormat.replace('{{amount}}', amount);
      formatted = formatted.replace('{{amount_no_decimals}}', amount);
      formatted = formatted.replace('{{amount_with_comma_separator}}', amount);
      // Strip HTML tags - Shopify money_format often contains <span class=money>
      return stripHtmlTags(formatted);
    }
    
    function formatMoneyFromDecimal(decimal) {
      // For cases where price is already in decimal format (not cents)
      return decimal.toFixed(2);
    }

    // ========================================================================
    // CASH REGISTER PRICE TICKER ANIMATION
    // ========================================================================
    // State stored directly on elements via _tickerState property to avoid hoisting issues
    
    /**
     * Animates a price display element with a cash register ticking effect
     * @param {HTMLElement} el - The price display element
     * @param {number} targetCents - The target price in cents
     * @param {object} options - Animation options
     */
    function animatePriceTicker(el, targetCents, options) {
      options = options || {};
      var duration = options.duration || 400; // ms
      var playSound = options.playSound !== false;
      
      // Get or initialize state stored on the element itself
      if (!el._tickerState) {
        el._tickerState = { currentCents: 0, animationId: null };
      }
      var state = el._tickerState;
      
      // Cancel any existing animation
      if (state.animationId) {
        cancelAnimationFrame(state.animationId);
        state.animationId = null;
      }
      
      var startCents = state.currentCents;
      var startTime = null;
      var lastTickTime = 0;
      var tickInterval = 50; // ms between tick sounds
      
      // If no change, just render final state
      if (startCents === targetCents) {
        renderPrice(el, targetCents);
        return;
      }
      
      // Easing function: ease-out cubic for that "slowing down" cash register feel
      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }
      
      function animate(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easeOutCubic(progress);
        
        // Calculate current value
        var currentCents = Math.round(startCents + (targetCents - startCents) * easedProgress);
        
        // Render the current price
        renderPrice(el, currentCents);
        
        // Play tick sound at intervals (not every frame)
        if (playSound && progress < 1 && timestamp - lastTickTime > tickInterval) {
          lastTickTime = timestamp;
          // Use existing sound system with quieter volume for rapid ticks
          if (window.SoundSystem && window.SoundSystem.play) {
            window.SoundSystem.play('number-tick', null, 0.08);
          }
        }
        
        if (progress < 1) {
          state.animationId = requestAnimationFrame(animate);
          state.currentCents = currentCents;
        } else {
          // Animation complete - ensure final value is exact
          state.currentCents = targetCents;
          state.animationId = null;
          renderPrice(el, targetCents);
        }
      }
      
      state.animationId = requestAnimationFrame(animate);
    }
    
    /**
     * Renders a price value to an element with proper formatting
     * @param {HTMLElement} el - The element to render to
     * @param {number} cents - The price in cents
     */
    function renderPrice(el, cents) {
      var priceStr = formatMoney(cents);
      var parts = priceStr.split('.');
      if (parts.length === 2) {
        el.innerHTML = '<span class="bb-price-dollars">' + parts[0] + '</span><span class="bb-tier-total-decimals">.' + parts[1] + '</span>';
      } else {
        el.textContent = priceStr;
      }
    }

    // ========================================================================
    // STAR BACKGROUND ANIMATION (Balatro Theme Only)
    // ========================================================================
    function initStarBackground() {
      // iOS: Skip star background entirely to prevent GPU memory issues
      var isIOSDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isIOSDevice) {
        console.log('📱 [BB] Star background disabled on iOS for stability');
        return;
      }
      
      // Skip star animations on mobile unless particles enabled (High Spec)
      if (Perf.isMobile && !Perf.enableParticles) {
        console.log('⚡ Star animations disabled on mobile (Low Spec)');
        return;
      }
      
      var starSvg = document.getElementById('bb-shooting-star-canvas');
      if (!starSvg) return; // Only run if SVG exists (Balatro theme)
      
      var starContainer = container;

      // --- 1. STATIC STARS (Background) ---
      function createStaticStars() {
        var starCount = 180;
        
        for (var i = 0; i < starCount; i++) {
          var circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
          
          var x = Math.random() * 100;
          var y = Math.random() * 100;
          // Weighted size: mostly small, occasional medium
          var r = Math.random() > 0.9 ? Math.random() * 1.5 + 1 : Math.random() * 0.8 + 0.5;
          var opacity = Math.random() * 0.6 + 0.3;

          circle.setAttribute("cx", x + "%");
          circle.setAttribute("cy", y + "%");
          circle.setAttribute("r", r);
          circle.setAttribute("fill", "white");
          circle.setAttribute("fill-opacity", opacity);

          // GLOW: ~10% of stars get a strong glow and full opacity
          if (Math.random() > 0.9) {
            circle.setAttribute("filter", "url(#bb-glow-filter)");
            circle.setAttribute("fill-opacity", 1);
            circle.setAttribute("r", r * 1.2);
          }

          // TWINKLE: ~25% of stars flicker subtly
          if (Math.random() > 0.75) {
            circle.classList.add("bb-star-twinkle");
            circle.style.animationDuration = (Math.random() * 3 + 2) + "s";
            circle.style.animationDelay = (Math.random() * -5) + "s";
          }
          
          starSvg.appendChild(circle);
        }
      }
      createStaticStars();

      // --- 2. SPACE DUST (Drifting & Fading) ---
      function DustParticle() {
        this.element = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        this.reset(true);
        starSvg.insertBefore(this.element, starSvg.firstChild);
      }

      DustParticle.prototype.reset = function(initial) {
        this.x = Math.random() * (starContainer.clientWidth || window.innerWidth);
        this.y = Math.random() * (starContainer.clientHeight || window.innerHeight);
        
        var angle = Math.random() * Math.PI * 2;
        var speed = Math.random() * 0.15 + 0.05;
        this.dx = Math.cos(angle) * speed;
        this.dy = Math.sin(angle) * speed;

        this.r = Math.random() * 1 + 0.5;
        this.element.setAttribute("r", this.r);
        this.element.setAttribute("fill", "#8ecae6");

        this.life = 0;
        this.maxLife = Math.random() * 300 + 300;

        if (initial) this.life = Math.random() * this.maxLife;
        
        this.updateGraphic();
      };

      DustParticle.prototype.update = function() {
        var w = starContainer.clientWidth || window.innerWidth;
        var h = starContainer.clientHeight || window.innerHeight;
        
        this.x += this.dx;
        this.y += this.dy;

        if (this.x < -50) this.x = w + 50;
        if (this.x > w + 50) this.x = -50;
        if (this.y < -50) this.y = h + 50;
        if (this.y > h + 50) this.y = -50;

        this.life++;
        if (this.life >= this.maxLife) {
          this.reset(false);
        }

        var progress = this.life / this.maxLife;
        var opacity = Math.sin(progress * Math.PI) * 0.4;
        this.element.setAttribute("fill-opacity", opacity);

        this.updateGraphic();
      };

      DustParticle.prototype.updateGraphic = function() {
        this.element.setAttribute("cx", this.x);
        this.element.setAttribute("cy", this.y);
      };

      var dustParticles = [];
      for (var i = 0; i < 40; i++) {
        dustParticles.push(new DustParticle());
      }

      // --- 3. FAST COMETS (Shooting Stars) ---
      var minSpeed = 30;
      var maxSpeed = 60;
      var minDelay = 4000;
      var maxDelay = 12000;

      function ShootingStar() {
        this.path = null;
        this.finished = false;
        this.reset();
      }

      ShootingStar.prototype.reset = function() {
        var w = starContainer.clientWidth || window.innerWidth;
        var h = starContainer.clientHeight || window.innerHeight;
        
        var startX = Math.random() * w;
        var startY = Math.random() * (h * 0.7);
        
        this.x = startX;
        this.y = startY;
        
        var angle = (Math.random() * 20 + 25) * (Math.PI / 180);
        var speed = Math.random() * (maxSpeed - minSpeed) + minSpeed;
        
        this.dx = Math.cos(angle) * speed;
        this.dy = Math.sin(angle) * speed;
        
        this.length = Math.random() * 200 + 150;
        this.opacity = 0;
        this.fadingIn = true;
        this.finished = false;
        
        this.path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        var gradId = Math.random() > 0.8 ? "bb-meteor-gradient-cyan" : "bb-meteor-gradient";
        this.path.setAttribute("stroke", "url(#" + gradId + ")");
        this.path.setAttribute("stroke-width", Math.random() * 3 + 1);
        this.path.setAttribute("fill", "none");
        this.path.setAttribute("stroke-linecap", "round");
        
        starSvg.appendChild(this.path);
      };

      ShootingStar.prototype.update = function() {
        if (this.finished) return;

        var w = starContainer.clientWidth || window.innerWidth;
        var h = starContainer.clientHeight || window.innerHeight;

        this.x += this.dx;
        this.y += this.dy;

        if (this.fadingIn) {
          this.opacity += 0.1;
          if (this.opacity >= 1) {
            this.opacity = 1;
            this.fadingIn = false;
          }
        }

        if (this.x > w + this.length || this.y > h + this.length) {
          this.finished = true;
          if (this.path && this.path.parentNode) {
            this.path.remove();
          }
          var self = this;
          setTimeout(function() { self.reset(); }, Math.random() * (maxDelay - minDelay) + minDelay);
          return;
        }

        var speed = Math.sqrt(this.dx * this.dx + this.dy * this.dy);
        var tailX = this.x - (this.dx / speed) * this.length;
        var tailY = this.y - (this.dy / speed) * this.length;
        var d = "M " + tailX + " " + tailY + " L " + this.x + " " + this.y;
        
        this.path.setAttribute("d", d);
        this.path.setAttribute("opacity", this.opacity);
      };

      var comets = [];
      comets.push(new ShootingStar());
      setTimeout(function() { comets.push(new ShootingStar()); }, 6000);

      // --- MASTER ANIMATION LOOP ---
      // Star background uses SVG (lightweight) - always runs regardless of Perf.enableParticles
      var starAnimationRunning = true;
      
      function animateStars() {
        if (!starAnimationRunning) return;
        
        for (var i = 0; i < dustParticles.length; i++) {
          dustParticles[i].update();
        }
        for (var j = 0; j < comets.length; j++) {
          comets[j].update();
        }
        
        requestAnimationFrame(animateStars);
      }
      
      // Expose globally for control
      window._restartStarAnimation = function() {
        if (!starAnimationRunning) {
          starAnimationRunning = true;
          requestAnimationFrame(animateStars);
        }
      };
      window._stopStarAnimation = function() {
        starAnimationRunning = false;
      };
      
      // Always start - SVG is lightweight
      animateStars();
      
      console.log('🌟 Star background initialized');
    }
    
    // Initialize star background after a short delay
    setTimeout(initStarBackground, 100);
    
    // ========================================================================
    // HARDWARE CAPABILITY DETECTION (Auto-Tuning)
    // ========================================================================
    var HardwareMonitor = (function() {
      var frameTimes = [];
      var lastFrameTime = 0;
      var isActive = false;
      var rafId = null;
      var results = {
        avgFps: 0,
        minFps: 0,
        maxFps: 0,
        cores: navigator.hardwareConcurrency || 'unknown',
        frameCount: 0,
        duration: 0,
        tier: 'pending'
      };
      
      function start() {
        if (isActive) return;
        isActive = true;
        frameTimes = [];
        lastFrameTime = performance.now();
        results.startTime = performance.now();
        loop();
      }
      
      function loop() {
        if (!isActive) return;
        var now = performance.now();
        var dt = now - lastFrameTime;
        lastFrameTime = now;
        
        // Ignore very long frames (tab switching)
        if (dt < 200 && dt > 0) frameTimes.push(dt);
        
        rafId = requestAnimationFrame(loop);
      }
      
      function stopAndAssess() {
        isActive = false;
        if (rafId) cancelAnimationFrame(rafId);
        
        results.duration = Math.round(performance.now() - results.startTime);
        results.frameCount = frameTimes.length;
        
        if (frameTimes.length < 30) {
          results.tier = 'unknown';
          return 'unknown';
        }
        
        // Calculate stats
        var sum = frameTimes.reduce(function(a, b) { return a + b; }, 0);
        var avgFrameTime = sum / frameTimes.length;
        results.avgFps = Math.round(1000 / avgFrameTime);
        
        // Min/Max (convert frame times to FPS)
        var minFrameTime = Math.min.apply(null, frameTimes);
        var maxFrameTime = Math.max.apply(null, frameTimes);
        results.maxFps = Math.round(1000 / minFrameTime); // Fastest frame = highest FPS
        results.minFps = Math.round(1000 / maxFrameTime); // Slowest frame = lowest FPS
        
        console.log('📊 Hardware Benchmark Results:');
        console.log('   Avg FPS: ' + results.avgFps);
        console.log('   Min FPS: ' + results.minFps);
        console.log('   Max FPS: ' + results.maxFps);
        console.log('   Frames:  ' + results.frameCount);
        console.log('   Cores:   ' + results.cores);
        
        // Simple Heuristic
        // < 35 FPS: Low End (Disable expensive stuff)
        // 35 - 55 FPS: Medium (Disable heaviest stuff)
        // > 55 FPS: High (Enable all)
        
        var cores = navigator.hardwareConcurrency || 4;
        
        if (results.avgFps < 35 || cores < 4) {
          results.tier = 'low';
        } else if (results.avgFps < 55) {
          results.tier = 'medium';
        } else {
          results.tier = 'high';
        }
        
        // Store results globally for debug panel
        if (window.BBPerf) {
          window.BBPerf.benchmarkResults = results;
        }
        
        return results.tier;
      }
      
      function getResults() {
        return results;
      }
      
      return { start: start, stopAndAssess: stopAndAssess, getResults: getResults };
    })();

    // ========================================================================
    // CINEMATIC INTRO SEQUENCE
    // ========================================================================
    function initIntroSequence() {
      // #region agent log - H3/H4 intro sequence tracking
      if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:initIntroSequence', 'Intro sequence started', {}, 'H3');
      // #endregion
      
      // Start monitoring hardware performance during the intro animation
      HardwareMonitor.start();
      
      // #region agent log - H7 Safari iOS memory fix: DELAY multiplayer init
      // Safari iOS crashes when too many heavy resources load simultaneously on cold start.
      // Delay Liveblocks/Firebase init by 3 seconds to reduce memory pressure.
      // This allows critical UI to render first before starting network-heavy operations.
      // On iOS: No delay needed since multiplayer is disabled anyway
      var isIOSDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      var MULTIPLAYER_DELAY_MS = isIOSDevice ? 0 : 3000; // 0ms iOS (multiplayer disabled), 3s desktop
      
      if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:multiplayerDelay', 'Delaying multiplayer init for Safari iOS stability', { delayMs: MULTIPLAYER_DELAY_MS }, 'H7');
      
      setTimeout(function() {
        if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:multiplayerStart', 'Starting multiplayer init after delay', {}, 'H7');
        
        // Start multiplayer cursor tracking (Liveblocks)
        if (typeof MultiplayerSystem !== 'undefined') {
          MultiplayerSystem.init();
          
          // Listen for batch release to enable enter button
          if (MultiplayerSystem.onRelease) {
            MultiplayerSystem.onRelease(function() {
              console.log('🚀 Batch released! Enabling enter button...');
              enableEnterButton();
            });
          }
        }
      }, MULTIPLAYER_DELAY_MS);
      // #endregion
      
      var sectionId = container.dataset.sectionId;
      var introOverlay = document.getElementById('bb-intro-' + sectionId);
      var queuePhase = document.getElementById('bb-queue-phase-' + sectionId);
      var darkPhase = document.getElementById('bb-dark-phase-' + sectionId);
      var spacePhase = document.getElementById('bb-space-phase-' + sectionId);
      var queueFill = document.getElementById('bb-queue-fill-' + sectionId);
      var queueStatus = document.getElementById('bb-queue-status-' + sectionId);
      var queueCount = document.getElementById('bb-queue-count-' + sectionId);
      var queueAvatars = document.getElementById('bb-queue-avatars-' + sectionId);
      var header = document.getElementById('bb-header-' + sectionId);
      var main = document.getElementById('bb-main-' + sectionId);
      
      // iOS: Hide multiplayer UI elements entirely to reduce complexity
      var isIOSDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isIOSDevice) {
        console.log('📱 [BB] Hiding multiplayer UI on iOS for stability');
        // Hide queue status (loading bar text like "Connecting...")
        if (queueStatus) queueStatus.style.display = 'none';
        // Hide avatars container
        if (queueAvatars) queueAvatars.style.display = 'none';
        // Change the door text to remove multiplayer reference
        var queueCountText = document.getElementById('bb-queue-count-text-' + sectionId);
        if (queueCountText) {
          queueCountText.textContent = '🎉 Ready to build your bundle!';
        }
        // Change title from "LIVE MULTIPLAYER BUNDLE BUILDER" to "BUNDLE BUILDER"
        var queueTitle = introOverlay.querySelector('.bb-queue-title');
        if (queueTitle) {
          queueTitle.textContent = 'BUNDLE BUILDER';
        }
      }
      
      if (!introOverlay) {
        // No intro overlay, just show content
        if (header) header.classList.remove('bb-intro-hidden');
        if (main) main.classList.remove('bb-intro-hidden');
        return;
      }
      
      // ========================================================================
      // REAL LOADING: Staggered resource loading for Safari iOS stability
      // ========================================================================
      
      // 1. DELAY SoundSystem loading - it loads 62 sound groups which is memory-intensive
      // Wait 1.5 seconds to let critical UI render first
      setTimeout(function() {
        if (window.SoundSystem && window.SoundSystem.init) {
          console.log('🔊 Intro: Triggering SoundSystem.init() (delayed for iOS stability)');
          window.SoundSystem.init();
        }
      }, 1500);
      
      // 2. Preload card images
      var cardImages = container.querySelectorAll('.bb-balatro-card img[data-src], .bb-balatro-card img[src]');
      var imagesToLoad = [];
      cardImages.forEach(function(img) {
        var src = img.dataset.src || img.src;
        if (src && !img.complete) {
          imagesToLoad.push(src);
        }
      });
      
      // Avatar dots are now synced from Liveblocks via bb-multiplayer.js syncQueueAvatars()
      // No fake avatars needed - real user presence will populate them
      
      // ========================================================================
      // SINGLE BAR LOADING SEQUENCE - One 0-100% bar, cycling messages
      // ========================================================================
      var loadingState = {
        sounds: false,
        images: false,
        soundStarted: false,
        twemoji: false,
        emojisPreloaded: false
      };
      
      // All emojis used in evolution chains (14 stages each) - preload these as Twemoji SVGs
      var allTeamEmojis = [
        // Feline chain (14 stages)
        '🐱', '🐈', '🐈‍⬛', '🐆', '🐅', '🐕', '🦏', '🦛', '🐘', '🦒', '🦭', '🐬', '🦈', '🐋',
        // Amphibian chain (14 stages)
        '🐸', '🦎', '🐍', '🐢', '🐊', '🦞', '🦀', '🦕', '🦖', '🐡', '🐙', '🐉', '🐳', '🦑',
        // Mammal chain (14 stages)
        '🐰', '🐇', '🐿️', '🐁', '🐀', '🦔', '🦫', '🦦', '🦡', '🐗', '🦌', '🐎', '🦬', '🦣',
        // Avian chain (14 stages)
        '🐣', '🐥', '🐤', '🐦', '🐓', '🦜', '🕊️', '🦆', '🦃', '🦢', '🦤', '🦩', '🦅', '🦚',
        // UI emojis
        '🔒', '🎉', '🚀'
      ];
      
      // Preload all team emojis by rendering them in hidden DOM
      // This ensures Twemoji parses them AND the browser pre-renders the images
      function preloadTwemojiSvgs() {
        // iOS: Skip Twemoji preload entirely to prevent memory issues
        var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (isIOS) {
          console.log('📱 [BB] Skipping Twemoji preload on iOS to prevent memory issues');
          loadingState.emojisPreloaded = true;
          return;
        }
        
        var total = allTeamEmojis.length;
        console.log('🎨 [BB] Pre-rendering ' + total + ' Twemoji in DOM...');
        
        // Create hidden container for pre-rendering
        var preloadContainer = document.createElement('div');
        preloadContainer.id = 'bb-emoji-preload';
        preloadContainer.setAttribute('aria-hidden', 'true');
        preloadContainer.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;overflow:hidden;pointer-events:none;opacity:0;';
        
        // Add each emoji as a span (will be parsed by Twemoji)
        allTeamEmojis.forEach(function(emoji) {
          var span = document.createElement('span');
          span.className = 'bb-preload-emoji';
          span.textContent = emoji;
          span.style.cssText = 'display:inline-block;font-size:24px;margin:2px;';
          preloadContainer.appendChild(span);
        });
        
        // Add to DOM
        document.body.appendChild(preloadContainer);
        
        // Parse with Twemoji - this converts text emojis to <img> tags
        if (window.twemoji) {
          window.twemoji.parse(preloadContainer, {
            folder: 'svg',
            ext: '.svg',
            className: 'twemoji'
          });
          console.log('🎨 [BB] Twemoji parsed preload container');
        }
        
        // Wait for all Twemoji images to fully load
        var images = preloadContainer.querySelectorAll('img.twemoji');
        var loaded = 0;
        var imageCount = images.length;
        
        if (imageCount === 0) {
          // No images found (Twemoji might not have loaded yet)
          loadingState.emojisPreloaded = true;
          console.log('🎨 [BB] No Twemoji images to preload (fallback to native)');
          return;
        }
        
        function checkAllLoaded() {
          loaded++;
          if (loaded >= imageCount) {
            loadingState.emojisPreloaded = true;
            console.log('🎨 [BB] All ' + imageCount + ' Twemoji images pre-rendered in DOM');
          }
        }
        
        images.forEach(function(img) {
          if (img.complete) {
            checkAllLoaded();
          } else {
            img.onload = checkAllLoaded;
            img.onerror = checkAllLoaded;
          }
        });
        
        // Fallback timeout - don't block forever
        setTimeout(function() {
          if (!loadingState.emojisPreloaded) {
            loadingState.emojisPreloaded = true;
            console.log('🎨 [BB] Twemoji preload timeout - continuing (' + loaded + '/' + imageCount + ' loaded)');
          }
        }, 8000);
      }
      
      // Load Twemoji - DELAYED for Safari iOS stability (reduces memory pressure during cold start)
      setTimeout(function loadTwemojiDelayed() {
        if (window.twemoji) {
          loadingState.twemoji = true;
          preloadTwemojiSvgs();
          return;
        }
        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/twemoji@14.0.2/dist/twemoji.min.js';
        script.onload = function() {
          loadingState.twemoji = true;
          console.log('🎨 [BB] Twemoji loaded during queue (delayed for iOS stability)');
          preloadTwemojiSvgs();
        };
        script.onerror = function() {
          loadingState.twemoji = true; // Continue anyway
          loadingState.emojisPreloaded = true; // Skip preload
          console.warn('⚠️ [BB] Twemoji failed to load');
        };
        document.head.appendChild(script);
      }, 2000); // 2 second delay for Safari iOS stability
      
      var soundProgress = 0;
      var imageProgress = 0;
      var imagesLoaded = 0;
      var totalImages = imagesToLoad.length || 1;
      
      // Cache detection - speed through if sounds already cached
      var isCachedSession = window.SoundSystem && window.SoundSystem.isCached && window.SoundSystem.isCached();
      
      // iOS: Use instant loading since we skip heavy resources anyway
      var isIOSDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      var baseDuration = isIOSDevice ? 500 : (isCachedSession ? 5000 : 28000); // 0.5s iOS, 5s cached, 28s normal
      
      if (isIOSDevice) {
        console.log('📱 iOS detected - instant loading mode (0.5s)');
      } else if (isCachedSession) {
        console.log('⚡ Cached session detected - fast loading mode');
      }
      
      // Loading messages with their progress thresholds
      // Messages show when progress crosses their threshold
      // Gates pause progress until real loading catches up
      var loadingMessages = [
        { at: 0,  msg: 'Establishing connection to dopamine' },
        { at: 4,  msg: 'Connected - waiting for response' },
        { at: 8,  msg: 'Feels good' },
        { at: 12, msg: 'Loading other players' },
        { at: 16, msg: 'Loading emojis 🎨', gate: 'emojisPreloaded' },
        { at: 18, msg: 'Handshake successful: strong 💪' },
        { at: 20, msg: 'Importing pastéis de nata' },
        { at: 24, msg: 'Scrubbing the decks' },
        { at: 28, msg: 'Colliding particles' },
        { at: 32, msg: 'Detecting CPU perf' },
        { at: 36, msg: 'Allocating pixels' },
        { at: 40, msg: 'Loading bonuses' },
        { at: 44, msg: 'Unpacking discount tiers' },
        { at: 48, msg: 'Checking stock levels' },
        { at: 52, msg: 'Rerolling for tarot' },
        { at: 56, msg: 'Rerolling for joker pack (x2)' },
        { at: 60, msg: 'Rolled: Nat 20 🎲' },
        { at: 64, msg: 'Connecting to sound server', gate: 'soundStarted' },
        { at: 68, msg: 'Buffering sounds', gate: 'soundsLoaded' },
        { at: 72, msg: 'Success! Buffering Jhauk' },
        { at: 76, msg: 'Warming up particle systems' },
        { at: 80, msg: 'Reticulating splines' },
        { at: 84, msg: 'I spent too long making this' },
        { at: 88, msg: 'I hope it was worth it' },
        { at: 92, msg: 'Almost there...' },
        { at: 96, msg: 'Loaded - please stand by', gate: 'allReady' }
      ];
      
      var loadingStartTime = 0;
      var loadingProgress = 0;
      var currentMessageIndex = 0;
      var loadingComplete = false;
      var progressChunks = [];
      var lastChunkIndex = -1;
      var isWaitingForGate = false;
      var gateWaitProgress = 0;
      
      // Generate chunky progress increments for realistic feel
      function generateProgressChunks(duration) {
        var chunks = [{ time: 0, progress: 0 }];
        var currentProgress = 0;
        var numChunks = 30 + Math.floor(Math.random() * 50);
        
        for (var i = 0; i < numChunks && currentProgress < 100; i++) {
          // Time for this chunk
          var time = (i + 1) * (duration / numChunks) * (0.5 + Math.random());
          
          // Size varies: mostly tiny, occasional big jumps
          var roll = Math.random();
          var size;
          if (roll < 0.5) {
            size = 0.2 + Math.random() * 1;    // 50%: micro
          } else if (roll < 0.75) {
            size = 1 + Math.random() * 2;      // 25%: small
          } else if (roll < 0.92) {
            size = 2 + Math.random() * 4;      // 17%: medium
          } else {
            size = 5 + Math.random() * 8;      // 8%: large
          }
          
          currentProgress = Math.min(100, currentProgress + size);
          chunks.push({ time: time, progress: currentProgress });
        }
        
        // Ensure we end at 100
        chunks.push({ time: duration, progress: 100 });
        return chunks;
      }
      
      // Check if a gate condition is met
      function checkGate(gate) {
        if (!gate) return true;
        switch (gate) {
          case 'twemojiLoaded': return loadingState.twemoji;
          case 'emojisPreloaded': return loadingState.emojisPreloaded;
          case 'soundStarted': return loadingState.soundStarted || soundProgress > 0;
          case 'soundsLoaded': return loadingState.sounds;
          case 'allReady': return loadingState.sounds && loadingState.images;
          default: return true;
        }
      }
      
      // Find current message based on progress
      function getCurrentMessage(progress) {
        var msg = loadingMessages[0];
        for (var i = 0; i < loadingMessages.length; i++) {
          if (progress >= loadingMessages[i].at) {
            msg = loadingMessages[i];
          } else {
            break;
          }
        }
        return msg;
      }
      
      function runLoadingSequence() {
        if (loadingComplete) return;
        
        var now = Date.now();
        
        // Initialize on first run
        if (loadingStartTime === 0) {
          loadingStartTime = now;
          progressChunks = generateProgressChunks(baseDuration);
          console.log('📦 Loading sequence started (' + baseDuration + 'ms, ' + progressChunks.length + ' chunks)');
        }
        
        var elapsed = now - loadingStartTime;
        
        // Find current progress from chunks
        for (var i = lastChunkIndex + 1; i < progressChunks.length; i++) {
          if (elapsed >= progressChunks[i].time) {
            loadingProgress = progressChunks[i].progress;
            lastChunkIndex = i;
          } else {
            break;
          }
        }
        
        // Get current message and check for gates
        var currentMsg = getCurrentMessage(loadingProgress);
        
        // Check if we need to wait for a gate
        if (currentMsg.gate && !checkGate(currentMsg.gate)) {
          isWaitingForGate = true;
          gateWaitProgress = loadingProgress;
          
          // Show waiting message with animated dots
          if (queueStatus) {
            var dots = '.'.repeat((Math.floor(now / 400) % 3) + 1);
            queueStatus.textContent = currentMsg.msg + dots;
          }
          
          // Pulse progress slightly while waiting
          if (queueFill) {
            var pulse = gateWaitProgress + Math.sin(now / 300) * 2;
            queueFill.style.width = Math.min(99, pulse) + '%';
          }
          
          requestAnimationFrame(runLoadingSequence);
          return;
        }
        
        // Gate passed - resume if we were waiting
        if (isWaitingForGate) {
          isWaitingForGate = false;
          // Adjust start time to account for wait
          var progressRatio = loadingProgress / 100;
          loadingStartTime = now - (progressRatio * baseDuration);
        }
        
        // Update message display
        if (queueStatus && currentMsg.msg) {
          queueStatus.textContent = currentMsg.msg;
        }
        
        // Update progress bar
        if (queueFill) {
          queueFill.style.width = loadingProgress + '%';
        }
        
        // Check if complete
        if (loadingProgress >= 100 && checkGate('allReady')) {
          loadingComplete = true;
          console.log('✅ All resources loaded');
          
          // Hide loading state in action container
          var loadingState = document.getElementById('bb-queue-loading-state-' + sectionId);
          if (loadingState) {
            loadingState.classList.add('bb-hidden');
          }
          
          // Also hide old progress container (legacy)
          var progressContainer = document.getElementById('bb-queue-progress-container-' + sectionId);
          if (progressContainer) {
            progressContainer.classList.add('bb-hidden');
          }
          
          // Show room info panel
          var roomInfo = document.getElementById('bb-queue-room-info-' + sectionId);
          if (roomInfo) {
            roomInfo.classList.remove('bb-hidden');
          }
          
          // Show avatars/people section
          var queuePeople = document.getElementById('bb-queue-people-' + sectionId);
          if (queuePeople) {
            queuePeople.classList.remove('bb-hidden');
          }
          
          showEnterButton();
          return;
        }
        
        requestAnimationFrame(runLoadingSequence);
      }
      
      // Start the loading sequence
      runLoadingSequence();
      
      // Legacy updateProgress - now just updates internal state
      function updateProgress() {
        // No longer updates UI directly - the sequence handles that
        // But we still need to check for completion
        if (loadingState.sounds && loadingState.images && !loadingState.minTime) {
          loadingState.minTime = true; // Mark minimum time as satisfied when real loading done
        }
      }
      
      function checkReadyToTransition() {
        // Now handled by the loading sequence reaching the final stage
        // This is kept for backwards compatibility
      }
      
      // ========================================================================
      // "CLICK TO ENTER" BUTTON - Ensures audio is unlocked via user click
      // ========================================================================
      var enterButtonShown = false;
      
      function showEnterButton() {
        enterButtonShown = true;
        // Mark loading complete globally so bb-multiplayer.js can check
        window.BB = window.BB || {};
        window.BB.loadingComplete = true;
        console.log('✅ [BB] Loading complete - BB.loadingComplete = true');
        
        // Trigger any waiting callbacks
        if (window.BB._onLoadingComplete) {
          window.BB._onLoadingComplete.forEach(function(cb) {
            try { cb(); } catch(e) { console.error(e); }
          });
        }
        
        // Visibility is controlled by bb-multiplayer.js based on door state
        // This just marks that resources are loaded
      }
      
      function enableEnterButton() {
        var enterBtn = document.getElementById('bb-queue-enter-' + sectionId);
        if (enterBtn) {
          enterBtn.disabled = false;
          enterBtn.style.opacity = '1';
        }
      }
      
      // Global API for checking/waiting on loading state
      window.BB = window.BB || {};
      window.BB.loadingComplete = false;
      window.BB._onLoadingComplete = [];
      window.BB.onLoadingComplete = function(callback) {
        if (window.BB.loadingComplete) {
          callback();
        } else {
          window.BB._onLoadingComplete.push(callback);
        }
      };
      window.BB.isLoadingComplete = function() {
        return window.BB.loadingComplete === true;
      };
      
      // ========================================================================
      // ENTER BUTTON SETUP (uses Liquid button, visibility controlled by bb-multiplayer.js)
      // ========================================================================
      function setupEnterButton() {
        // Get the Liquid-based enter button (visibility controlled by bb-multiplayer.js)
        var enterBtn = document.getElementById('bb-queue-enter-' + sectionId);
        if (!enterBtn) {
          console.warn('Enter button not found: bb-queue-enter-' + sectionId);
          return;
        }
        
        // Click handler - THIS is what unlocks audio and starts transition
        enterBtn.addEventListener('click', function() {
          console.log('🎮 Enter button clicked - starting transition');
          // #region agent log - H17 Enter button click tracking
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Enter button clicked', { step: 1 }, 'H17');
          // #endregion
          
          // Visual feedback ONLY - nothing else until fade completes
          enterBtn.style.transform = 'scale(0.95)';
          enterBtn.style.opacity = '0.8';
          enterBtn.style.pointerEvents = 'none'; // Prevent double-clicks
          
          // iOS: Use simplified instant transition (no animation) to prevent GPU crashes
          var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
          if (isIOS) {
            console.log('📱 [BB] Using simplified iOS transition (no animation)');
            if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'iOS simplified transition', { step: 'ios' }, 'H17');
            
            // Skip all the fancy animation - just start the transition immediately
            startSessionTimer();
            startTransition(null); // Pass null for overlay - will be handled
            return;
          }
          
          // #region agent log - H17 Button style applied
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Button style applied', { step: 2 }, 'H17');
          // #endregion
          
          // STEP 1: Create black overlay and start fade to black
          var blackOverlay = document.createElement('div');
          blackOverlay.id = 'bb-black-transition';
          // #region agent log - H17 Overlay created
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Overlay element created', { step: 3 }, 'H17');
          // #endregion
          blackOverlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:#000;z-index:99999;opacity:0;transition:opacity 0.4s ease;';
          // #region agent log - H17 Overlay style set
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Overlay style set', { step: 4 }, 'H17');
          // #endregion
          document.body.appendChild(blackOverlay);
          // #region agent log - H17 Overlay appended to DOM
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Overlay appended to DOM', { step: 5 }, 'H17');
          // #endregion
          
          // Force reflow then fade to black
          blackOverlay.offsetHeight;
          // #region agent log - H17 Reflow forced
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Reflow forced', { step: 6 }, 'H17');
          // #endregion
          blackOverlay.style.opacity = '1';
          // #region agent log - H17 Opacity transition started
          if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Opacity transition started', { step: 7 }, 'H17');
          // #endregion
          
          // STEP 2: Wait for fade to black to COMPLETE before doing ANYTHING else
          // The transition is 0.4s, so wait 450ms to be safe
          setTimeout(function() {
            // #region agent log - H17 Timeout fired
            if (window._bbDebugLog) window._bbDebugLog('bundle-builder.js:enterClick', 'Timeout fired - fade complete', { step: 8 }, 'H17');
            // #endregion
            console.log('🎬 Fade to black complete - now transitioning');
            
            // NOW it's safe to start the session timer
            startSessionTimer();
            
            // NOW transition multiplayer state to 'playing' (hides cursors etc)
            if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.enterGame) {
              MultiplayerSystem.enterGame();
            }
            
            // NOW unlock audio (user has interacted)
            if (window.SoundSystem && window.SoundSystem.forceUnlock) {
              window.SoundSystem.forceUnlock();
            }
            
            // NOW start music player autoplay
            if (window.BBMusicPlayer && window.BBMusicPlayer.startAutoplay) {
              window.BBMusicPlayer.startAutoplay();
            }
            
            // NOW start the actual transition (which will fade OUT of black)
            startTransition(blackOverlay);
          }, 450);
        });
        
        console.log('✅ Enter button setup complete');
      }
      
      // Call setup immediately
      setupEnterButton();
      
      // ========================================================================
      // 3D CARD MOUSE TRACKING (Queue Card)
      // ========================================================================
      function setupQueueCard() {
        var card = document.getElementById('bb-queue-card-' + sectionId);
        if (!card) return;
        
        var card3d = card.querySelector('.bb-card-3d');
        if (!card3d) return;
        
        card.addEventListener('mousemove', function(e) {
          var rect = card.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var y = e.clientY - rect.top;
          var centerX = rect.width / 2;
          var centerY = rect.height / 2;
          
          // Rotation (max +/- 15deg)
          var rotateY = ((x - centerX) / centerX) * 15;
          var rotateX = -((y - centerY) / centerY) * 15;
          
          // Shine position (opposite to mouse)
          var shineX = 100 - ((x / rect.width) * 100);
          var shineY = 100 - ((y / rect.height) * 100);
          
          card.style.setProperty('--rotate-x', rotateX + 'deg');
          card.style.setProperty('--rotate-y', rotateY + 'deg');
          card.style.setProperty('--shine-pos-x', shineX + '%');
          card.style.setProperty('--shine-pos-y', shineY + '%');
          card.style.setProperty('--mouse-x', (x / rect.width) * 100 + '%');
          card.style.setProperty('--mouse-y', (y / rect.height) * 100 + '%');
        });
        
        card.addEventListener('mouseleave', function() {
          card.style.setProperty('--rotate-x', '0deg');
          card.style.setProperty('--rotate-y', '0deg');
          card.style.setProperty('--shine-pos-x', '50%');
          card.style.setProperty('--shine-pos-y', '50%');
        });
        
        console.log('🎴 Queue card 3D tracking enabled');
      }
      
      setupQueueCard();
      
      // ========================================================================
      // SOUND LOADING (Real) - Gates: soundStarted, soundsLoaded
      // ========================================================================
      if (window.SoundSystem && window.SoundSystem.onLoadingProgress) {
        window.SoundSystem.onLoadingProgress(function(progress) {
          // Mark sound loading as started on first progress update
          if (!loadingState.soundStarted && progress > 0) {
            loadingState.soundStarted = true;
            console.log('🔊 Sound loading started');
          }
          soundProgress = progress;
          if (progress >= 100 && !loadingState.sounds) {
            loadingState.sounds = true;
            console.log('✅ Sounds loaded');
          }
        });
        
        // Check if already loaded (in case init was called before)
        if (window.SoundSystem.isLoaded && window.SoundSystem.isLoaded()) {
          soundProgress = 100;
          loadingState.sounds = true;
          loadingState.soundStarted = true;
          console.log('✅ Sounds already loaded');
        }
      } else {
        // No sound system configured - mark as complete
        soundProgress = 100;
        loadingState.sounds = true;
        loadingState.soundStarted = true;
        console.log('ℹ️ No sound system - skipping sound loading');
      }
      
      // ========================================================================
      // IMAGE PRELOADING (Real) - Gate: imagesLoaded
      // ========================================================================
      if (imagesToLoad.length > 0) {
        console.log('🖼️ Preloading ' + imagesToLoad.length + ' card images');
        
        imagesToLoad.forEach(function(src) {
          var img = new Image();
          img.onload = img.onerror = function() {
            imagesLoaded++;
            imageProgress = (imagesLoaded / totalImages) * 100;
            if (imagesLoaded >= totalImages && !loadingState.images) {
              loadingState.images = true;
              console.log('✅ Images loaded');
            }
          };
          img.src = src;
        });
      } else {
        // No images to load
        imageProgress = 100;
        loadingState.images = true;
        console.log('ℹ️ No images to preload');
      }
      
      // Note: Minimum display time is now handled by the dramatic loading sequence
      // The sequence has ~15+ seconds of messages which ensures users see the loading screen
      
      // ========================================================================
      // QUEUE COUNTDOWN - Now handled by MultiplayerSystem
      // ========================================================================
      // Visual countdown is managed by bb-multiplayer.js updateStatusCount()
      
      // DEV BYPASS button - completely skips queue and enters experience
      var skipBtn = document.getElementById('bb-queue-skip-' + sectionId);
      if (skipBtn) {
        skipBtn.textContent = '🔓 DEV BYPASS';
        skipBtn.addEventListener('click', function() {
          console.log('🔓 DEV BYPASS - Forcing entry into Bundle Builder');
          
          // Force all loading states to complete
          loadingState.sounds = true;
          loadingState.images = true;
          loadingState.minTime = true;
          
          // Force release state in MultiplayerSystem
          if (typeof MultiplayerSystem !== 'undefined' && MultiplayerSystem.forceRelease) {
            MultiplayerSystem.forceRelease();
          }
          
          // Show enter button as enabled
          showEnterButton();
          enableEnterButton();
          
          // Auto-start the transition after a brief moment (with black overlay)
          setTimeout(function() {
            var blackOverlay = document.createElement('div');
            blackOverlay.id = 'bb-black-transition';
            blackOverlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:#000;z-index:99999;opacity:1;';
            document.body.appendChild(blackOverlay);
            startTransition(blackOverlay);
          }, 500);
        });
      }
      
      // Failsafe timeout - if loading takes too long, show Enter button anyway
      var FAILSAFE_TIMEOUT = 15000; // 15 seconds max
      var failsafeTimer = setTimeout(function() {
        if (!enterButtonShown) {
          console.warn('⚠️ Failsafe timeout - showing Enter button despite incomplete loading');
          console.log('   Sounds:', loadingState.sounds ? 'loaded' : 'NOT loaded');
          console.log('   Images:', loadingState.images ? 'loaded' : 'NOT loaded');
          loadingState.sounds = true;
          loadingState.images = true;
          loadingState.minTime = true;
          showEnterButton();
        }
      }, FAILSAFE_TIMEOUT);
      
      var transitionStarted = false;
      
      // Set up initial waiting states for elements
      var titles = container.querySelectorAll('.bb-step-title');
      var cards = container.querySelectorAll('.bb-balatro-card');
      var progressBars = container.querySelectorAll('.bb-tier-progress');
      
      titles.forEach(function(title) { title.classList.add('bb-intro-waiting'); });
      cards.forEach(function(card) { card.classList.add('bb-intro-waiting'); });
      progressBars.forEach(function(bar) { bar.classList.add('bb-intro-waiting'); });
      
      function startTransition(blackOverlay) {
        // Prevent multiple calls
        if (transitionStarted) return;
        transitionStarted = true;
        
        // Clear failsafe timer
        clearTimeout(failsafeTimer);
        
        var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        
        // iOS: Skip audio unlock and music (not loaded anyway)
        if (!isIOS) {
          // Force unlock audio - user has interacted by getting past the loading screen
          if (window.SoundSystem && window.SoundSystem.forceUnlock) {
            window.SoundSystem.forceUnlock();
          }
          
          // Start music player autoplay
          if (window.BBMusicPlayer && window.BBMusicPlayer.startAutoplay) {
            window.BBMusicPlayer.startAutoplay();
          }
        }
        
        console.log('🎬 Starting transition sequence' + (isIOS ? ' (iOS simplified)' : ' (black overlay mode)'));
        
        // IMMEDIATELY hide intro overlay (it's behind the black now)
        if (introOverlay) {
          introOverlay.style.display = 'none';
        }
        
        // Prepare ALL content while black is showing (no animation delays)
        if (main) {
          main.classList.remove('bb-intro-hidden');
          main.style.opacity = '1';
        }
        if (header) {
          header.classList.remove('bb-intro-hidden');
          header.style.opacity = '1';
        }
        titles.forEach(function(title) {
          title.classList.remove('bb-intro-waiting');
          title.style.opacity = '1';
        });
        cards.forEach(function(card) {
          card.classList.remove('bb-intro-waiting');
          card.style.opacity = '1';
        });
        progressBars.forEach(function(bar) {
          bar.classList.remove('bb-intro-waiting');
          bar.style.opacity = '1';
        });
        
        // Give DOM time to settle and paint (prevents CLS)
        // iOS: Shorter delay since no animation
        var settleDelay = isIOS ? 50 : 200;
        setTimeout(function() {
          // Now fade out the black overlay to reveal the ready content
          if (blackOverlay) {
            blackOverlay.style.transition = 'opacity 0.6s ease';
            blackOverlay.style.opacity = '0';
            
            // Remove black overlay and clean up after fade completes
            setTimeout(function() {
              blackOverlay.remove();
              finishIntro();
            }, 700);
          } else {
            // iOS simplified mode - no overlay, just finish immediately
            finishIntro();
          }
        }, settleDelay);
        
        function finishIntro() {
          // Clean up: Mark all elements as intro-complete
          if (header) header.classList.add('intro-complete');
          if (main) main.classList.add('intro-complete');
          titles.forEach(function(title) { title.classList.add('intro-complete'); });
          cards.forEach(function(card) { 
            card.classList.remove('bb-intro-waiting');
            card.classList.add('intro-complete'); 
          });
          progressBars.forEach(function(bar) { bar.classList.add('intro-complete'); });
          
          console.log('✨ Intro sequence complete - all elements in clean state');
          
          // Stop hardware monitor and apply settings
          var qualityTier = HardwareMonitor.stopAndAssess();
          if (window.BBPerf) {
            window.BBPerf.benchmarkResults = HardwareMonitor.getResults();
            window.BBPerf.benchmarkResults.tier = qualityTier;
            window.BBPerf.tier = qualityTier;
          }
          
          // Force update of all UI controls
          applyPerformanceSettings(qualityTier);
        }
      }
    }
    
    function applyPerformanceSettings(tier) {
      console.log('⚙️ Auto-tuning performance to: ' + tier);
      
      var perfControls = window.BBPerf;
      if (!perfControls) return;
      
      // Update internal state
      if (tier === 'low') {
        // Low End: Disable almost everything
        perfControls.enable3DTilt = false;
        perfControls.enableCardWave = false; // Wave OFF for low tier
        perfControls.enableShadows = false;
        perfControls.enableFire = false;
        perfControls.enableParticles = false;
        perfControls.enableTextShake = false;
        document.body.classList.add('bb-perf-low'); // Disable CSS effects
        toggleShadows(false);
        toggleFire(false);
        // Stop any running particle animations
        if (window._clearAllParticles) window._clearAllParticles();
        // Hide other users' avatars for performance
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(false);
        }
      } else if (tier === 'medium') {
        // Medium: Disable expensive compositing (shadows/tilt)
        perfControls.enable3DTilt = false;
        perfControls.enableCardWave = true;
        perfControls.enableShadows = false; // Disable shadows for medium
        perfControls.enableFire = true;     // Keep fire
        perfControls.enableParticles = true; // Particles ON for medium
        perfControls.enableTextShake = true;
        document.body.classList.remove('bb-perf-low'); // Re-enable CSS effects
        toggleShadows(false);
        toggleFire(true);
        // Show other users' avatars
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(true);
        }
      } else if (tier === 'off') {
        // Off: Minimum settings
        perfControls.enable3DTilt = false;
        perfControls.enableCardWave = false;
        perfControls.enableShadows = false;
        perfControls.enableFire = false;
        perfControls.enableParticles = false;
        perfControls.enableTextShake = false;
        document.body.classList.add('bb-perf-low'); // Disable CSS effects
        toggleShadows(false);
        toggleFire(false);
        // Stop any running particle animations
        if (window._clearAllParticles) window._clearAllParticles();
        // Hide other users' avatars for performance
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(false);
        }
      } else {
        // High: All systems go (Default fallback)
        perfControls.enable3DTilt = true;
        perfControls.enableCardWave = true;
        perfControls.enableShadows = true;
        perfControls.enableFire = true;
        perfControls.enableParticles = true;
        perfControls.enableTextShake = true;
        document.body.classList.remove('bb-perf-low'); // Re-enable CSS effects
        toggleShadows(true);
        toggleFire(true);
        // Show other users' avatars
        if (window.MultiplayerSystem && window.MultiplayerSystem.setPeersVisible) {
          window.MultiplayerSystem.setPeersVisible(true);
        }
        
        // Re-initialize spark system if it wasn't initialized on page load (e.g. iOS started as medium/low)
        if (!window._sparkSystemInitialized) {
          console.log('✨ Re-initializing spark system for HIGH tier (post-benchmark)');
          initSparkSystem();
        } else if (window._restartSparkAnimation) {
          window._restartSparkAnimation();
        }
      }
      
      // Sync debug panel controls
      updatePerfControls();
      
      // Sync floating widget UI
      var menu = document.getElementById('bb-settings-menu');
      if (menu) {
        var tierOptions = menu.querySelectorAll('.menu-option[data-tier]');
        tierOptions.forEach(function(option) {
          option.classList.remove('active');
          if (option.dataset.tier === tier) {
            option.classList.add('active');
          }
        });
      }
    }
    
    // Start intro sequence
    initIntroSequence();
  }
})();

